(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.v;
  var initMetadataForClass = kotlin_kotlin.$_$.q;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.c;
  var initMetadataForObject = kotlin_kotlin.$_$.t;
  var defineProp = kotlin_kotlin.$_$.m;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.a1;
  var equals = kotlin_kotlin.$_$.n;
  var FunctionAdapter = kotlin_kotlin.$_$.l;
  var isInterface = kotlin_kotlin.$_$.u;
  var Comparator = kotlin_kotlin.$_$.x;
  var hashCode = kotlin_kotlin.$_$.p;
  var VOID = kotlin_kotlin.$_$.a;
  var compareValues = kotlin_kotlin.$_$.k;
  var listOf = kotlin_kotlin.$_$.f;
  var sortedWith = kotlin_kotlin.$_$.h;
  var plus = kotlin_kotlin.$_$.g;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.b;
  var Long = kotlin_kotlin.$_$.y;
  var Unit_instance = kotlin_kotlin.$_$.d;
  var subtract = kotlin_kotlin.$_$.i;
  var toList = kotlin_kotlin.$_$.j;
  var initMetadataForInterface = kotlin_kotlin.$_$.s;
  var initMetadataForCompanion = kotlin_kotlin.$_$.r;
  var toString = kotlin_kotlin.$_$.w;
  var getStringHashCode = kotlin_kotlin.$_$.o;
  var THROW_CCE = kotlin_kotlin.$_$.z;
  var copyToArray = kotlin_kotlin.$_$.e;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(CountryProvider, 'CountryProvider', CountryProvider);
  initMetadataForObject(CountryResolver, 'CountryResolver');
  initMetadataForObject(CurrencyResolver, 'CurrencyResolver');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(GetSupportedNationalities, 'GetSupportedNationalities', GetSupportedNationalities);
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(GetSupportedPhoneCountriesUseCase, 'GetSupportedPhoneCountriesUseCase', GetSupportedPhoneCountriesUseCase);
  function get_phoneNumberHint() {
    return '';
  }
  function get_flagUrl() {
    return 'https://taager.com/media/icons/countries-flags/' + this.isoCode2 + '.svg';
  }
  function isPhoneNumberValid(phoneNumber) {
    return Regex_init_$Create$(this.phoneRegex).j4(phoneNumber);
  }
  initMetadataForInterface(Country, 'Country');
  initMetadataForCompanion(Companion);
  initMetadataForClass(Egypt, 'Egypt', Egypt, VOID, [Country]);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(UAE, 'UAE', UAE, VOID, [Country]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(KSA, 'KSA', KSA, VOID, [Country]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(TMT, 'TMT', TMT, VOID, [Country]);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(Afghanistan, 'Afghanistan', Afghanistan, VOID, [Country]);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(AlandIslands, 'AlandIslands', AlandIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(Albania, 'Albania', Albania, VOID, [Country]);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(Algeria, 'Algeria', Algeria, VOID, [Country]);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(AmericanSamoa, 'AmericanSamoa', AmericanSamoa, VOID, [Country]);
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(Andorra, 'Andorra', Andorra, VOID, [Country]);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(Angola, 'Angola', Angola, VOID, [Country]);
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(Anguilla, 'Anguilla', Anguilla, VOID, [Country]);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(Antarctica, 'Antarctica', Antarctica, VOID, [Country]);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(AntiguaandBarbuda, 'AntiguaandBarbuda', AntiguaandBarbuda, VOID, [Country]);
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(Argentina, 'Argentina', Argentina, VOID, [Country]);
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(Armenia, 'Armenia', Armenia, VOID, [Country]);
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(Aruba, 'Aruba', Aruba, VOID, [Country]);
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(Australia, 'Australia', Australia, VOID, [Country]);
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(Austria, 'Austria', Austria, VOID, [Country]);
  initMetadataForCompanion(Companion_18);
  initMetadataForClass(Azerbaijan, 'Azerbaijan', Azerbaijan, VOID, [Country]);
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(Bahamas, 'Bahamas', Bahamas, VOID, [Country]);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(Bahrain, 'Bahrain', Bahrain, VOID, [Country]);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(Bangladesh, 'Bangladesh', Bangladesh, VOID, [Country]);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(Barbados, 'Barbados', Barbados, VOID, [Country]);
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(Belarus, 'Belarus', Belarus, VOID, [Country]);
  initMetadataForCompanion(Companion_24);
  initMetadataForClass(Belgium, 'Belgium', Belgium, VOID, [Country]);
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(Belize, 'Belize', Belize, VOID, [Country]);
  initMetadataForCompanion(Companion_26);
  initMetadataForClass(Benin, 'Benin', Benin, VOID, [Country]);
  initMetadataForCompanion(Companion_27);
  initMetadataForClass(Bermuda, 'Bermuda', Bermuda, VOID, [Country]);
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(Bhutan, 'Bhutan', Bhutan, VOID, [Country]);
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(BoliviaPlurinationalStateof, 'BoliviaPlurinationalStateof', BoliviaPlurinationalStateof, VOID, [Country]);
  initMetadataForCompanion(Companion_30);
  initMetadataForClass(BonaireSintEustatiusandSaba, 'BonaireSintEustatiusandSaba', BonaireSintEustatiusandSaba, VOID, [Country]);
  initMetadataForCompanion(Companion_31);
  initMetadataForClass(BosniaandHerzegovina, 'BosniaandHerzegovina', BosniaandHerzegovina, VOID, [Country]);
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(Botswana, 'Botswana', Botswana, VOID, [Country]);
  initMetadataForCompanion(Companion_33);
  initMetadataForClass(BouvetIsland, 'BouvetIsland', BouvetIsland, VOID, [Country]);
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(Brazil, 'Brazil', Brazil, VOID, [Country]);
  initMetadataForCompanion(Companion_35);
  initMetadataForClass(BritishIndianOceanTerritory, 'BritishIndianOceanTerritory', BritishIndianOceanTerritory, VOID, [Country]);
  initMetadataForCompanion(Companion_36);
  initMetadataForClass(BruneiDarussalam, 'BruneiDarussalam', BruneiDarussalam, VOID, [Country]);
  initMetadataForCompanion(Companion_37);
  initMetadataForClass(Bulgaria, 'Bulgaria', Bulgaria, VOID, [Country]);
  initMetadataForCompanion(Companion_38);
  initMetadataForClass(BurkinaFaso, 'BurkinaFaso', BurkinaFaso, VOID, [Country]);
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(Burundi, 'Burundi', Burundi, VOID, [Country]);
  initMetadataForCompanion(Companion_40);
  initMetadataForClass(Cambodia, 'Cambodia', Cambodia, VOID, [Country]);
  initMetadataForCompanion(Companion_41);
  initMetadataForClass(Cameroon, 'Cameroon', Cameroon, VOID, [Country]);
  initMetadataForCompanion(Companion_42);
  initMetadataForClass(Canada, 'Canada', Canada, VOID, [Country]);
  initMetadataForCompanion(Companion_43);
  initMetadataForClass(CaboVerde, 'CaboVerde', CaboVerde, VOID, [Country]);
  initMetadataForCompanion(Companion_44);
  initMetadataForClass(CaymanIslands, 'CaymanIslands', CaymanIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_45);
  initMetadataForClass(CentralAfricanRepublic, 'CentralAfricanRepublic', CentralAfricanRepublic, VOID, [Country]);
  initMetadataForCompanion(Companion_46);
  initMetadataForClass(Chad, 'Chad', Chad, VOID, [Country]);
  initMetadataForCompanion(Companion_47);
  initMetadataForClass(Chile, 'Chile', Chile, VOID, [Country]);
  initMetadataForCompanion(Companion_48);
  initMetadataForClass(China, 'China', China, VOID, [Country]);
  initMetadataForCompanion(Companion_49);
  initMetadataForClass(ChristmasIsland, 'ChristmasIsland', ChristmasIsland, VOID, [Country]);
  initMetadataForCompanion(Companion_50);
  initMetadataForClass(CocosKeelingIslands, 'CocosKeelingIslands', CocosKeelingIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_51);
  initMetadataForClass(Colombia, 'Colombia', Colombia, VOID, [Country]);
  initMetadataForCompanion(Companion_52);
  initMetadataForClass(Comoros, 'Comoros', Comoros, VOID, [Country]);
  initMetadataForCompanion(Companion_53);
  initMetadataForClass(Congo, 'Congo', Congo, VOID, [Country]);
  initMetadataForCompanion(Companion_54);
  initMetadataForClass(CongoDemocraticRepublicofthe, 'CongoDemocraticRepublicofthe', CongoDemocraticRepublicofthe, VOID, [Country]);
  initMetadataForCompanion(Companion_55);
  initMetadataForClass(CookIslands, 'CookIslands', CookIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_56);
  initMetadataForClass(CostaRica, 'CostaRica', CostaRica, VOID, [Country]);
  initMetadataForCompanion(Companion_57);
  initMetadataForClass(CotedIvoire, 'CotedIvoire', CotedIvoire, VOID, [Country]);
  initMetadataForCompanion(Companion_58);
  initMetadataForClass(Croatia, 'Croatia', Croatia, VOID, [Country]);
  initMetadataForCompanion(Companion_59);
  initMetadataForClass(Cuba, 'Cuba', Cuba, VOID, [Country]);
  initMetadataForCompanion(Companion_60);
  initMetadataForClass(Curacao, 'Curacao', Curacao, VOID, [Country]);
  initMetadataForCompanion(Companion_61);
  initMetadataForClass(Cyprus, 'Cyprus', Cyprus, VOID, [Country]);
  initMetadataForCompanion(Companion_62);
  initMetadataForClass(Czechia, 'Czechia', Czechia, VOID, [Country]);
  initMetadataForCompanion(Companion_63);
  initMetadataForClass(Denmark, 'Denmark', Denmark, VOID, [Country]);
  initMetadataForCompanion(Companion_64);
  initMetadataForClass(Djibouti, 'Djibouti', Djibouti, VOID, [Country]);
  initMetadataForCompanion(Companion_65);
  initMetadataForClass(Dominica, 'Dominica', Dominica, VOID, [Country]);
  initMetadataForCompanion(Companion_66);
  initMetadataForClass(DominicanRepublic, 'DominicanRepublic', DominicanRepublic, VOID, [Country]);
  initMetadataForCompanion(Companion_67);
  initMetadataForClass(Ecuador, 'Ecuador', Ecuador, VOID, [Country]);
  initMetadataForCompanion(Companion_68);
  initMetadataForClass(ElSalvador, 'ElSalvador', ElSalvador, VOID, [Country]);
  initMetadataForCompanion(Companion_69);
  initMetadataForClass(EquatorialGuinea, 'EquatorialGuinea', EquatorialGuinea, VOID, [Country]);
  initMetadataForCompanion(Companion_70);
  initMetadataForClass(Eritrea, 'Eritrea', Eritrea, VOID, [Country]);
  initMetadataForCompanion(Companion_71);
  initMetadataForClass(Estonia, 'Estonia', Estonia, VOID, [Country]);
  initMetadataForCompanion(Companion_72);
  initMetadataForClass(Ethiopia, 'Ethiopia', Ethiopia, VOID, [Country]);
  initMetadataForCompanion(Companion_73);
  initMetadataForClass(FalklandIslandsMalvinas, 'FalklandIslandsMalvinas', FalklandIslandsMalvinas, VOID, [Country]);
  initMetadataForCompanion(Companion_74);
  initMetadataForClass(FaroeIslands, 'FaroeIslands', FaroeIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_75);
  initMetadataForClass(Fiji, 'Fiji', Fiji, VOID, [Country]);
  initMetadataForCompanion(Companion_76);
  initMetadataForClass(Finland, 'Finland', Finland, VOID, [Country]);
  initMetadataForCompanion(Companion_77);
  initMetadataForClass(France, 'France', France, VOID, [Country]);
  initMetadataForCompanion(Companion_78);
  initMetadataForClass(FrenchGuiana, 'FrenchGuiana', FrenchGuiana, VOID, [Country]);
  initMetadataForCompanion(Companion_79);
  initMetadataForClass(FrenchPolynesia, 'FrenchPolynesia', FrenchPolynesia, VOID, [Country]);
  initMetadataForCompanion(Companion_80);
  initMetadataForClass(FrenchSouthernTerritories, 'FrenchSouthernTerritories', FrenchSouthernTerritories, VOID, [Country]);
  initMetadataForCompanion(Companion_81);
  initMetadataForClass(Gabon, 'Gabon', Gabon, VOID, [Country]);
  initMetadataForCompanion(Companion_82);
  initMetadataForClass(Gambia, 'Gambia', Gambia, VOID, [Country]);
  initMetadataForCompanion(Companion_83);
  initMetadataForClass(Georgia, 'Georgia', Georgia, VOID, [Country]);
  initMetadataForCompanion(Companion_84);
  initMetadataForClass(Germany, 'Germany', Germany, VOID, [Country]);
  initMetadataForCompanion(Companion_85);
  initMetadataForClass(Ghana, 'Ghana', Ghana, VOID, [Country]);
  initMetadataForCompanion(Companion_86);
  initMetadataForClass(Gibraltar, 'Gibraltar', Gibraltar, VOID, [Country]);
  initMetadataForCompanion(Companion_87);
  initMetadataForClass(Greece, 'Greece', Greece, VOID, [Country]);
  initMetadataForCompanion(Companion_88);
  initMetadataForClass(Greenland, 'Greenland', Greenland, VOID, [Country]);
  initMetadataForCompanion(Companion_89);
  initMetadataForClass(Grenada, 'Grenada', Grenada, VOID, [Country]);
  initMetadataForCompanion(Companion_90);
  initMetadataForClass(Guadeloupe, 'Guadeloupe', Guadeloupe, VOID, [Country]);
  initMetadataForCompanion(Companion_91);
  initMetadataForClass(Guam, 'Guam', Guam, VOID, [Country]);
  initMetadataForCompanion(Companion_92);
  initMetadataForClass(Guatemala, 'Guatemala', Guatemala, VOID, [Country]);
  initMetadataForCompanion(Companion_93);
  initMetadataForClass(Guernsey, 'Guernsey', Guernsey, VOID, [Country]);
  initMetadataForCompanion(Companion_94);
  initMetadataForClass(Guinea, 'Guinea', Guinea, VOID, [Country]);
  initMetadataForCompanion(Companion_95);
  initMetadataForClass(GuineaBissau, 'GuineaBissau', GuineaBissau, VOID, [Country]);
  initMetadataForCompanion(Companion_96);
  initMetadataForClass(Guyana, 'Guyana', Guyana, VOID, [Country]);
  initMetadataForCompanion(Companion_97);
  initMetadataForClass(Haiti, 'Haiti', Haiti, VOID, [Country]);
  initMetadataForCompanion(Companion_98);
  initMetadataForClass(HeardIslandandMcDonaldIslands, 'HeardIslandandMcDonaldIslands', HeardIslandandMcDonaldIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_99);
  initMetadataForClass(HolySee, 'HolySee', HolySee, VOID, [Country]);
  initMetadataForCompanion(Companion_100);
  initMetadataForClass(Honduras, 'Honduras', Honduras, VOID, [Country]);
  initMetadataForCompanion(Companion_101);
  initMetadataForClass(HongKong, 'HongKong', HongKong, VOID, [Country]);
  initMetadataForCompanion(Companion_102);
  initMetadataForClass(Hungary, 'Hungary', Hungary, VOID, [Country]);
  initMetadataForCompanion(Companion_103);
  initMetadataForClass(Iceland, 'Iceland', Iceland, VOID, [Country]);
  initMetadataForCompanion(Companion_104);
  initMetadataForClass(India, 'India', India, VOID, [Country]);
  initMetadataForCompanion(Companion_105);
  initMetadataForClass(Indonesia, 'Indonesia', Indonesia, VOID, [Country]);
  initMetadataForCompanion(Companion_106);
  initMetadataForClass(IranIslamicRepublicof, 'IranIslamicRepublicof', IranIslamicRepublicof, VOID, [Country]);
  initMetadataForCompanion(Companion_107);
  initMetadataForClass(Iraq, 'Iraq', Iraq, VOID, [Country]);
  initMetadataForCompanion(Companion_108);
  initMetadataForClass(Ireland, 'Ireland', Ireland, VOID, [Country]);
  initMetadataForCompanion(Companion_109);
  initMetadataForClass(IsleofMan, 'IsleofMan', IsleofMan, VOID, [Country]);
  initMetadataForCompanion(Companion_110);
  initMetadataForClass(Israel, 'Israel', Israel, VOID, [Country]);
  initMetadataForCompanion(Companion_111);
  initMetadataForClass(Italy, 'Italy', Italy, VOID, [Country]);
  initMetadataForCompanion(Companion_112);
  initMetadataForClass(Jamaica, 'Jamaica', Jamaica, VOID, [Country]);
  initMetadataForCompanion(Companion_113);
  initMetadataForClass(Japan, 'Japan', Japan, VOID, [Country]);
  initMetadataForCompanion(Companion_114);
  initMetadataForClass(Jersey, 'Jersey', Jersey, VOID, [Country]);
  initMetadataForCompanion(Companion_115);
  initMetadataForClass(Jordan, 'Jordan', Jordan, VOID, [Country]);
  initMetadataForCompanion(Companion_116);
  initMetadataForClass(Kazakhstan, 'Kazakhstan', Kazakhstan, VOID, [Country]);
  initMetadataForCompanion(Companion_117);
  initMetadataForClass(Kenya, 'Kenya', Kenya, VOID, [Country]);
  initMetadataForCompanion(Companion_118);
  initMetadataForClass(Kiribati, 'Kiribati', Kiribati, VOID, [Country]);
  initMetadataForCompanion(Companion_119);
  initMetadataForClass(KoreaDemocraticPeoplesRepublicof, 'KoreaDemocraticPeoplesRepublicof', KoreaDemocraticPeoplesRepublicof, VOID, [Country]);
  initMetadataForCompanion(Companion_120);
  initMetadataForClass(KoreaRepublicof, 'KoreaRepublicof', KoreaRepublicof, VOID, [Country]);
  initMetadataForCompanion(Companion_121);
  initMetadataForClass(Kuwait, 'Kuwait', Kuwait, VOID, [Country]);
  initMetadataForCompanion(Companion_122);
  initMetadataForClass(Kyrgyzstan, 'Kyrgyzstan', Kyrgyzstan, VOID, [Country]);
  initMetadataForCompanion(Companion_123);
  initMetadataForClass(LaoPeoplesDemocraticRepublic, 'LaoPeoplesDemocraticRepublic', LaoPeoplesDemocraticRepublic, VOID, [Country]);
  initMetadataForCompanion(Companion_124);
  initMetadataForClass(Latvia, 'Latvia', Latvia, VOID, [Country]);
  initMetadataForCompanion(Companion_125);
  initMetadataForClass(Lebanon, 'Lebanon', Lebanon, VOID, [Country]);
  initMetadataForCompanion(Companion_126);
  initMetadataForClass(Lesotho, 'Lesotho', Lesotho, VOID, [Country]);
  initMetadataForCompanion(Companion_127);
  initMetadataForClass(Liberia, 'Liberia', Liberia, VOID, [Country]);
  initMetadataForCompanion(Companion_128);
  initMetadataForClass(Libya, 'Libya', Libya, VOID, [Country]);
  initMetadataForCompanion(Companion_129);
  initMetadataForClass(Liechtenstein, 'Liechtenstein', Liechtenstein, VOID, [Country]);
  initMetadataForCompanion(Companion_130);
  initMetadataForClass(Lithuania, 'Lithuania', Lithuania, VOID, [Country]);
  initMetadataForCompanion(Companion_131);
  initMetadataForClass(Luxembourg, 'Luxembourg', Luxembourg, VOID, [Country]);
  initMetadataForCompanion(Companion_132);
  initMetadataForClass(Macao, 'Macao', Macao, VOID, [Country]);
  initMetadataForCompanion(Companion_133);
  initMetadataForClass(NorthMacedonia, 'NorthMacedonia', NorthMacedonia, VOID, [Country]);
  initMetadataForCompanion(Companion_134);
  initMetadataForClass(Madagascar, 'Madagascar', Madagascar, VOID, [Country]);
  initMetadataForCompanion(Companion_135);
  initMetadataForClass(Malawi, 'Malawi', Malawi, VOID, [Country]);
  initMetadataForCompanion(Companion_136);
  initMetadataForClass(Malaysia, 'Malaysia', Malaysia, VOID, [Country]);
  initMetadataForCompanion(Companion_137);
  initMetadataForClass(Maldives, 'Maldives', Maldives, VOID, [Country]);
  initMetadataForCompanion(Companion_138);
  initMetadataForClass(Mali, 'Mali', Mali, VOID, [Country]);
  initMetadataForCompanion(Companion_139);
  initMetadataForClass(Malta, 'Malta', Malta, VOID, [Country]);
  initMetadataForCompanion(Companion_140);
  initMetadataForClass(MarshallIslands, 'MarshallIslands', MarshallIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_141);
  initMetadataForClass(Martinique, 'Martinique', Martinique, VOID, [Country]);
  initMetadataForCompanion(Companion_142);
  initMetadataForClass(Mauritania, 'Mauritania', Mauritania, VOID, [Country]);
  initMetadataForCompanion(Companion_143);
  initMetadataForClass(Mauritius, 'Mauritius', Mauritius, VOID, [Country]);
  initMetadataForCompanion(Companion_144);
  initMetadataForClass(Mayotte, 'Mayotte', Mayotte, VOID, [Country]);
  initMetadataForCompanion(Companion_145);
  initMetadataForClass(Mexico, 'Mexico', Mexico, VOID, [Country]);
  initMetadataForCompanion(Companion_146);
  initMetadataForClass(MicronesiaFederatedStatesof, 'MicronesiaFederatedStatesof', MicronesiaFederatedStatesof, VOID, [Country]);
  initMetadataForCompanion(Companion_147);
  initMetadataForClass(Morocco, 'Morocco', Morocco, VOID, [Country]);
  initMetadataForCompanion(Companion_148);
  initMetadataForClass(MoldovaRepublicof, 'MoldovaRepublicof', MoldovaRepublicof, VOID, [Country]);
  initMetadataForCompanion(Companion_149);
  initMetadataForClass(Monaco, 'Monaco', Monaco, VOID, [Country]);
  initMetadataForCompanion(Companion_150);
  initMetadataForClass(Mongolia, 'Mongolia', Mongolia, VOID, [Country]);
  initMetadataForCompanion(Companion_151);
  initMetadataForClass(Montenegro, 'Montenegro', Montenegro, VOID, [Country]);
  initMetadataForCompanion(Companion_152);
  initMetadataForClass(Montserrat, 'Montserrat', Montserrat, VOID, [Country]);
  initMetadataForCompanion(Companion_153);
  initMetadataForClass(Mozambique, 'Mozambique', Mozambique, VOID, [Country]);
  initMetadataForCompanion(Companion_154);
  initMetadataForClass(Myanmar, 'Myanmar', Myanmar, VOID, [Country]);
  initMetadataForCompanion(Companion_155);
  initMetadataForClass(Namibia, 'Namibia', Namibia, VOID, [Country]);
  initMetadataForCompanion(Companion_156);
  initMetadataForClass(Nauru, 'Nauru', Nauru, VOID, [Country]);
  initMetadataForCompanion(Companion_157);
  initMetadataForClass(Nepal, 'Nepal', Nepal, VOID, [Country]);
  initMetadataForCompanion(Companion_158);
  initMetadataForClass(Netherlands, 'Netherlands', Netherlands, VOID, [Country]);
  initMetadataForCompanion(Companion_159);
  initMetadataForClass(NewCaledonia, 'NewCaledonia', NewCaledonia, VOID, [Country]);
  initMetadataForCompanion(Companion_160);
  initMetadataForClass(NewZealand, 'NewZealand', NewZealand, VOID, [Country]);
  initMetadataForCompanion(Companion_161);
  initMetadataForClass(Nicaragua, 'Nicaragua', Nicaragua, VOID, [Country]);
  initMetadataForCompanion(Companion_162);
  initMetadataForClass(Niger, 'Niger', Niger, VOID, [Country]);
  initMetadataForCompanion(Companion_163);
  initMetadataForClass(Nigeria, 'Nigeria', Nigeria, VOID, [Country]);
  initMetadataForCompanion(Companion_164);
  initMetadataForClass(Niue, 'Niue', Niue, VOID, [Country]);
  initMetadataForCompanion(Companion_165);
  initMetadataForClass(NorfolkIsland, 'NorfolkIsland', NorfolkIsland, VOID, [Country]);
  initMetadataForCompanion(Companion_166);
  initMetadataForClass(NorthernMarianaIslands, 'NorthernMarianaIslands', NorthernMarianaIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_167);
  initMetadataForClass(Norway, 'Norway', Norway, VOID, [Country]);
  initMetadataForCompanion(Companion_168);
  initMetadataForClass(Oman, 'Oman', Oman, VOID, [Country]);
  initMetadataForCompanion(Companion_169);
  initMetadataForClass(Pakistan, 'Pakistan', Pakistan, VOID, [Country]);
  initMetadataForCompanion(Companion_170);
  initMetadataForClass(Palau, 'Palau', Palau, VOID, [Country]);
  initMetadataForCompanion(Companion_171);
  initMetadataForClass(PalestineStateof, 'PalestineStateof', PalestineStateof, VOID, [Country]);
  initMetadataForCompanion(Companion_172);
  initMetadataForClass(Panama, 'Panama', Panama, VOID, [Country]);
  initMetadataForCompanion(Companion_173);
  initMetadataForClass(PapuaNewGuinea, 'PapuaNewGuinea', PapuaNewGuinea, VOID, [Country]);
  initMetadataForCompanion(Companion_174);
  initMetadataForClass(Paraguay, 'Paraguay', Paraguay, VOID, [Country]);
  initMetadataForCompanion(Companion_175);
  initMetadataForClass(Peru, 'Peru', Peru, VOID, [Country]);
  initMetadataForCompanion(Companion_176);
  initMetadataForClass(Philippines, 'Philippines', Philippines, VOID, [Country]);
  initMetadataForCompanion(Companion_177);
  initMetadataForClass(Pitcairn, 'Pitcairn', Pitcairn, VOID, [Country]);
  initMetadataForCompanion(Companion_178);
  initMetadataForClass(Poland, 'Poland', Poland, VOID, [Country]);
  initMetadataForCompanion(Companion_179);
  initMetadataForClass(Portugal, 'Portugal', Portugal, VOID, [Country]);
  initMetadataForCompanion(Companion_180);
  initMetadataForClass(PuertoRico, 'PuertoRico', PuertoRico, VOID, [Country]);
  initMetadataForCompanion(Companion_181);
  initMetadataForClass(Qatar, 'Qatar', Qatar, VOID, [Country]);
  initMetadataForCompanion(Companion_182);
  initMetadataForClass(Reunion, 'Reunion', Reunion, VOID, [Country]);
  initMetadataForCompanion(Companion_183);
  initMetadataForClass(Romania, 'Romania', Romania, VOID, [Country]);
  initMetadataForCompanion(Companion_184);
  initMetadataForClass(RussianFederation, 'RussianFederation', RussianFederation, VOID, [Country]);
  initMetadataForCompanion(Companion_185);
  initMetadataForClass(Rwanda, 'Rwanda', Rwanda, VOID, [Country]);
  initMetadataForCompanion(Companion_186);
  initMetadataForClass(SaintBarthelemy, 'SaintBarthelemy', SaintBarthelemy, VOID, [Country]);
  initMetadataForCompanion(Companion_187);
  initMetadataForClass(SaintHelenaAscensionandTristandaCunha, 'SaintHelenaAscensionandTristandaCunha', SaintHelenaAscensionandTristandaCunha, VOID, [Country]);
  initMetadataForCompanion(Companion_188);
  initMetadataForClass(SaintKittsandNevis, 'SaintKittsandNevis', SaintKittsandNevis, VOID, [Country]);
  initMetadataForCompanion(Companion_189);
  initMetadataForClass(SaintLucia, 'SaintLucia', SaintLucia, VOID, [Country]);
  initMetadataForCompanion(Companion_190);
  initMetadataForClass(SaintMartinFrenchpart, 'SaintMartinFrenchpart', SaintMartinFrenchpart, VOID, [Country]);
  initMetadataForCompanion(Companion_191);
  initMetadataForClass(SaintPierreandMiquelon, 'SaintPierreandMiquelon', SaintPierreandMiquelon, VOID, [Country]);
  initMetadataForCompanion(Companion_192);
  initMetadataForClass(SaintVincentandtheGrenadines, 'SaintVincentandtheGrenadines', SaintVincentandtheGrenadines, VOID, [Country]);
  initMetadataForCompanion(Companion_193);
  initMetadataForClass(Samoa, 'Samoa', Samoa, VOID, [Country]);
  initMetadataForCompanion(Companion_194);
  initMetadataForClass(SanMarino, 'SanMarino', SanMarino, VOID, [Country]);
  initMetadataForCompanion(Companion_195);
  initMetadataForClass(SaoTomeandPrincipe, 'SaoTomeandPrincipe', SaoTomeandPrincipe, VOID, [Country]);
  initMetadataForCompanion(Companion_196);
  initMetadataForClass(Senegal, 'Senegal', Senegal, VOID, [Country]);
  initMetadataForCompanion(Companion_197);
  initMetadataForClass(Serbia, 'Serbia', Serbia, VOID, [Country]);
  initMetadataForCompanion(Companion_198);
  initMetadataForClass(Seychelles, 'Seychelles', Seychelles, VOID, [Country]);
  initMetadataForCompanion(Companion_199);
  initMetadataForClass(SierraLeone, 'SierraLeone', SierraLeone, VOID, [Country]);
  initMetadataForCompanion(Companion_200);
  initMetadataForClass(Singapore, 'Singapore', Singapore, VOID, [Country]);
  initMetadataForCompanion(Companion_201);
  initMetadataForClass(SintMaartenDutchpart, 'SintMaartenDutchpart', SintMaartenDutchpart, VOID, [Country]);
  initMetadataForCompanion(Companion_202);
  initMetadataForClass(Slovakia, 'Slovakia', Slovakia, VOID, [Country]);
  initMetadataForCompanion(Companion_203);
  initMetadataForClass(Slovenia, 'Slovenia', Slovenia, VOID, [Country]);
  initMetadataForCompanion(Companion_204);
  initMetadataForClass(SolomonIslands, 'SolomonIslands', SolomonIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_205);
  initMetadataForClass(Somalia, 'Somalia', Somalia, VOID, [Country]);
  initMetadataForCompanion(Companion_206);
  initMetadataForClass(SouthAfrica, 'SouthAfrica', SouthAfrica, VOID, [Country]);
  initMetadataForCompanion(Companion_207);
  initMetadataForClass(SouthGeorgiaandtheSouthSandwichIslands, 'SouthGeorgiaandtheSouthSandwichIslands', SouthGeorgiaandtheSouthSandwichIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_208);
  initMetadataForClass(SouthSudan, 'SouthSudan', SouthSudan, VOID, [Country]);
  initMetadataForCompanion(Companion_209);
  initMetadataForClass(Spain, 'Spain', Spain, VOID, [Country]);
  initMetadataForCompanion(Companion_210);
  initMetadataForClass(SriLanka, 'SriLanka', SriLanka, VOID, [Country]);
  initMetadataForCompanion(Companion_211);
  initMetadataForClass(Sudan, 'Sudan', Sudan, VOID, [Country]);
  initMetadataForCompanion(Companion_212);
  initMetadataForClass(Suriname, 'Suriname', Suriname, VOID, [Country]);
  initMetadataForCompanion(Companion_213);
  initMetadataForClass(SvalbardandJanMayen, 'SvalbardandJanMayen', SvalbardandJanMayen, VOID, [Country]);
  initMetadataForCompanion(Companion_214);
  initMetadataForClass(Eswatini, 'Eswatini', Eswatini, VOID, [Country]);
  initMetadataForCompanion(Companion_215);
  initMetadataForClass(Sweden, 'Sweden', Sweden, VOID, [Country]);
  initMetadataForCompanion(Companion_216);
  initMetadataForClass(Switzerland, 'Switzerland', Switzerland, VOID, [Country]);
  initMetadataForCompanion(Companion_217);
  initMetadataForClass(SyrianArabRepublic, 'SyrianArabRepublic', SyrianArabRepublic, VOID, [Country]);
  initMetadataForCompanion(Companion_218);
  initMetadataForClass(TaiwanProvinceofChina, 'TaiwanProvinceofChina', TaiwanProvinceofChina, VOID, [Country]);
  initMetadataForCompanion(Companion_219);
  initMetadataForClass(Tajikistan, 'Tajikistan', Tajikistan, VOID, [Country]);
  initMetadataForCompanion(Companion_220);
  initMetadataForClass(TanzaniaUnitedRepublicof, 'TanzaniaUnitedRepublicof', TanzaniaUnitedRepublicof, VOID, [Country]);
  initMetadataForCompanion(Companion_221);
  initMetadataForClass(Thailand, 'Thailand', Thailand, VOID, [Country]);
  initMetadataForCompanion(Companion_222);
  initMetadataForClass(TimorLeste, 'TimorLeste', TimorLeste, VOID, [Country]);
  initMetadataForCompanion(Companion_223);
  initMetadataForClass(Togo, 'Togo', Togo, VOID, [Country]);
  initMetadataForCompanion(Companion_224);
  initMetadataForClass(Tokelau, 'Tokelau', Tokelau, VOID, [Country]);
  initMetadataForCompanion(Companion_225);
  initMetadataForClass(Tonga, 'Tonga', Tonga, VOID, [Country]);
  initMetadataForCompanion(Companion_226);
  initMetadataForClass(TrinidadandTobago, 'TrinidadandTobago', TrinidadandTobago, VOID, [Country]);
  initMetadataForCompanion(Companion_227);
  initMetadataForClass(Tunisia, 'Tunisia', Tunisia, VOID, [Country]);
  initMetadataForCompanion(Companion_228);
  initMetadataForClass(Turkey, 'Turkey', Turkey, VOID, [Country]);
  initMetadataForCompanion(Companion_229);
  initMetadataForClass(Turkmenistan, 'Turkmenistan', Turkmenistan, VOID, [Country]);
  initMetadataForCompanion(Companion_230);
  initMetadataForClass(TurksandCaicosIslands, 'TurksandCaicosIslands', TurksandCaicosIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_231);
  initMetadataForClass(Tuvalu, 'Tuvalu', Tuvalu, VOID, [Country]);
  initMetadataForCompanion(Companion_232);
  initMetadataForClass(Uganda, 'Uganda', Uganda, VOID, [Country]);
  initMetadataForCompanion(Companion_233);
  initMetadataForClass(Ukraine, 'Ukraine', Ukraine, VOID, [Country]);
  initMetadataForCompanion(Companion_234);
  initMetadataForClass(UnitedKingdomofGreatBritainandNorthernIreland, 'UnitedKingdomofGreatBritainandNorthernIreland', UnitedKingdomofGreatBritainandNorthernIreland, VOID, [Country]);
  initMetadataForCompanion(Companion_235);
  initMetadataForClass(UnitedStatesofAmerica, 'UnitedStatesofAmerica', UnitedStatesofAmerica, VOID, [Country]);
  initMetadataForCompanion(Companion_236);
  initMetadataForClass(UnitedStatesMinorOutlyingIslands, 'UnitedStatesMinorOutlyingIslands', UnitedStatesMinorOutlyingIslands, VOID, [Country]);
  initMetadataForCompanion(Companion_237);
  initMetadataForClass(Uruguay, 'Uruguay', Uruguay, VOID, [Country]);
  initMetadataForCompanion(Companion_238);
  initMetadataForClass(Uzbekistan, 'Uzbekistan', Uzbekistan, VOID, [Country]);
  initMetadataForCompanion(Companion_239);
  initMetadataForClass(Vanuatu, 'Vanuatu', Vanuatu, VOID, [Country]);
  initMetadataForCompanion(Companion_240);
  initMetadataForClass(VenezuelaBolivarianRepublicof, 'VenezuelaBolivarianRepublicof', VenezuelaBolivarianRepublicof, VOID, [Country]);
  initMetadataForCompanion(Companion_241);
  initMetadataForClass(VietNam, 'VietNam', VietNam, VOID, [Country]);
  initMetadataForCompanion(Companion_242);
  initMetadataForClass(VirginIslandsBritish, 'VirginIslandsBritish', VirginIslandsBritish, VOID, [Country]);
  initMetadataForCompanion(Companion_243);
  initMetadataForClass(VirginIslandsUS, 'VirginIslandsUS', VirginIslandsUS, VOID, [Country]);
  initMetadataForCompanion(Companion_244);
  initMetadataForClass(WallisandFutuna, 'WallisandFutuna', WallisandFutuna, VOID, [Country]);
  initMetadataForCompanion(Companion_245);
  initMetadataForClass(Yemen, 'Yemen', Yemen, VOID, [Country]);
  initMetadataForCompanion(Companion_246);
  initMetadataForClass(Zambia, 'Zambia', Zambia, VOID, [Country]);
  initMetadataForCompanion(Companion_247);
  initMetadataForClass(Zimbabwe, 'Zimbabwe', Zimbabwe, VOID, [Country]);
  initMetadataForClass(Currency, 'Currency');
  initMetadataForObject(EGP, 'EGP', VOID, Currency);
  initMetadataForObject(AED, 'AED', VOID, Currency);
  initMetadataForObject(SAR, 'SAR', VOID, Currency);
  initMetadataForObject(IQD, 'IQD', VOID, Currency);
  initMetadataForObject(USD, 'USD', VOID, Currency);
  initMetadataForObject(CTM, 'CTM', VOID, Currency);
  initMetadataForObject(KWD, 'KWD', VOID, Currency);
  initMetadataForObject(OMR, 'OMR', VOID, Currency);
  initMetadataForClass(Locale, 'Locale');
  initMetadataForObject(English, 'English', VOID, Locale);
  initMetadataForObject(Arabic, 'Arabic', VOID, Locale);
  //endregion
  function CountryProvider() {
  }
  protoOf(CountryProvider).getSupportedCountries = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new Egypt(), new UAE(), new KSA(), new TMT(), new Iraq(), new Kuwait(), new Oman()];
  };
  function CountryResolver() {
  }
  protoOf(CountryResolver).retrieveMultitenancyEnabledCountriesFromIsoCode2 = function (countryIsoCode2) {
    var egypt = new Egypt();
    var uae = new UAE();
    var ksa = new KSA();
    var tmt = new TMT();
    var iraq = new Iraq();
    var kuwait = new Kuwait();
    var oman = new Oman();
    return countryIsoCode2 === egypt.r6_1 ? egypt : countryIsoCode2 === uae.j6_1 ? uae : countryIsoCode2 === ksa.b6_1 ? ksa : countryIsoCode2 === tmt.t5_1 ? tmt : countryIsoCode2 === iraq.l5_1 ? iraq : countryIsoCode2 === kuwait.d5_1 ? kuwait : countryIsoCode2 === oman.w4_1 ? oman : egypt;
  };
  protoOf(CountryResolver).retrieveMultitenancyEnabledCountriesFromIsoCode3 = function (countryIsoCode3) {
    var egypt = new Egypt();
    var uae = new UAE();
    var ksa = new KSA();
    var tmt = new TMT();
    var iraq = new Iraq();
    var kuwait = new Kuwait();
    var oman = new Oman();
    return countryIsoCode3 === egypt.s6_1 ? egypt : countryIsoCode3 === uae.k6_1 ? uae : countryIsoCode3 === ksa.c6_1 ? ksa : countryIsoCode3 === tmt.u5_1 ? tmt : countryIsoCode3 === iraq.m5_1 ? iraq : countryIsoCode3 === kuwait.e5_1 ? kuwait : countryIsoCode3 === oman.x4_1 ? oman : egypt;
  };
  protoOf(CountryResolver).retrieveCountryFromPhonePrefix = function (phoneNumPrefix) {
    var egypt = new Egypt();
    var uae = new UAE();
    var ksa = new KSA();
    var algeria = new Algeria();
    var bahrain = new Bahrain();
    var kenya = new Kenya();
    var libya = new Libya();
    var morocco = new Morocco();
    var nigeria = new Nigeria();
    var oman = new Oman();
    var qatar = new Qatar();
    var tunisia = new Tunisia();
    var turkey = new Turkey();
    var uk = new UnitedKingdomofGreatBritainandNorthernIreland();
    var india = new India();
    var pakistan = new Pakistan();
    var bangladesh = new Bangladesh();
    var philippines = new Philippines();
    var jordan = new Jordan();
    var lebanon = new Lebanon();
    var nepal = new Nepal();
    var china = new China();
    var usa = new UnitedStatesofAmerica();
    var germany = new Germany();
    var france = new France();
    var iraq = new Iraq();
    return phoneNumPrefix === egypt.w6_1.toString() ? egypt : phoneNumPrefix === uae.o6_1.toString() ? uae : phoneNumPrefix === ksa.g6_1.toString() ? ksa : phoneNumPrefix === algeria.dd_1.toString() ? algeria : phoneNumPrefix === bahrain.vc_1.toString() ? bahrain : phoneNumPrefix === kenya.nc_1.toString() ? kenya : phoneNumPrefix === libya.fc_1.toString() ? libya : phoneNumPrefix === morocco.xb_1.toString() ? morocco : phoneNumPrefix === nigeria.pb_1.toString() ? nigeria : phoneNumPrefix === oman.v4_1.toString() ? oman : phoneNumPrefix === qatar.hb_1.toString() ? qatar : phoneNumPrefix === tunisia.za_1.toString() ? tunisia : phoneNumPrefix === turkey.ra_1.toString() ? turkey : phoneNumPrefix === uk.ja_1.toString() ? uk : phoneNumPrefix === india.ba_1.toString() ? india : phoneNumPrefix === pakistan.t9_1.toString() ? pakistan : phoneNumPrefix === bangladesh.l9_1.toString() ? bangladesh : phoneNumPrefix === philippines.d9_1.toString() ? philippines : phoneNumPrefix === jordan.v8_1.toString() ? jordan : phoneNumPrefix === lebanon.n8_1.toString() ? lebanon : phoneNumPrefix === nepal.f8_1.toString() ? nepal : phoneNumPrefix === china.x7_1.toString() ? china : phoneNumPrefix === usa.p7_1.toString() ? usa : phoneNumPrefix === germany.h7_1.toString() ? germany : phoneNumPrefix === france.z6_1.toString() ? france : phoneNumPrefix === iraq.q5_1.toString() ? iraq : egypt;
  };
  protoOf(CountryResolver).isPhoneNumberValid = function (phoneNumber) {
    return Regex_init_$Create$('(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\\s*[)]?[-\\s\\.]?[(]?[0-9]{1,3}[)]?([-\\s\\.]?[0-9]{3})([-\\s\\.]?[0-9]{3,4})').j4(phoneNumber);
  };
  var CountryResolver_instance;
  function CountryResolver_getInstance() {
    return CountryResolver_instance;
  }
  function CurrencyResolver() {
  }
  protoOf(CurrencyResolver).retrieveCurrencyFromIso4217Code = function (currencyIso4217Code) {
    return currencyIso4217Code === EGP_getInstance().iso4217Code ? EGP_getInstance() : currencyIso4217Code === AED_getInstance().iso4217Code ? AED_getInstance() : currencyIso4217Code === SAR_getInstance().iso4217Code ? SAR_getInstance() : currencyIso4217Code === CTM_getInstance().iso4217Code ? CTM_getInstance() : currencyIso4217Code === IQD_getInstance().iso4217Code ? IQD_getInstance() : currencyIso4217Code === KWD_getInstance().iso4217Code ? KWD_getInstance() : currencyIso4217Code === OMR_getInstance().iso4217Code ? OMR_getInstance() : EGP_getInstance();
  };
  var CurrencyResolver_instance;
  function CurrencyResolver_getInstance() {
    return CurrencyResolver_instance;
  }
  function sorting(_this__u8e3s4, $this, locale) {
    var tmp;
    if (locale instanceof English) {
      tmp = _this__u8e3s4.englishName;
    } else {
      if (locale instanceof Arabic) {
        tmp = _this__u8e3s4.arabicName;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.ld_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
    return this.ld_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.md(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).g1 = function () {
    return this.ld_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.g1(), other.g1());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.g1());
  };
  function GetSupportedNationalities$invoke$lambda(this$0, $locale) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.taager.country.GetSupportedNationalities.invoke.<anonymous>' call
      var tmp = sorting(a, this$0, $locale);
      // Inline function 'com.taager.country.GetSupportedNationalities.invoke.<anonymous>' call
      var tmp$ret$1 = sorting(b, this$0, $locale);
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function GetSupportedNationalities$invoke$lambda_0(this$0, $locale) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.taager.country.GetSupportedNationalities.invoke.<anonymous>' call
      var tmp = sorting(a, this$0, $locale);
      // Inline function 'com.taager.country.GetSupportedNationalities.invoke.<anonymous>' call
      var tmp$ret$1 = sorting(b, this$0, $locale);
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function GetSupportedNationalities() {
  }
  protoOf(GetSupportedNationalities).nd = function (locale) {
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = listOf([new UAE(), new Egypt(), new KSA()]);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = GetSupportedNationalities$invoke$lambda(this, locale);
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var tmp_0 = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.sortedBy' call
    var this_1 = listOf([new Afghanistan(), new AlandIslands(), new Albania(), new Algeria(), new AmericanSamoa(), new Andorra(), new Angola(), new Anguilla(), new Antarctica(), new AntiguaandBarbuda(), new Argentina(), new Armenia(), new Aruba(), new Australia(), new Austria(), new Azerbaijan(), new Bahamas(), new Bahrain(), new Bangladesh(), new Barbados(), new Belarus(), new Belgium(), new Belize(), new Benin(), new Bermuda(), new Bhutan(), new BoliviaPlurinationalStateof(), new BonaireSintEustatiusandSaba(), new BosniaandHerzegovina(), new Botswana(), new BouvetIsland(), new Brazil(), new BritishIndianOceanTerritory(), new BruneiDarussalam(), new Bulgaria(), new BurkinaFaso(), new Burundi(), new Cambodia(), new Cameroon(), new Canada(), new CaboVerde(), new CaymanIslands(), new CentralAfricanRepublic(), new Chad(), new Chile(), new China(), new ChristmasIsland(), new CocosKeelingIslands(), new Colombia(), new Comoros(), new Congo(), new CongoDemocraticRepublicofthe(), new CookIslands(), new CostaRica(), new CotedIvoire(), new Croatia(), new Cuba(), new Curacao(), new Cyprus(), new Czechia(), new Denmark(), new Djibouti(), new Dominica(), new DominicanRepublic(), new Ecuador(), new ElSalvador(), new EquatorialGuinea(), new Eritrea(), new Estonia(), new Ethiopia(), new FalklandIslandsMalvinas(), new FaroeIslands(), new Fiji(), new Finland(), new France(), new FrenchGuiana(), new FrenchPolynesia(), new FrenchSouthernTerritories(), new Gabon(), new Gambia(), new Georgia(), new Germany(), new Ghana(), new Gibraltar(), new Greece(), new Greenland(), new Grenada(), new Guadeloupe(), new Guam(), new Guatemala(), new Guernsey(), new Guinea(), new GuineaBissau(), new Guyana(), new Haiti(), new HeardIslandandMcDonaldIslands(), new HolySee(), new Honduras(), new HongKong(), new Hungary(), new Iceland(), new India(), new Indonesia(), new IranIslamicRepublicof(), new Iraq(), new Ireland(), new IsleofMan(), new Israel(), new Italy(), new Jamaica(), new Japan(), new Jersey(), new Jordan(), new Kazakhstan(), new Kenya(), new Kiribati(), new KoreaDemocraticPeoplesRepublicof(), new KoreaRepublicof(), new Kuwait(), new Kyrgyzstan(), new LaoPeoplesDemocraticRepublic(), new Latvia(), new Lebanon(), new Lesotho(), new Liberia(), new Libya(), new Liechtenstein(), new Lithuania(), new Luxembourg(), new Macao(), new NorthMacedonia(), new Madagascar(), new Malawi(), new Malaysia(), new Maldives(), new Mali(), new Malta(), new MarshallIslands(), new Martinique(), new Mauritania(), new Mauritius(), new Mayotte(), new Mexico(), new MicronesiaFederatedStatesof(), new Morocco(), new MoldovaRepublicof(), new Monaco(), new Mongolia(), new Montenegro(), new Montserrat(), new Mozambique(), new Myanmar(), new Namibia(), new Nauru(), new Nepal(), new Netherlands(), new NewCaledonia(), new NewZealand(), new Nicaragua(), new Niger(), new Nigeria(), new Niue(), new NorfolkIsland(), new NorthernMarianaIslands(), new Norway(), new Oman(), new Pakistan(), new Palau(), new PalestineStateof(), new Panama(), new PapuaNewGuinea(), new Paraguay(), new Peru(), new Philippines(), new Pitcairn(), new Poland(), new Portugal(), new PuertoRico(), new Qatar(), new Reunion(), new Romania(), new RussianFederation(), new Rwanda(), new SaintBarthelemy(), new SaintHelenaAscensionandTristandaCunha(), new SaintKittsandNevis(), new SaintLucia(), new SaintMartinFrenchpart(), new SaintPierreandMiquelon(), new SaintVincentandtheGrenadines(), new Samoa(), new SanMarino(), new SaoTomeandPrincipe(), new Senegal(), new Serbia(), new Seychelles(), new SierraLeone(), new Singapore(), new SintMaartenDutchpart(), new Slovakia(), new Slovenia(), new SolomonIslands(), new Somalia(), new SouthAfrica(), new SouthGeorgiaandtheSouthSandwichIslands(), new SouthSudan(), new Spain(), new SriLanka(), new Sudan(), new Suriname(), new SvalbardandJanMayen(), new Eswatini(), new Sweden(), new Switzerland(), new SyrianArabRepublic(), new TaiwanProvinceofChina(), new Tajikistan(), new TanzaniaUnitedRepublicof(), new Thailand(), new TimorLeste(), new Togo(), new Tokelau(), new Tonga(), new TrinidadandTobago(), new Tunisia(), new Turkey(), new Turkmenistan(), new TurksandCaicosIslands(), new Tuvalu(), new Uganda(), new Ukraine(), new UnitedKingdomofGreatBritainandNorthernIreland(), new UnitedStatesofAmerica(), new UnitedStatesMinorOutlyingIslands(), new Uruguay(), new Uzbekistan(), new Vanuatu(), new VenezuelaBolivarianRepublicof(), new VietNam(), new VirginIslandsBritish(), new VirginIslandsUS(), new WallisandFutuna(), new Yemen(), new Zambia(), new Zimbabwe()]);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = GetSupportedNationalities$invoke$lambda_0(this, locale);
    var tmp$ret$2 = new sam$kotlin_Comparator$0(tmp_1);
    var tmp$ret$3 = sortedWith(this_1, tmp$ret$2);
    return plus(tmp_0, tmp$ret$3);
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this.od_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).md = function (a, b) {
    return this.od_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.md(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).g1 = function () {
    return this.od_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.g1(), other.g1());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.g1());
  };
  function GetSupportedPhoneCountriesUseCase$invoke$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.taager.country.GetSupportedPhoneCountriesUseCase.invoke.stub_for_inlining' call
    var tmp = a.phoneNumPrefix;
    // Inline function 'com.taager.country.GetSupportedPhoneCountriesUseCase.invoke.stub_for_inlining' call
    var tmp$ret$1 = b.phoneNumPrefix;
    return compareValues(tmp, tmp$ret$1);
  }
  function GetSupportedPhoneCountriesUseCase() {
    this.pd_1 = listOf([new India(), new Bangladesh(), new Philippines(), new Nepal(), new China(), new UnitedStatesofAmerica(), new UnitedKingdomofGreatBritainandNorthernIreland(), new Libya(), new Kenya(), new Nigeria()]);
  }
  protoOf(GetSupportedPhoneCountriesUseCase).qd = function (ignoreUncoveredCountries) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = listOf([new Algeria(), new Bahrain(), new Kenya(), new Libya(), new Morocco(), new Nigeria(), new Oman(), new Qatar(), new KSA(), new Tunisia(), new Turkey(), new UAE(), new UnitedKingdomofGreatBritainandNorthernIreland(), new Egypt(), new India(), new Pakistan(), new Bangladesh(), new Philippines(), new Jordan(), new Lebanon(), new Nepal(), new China(), new UnitedStatesofAmerica(), new Germany(), new France(), new Iraq()]);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.e();
    while (_iterator__ex2g4s.f()) {
      var element = _iterator__ex2g4s.g();
      // Inline function 'com.taager.country.GetSupportedPhoneCountriesUseCase.invoke.<anonymous>' call
      if (!element.phoneNumPrefix.equals(new Long(0, 0))) {
        destination.c(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = GetSupportedPhoneCountriesUseCase$invoke$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0_0(tmp);
    var allSupportedCountries = sortedWith(destination, tmp$ret$3);
    var tmp_0;
    if (ignoreUncoveredCountries) {
      tmp_0 = toList(subtract(allSupportedCountries, this.pd_1));
    } else {
      tmp_0 = allSupportedCountries;
    }
    return tmp_0;
  };
  function Country() {
  }
  function Companion() {
  }
  protoOf(Companion).instantiate = function () {
    return new Egypt();
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function Egypt(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    isoCode2 = isoCode2 === VOID ? 'EG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'EGY' : isoCode3;
    currency = currency === VOID ? EGP_getInstance() : currency;
    englishName = englishName === VOID ? 'Egypt' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0635\u0631' : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(20, 0) : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? '^(00201|201|\\+201|01|1)[0125][0-9]{8}$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '201001234567' : phoneNumberHint;
    this.r6_1 = isoCode2;
    this.s6_1 = isoCode3;
    this.t6_1 = currency;
    this.u6_1 = englishName;
    this.v6_1 = arabicName;
    this.w6_1 = phoneNumPrefix;
    this.x6_1 = phoneRegex;
    this.y6_1 = phoneNumberHint;
  }
  protoOf(Egypt).rd = function () {
    return this.r6_1;
  };
  protoOf(Egypt).sd = function () {
    return this.s6_1;
  };
  protoOf(Egypt).td = function () {
    return this.t6_1;
  };
  protoOf(Egypt).ud = function () {
    return this.u6_1;
  };
  protoOf(Egypt).vd = function () {
    return this.v6_1;
  };
  protoOf(Egypt).wd = function () {
    return this.w6_1;
  };
  protoOf(Egypt).xd = function () {
    return this.x6_1;
  };
  protoOf(Egypt).yd = function () {
    return this.y6_1;
  };
  protoOf(Egypt).ae = function () {
    return this.r6_1;
  };
  protoOf(Egypt).be = function () {
    return this.s6_1;
  };
  protoOf(Egypt).ce = function () {
    return this.t6_1;
  };
  protoOf(Egypt).de = function () {
    return this.u6_1;
  };
  protoOf(Egypt).ee = function () {
    return this.v6_1;
  };
  protoOf(Egypt).fe = function () {
    return this.w6_1;
  };
  protoOf(Egypt).ge = function () {
    return this.x6_1;
  };
  protoOf(Egypt).he = function () {
    return this.y6_1;
  };
  protoOf(Egypt).ie = function (isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    return new Egypt(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint);
  };
  protoOf(Egypt).copy = function (isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint, $super) {
    isoCode2 = isoCode2 === VOID ? this.r6_1 : isoCode2;
    isoCode3 = isoCode3 === VOID ? this.s6_1 : isoCode3;
    currency = currency === VOID ? this.t6_1 : currency;
    englishName = englishName === VOID ? this.u6_1 : englishName;
    arabicName = arabicName === VOID ? this.v6_1 : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? this.w6_1 : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? this.x6_1 : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? this.y6_1 : phoneNumberHint;
    return this.ie(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint);
  };
  protoOf(Egypt).toString = function () {
    return 'Egypt(isoCode2=' + this.r6_1 + ', isoCode3=' + this.s6_1 + ', currency=' + toString(this.t6_1) + ', englishName=' + this.u6_1 + ', arabicName=' + this.v6_1 + ', phoneNumPrefix=' + this.w6_1.toString() + ', phoneRegex=' + this.x6_1 + ', phoneNumberHint=' + this.y6_1 + ')';
  };
  protoOf(Egypt).hashCode = function () {
    var result = getStringHashCode(this.r6_1);
    result = imul(result, 31) + getStringHashCode(this.s6_1) | 0;
    result = imul(result, 31) + hashCode(this.t6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v6_1) | 0;
    result = imul(result, 31) + this.w6_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.x6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y6_1) | 0;
    return result;
  };
  protoOf(Egypt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Egypt))
      return false;
    var tmp0_other_with_cast = other instanceof Egypt ? other : THROW_CCE();
    if (!(this.r6_1 === tmp0_other_with_cast.r6_1))
      return false;
    if (!(this.s6_1 === tmp0_other_with_cast.s6_1))
      return false;
    if (!equals(this.t6_1, tmp0_other_with_cast.t6_1))
      return false;
    if (!(this.u6_1 === tmp0_other_with_cast.u6_1))
      return false;
    if (!(this.v6_1 === tmp0_other_with_cast.v6_1))
      return false;
    if (!this.w6_1.equals(tmp0_other_with_cast.w6_1))
      return false;
    if (!(this.x6_1 === tmp0_other_with_cast.x6_1))
      return false;
    if (!(this.y6_1 === tmp0_other_with_cast.y6_1))
      return false;
    return true;
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function UAE(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    isoCode2 = isoCode2 === VOID ? 'AE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ARE' : isoCode3;
    currency = currency === VOID ? AED_getInstance() : currency;
    englishName = englishName === VOID ? 'United Arab Emirates' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629' : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(971, 0) : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? '^(009715|9715|\\+9715|05|5)[024568]([0-9]{7})$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '971501234567' : phoneNumberHint;
    this.j6_1 = isoCode2;
    this.k6_1 = isoCode3;
    this.l6_1 = currency;
    this.m6_1 = englishName;
    this.n6_1 = arabicName;
    this.o6_1 = phoneNumPrefix;
    this.p6_1 = phoneRegex;
    this.q6_1 = phoneNumberHint;
  }
  protoOf(UAE).rd = function () {
    return this.j6_1;
  };
  protoOf(UAE).sd = function () {
    return this.k6_1;
  };
  protoOf(UAE).td = function () {
    return this.l6_1;
  };
  protoOf(UAE).ud = function () {
    return this.m6_1;
  };
  protoOf(UAE).vd = function () {
    return this.n6_1;
  };
  protoOf(UAE).wd = function () {
    return this.o6_1;
  };
  protoOf(UAE).xd = function () {
    return this.p6_1;
  };
  protoOf(UAE).yd = function () {
    return this.q6_1;
  };
  protoOf(UAE).toString = function () {
    return 'UAE(isoCode2=' + this.j6_1 + ', isoCode3=' + this.k6_1 + ', currency=' + toString(this.l6_1) + ', englishName=' + this.m6_1 + ', arabicName=' + this.n6_1 + ', phoneNumPrefix=' + this.o6_1.toString() + ', phoneRegex=' + this.p6_1 + ', phoneNumberHint=' + this.q6_1 + ')';
  };
  protoOf(UAE).hashCode = function () {
    var result = getStringHashCode(this.j6_1);
    result = imul(result, 31) + getStringHashCode(this.k6_1) | 0;
    result = imul(result, 31) + hashCode(this.l6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n6_1) | 0;
    result = imul(result, 31) + this.o6_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.p6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q6_1) | 0;
    return result;
  };
  protoOf(UAE).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UAE))
      return false;
    var tmp0_other_with_cast = other instanceof UAE ? other : THROW_CCE();
    if (!(this.j6_1 === tmp0_other_with_cast.j6_1))
      return false;
    if (!(this.k6_1 === tmp0_other_with_cast.k6_1))
      return false;
    if (!equals(this.l6_1, tmp0_other_with_cast.l6_1))
      return false;
    if (!(this.m6_1 === tmp0_other_with_cast.m6_1))
      return false;
    if (!(this.n6_1 === tmp0_other_with_cast.n6_1))
      return false;
    if (!this.o6_1.equals(tmp0_other_with_cast.o6_1))
      return false;
    if (!(this.p6_1 === tmp0_other_with_cast.p6_1))
      return false;
    if (!(this.q6_1 === tmp0_other_with_cast.q6_1))
      return false;
    return true;
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function KSA(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    isoCode2 = isoCode2 === VOID ? 'SA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SAU' : isoCode3;
    currency = currency === VOID ? SAR_getInstance() : currency;
    englishName = englishName === VOID ? 'Kingdom of Saudi Arabia' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629' : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(966, 0) : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? '^(009665|9665|\\+9665|05|5)[503649187]([0-9]{7})$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '966512345678' : phoneNumberHint;
    this.b6_1 = isoCode2;
    this.c6_1 = isoCode3;
    this.d6_1 = currency;
    this.e6_1 = englishName;
    this.f6_1 = arabicName;
    this.g6_1 = phoneNumPrefix;
    this.h6_1 = phoneRegex;
    this.i6_1 = phoneNumberHint;
  }
  protoOf(KSA).rd = function () {
    return this.b6_1;
  };
  protoOf(KSA).sd = function () {
    return this.c6_1;
  };
  protoOf(KSA).td = function () {
    return this.d6_1;
  };
  protoOf(KSA).ud = function () {
    return this.e6_1;
  };
  protoOf(KSA).vd = function () {
    return this.f6_1;
  };
  protoOf(KSA).wd = function () {
    return this.g6_1;
  };
  protoOf(KSA).xd = function () {
    return this.h6_1;
  };
  protoOf(KSA).yd = function () {
    return this.i6_1;
  };
  protoOf(KSA).toString = function () {
    return 'KSA(isoCode2=' + this.b6_1 + ', isoCode3=' + this.c6_1 + ', currency=' + toString(this.d6_1) + ', englishName=' + this.e6_1 + ', arabicName=' + this.f6_1 + ', phoneNumPrefix=' + this.g6_1.toString() + ', phoneRegex=' + this.h6_1 + ', phoneNumberHint=' + this.i6_1 + ')';
  };
  protoOf(KSA).hashCode = function () {
    var result = getStringHashCode(this.b6_1);
    result = imul(result, 31) + getStringHashCode(this.c6_1) | 0;
    result = imul(result, 31) + hashCode(this.d6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f6_1) | 0;
    result = imul(result, 31) + this.g6_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.h6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i6_1) | 0;
    return result;
  };
  protoOf(KSA).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KSA))
      return false;
    var tmp0_other_with_cast = other instanceof KSA ? other : THROW_CCE();
    if (!(this.b6_1 === tmp0_other_with_cast.b6_1))
      return false;
    if (!(this.c6_1 === tmp0_other_with_cast.c6_1))
      return false;
    if (!equals(this.d6_1, tmp0_other_with_cast.d6_1))
      return false;
    if (!(this.e6_1 === tmp0_other_with_cast.e6_1))
      return false;
    if (!(this.f6_1 === tmp0_other_with_cast.f6_1))
      return false;
    if (!this.g6_1.equals(tmp0_other_with_cast.g6_1))
      return false;
    if (!(this.h6_1 === tmp0_other_with_cast.h6_1))
      return false;
    if (!(this.i6_1 === tmp0_other_with_cast.i6_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function TMT(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    isoCode2 = isoCode2 === VOID ? 'TT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TMT' : isoCode3;
    currency = currency === VOID ? CTM_getInstance() : currency;
    englishName = englishName === VOID ? 'Testing' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A' : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? '^00([0-9]{7})$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '001234567' : phoneNumberHint;
    this.t5_1 = isoCode2;
    this.u5_1 = isoCode3;
    this.v5_1 = currency;
    this.w5_1 = englishName;
    this.x5_1 = arabicName;
    this.y5_1 = phoneNumPrefix;
    this.z5_1 = phoneRegex;
    this.a6_1 = phoneNumberHint;
  }
  protoOf(TMT).rd = function () {
    return this.t5_1;
  };
  protoOf(TMT).sd = function () {
    return this.u5_1;
  };
  protoOf(TMT).td = function () {
    return this.v5_1;
  };
  protoOf(TMT).ud = function () {
    return this.w5_1;
  };
  protoOf(TMT).vd = function () {
    return this.x5_1;
  };
  protoOf(TMT).wd = function () {
    return this.y5_1;
  };
  protoOf(TMT).xd = function () {
    return this.z5_1;
  };
  protoOf(TMT).yd = function () {
    return this.a6_1;
  };
  protoOf(TMT).toString = function () {
    return 'TMT(isoCode2=' + this.t5_1 + ', isoCode3=' + this.u5_1 + ', currency=' + toString(this.v5_1) + ', englishName=' + this.w5_1 + ', arabicName=' + this.x5_1 + ', phoneNumPrefix=' + this.y5_1.toString() + ', phoneRegex=' + this.z5_1 + ', phoneNumberHint=' + this.a6_1 + ')';
  };
  protoOf(TMT).hashCode = function () {
    var result = getStringHashCode(this.t5_1);
    result = imul(result, 31) + getStringHashCode(this.u5_1) | 0;
    result = imul(result, 31) + hashCode(this.v5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x5_1) | 0;
    result = imul(result, 31) + this.y5_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.z5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a6_1) | 0;
    return result;
  };
  protoOf(TMT).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TMT))
      return false;
    var tmp0_other_with_cast = other instanceof TMT ? other : THROW_CCE();
    if (!(this.t5_1 === tmp0_other_with_cast.t5_1))
      return false;
    if (!(this.u5_1 === tmp0_other_with_cast.u5_1))
      return false;
    if (!equals(this.v5_1, tmp0_other_with_cast.v5_1))
      return false;
    if (!(this.w5_1 === tmp0_other_with_cast.w5_1))
      return false;
    if (!(this.x5_1 === tmp0_other_with_cast.x5_1))
      return false;
    if (!this.y5_1.equals(tmp0_other_with_cast.y5_1))
      return false;
    if (!(this.z5_1 === tmp0_other_with_cast.z5_1))
      return false;
    if (!(this.a6_1 === tmp0_other_with_cast.a6_1))
      return false;
    return true;
  };
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function Afghanistan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AFG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Afghanistan' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.je_1 = phoneNumPrefix;
    this.ke_1 = isoCode2;
    this.le_1 = isoCode3;
    this.me_1 = currency;
    this.ne_1 = englishName;
    this.oe_1 = arabicName;
    this.pe_1 = phoneRegex;
  }
  protoOf(Afghanistan).wd = function () {
    return this.je_1;
  };
  protoOf(Afghanistan).rd = function () {
    return this.ke_1;
  };
  protoOf(Afghanistan).sd = function () {
    return this.le_1;
  };
  protoOf(Afghanistan).td = function () {
    return this.me_1;
  };
  protoOf(Afghanistan).ud = function () {
    return this.ne_1;
  };
  protoOf(Afghanistan).vd = function () {
    return this.oe_1;
  };
  protoOf(Afghanistan).xd = function () {
    return this.pe_1;
  };
  protoOf(Afghanistan).toString = function () {
    return 'Afghanistan(phoneNumPrefix=' + this.je_1.toString() + ', isoCode2=' + this.ke_1 + ', isoCode3=' + this.le_1 + ', currency=' + toString(this.me_1) + ', englishName=' + this.ne_1 + ', arabicName=' + this.oe_1 + ', phoneRegex=' + this.pe_1 + ')';
  };
  protoOf(Afghanistan).hashCode = function () {
    var result = this.je_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ke_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.le_1) | 0;
    result = imul(result, 31) + hashCode(this.me_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ne_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oe_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pe_1) | 0;
    return result;
  };
  protoOf(Afghanistan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Afghanistan))
      return false;
    var tmp0_other_with_cast = other instanceof Afghanistan ? other : THROW_CCE();
    if (!this.je_1.equals(tmp0_other_with_cast.je_1))
      return false;
    if (!(this.ke_1 === tmp0_other_with_cast.ke_1))
      return false;
    if (!(this.le_1 === tmp0_other_with_cast.le_1))
      return false;
    if (!equals(this.me_1, tmp0_other_with_cast.me_1))
      return false;
    if (!(this.ne_1 === tmp0_other_with_cast.ne_1))
      return false;
    if (!(this.oe_1 === tmp0_other_with_cast.oe_1))
      return false;
    if (!(this.pe_1 === tmp0_other_with_cast.pe_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function AlandIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AX' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ALA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? '\xC5land Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0623\u0648\u0644\u0627\u0646\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.qe_1 = phoneNumPrefix;
    this.re_1 = isoCode2;
    this.se_1 = isoCode3;
    this.te_1 = currency;
    this.ue_1 = englishName;
    this.ve_1 = arabicName;
    this.we_1 = phoneRegex;
  }
  protoOf(AlandIslands).wd = function () {
    return this.qe_1;
  };
  protoOf(AlandIslands).rd = function () {
    return this.re_1;
  };
  protoOf(AlandIslands).sd = function () {
    return this.se_1;
  };
  protoOf(AlandIslands).td = function () {
    return this.te_1;
  };
  protoOf(AlandIslands).ud = function () {
    return this.ue_1;
  };
  protoOf(AlandIslands).vd = function () {
    return this.ve_1;
  };
  protoOf(AlandIslands).xd = function () {
    return this.we_1;
  };
  protoOf(AlandIslands).toString = function () {
    return 'AlandIslands(phoneNumPrefix=' + this.qe_1.toString() + ', isoCode2=' + this.re_1 + ', isoCode3=' + this.se_1 + ', currency=' + toString(this.te_1) + ', englishName=' + this.ue_1 + ', arabicName=' + this.ve_1 + ', phoneRegex=' + this.we_1 + ')';
  };
  protoOf(AlandIslands).hashCode = function () {
    var result = this.qe_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.re_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.se_1) | 0;
    result = imul(result, 31) + hashCode(this.te_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ue_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ve_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.we_1) | 0;
    return result;
  };
  protoOf(AlandIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AlandIslands))
      return false;
    var tmp0_other_with_cast = other instanceof AlandIslands ? other : THROW_CCE();
    if (!this.qe_1.equals(tmp0_other_with_cast.qe_1))
      return false;
    if (!(this.re_1 === tmp0_other_with_cast.re_1))
      return false;
    if (!(this.se_1 === tmp0_other_with_cast.se_1))
      return false;
    if (!equals(this.te_1, tmp0_other_with_cast.te_1))
      return false;
    if (!(this.ue_1 === tmp0_other_with_cast.ue_1))
      return false;
    if (!(this.ve_1 === tmp0_other_with_cast.ve_1))
      return false;
    if (!(this.we_1 === tmp0_other_with_cast.we_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function Albania(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ALB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Albania' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0644\u0628\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.xe_1 = phoneNumPrefix;
    this.ye_1 = isoCode2;
    this.ze_1 = isoCode3;
    this.af_1 = currency;
    this.bf_1 = englishName;
    this.cf_1 = arabicName;
    this.df_1 = phoneRegex;
  }
  protoOf(Albania).wd = function () {
    return this.xe_1;
  };
  protoOf(Albania).rd = function () {
    return this.ye_1;
  };
  protoOf(Albania).sd = function () {
    return this.ze_1;
  };
  protoOf(Albania).td = function () {
    return this.af_1;
  };
  protoOf(Albania).ud = function () {
    return this.bf_1;
  };
  protoOf(Albania).vd = function () {
    return this.cf_1;
  };
  protoOf(Albania).xd = function () {
    return this.df_1;
  };
  protoOf(Albania).toString = function () {
    return 'Albania(phoneNumPrefix=' + this.xe_1.toString() + ', isoCode2=' + this.ye_1 + ', isoCode3=' + this.ze_1 + ', currency=' + toString(this.af_1) + ', englishName=' + this.bf_1 + ', arabicName=' + this.cf_1 + ', phoneRegex=' + this.df_1 + ')';
  };
  protoOf(Albania).hashCode = function () {
    var result = this.xe_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ye_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ze_1) | 0;
    result = imul(result, 31) + hashCode(this.af_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.df_1) | 0;
    return result;
  };
  protoOf(Albania).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Albania))
      return false;
    var tmp0_other_with_cast = other instanceof Albania ? other : THROW_CCE();
    if (!this.xe_1.equals(tmp0_other_with_cast.xe_1))
      return false;
    if (!(this.ye_1 === tmp0_other_with_cast.ye_1))
      return false;
    if (!(this.ze_1 === tmp0_other_with_cast.ze_1))
      return false;
    if (!equals(this.af_1, tmp0_other_with_cast.af_1))
      return false;
    if (!(this.bf_1 === tmp0_other_with_cast.bf_1))
      return false;
    if (!(this.cf_1 === tmp0_other_with_cast.cf_1))
      return false;
    if (!(this.df_1 === tmp0_other_with_cast.df_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function Algeria(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(213, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'DZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'DZA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Algeria' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u062C\u0632\u0627\u0626\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(9) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '551234567' : phoneNumberHint;
    this.dd_1 = phoneNumPrefix;
    this.ed_1 = isoCode2;
    this.fd_1 = isoCode3;
    this.gd_1 = currency;
    this.hd_1 = englishName;
    this.id_1 = arabicName;
    this.jd_1 = phoneRegex;
    this.kd_1 = phoneNumberHint;
  }
  protoOf(Algeria).wd = function () {
    return this.dd_1;
  };
  protoOf(Algeria).rd = function () {
    return this.ed_1;
  };
  protoOf(Algeria).sd = function () {
    return this.fd_1;
  };
  protoOf(Algeria).td = function () {
    return this.gd_1;
  };
  protoOf(Algeria).ud = function () {
    return this.hd_1;
  };
  protoOf(Algeria).vd = function () {
    return this.id_1;
  };
  protoOf(Algeria).xd = function () {
    return this.jd_1;
  };
  protoOf(Algeria).yd = function () {
    return this.kd_1;
  };
  protoOf(Algeria).toString = function () {
    return 'Algeria(phoneNumPrefix=' + this.dd_1.toString() + ', isoCode2=' + this.ed_1 + ', isoCode3=' + this.fd_1 + ', currency=' + toString(this.gd_1) + ', englishName=' + this.hd_1 + ', arabicName=' + this.id_1 + ', phoneRegex=' + this.jd_1 + ', phoneNumberHint=' + this.kd_1 + ')';
  };
  protoOf(Algeria).hashCode = function () {
    var result = this.dd_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ed_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fd_1) | 0;
    result = imul(result, 31) + hashCode(this.gd_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hd_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.id_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jd_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kd_1) | 0;
    return result;
  };
  protoOf(Algeria).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Algeria))
      return false;
    var tmp0_other_with_cast = other instanceof Algeria ? other : THROW_CCE();
    if (!this.dd_1.equals(tmp0_other_with_cast.dd_1))
      return false;
    if (!(this.ed_1 === tmp0_other_with_cast.ed_1))
      return false;
    if (!(this.fd_1 === tmp0_other_with_cast.fd_1))
      return false;
    if (!equals(this.gd_1, tmp0_other_with_cast.gd_1))
      return false;
    if (!(this.hd_1 === tmp0_other_with_cast.hd_1))
      return false;
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.jd_1 === tmp0_other_with_cast.jd_1))
      return false;
    if (!(this.kd_1 === tmp0_other_with_cast.kd_1))
      return false;
    return true;
  };
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function AmericanSamoa(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ASM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'American Samoa' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0645\u0648\u0627 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ef_1 = phoneNumPrefix;
    this.ff_1 = isoCode2;
    this.gf_1 = isoCode3;
    this.hf_1 = currency;
    this.if_1 = englishName;
    this.jf_1 = arabicName;
    this.kf_1 = phoneRegex;
  }
  protoOf(AmericanSamoa).wd = function () {
    return this.ef_1;
  };
  protoOf(AmericanSamoa).rd = function () {
    return this.ff_1;
  };
  protoOf(AmericanSamoa).sd = function () {
    return this.gf_1;
  };
  protoOf(AmericanSamoa).td = function () {
    return this.hf_1;
  };
  protoOf(AmericanSamoa).ud = function () {
    return this.if_1;
  };
  protoOf(AmericanSamoa).vd = function () {
    return this.jf_1;
  };
  protoOf(AmericanSamoa).xd = function () {
    return this.kf_1;
  };
  protoOf(AmericanSamoa).toString = function () {
    return 'AmericanSamoa(phoneNumPrefix=' + this.ef_1.toString() + ', isoCode2=' + this.ff_1 + ', isoCode3=' + this.gf_1 + ', currency=' + toString(this.hf_1) + ', englishName=' + this.if_1 + ', arabicName=' + this.jf_1 + ', phoneRegex=' + this.kf_1 + ')';
  };
  protoOf(AmericanSamoa).hashCode = function () {
    var result = this.ef_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ff_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gf_1) | 0;
    result = imul(result, 31) + hashCode(this.hf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.if_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kf_1) | 0;
    return result;
  };
  protoOf(AmericanSamoa).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AmericanSamoa))
      return false;
    var tmp0_other_with_cast = other instanceof AmericanSamoa ? other : THROW_CCE();
    if (!this.ef_1.equals(tmp0_other_with_cast.ef_1))
      return false;
    if (!(this.ff_1 === tmp0_other_with_cast.ff_1))
      return false;
    if (!(this.gf_1 === tmp0_other_with_cast.gf_1))
      return false;
    if (!equals(this.hf_1, tmp0_other_with_cast.hf_1))
      return false;
    if (!(this.if_1 === tmp0_other_with_cast.if_1))
      return false;
    if (!(this.jf_1 === tmp0_other_with_cast.jf_1))
      return false;
    if (!(this.kf_1 === tmp0_other_with_cast.kf_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function Andorra(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AND' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Andorra' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0646\u062F\u0648\u0631\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.lf_1 = phoneNumPrefix;
    this.mf_1 = isoCode2;
    this.nf_1 = isoCode3;
    this.of_1 = currency;
    this.pf_1 = englishName;
    this.qf_1 = arabicName;
    this.rf_1 = phoneRegex;
  }
  protoOf(Andorra).wd = function () {
    return this.lf_1;
  };
  protoOf(Andorra).rd = function () {
    return this.mf_1;
  };
  protoOf(Andorra).sd = function () {
    return this.nf_1;
  };
  protoOf(Andorra).td = function () {
    return this.of_1;
  };
  protoOf(Andorra).ud = function () {
    return this.pf_1;
  };
  protoOf(Andorra).vd = function () {
    return this.qf_1;
  };
  protoOf(Andorra).xd = function () {
    return this.rf_1;
  };
  protoOf(Andorra).toString = function () {
    return 'Andorra(phoneNumPrefix=' + this.lf_1.toString() + ', isoCode2=' + this.mf_1 + ', isoCode3=' + this.nf_1 + ', currency=' + toString(this.of_1) + ', englishName=' + this.pf_1 + ', arabicName=' + this.qf_1 + ', phoneRegex=' + this.rf_1 + ')';
  };
  protoOf(Andorra).hashCode = function () {
    var result = this.lf_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.mf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nf_1) | 0;
    result = imul(result, 31) + hashCode(this.of_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rf_1) | 0;
    return result;
  };
  protoOf(Andorra).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Andorra))
      return false;
    var tmp0_other_with_cast = other instanceof Andorra ? other : THROW_CCE();
    if (!this.lf_1.equals(tmp0_other_with_cast.lf_1))
      return false;
    if (!(this.mf_1 === tmp0_other_with_cast.mf_1))
      return false;
    if (!(this.nf_1 === tmp0_other_with_cast.nf_1))
      return false;
    if (!equals(this.of_1, tmp0_other_with_cast.of_1))
      return false;
    if (!(this.pf_1 === tmp0_other_with_cast.pf_1))
      return false;
    if (!(this.qf_1 === tmp0_other_with_cast.qf_1))
      return false;
    if (!(this.rf_1 === tmp0_other_with_cast.rf_1))
      return false;
    return true;
  };
  function Companion_9() {
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    return Companion_instance_9;
  }
  function Angola(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AGO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Angola' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0646\u063A\u0648\u0644\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.sf_1 = phoneNumPrefix;
    this.tf_1 = isoCode2;
    this.uf_1 = isoCode3;
    this.vf_1 = currency;
    this.wf_1 = englishName;
    this.xf_1 = arabicName;
    this.yf_1 = phoneRegex;
  }
  protoOf(Angola).wd = function () {
    return this.sf_1;
  };
  protoOf(Angola).rd = function () {
    return this.tf_1;
  };
  protoOf(Angola).sd = function () {
    return this.uf_1;
  };
  protoOf(Angola).td = function () {
    return this.vf_1;
  };
  protoOf(Angola).ud = function () {
    return this.wf_1;
  };
  protoOf(Angola).vd = function () {
    return this.xf_1;
  };
  protoOf(Angola).xd = function () {
    return this.yf_1;
  };
  protoOf(Angola).toString = function () {
    return 'Angola(phoneNumPrefix=' + this.sf_1.toString() + ', isoCode2=' + this.tf_1 + ', isoCode3=' + this.uf_1 + ', currency=' + toString(this.vf_1) + ', englishName=' + this.wf_1 + ', arabicName=' + this.xf_1 + ', phoneRegex=' + this.yf_1 + ')';
  };
  protoOf(Angola).hashCode = function () {
    var result = this.sf_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.tf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uf_1) | 0;
    result = imul(result, 31) + hashCode(this.vf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yf_1) | 0;
    return result;
  };
  protoOf(Angola).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Angola))
      return false;
    var tmp0_other_with_cast = other instanceof Angola ? other : THROW_CCE();
    if (!this.sf_1.equals(tmp0_other_with_cast.sf_1))
      return false;
    if (!(this.tf_1 === tmp0_other_with_cast.tf_1))
      return false;
    if (!(this.uf_1 === tmp0_other_with_cast.uf_1))
      return false;
    if (!equals(this.vf_1, tmp0_other_with_cast.vf_1))
      return false;
    if (!(this.wf_1 === tmp0_other_with_cast.wf_1))
      return false;
    if (!(this.xf_1 === tmp0_other_with_cast.xf_1))
      return false;
    if (!(this.yf_1 === tmp0_other_with_cast.yf_1))
      return false;
    return true;
  };
  function Companion_10() {
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    return Companion_instance_10;
  }
  function Anguilla(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AIA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Anguilla' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0646\u063A\u0648\u064A\u0644\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.zf_1 = phoneNumPrefix;
    this.ag_1 = isoCode2;
    this.bg_1 = isoCode3;
    this.cg_1 = currency;
    this.dg_1 = englishName;
    this.eg_1 = arabicName;
    this.fg_1 = phoneRegex;
  }
  protoOf(Anguilla).wd = function () {
    return this.zf_1;
  };
  protoOf(Anguilla).rd = function () {
    return this.ag_1;
  };
  protoOf(Anguilla).sd = function () {
    return this.bg_1;
  };
  protoOf(Anguilla).td = function () {
    return this.cg_1;
  };
  protoOf(Anguilla).ud = function () {
    return this.dg_1;
  };
  protoOf(Anguilla).vd = function () {
    return this.eg_1;
  };
  protoOf(Anguilla).xd = function () {
    return this.fg_1;
  };
  protoOf(Anguilla).toString = function () {
    return 'Anguilla(phoneNumPrefix=' + this.zf_1.toString() + ', isoCode2=' + this.ag_1 + ', isoCode3=' + this.bg_1 + ', currency=' + toString(this.cg_1) + ', englishName=' + this.dg_1 + ', arabicName=' + this.eg_1 + ', phoneRegex=' + this.fg_1 + ')';
  };
  protoOf(Anguilla).hashCode = function () {
    var result = this.zf_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ag_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bg_1) | 0;
    result = imul(result, 31) + hashCode(this.cg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.eg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fg_1) | 0;
    return result;
  };
  protoOf(Anguilla).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Anguilla))
      return false;
    var tmp0_other_with_cast = other instanceof Anguilla ? other : THROW_CCE();
    if (!this.zf_1.equals(tmp0_other_with_cast.zf_1))
      return false;
    if (!(this.ag_1 === tmp0_other_with_cast.ag_1))
      return false;
    if (!(this.bg_1 === tmp0_other_with_cast.bg_1))
      return false;
    if (!equals(this.cg_1, tmp0_other_with_cast.cg_1))
      return false;
    if (!(this.dg_1 === tmp0_other_with_cast.dg_1))
      return false;
    if (!(this.eg_1 === tmp0_other_with_cast.eg_1))
      return false;
    if (!(this.fg_1 === tmp0_other_with_cast.fg_1))
      return false;
    return true;
  };
  function Companion_11() {
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    return Companion_instance_11;
  }
  function Antarctica(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AQ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ATA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Antarctica' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0642\u0627\u0631\u0629 \u0627\u0644\u0642\u0637\u0628\u064A\u0629 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.gg_1 = phoneNumPrefix;
    this.hg_1 = isoCode2;
    this.ig_1 = isoCode3;
    this.jg_1 = currency;
    this.kg_1 = englishName;
    this.lg_1 = arabicName;
    this.mg_1 = phoneRegex;
  }
  protoOf(Antarctica).wd = function () {
    return this.gg_1;
  };
  protoOf(Antarctica).rd = function () {
    return this.hg_1;
  };
  protoOf(Antarctica).sd = function () {
    return this.ig_1;
  };
  protoOf(Antarctica).td = function () {
    return this.jg_1;
  };
  protoOf(Antarctica).ud = function () {
    return this.kg_1;
  };
  protoOf(Antarctica).vd = function () {
    return this.lg_1;
  };
  protoOf(Antarctica).xd = function () {
    return this.mg_1;
  };
  protoOf(Antarctica).toString = function () {
    return 'Antarctica(phoneNumPrefix=' + this.gg_1.toString() + ', isoCode2=' + this.hg_1 + ', isoCode3=' + this.ig_1 + ', currency=' + toString(this.jg_1) + ', englishName=' + this.kg_1 + ', arabicName=' + this.lg_1 + ', phoneRegex=' + this.mg_1 + ')';
  };
  protoOf(Antarctica).hashCode = function () {
    var result = this.gg_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.hg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ig_1) | 0;
    result = imul(result, 31) + hashCode(this.jg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mg_1) | 0;
    return result;
  };
  protoOf(Antarctica).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Antarctica))
      return false;
    var tmp0_other_with_cast = other instanceof Antarctica ? other : THROW_CCE();
    if (!this.gg_1.equals(tmp0_other_with_cast.gg_1))
      return false;
    if (!(this.hg_1 === tmp0_other_with_cast.hg_1))
      return false;
    if (!(this.ig_1 === tmp0_other_with_cast.ig_1))
      return false;
    if (!equals(this.jg_1, tmp0_other_with_cast.jg_1))
      return false;
    if (!(this.kg_1 === tmp0_other_with_cast.kg_1))
      return false;
    if (!(this.lg_1 === tmp0_other_with_cast.lg_1))
      return false;
    if (!(this.mg_1 === tmp0_other_with_cast.mg_1))
      return false;
    return true;
  };
  function Companion_12() {
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    return Companion_instance_12;
  }
  function AntiguaandBarbuda(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ATG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Antigua and Barbuda' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0646\u062A\u064A\u063A\u0648\u0627 \u0648\u0628\u0627\u0631\u0628\u0648\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ng_1 = phoneNumPrefix;
    this.og_1 = isoCode2;
    this.pg_1 = isoCode3;
    this.qg_1 = currency;
    this.rg_1 = englishName;
    this.sg_1 = arabicName;
    this.tg_1 = phoneRegex;
  }
  protoOf(AntiguaandBarbuda).wd = function () {
    return this.ng_1;
  };
  protoOf(AntiguaandBarbuda).rd = function () {
    return this.og_1;
  };
  protoOf(AntiguaandBarbuda).sd = function () {
    return this.pg_1;
  };
  protoOf(AntiguaandBarbuda).td = function () {
    return this.qg_1;
  };
  protoOf(AntiguaandBarbuda).ud = function () {
    return this.rg_1;
  };
  protoOf(AntiguaandBarbuda).vd = function () {
    return this.sg_1;
  };
  protoOf(AntiguaandBarbuda).xd = function () {
    return this.tg_1;
  };
  protoOf(AntiguaandBarbuda).toString = function () {
    return 'AntiguaandBarbuda(phoneNumPrefix=' + this.ng_1.toString() + ', isoCode2=' + this.og_1 + ', isoCode3=' + this.pg_1 + ', currency=' + toString(this.qg_1) + ', englishName=' + this.rg_1 + ', arabicName=' + this.sg_1 + ', phoneRegex=' + this.tg_1 + ')';
  };
  protoOf(AntiguaandBarbuda).hashCode = function () {
    var result = this.ng_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.og_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pg_1) | 0;
    result = imul(result, 31) + hashCode(this.qg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tg_1) | 0;
    return result;
  };
  protoOf(AntiguaandBarbuda).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AntiguaandBarbuda))
      return false;
    var tmp0_other_with_cast = other instanceof AntiguaandBarbuda ? other : THROW_CCE();
    if (!this.ng_1.equals(tmp0_other_with_cast.ng_1))
      return false;
    if (!(this.og_1 === tmp0_other_with_cast.og_1))
      return false;
    if (!(this.pg_1 === tmp0_other_with_cast.pg_1))
      return false;
    if (!equals(this.qg_1, tmp0_other_with_cast.qg_1))
      return false;
    if (!(this.rg_1 === tmp0_other_with_cast.rg_1))
      return false;
    if (!(this.sg_1 === tmp0_other_with_cast.sg_1))
      return false;
    if (!(this.tg_1 === tmp0_other_with_cast.tg_1))
      return false;
    return true;
  };
  function Companion_13() {
  }
  var Companion_instance_13;
  function Companion_getInstance_13() {
    return Companion_instance_13;
  }
  function Argentina(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ARG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Argentina' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0623\u0631\u062C\u0646\u062A\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ug_1 = phoneNumPrefix;
    this.vg_1 = isoCode2;
    this.wg_1 = isoCode3;
    this.xg_1 = currency;
    this.yg_1 = englishName;
    this.zg_1 = arabicName;
    this.ah_1 = phoneRegex;
  }
  protoOf(Argentina).wd = function () {
    return this.ug_1;
  };
  protoOf(Argentina).rd = function () {
    return this.vg_1;
  };
  protoOf(Argentina).sd = function () {
    return this.wg_1;
  };
  protoOf(Argentina).td = function () {
    return this.xg_1;
  };
  protoOf(Argentina).ud = function () {
    return this.yg_1;
  };
  protoOf(Argentina).vd = function () {
    return this.zg_1;
  };
  protoOf(Argentina).xd = function () {
    return this.ah_1;
  };
  protoOf(Argentina).toString = function () {
    return 'Argentina(phoneNumPrefix=' + this.ug_1.toString() + ', isoCode2=' + this.vg_1 + ', isoCode3=' + this.wg_1 + ', currency=' + toString(this.xg_1) + ', englishName=' + this.yg_1 + ', arabicName=' + this.zg_1 + ', phoneRegex=' + this.ah_1 + ')';
  };
  protoOf(Argentina).hashCode = function () {
    var result = this.ug_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.vg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wg_1) | 0;
    result = imul(result, 31) + hashCode(this.xg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ah_1) | 0;
    return result;
  };
  protoOf(Argentina).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Argentina))
      return false;
    var tmp0_other_with_cast = other instanceof Argentina ? other : THROW_CCE();
    if (!this.ug_1.equals(tmp0_other_with_cast.ug_1))
      return false;
    if (!(this.vg_1 === tmp0_other_with_cast.vg_1))
      return false;
    if (!(this.wg_1 === tmp0_other_with_cast.wg_1))
      return false;
    if (!equals(this.xg_1, tmp0_other_with_cast.xg_1))
      return false;
    if (!(this.yg_1 === tmp0_other_with_cast.yg_1))
      return false;
    if (!(this.zg_1 === tmp0_other_with_cast.zg_1))
      return false;
    if (!(this.ah_1 === tmp0_other_with_cast.ah_1))
      return false;
    return true;
  };
  function Companion_14() {
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    return Companion_instance_14;
  }
  function Armenia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ARM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Armenia' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0631\u0645\u064A\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.bh_1 = phoneNumPrefix;
    this.ch_1 = isoCode2;
    this.dh_1 = isoCode3;
    this.eh_1 = currency;
    this.fh_1 = englishName;
    this.gh_1 = arabicName;
    this.hh_1 = phoneRegex;
  }
  protoOf(Armenia).wd = function () {
    return this.bh_1;
  };
  protoOf(Armenia).rd = function () {
    return this.ch_1;
  };
  protoOf(Armenia).sd = function () {
    return this.dh_1;
  };
  protoOf(Armenia).td = function () {
    return this.eh_1;
  };
  protoOf(Armenia).ud = function () {
    return this.fh_1;
  };
  protoOf(Armenia).vd = function () {
    return this.gh_1;
  };
  protoOf(Armenia).xd = function () {
    return this.hh_1;
  };
  protoOf(Armenia).toString = function () {
    return 'Armenia(phoneNumPrefix=' + this.bh_1.toString() + ', isoCode2=' + this.ch_1 + ', isoCode3=' + this.dh_1 + ', currency=' + toString(this.eh_1) + ', englishName=' + this.fh_1 + ', arabicName=' + this.gh_1 + ', phoneRegex=' + this.hh_1 + ')';
  };
  protoOf(Armenia).hashCode = function () {
    var result = this.bh_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ch_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dh_1) | 0;
    result = imul(result, 31) + hashCode(this.eh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hh_1) | 0;
    return result;
  };
  protoOf(Armenia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Armenia))
      return false;
    var tmp0_other_with_cast = other instanceof Armenia ? other : THROW_CCE();
    if (!this.bh_1.equals(tmp0_other_with_cast.bh_1))
      return false;
    if (!(this.ch_1 === tmp0_other_with_cast.ch_1))
      return false;
    if (!(this.dh_1 === tmp0_other_with_cast.dh_1))
      return false;
    if (!equals(this.eh_1, tmp0_other_with_cast.eh_1))
      return false;
    if (!(this.fh_1 === tmp0_other_with_cast.fh_1))
      return false;
    if (!(this.gh_1 === tmp0_other_with_cast.gh_1))
      return false;
    if (!(this.hh_1 === tmp0_other_with_cast.hh_1))
      return false;
    return true;
  };
  function Companion_15() {
  }
  var Companion_instance_15;
  function Companion_getInstance_15() {
    return Companion_instance_15;
  }
  function Aruba(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ABW' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Aruba' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0631\u0648\u0628\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ih_1 = phoneNumPrefix;
    this.jh_1 = isoCode2;
    this.kh_1 = isoCode3;
    this.lh_1 = currency;
    this.mh_1 = englishName;
    this.nh_1 = arabicName;
    this.oh_1 = phoneRegex;
  }
  protoOf(Aruba).wd = function () {
    return this.ih_1;
  };
  protoOf(Aruba).rd = function () {
    return this.jh_1;
  };
  protoOf(Aruba).sd = function () {
    return this.kh_1;
  };
  protoOf(Aruba).td = function () {
    return this.lh_1;
  };
  protoOf(Aruba).ud = function () {
    return this.mh_1;
  };
  protoOf(Aruba).vd = function () {
    return this.nh_1;
  };
  protoOf(Aruba).xd = function () {
    return this.oh_1;
  };
  protoOf(Aruba).toString = function () {
    return 'Aruba(phoneNumPrefix=' + this.ih_1.toString() + ', isoCode2=' + this.jh_1 + ', isoCode3=' + this.kh_1 + ', currency=' + toString(this.lh_1) + ', englishName=' + this.mh_1 + ', arabicName=' + this.nh_1 + ', phoneRegex=' + this.oh_1 + ')';
  };
  protoOf(Aruba).hashCode = function () {
    var result = this.ih_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.jh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kh_1) | 0;
    result = imul(result, 31) + hashCode(this.lh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oh_1) | 0;
    return result;
  };
  protoOf(Aruba).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Aruba))
      return false;
    var tmp0_other_with_cast = other instanceof Aruba ? other : THROW_CCE();
    if (!this.ih_1.equals(tmp0_other_with_cast.ih_1))
      return false;
    if (!(this.jh_1 === tmp0_other_with_cast.jh_1))
      return false;
    if (!(this.kh_1 === tmp0_other_with_cast.kh_1))
      return false;
    if (!equals(this.lh_1, tmp0_other_with_cast.lh_1))
      return false;
    if (!(this.mh_1 === tmp0_other_with_cast.mh_1))
      return false;
    if (!(this.nh_1 === tmp0_other_with_cast.nh_1))
      return false;
    if (!(this.oh_1 === tmp0_other_with_cast.oh_1))
      return false;
    return true;
  };
  function Companion_16() {
  }
  var Companion_instance_16;
  function Companion_getInstance_16() {
    return Companion_instance_16;
  }
  function Australia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AUS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Australia' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ph_1 = phoneNumPrefix;
    this.qh_1 = isoCode2;
    this.rh_1 = isoCode3;
    this.sh_1 = currency;
    this.th_1 = englishName;
    this.uh_1 = arabicName;
    this.vh_1 = phoneRegex;
  }
  protoOf(Australia).wd = function () {
    return this.ph_1;
  };
  protoOf(Australia).rd = function () {
    return this.qh_1;
  };
  protoOf(Australia).sd = function () {
    return this.rh_1;
  };
  protoOf(Australia).td = function () {
    return this.sh_1;
  };
  protoOf(Australia).ud = function () {
    return this.th_1;
  };
  protoOf(Australia).vd = function () {
    return this.uh_1;
  };
  protoOf(Australia).xd = function () {
    return this.vh_1;
  };
  protoOf(Australia).toString = function () {
    return 'Australia(phoneNumPrefix=' + this.ph_1.toString() + ', isoCode2=' + this.qh_1 + ', isoCode3=' + this.rh_1 + ', currency=' + toString(this.sh_1) + ', englishName=' + this.th_1 + ', arabicName=' + this.uh_1 + ', phoneRegex=' + this.vh_1 + ')';
  };
  protoOf(Australia).hashCode = function () {
    var result = this.ph_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.qh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rh_1) | 0;
    result = imul(result, 31) + hashCode(this.sh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.th_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vh_1) | 0;
    return result;
  };
  protoOf(Australia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Australia))
      return false;
    var tmp0_other_with_cast = other instanceof Australia ? other : THROW_CCE();
    if (!this.ph_1.equals(tmp0_other_with_cast.ph_1))
      return false;
    if (!(this.qh_1 === tmp0_other_with_cast.qh_1))
      return false;
    if (!(this.rh_1 === tmp0_other_with_cast.rh_1))
      return false;
    if (!equals(this.sh_1, tmp0_other_with_cast.sh_1))
      return false;
    if (!(this.th_1 === tmp0_other_with_cast.th_1))
      return false;
    if (!(this.uh_1 === tmp0_other_with_cast.uh_1))
      return false;
    if (!(this.vh_1 === tmp0_other_with_cast.vh_1))
      return false;
    return true;
  };
  function Companion_17() {
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    return Companion_instance_17;
  }
  function Austria(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AUT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Austria' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0646\u0645\u0633\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.wh_1 = phoneNumPrefix;
    this.xh_1 = isoCode2;
    this.yh_1 = isoCode3;
    this.zh_1 = currency;
    this.ai_1 = englishName;
    this.bi_1 = arabicName;
    this.ci_1 = phoneRegex;
  }
  protoOf(Austria).wd = function () {
    return this.wh_1;
  };
  protoOf(Austria).rd = function () {
    return this.xh_1;
  };
  protoOf(Austria).sd = function () {
    return this.yh_1;
  };
  protoOf(Austria).td = function () {
    return this.zh_1;
  };
  protoOf(Austria).ud = function () {
    return this.ai_1;
  };
  protoOf(Austria).vd = function () {
    return this.bi_1;
  };
  protoOf(Austria).xd = function () {
    return this.ci_1;
  };
  protoOf(Austria).toString = function () {
    return 'Austria(phoneNumPrefix=' + this.wh_1.toString() + ', isoCode2=' + this.xh_1 + ', isoCode3=' + this.yh_1 + ', currency=' + toString(this.zh_1) + ', englishName=' + this.ai_1 + ', arabicName=' + this.bi_1 + ', phoneRegex=' + this.ci_1 + ')';
  };
  protoOf(Austria).hashCode = function () {
    var result = this.wh_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.xh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yh_1) | 0;
    result = imul(result, 31) + hashCode(this.zh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ai_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ci_1) | 0;
    return result;
  };
  protoOf(Austria).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Austria))
      return false;
    var tmp0_other_with_cast = other instanceof Austria ? other : THROW_CCE();
    if (!this.wh_1.equals(tmp0_other_with_cast.wh_1))
      return false;
    if (!(this.xh_1 === tmp0_other_with_cast.xh_1))
      return false;
    if (!(this.yh_1 === tmp0_other_with_cast.yh_1))
      return false;
    if (!equals(this.zh_1, tmp0_other_with_cast.zh_1))
      return false;
    if (!(this.ai_1 === tmp0_other_with_cast.ai_1))
      return false;
    if (!(this.bi_1 === tmp0_other_with_cast.bi_1))
      return false;
    if (!(this.ci_1 === tmp0_other_with_cast.ci_1))
      return false;
    return true;
  };
  function Companion_18() {
  }
  var Companion_instance_18;
  function Companion_getInstance_18() {
    return Companion_instance_18;
  }
  function Azerbaijan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'AZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'AZE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Azerbaijan' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.di_1 = phoneNumPrefix;
    this.ei_1 = isoCode2;
    this.fi_1 = isoCode3;
    this.gi_1 = currency;
    this.hi_1 = englishName;
    this.ii_1 = arabicName;
    this.ji_1 = phoneRegex;
  }
  protoOf(Azerbaijan).wd = function () {
    return this.di_1;
  };
  protoOf(Azerbaijan).rd = function () {
    return this.ei_1;
  };
  protoOf(Azerbaijan).sd = function () {
    return this.fi_1;
  };
  protoOf(Azerbaijan).td = function () {
    return this.gi_1;
  };
  protoOf(Azerbaijan).ud = function () {
    return this.hi_1;
  };
  protoOf(Azerbaijan).vd = function () {
    return this.ii_1;
  };
  protoOf(Azerbaijan).xd = function () {
    return this.ji_1;
  };
  protoOf(Azerbaijan).toString = function () {
    return 'Azerbaijan(phoneNumPrefix=' + this.di_1.toString() + ', isoCode2=' + this.ei_1 + ', isoCode3=' + this.fi_1 + ', currency=' + toString(this.gi_1) + ', englishName=' + this.hi_1 + ', arabicName=' + this.ii_1 + ', phoneRegex=' + this.ji_1 + ')';
  };
  protoOf(Azerbaijan).hashCode = function () {
    var result = this.di_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ei_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fi_1) | 0;
    result = imul(result, 31) + hashCode(this.gi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ii_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ji_1) | 0;
    return result;
  };
  protoOf(Azerbaijan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Azerbaijan))
      return false;
    var tmp0_other_with_cast = other instanceof Azerbaijan ? other : THROW_CCE();
    if (!this.di_1.equals(tmp0_other_with_cast.di_1))
      return false;
    if (!(this.ei_1 === tmp0_other_with_cast.ei_1))
      return false;
    if (!(this.fi_1 === tmp0_other_with_cast.fi_1))
      return false;
    if (!equals(this.gi_1, tmp0_other_with_cast.gi_1))
      return false;
    if (!(this.hi_1 === tmp0_other_with_cast.hi_1))
      return false;
    if (!(this.ii_1 === tmp0_other_with_cast.ii_1))
      return false;
    if (!(this.ji_1 === tmp0_other_with_cast.ji_1))
      return false;
    return true;
  };
  function Companion_19() {
  }
  var Companion_instance_19;
  function Companion_getInstance_19() {
    return Companion_instance_19;
  }
  function Bahamas(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BHS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bahamas' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0627\u0647\u0627\u0645\u0627\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ki_1 = phoneNumPrefix;
    this.li_1 = isoCode2;
    this.mi_1 = isoCode3;
    this.ni_1 = currency;
    this.oi_1 = englishName;
    this.pi_1 = arabicName;
    this.qi_1 = phoneRegex;
  }
  protoOf(Bahamas).wd = function () {
    return this.ki_1;
  };
  protoOf(Bahamas).rd = function () {
    return this.li_1;
  };
  protoOf(Bahamas).sd = function () {
    return this.mi_1;
  };
  protoOf(Bahamas).td = function () {
    return this.ni_1;
  };
  protoOf(Bahamas).ud = function () {
    return this.oi_1;
  };
  protoOf(Bahamas).vd = function () {
    return this.pi_1;
  };
  protoOf(Bahamas).xd = function () {
    return this.qi_1;
  };
  protoOf(Bahamas).toString = function () {
    return 'Bahamas(phoneNumPrefix=' + this.ki_1.toString() + ', isoCode2=' + this.li_1 + ', isoCode3=' + this.mi_1 + ', currency=' + toString(this.ni_1) + ', englishName=' + this.oi_1 + ', arabicName=' + this.pi_1 + ', phoneRegex=' + this.qi_1 + ')';
  };
  protoOf(Bahamas).hashCode = function () {
    var result = this.ki_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.li_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mi_1) | 0;
    result = imul(result, 31) + hashCode(this.ni_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qi_1) | 0;
    return result;
  };
  protoOf(Bahamas).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bahamas))
      return false;
    var tmp0_other_with_cast = other instanceof Bahamas ? other : THROW_CCE();
    if (!this.ki_1.equals(tmp0_other_with_cast.ki_1))
      return false;
    if (!(this.li_1 === tmp0_other_with_cast.li_1))
      return false;
    if (!(this.mi_1 === tmp0_other_with_cast.mi_1))
      return false;
    if (!equals(this.ni_1, tmp0_other_with_cast.ni_1))
      return false;
    if (!(this.oi_1 === tmp0_other_with_cast.oi_1))
      return false;
    if (!(this.pi_1 === tmp0_other_with_cast.pi_1))
      return false;
    if (!(this.qi_1 === tmp0_other_with_cast.qi_1))
      return false;
    return true;
  };
  function Companion_20() {
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    return Companion_instance_20;
  }
  function Bahrain(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(973, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BHR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bahrain' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0628\u062D\u0631\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(8) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '36001234' : phoneNumberHint;
    this.vc_1 = phoneNumPrefix;
    this.wc_1 = isoCode2;
    this.xc_1 = isoCode3;
    this.yc_1 = currency;
    this.zc_1 = englishName;
    this.ad_1 = arabicName;
    this.bd_1 = phoneRegex;
    this.cd_1 = phoneNumberHint;
  }
  protoOf(Bahrain).wd = function () {
    return this.vc_1;
  };
  protoOf(Bahrain).rd = function () {
    return this.wc_1;
  };
  protoOf(Bahrain).sd = function () {
    return this.xc_1;
  };
  protoOf(Bahrain).td = function () {
    return this.yc_1;
  };
  protoOf(Bahrain).ud = function () {
    return this.zc_1;
  };
  protoOf(Bahrain).vd = function () {
    return this.ad_1;
  };
  protoOf(Bahrain).xd = function () {
    return this.bd_1;
  };
  protoOf(Bahrain).yd = function () {
    return this.cd_1;
  };
  protoOf(Bahrain).toString = function () {
    return 'Bahrain(phoneNumPrefix=' + this.vc_1.toString() + ', isoCode2=' + this.wc_1 + ', isoCode3=' + this.xc_1 + ', currency=' + toString(this.yc_1) + ', englishName=' + this.zc_1 + ', arabicName=' + this.ad_1 + ', phoneRegex=' + this.bd_1 + ', phoneNumberHint=' + this.cd_1 + ')';
  };
  protoOf(Bahrain).hashCode = function () {
    var result = this.vc_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.wc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xc_1) | 0;
    result = imul(result, 31) + hashCode(this.yc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ad_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bd_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cd_1) | 0;
    return result;
  };
  protoOf(Bahrain).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bahrain))
      return false;
    var tmp0_other_with_cast = other instanceof Bahrain ? other : THROW_CCE();
    if (!this.vc_1.equals(tmp0_other_with_cast.vc_1))
      return false;
    if (!(this.wc_1 === tmp0_other_with_cast.wc_1))
      return false;
    if (!(this.xc_1 === tmp0_other_with_cast.xc_1))
      return false;
    if (!equals(this.yc_1, tmp0_other_with_cast.yc_1))
      return false;
    if (!(this.zc_1 === tmp0_other_with_cast.zc_1))
      return false;
    if (!(this.ad_1 === tmp0_other_with_cast.ad_1))
      return false;
    if (!(this.bd_1 === tmp0_other_with_cast.bd_1))
      return false;
    if (!(this.cd_1 === tmp0_other_with_cast.cd_1))
      return false;
    return true;
  };
  function Companion_21() {
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    return Companion_instance_21;
  }
  function Bangladesh(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(880, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BGD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bangladesh' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0646\u063A\u0644\u0627\u062F\u064A\u0634' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '1812345678' : phoneNumberHint;
    this.l9_1 = phoneNumPrefix;
    this.m9_1 = isoCode2;
    this.n9_1 = isoCode3;
    this.o9_1 = currency;
    this.p9_1 = englishName;
    this.q9_1 = arabicName;
    this.r9_1 = phoneRegex;
    this.s9_1 = phoneNumberHint;
  }
  protoOf(Bangladesh).wd = function () {
    return this.l9_1;
  };
  protoOf(Bangladesh).rd = function () {
    return this.m9_1;
  };
  protoOf(Bangladesh).sd = function () {
    return this.n9_1;
  };
  protoOf(Bangladesh).td = function () {
    return this.o9_1;
  };
  protoOf(Bangladesh).ud = function () {
    return this.p9_1;
  };
  protoOf(Bangladesh).vd = function () {
    return this.q9_1;
  };
  protoOf(Bangladesh).xd = function () {
    return this.r9_1;
  };
  protoOf(Bangladesh).yd = function () {
    return this.s9_1;
  };
  protoOf(Bangladesh).toString = function () {
    return 'Bangladesh(phoneNumPrefix=' + this.l9_1.toString() + ', isoCode2=' + this.m9_1 + ', isoCode3=' + this.n9_1 + ', currency=' + toString(this.o9_1) + ', englishName=' + this.p9_1 + ', arabicName=' + this.q9_1 + ', phoneRegex=' + this.r9_1 + ', phoneNumberHint=' + this.s9_1 + ')';
  };
  protoOf(Bangladesh).hashCode = function () {
    var result = this.l9_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n9_1) | 0;
    result = imul(result, 31) + hashCode(this.o9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s9_1) | 0;
    return result;
  };
  protoOf(Bangladesh).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bangladesh))
      return false;
    var tmp0_other_with_cast = other instanceof Bangladesh ? other : THROW_CCE();
    if (!this.l9_1.equals(tmp0_other_with_cast.l9_1))
      return false;
    if (!(this.m9_1 === tmp0_other_with_cast.m9_1))
      return false;
    if (!(this.n9_1 === tmp0_other_with_cast.n9_1))
      return false;
    if (!equals(this.o9_1, tmp0_other_with_cast.o9_1))
      return false;
    if (!(this.p9_1 === tmp0_other_with_cast.p9_1))
      return false;
    if (!(this.q9_1 === tmp0_other_with_cast.q9_1))
      return false;
    if (!(this.r9_1 === tmp0_other_with_cast.r9_1))
      return false;
    if (!(this.s9_1 === tmp0_other_with_cast.s9_1))
      return false;
    return true;
  };
  function Companion_22() {
  }
  var Companion_instance_22;
  function Companion_getInstance_22() {
    return Companion_instance_22;
  }
  function Barbados(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BB' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BRB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Barbados' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0627\u0631\u0628\u0627\u062F\u0648\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ri_1 = phoneNumPrefix;
    this.si_1 = isoCode2;
    this.ti_1 = isoCode3;
    this.ui_1 = currency;
    this.vi_1 = englishName;
    this.wi_1 = arabicName;
    this.xi_1 = phoneRegex;
  }
  protoOf(Barbados).wd = function () {
    return this.ri_1;
  };
  protoOf(Barbados).rd = function () {
    return this.si_1;
  };
  protoOf(Barbados).sd = function () {
    return this.ti_1;
  };
  protoOf(Barbados).td = function () {
    return this.ui_1;
  };
  protoOf(Barbados).ud = function () {
    return this.vi_1;
  };
  protoOf(Barbados).vd = function () {
    return this.wi_1;
  };
  protoOf(Barbados).xd = function () {
    return this.xi_1;
  };
  protoOf(Barbados).toString = function () {
    return 'Barbados(phoneNumPrefix=' + this.ri_1.toString() + ', isoCode2=' + this.si_1 + ', isoCode3=' + this.ti_1 + ', currency=' + toString(this.ui_1) + ', englishName=' + this.vi_1 + ', arabicName=' + this.wi_1 + ', phoneRegex=' + this.xi_1 + ')';
  };
  protoOf(Barbados).hashCode = function () {
    var result = this.ri_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.si_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ti_1) | 0;
    result = imul(result, 31) + hashCode(this.ui_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xi_1) | 0;
    return result;
  };
  protoOf(Barbados).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Barbados))
      return false;
    var tmp0_other_with_cast = other instanceof Barbados ? other : THROW_CCE();
    if (!this.ri_1.equals(tmp0_other_with_cast.ri_1))
      return false;
    if (!(this.si_1 === tmp0_other_with_cast.si_1))
      return false;
    if (!(this.ti_1 === tmp0_other_with_cast.ti_1))
      return false;
    if (!equals(this.ui_1, tmp0_other_with_cast.ui_1))
      return false;
    if (!(this.vi_1 === tmp0_other_with_cast.vi_1))
      return false;
    if (!(this.wi_1 === tmp0_other_with_cast.wi_1))
      return false;
    if (!(this.xi_1 === tmp0_other_with_cast.xi_1))
      return false;
    return true;
  };
  function Companion_23() {
  }
  var Companion_instance_23;
  function Companion_getInstance_23() {
    return Companion_instance_23;
  }
  function Belarus(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BLR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Belarus' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u064A\u0644\u0627\u0631\u0648\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.yi_1 = phoneNumPrefix;
    this.zi_1 = isoCode2;
    this.aj_1 = isoCode3;
    this.bj_1 = currency;
    this.cj_1 = englishName;
    this.dj_1 = arabicName;
    this.ej_1 = phoneRegex;
  }
  protoOf(Belarus).wd = function () {
    return this.yi_1;
  };
  protoOf(Belarus).rd = function () {
    return this.zi_1;
  };
  protoOf(Belarus).sd = function () {
    return this.aj_1;
  };
  protoOf(Belarus).td = function () {
    return this.bj_1;
  };
  protoOf(Belarus).ud = function () {
    return this.cj_1;
  };
  protoOf(Belarus).vd = function () {
    return this.dj_1;
  };
  protoOf(Belarus).xd = function () {
    return this.ej_1;
  };
  protoOf(Belarus).toString = function () {
    return 'Belarus(phoneNumPrefix=' + this.yi_1.toString() + ', isoCode2=' + this.zi_1 + ', isoCode3=' + this.aj_1 + ', currency=' + toString(this.bj_1) + ', englishName=' + this.cj_1 + ', arabicName=' + this.dj_1 + ', phoneRegex=' + this.ej_1 + ')';
  };
  protoOf(Belarus).hashCode = function () {
    var result = this.yi_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.zi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.aj_1) | 0;
    result = imul(result, 31) + hashCode(this.bj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ej_1) | 0;
    return result;
  };
  protoOf(Belarus).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Belarus))
      return false;
    var tmp0_other_with_cast = other instanceof Belarus ? other : THROW_CCE();
    if (!this.yi_1.equals(tmp0_other_with_cast.yi_1))
      return false;
    if (!(this.zi_1 === tmp0_other_with_cast.zi_1))
      return false;
    if (!(this.aj_1 === tmp0_other_with_cast.aj_1))
      return false;
    if (!equals(this.bj_1, tmp0_other_with_cast.bj_1))
      return false;
    if (!(this.cj_1 === tmp0_other_with_cast.cj_1))
      return false;
    if (!(this.dj_1 === tmp0_other_with_cast.dj_1))
      return false;
    if (!(this.ej_1 === tmp0_other_with_cast.ej_1))
      return false;
    return true;
  };
  function Companion_24() {
  }
  var Companion_instance_24;
  function Companion_getInstance_24() {
    return Companion_instance_24;
  }
  function Belgium(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BEL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Belgium' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0644\u062C\u064A\u0643\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.fj_1 = phoneNumPrefix;
    this.gj_1 = isoCode2;
    this.hj_1 = isoCode3;
    this.ij_1 = currency;
    this.jj_1 = englishName;
    this.kj_1 = arabicName;
    this.lj_1 = phoneRegex;
  }
  protoOf(Belgium).wd = function () {
    return this.fj_1;
  };
  protoOf(Belgium).rd = function () {
    return this.gj_1;
  };
  protoOf(Belgium).sd = function () {
    return this.hj_1;
  };
  protoOf(Belgium).td = function () {
    return this.ij_1;
  };
  protoOf(Belgium).ud = function () {
    return this.jj_1;
  };
  protoOf(Belgium).vd = function () {
    return this.kj_1;
  };
  protoOf(Belgium).xd = function () {
    return this.lj_1;
  };
  protoOf(Belgium).toString = function () {
    return 'Belgium(phoneNumPrefix=' + this.fj_1.toString() + ', isoCode2=' + this.gj_1 + ', isoCode3=' + this.hj_1 + ', currency=' + toString(this.ij_1) + ', englishName=' + this.jj_1 + ', arabicName=' + this.kj_1 + ', phoneRegex=' + this.lj_1 + ')';
  };
  protoOf(Belgium).hashCode = function () {
    var result = this.fj_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.gj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hj_1) | 0;
    result = imul(result, 31) + hashCode(this.ij_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lj_1) | 0;
    return result;
  };
  protoOf(Belgium).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Belgium))
      return false;
    var tmp0_other_with_cast = other instanceof Belgium ? other : THROW_CCE();
    if (!this.fj_1.equals(tmp0_other_with_cast.fj_1))
      return false;
    if (!(this.gj_1 === tmp0_other_with_cast.gj_1))
      return false;
    if (!(this.hj_1 === tmp0_other_with_cast.hj_1))
      return false;
    if (!equals(this.ij_1, tmp0_other_with_cast.ij_1))
      return false;
    if (!(this.jj_1 === tmp0_other_with_cast.jj_1))
      return false;
    if (!(this.kj_1 === tmp0_other_with_cast.kj_1))
      return false;
    if (!(this.lj_1 === tmp0_other_with_cast.lj_1))
      return false;
    return true;
  };
  function Companion_25() {
  }
  var Companion_instance_25;
  function Companion_getInstance_25() {
    return Companion_instance_25;
  }
  function Belize(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BLZ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Belize' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0644\u064A\u0632' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.mj_1 = phoneNumPrefix;
    this.nj_1 = isoCode2;
    this.oj_1 = isoCode3;
    this.pj_1 = currency;
    this.qj_1 = englishName;
    this.rj_1 = arabicName;
    this.sj_1 = phoneRegex;
  }
  protoOf(Belize).wd = function () {
    return this.mj_1;
  };
  protoOf(Belize).rd = function () {
    return this.nj_1;
  };
  protoOf(Belize).sd = function () {
    return this.oj_1;
  };
  protoOf(Belize).td = function () {
    return this.pj_1;
  };
  protoOf(Belize).ud = function () {
    return this.qj_1;
  };
  protoOf(Belize).vd = function () {
    return this.rj_1;
  };
  protoOf(Belize).xd = function () {
    return this.sj_1;
  };
  protoOf(Belize).toString = function () {
    return 'Belize(phoneNumPrefix=' + this.mj_1.toString() + ', isoCode2=' + this.nj_1 + ', isoCode3=' + this.oj_1 + ', currency=' + toString(this.pj_1) + ', englishName=' + this.qj_1 + ', arabicName=' + this.rj_1 + ', phoneRegex=' + this.sj_1 + ')';
  };
  protoOf(Belize).hashCode = function () {
    var result = this.mj_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.nj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oj_1) | 0;
    result = imul(result, 31) + hashCode(this.pj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sj_1) | 0;
    return result;
  };
  protoOf(Belize).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Belize))
      return false;
    var tmp0_other_with_cast = other instanceof Belize ? other : THROW_CCE();
    if (!this.mj_1.equals(tmp0_other_with_cast.mj_1))
      return false;
    if (!(this.nj_1 === tmp0_other_with_cast.nj_1))
      return false;
    if (!(this.oj_1 === tmp0_other_with_cast.oj_1))
      return false;
    if (!equals(this.pj_1, tmp0_other_with_cast.pj_1))
      return false;
    if (!(this.qj_1 === tmp0_other_with_cast.qj_1))
      return false;
    if (!(this.rj_1 === tmp0_other_with_cast.rj_1))
      return false;
    if (!(this.sj_1 === tmp0_other_with_cast.sj_1))
      return false;
    return true;
  };
  function Companion_26() {
  }
  var Companion_instance_26;
  function Companion_getInstance_26() {
    return Companion_instance_26;
  }
  function Benin(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BJ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BEN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Benin' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0646\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.tj_1 = phoneNumPrefix;
    this.uj_1 = isoCode2;
    this.vj_1 = isoCode3;
    this.wj_1 = currency;
    this.xj_1 = englishName;
    this.yj_1 = arabicName;
    this.zj_1 = phoneRegex;
  }
  protoOf(Benin).wd = function () {
    return this.tj_1;
  };
  protoOf(Benin).rd = function () {
    return this.uj_1;
  };
  protoOf(Benin).sd = function () {
    return this.vj_1;
  };
  protoOf(Benin).td = function () {
    return this.wj_1;
  };
  protoOf(Benin).ud = function () {
    return this.xj_1;
  };
  protoOf(Benin).vd = function () {
    return this.yj_1;
  };
  protoOf(Benin).xd = function () {
    return this.zj_1;
  };
  protoOf(Benin).toString = function () {
    return 'Benin(phoneNumPrefix=' + this.tj_1.toString() + ', isoCode2=' + this.uj_1 + ', isoCode3=' + this.vj_1 + ', currency=' + toString(this.wj_1) + ', englishName=' + this.xj_1 + ', arabicName=' + this.yj_1 + ', phoneRegex=' + this.zj_1 + ')';
  };
  protoOf(Benin).hashCode = function () {
    var result = this.tj_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.uj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vj_1) | 0;
    result = imul(result, 31) + hashCode(this.wj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zj_1) | 0;
    return result;
  };
  protoOf(Benin).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Benin))
      return false;
    var tmp0_other_with_cast = other instanceof Benin ? other : THROW_CCE();
    if (!this.tj_1.equals(tmp0_other_with_cast.tj_1))
      return false;
    if (!(this.uj_1 === tmp0_other_with_cast.uj_1))
      return false;
    if (!(this.vj_1 === tmp0_other_with_cast.vj_1))
      return false;
    if (!equals(this.wj_1, tmp0_other_with_cast.wj_1))
      return false;
    if (!(this.xj_1 === tmp0_other_with_cast.xj_1))
      return false;
    if (!(this.yj_1 === tmp0_other_with_cast.yj_1))
      return false;
    if (!(this.zj_1 === tmp0_other_with_cast.zj_1))
      return false;
    return true;
  };
  function Companion_27() {
  }
  var Companion_instance_27;
  function Companion_getInstance_27() {
    return Companion_instance_27;
  }
  function Bermuda(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BMU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bermuda' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0631\u0645\u0648\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ak_1 = phoneNumPrefix;
    this.bk_1 = isoCode2;
    this.ck_1 = isoCode3;
    this.dk_1 = currency;
    this.ek_1 = englishName;
    this.fk_1 = arabicName;
    this.gk_1 = phoneRegex;
  }
  protoOf(Bermuda).wd = function () {
    return this.ak_1;
  };
  protoOf(Bermuda).rd = function () {
    return this.bk_1;
  };
  protoOf(Bermuda).sd = function () {
    return this.ck_1;
  };
  protoOf(Bermuda).td = function () {
    return this.dk_1;
  };
  protoOf(Bermuda).ud = function () {
    return this.ek_1;
  };
  protoOf(Bermuda).vd = function () {
    return this.fk_1;
  };
  protoOf(Bermuda).xd = function () {
    return this.gk_1;
  };
  protoOf(Bermuda).toString = function () {
    return 'Bermuda(phoneNumPrefix=' + this.ak_1.toString() + ', isoCode2=' + this.bk_1 + ', isoCode3=' + this.ck_1 + ', currency=' + toString(this.dk_1) + ', englishName=' + this.ek_1 + ', arabicName=' + this.fk_1 + ', phoneRegex=' + this.gk_1 + ')';
  };
  protoOf(Bermuda).hashCode = function () {
    var result = this.ak_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.bk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ck_1) | 0;
    result = imul(result, 31) + hashCode(this.dk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ek_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gk_1) | 0;
    return result;
  };
  protoOf(Bermuda).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bermuda))
      return false;
    var tmp0_other_with_cast = other instanceof Bermuda ? other : THROW_CCE();
    if (!this.ak_1.equals(tmp0_other_with_cast.ak_1))
      return false;
    if (!(this.bk_1 === tmp0_other_with_cast.bk_1))
      return false;
    if (!(this.ck_1 === tmp0_other_with_cast.ck_1))
      return false;
    if (!equals(this.dk_1, tmp0_other_with_cast.dk_1))
      return false;
    if (!(this.ek_1 === tmp0_other_with_cast.ek_1))
      return false;
    if (!(this.fk_1 === tmp0_other_with_cast.fk_1))
      return false;
    if (!(this.gk_1 === tmp0_other_with_cast.gk_1))
      return false;
    return true;
  };
  function Companion_28() {
  }
  var Companion_instance_28;
  function Companion_getInstance_28() {
    return Companion_instance_28;
  }
  function Bhutan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BTN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bhutan' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.hk_1 = phoneNumPrefix;
    this.ik_1 = isoCode2;
    this.jk_1 = isoCode3;
    this.kk_1 = currency;
    this.lk_1 = englishName;
    this.mk_1 = arabicName;
    this.nk_1 = phoneRegex;
  }
  protoOf(Bhutan).wd = function () {
    return this.hk_1;
  };
  protoOf(Bhutan).rd = function () {
    return this.ik_1;
  };
  protoOf(Bhutan).sd = function () {
    return this.jk_1;
  };
  protoOf(Bhutan).td = function () {
    return this.kk_1;
  };
  protoOf(Bhutan).ud = function () {
    return this.lk_1;
  };
  protoOf(Bhutan).vd = function () {
    return this.mk_1;
  };
  protoOf(Bhutan).xd = function () {
    return this.nk_1;
  };
  protoOf(Bhutan).toString = function () {
    return 'Bhutan(phoneNumPrefix=' + this.hk_1.toString() + ', isoCode2=' + this.ik_1 + ', isoCode3=' + this.jk_1 + ', currency=' + toString(this.kk_1) + ', englishName=' + this.lk_1 + ', arabicName=' + this.mk_1 + ', phoneRegex=' + this.nk_1 + ')';
  };
  protoOf(Bhutan).hashCode = function () {
    var result = this.hk_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ik_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jk_1) | 0;
    result = imul(result, 31) + hashCode(this.kk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nk_1) | 0;
    return result;
  };
  protoOf(Bhutan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bhutan))
      return false;
    var tmp0_other_with_cast = other instanceof Bhutan ? other : THROW_CCE();
    if (!this.hk_1.equals(tmp0_other_with_cast.hk_1))
      return false;
    if (!(this.ik_1 === tmp0_other_with_cast.ik_1))
      return false;
    if (!(this.jk_1 === tmp0_other_with_cast.jk_1))
      return false;
    if (!equals(this.kk_1, tmp0_other_with_cast.kk_1))
      return false;
    if (!(this.lk_1 === tmp0_other_with_cast.lk_1))
      return false;
    if (!(this.mk_1 === tmp0_other_with_cast.mk_1))
      return false;
    if (!(this.nk_1 === tmp0_other_with_cast.nk_1))
      return false;
    return true;
  };
  function Companion_29() {
  }
  var Companion_instance_29;
  function Companion_getInstance_29() {
    return Companion_instance_29;
  }
  function BoliviaPlurinationalStateof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BOL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bolivia (Plurinational State of)' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u0644\u064A\u0641\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ok_1 = phoneNumPrefix;
    this.pk_1 = isoCode2;
    this.qk_1 = isoCode3;
    this.rk_1 = currency;
    this.sk_1 = englishName;
    this.tk_1 = arabicName;
    this.uk_1 = phoneRegex;
  }
  protoOf(BoliviaPlurinationalStateof).wd = function () {
    return this.ok_1;
  };
  protoOf(BoliviaPlurinationalStateof).rd = function () {
    return this.pk_1;
  };
  protoOf(BoliviaPlurinationalStateof).sd = function () {
    return this.qk_1;
  };
  protoOf(BoliviaPlurinationalStateof).td = function () {
    return this.rk_1;
  };
  protoOf(BoliviaPlurinationalStateof).ud = function () {
    return this.sk_1;
  };
  protoOf(BoliviaPlurinationalStateof).vd = function () {
    return this.tk_1;
  };
  protoOf(BoliviaPlurinationalStateof).xd = function () {
    return this.uk_1;
  };
  protoOf(BoliviaPlurinationalStateof).toString = function () {
    return 'BoliviaPlurinationalStateof(phoneNumPrefix=' + this.ok_1.toString() + ', isoCode2=' + this.pk_1 + ', isoCode3=' + this.qk_1 + ', currency=' + toString(this.rk_1) + ', englishName=' + this.sk_1 + ', arabicName=' + this.tk_1 + ', phoneRegex=' + this.uk_1 + ')';
  };
  protoOf(BoliviaPlurinationalStateof).hashCode = function () {
    var result = this.ok_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.pk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qk_1) | 0;
    result = imul(result, 31) + hashCode(this.rk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uk_1) | 0;
    return result;
  };
  protoOf(BoliviaPlurinationalStateof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoliviaPlurinationalStateof))
      return false;
    var tmp0_other_with_cast = other instanceof BoliviaPlurinationalStateof ? other : THROW_CCE();
    if (!this.ok_1.equals(tmp0_other_with_cast.ok_1))
      return false;
    if (!(this.pk_1 === tmp0_other_with_cast.pk_1))
      return false;
    if (!(this.qk_1 === tmp0_other_with_cast.qk_1))
      return false;
    if (!equals(this.rk_1, tmp0_other_with_cast.rk_1))
      return false;
    if (!(this.sk_1 === tmp0_other_with_cast.sk_1))
      return false;
    if (!(this.tk_1 === tmp0_other_with_cast.tk_1))
      return false;
    if (!(this.uk_1 === tmp0_other_with_cast.uk_1))
      return false;
    return true;
  };
  function Companion_30() {
  }
  var Companion_instance_30;
  function Companion_getInstance_30() {
    return Companion_instance_30;
  }
  function BonaireSintEustatiusandSaba(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BQ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BES' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bonaire, Sint Eustatius and Saba' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u062C\u0632\u0631 \u0627\u0644\u0643\u0627\u0631\u064A\u0628\u064A\u0629 \u0627\u0644\u0647\u0648\u0644\u0646\u062F\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.vk_1 = phoneNumPrefix;
    this.wk_1 = isoCode2;
    this.xk_1 = isoCode3;
    this.yk_1 = currency;
    this.zk_1 = englishName;
    this.al_1 = arabicName;
    this.bl_1 = phoneRegex;
  }
  protoOf(BonaireSintEustatiusandSaba).wd = function () {
    return this.vk_1;
  };
  protoOf(BonaireSintEustatiusandSaba).rd = function () {
    return this.wk_1;
  };
  protoOf(BonaireSintEustatiusandSaba).sd = function () {
    return this.xk_1;
  };
  protoOf(BonaireSintEustatiusandSaba).td = function () {
    return this.yk_1;
  };
  protoOf(BonaireSintEustatiusandSaba).ud = function () {
    return this.zk_1;
  };
  protoOf(BonaireSintEustatiusandSaba).vd = function () {
    return this.al_1;
  };
  protoOf(BonaireSintEustatiusandSaba).xd = function () {
    return this.bl_1;
  };
  protoOf(BonaireSintEustatiusandSaba).toString = function () {
    return 'BonaireSintEustatiusandSaba(phoneNumPrefix=' + this.vk_1.toString() + ', isoCode2=' + this.wk_1 + ', isoCode3=' + this.xk_1 + ', currency=' + toString(this.yk_1) + ', englishName=' + this.zk_1 + ', arabicName=' + this.al_1 + ', phoneRegex=' + this.bl_1 + ')';
  };
  protoOf(BonaireSintEustatiusandSaba).hashCode = function () {
    var result = this.vk_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.wk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xk_1) | 0;
    result = imul(result, 31) + hashCode(this.yk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.al_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bl_1) | 0;
    return result;
  };
  protoOf(BonaireSintEustatiusandSaba).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonaireSintEustatiusandSaba))
      return false;
    var tmp0_other_with_cast = other instanceof BonaireSintEustatiusandSaba ? other : THROW_CCE();
    if (!this.vk_1.equals(tmp0_other_with_cast.vk_1))
      return false;
    if (!(this.wk_1 === tmp0_other_with_cast.wk_1))
      return false;
    if (!(this.xk_1 === tmp0_other_with_cast.xk_1))
      return false;
    if (!equals(this.yk_1, tmp0_other_with_cast.yk_1))
      return false;
    if (!(this.zk_1 === tmp0_other_with_cast.zk_1))
      return false;
    if (!(this.al_1 === tmp0_other_with_cast.al_1))
      return false;
    if (!(this.bl_1 === tmp0_other_with_cast.bl_1))
      return false;
    return true;
  };
  function Companion_31() {
  }
  var Companion_instance_31;
  function Companion_getInstance_31() {
    return Companion_instance_31;
  }
  function BosniaandHerzegovina(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BIH' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bosnia and Herzegovina' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0628\u0648\u0633\u0646\u0629 \u0648\u0627\u0644\u0647\u0631\u0633\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.cl_1 = phoneNumPrefix;
    this.dl_1 = isoCode2;
    this.el_1 = isoCode3;
    this.fl_1 = currency;
    this.gl_1 = englishName;
    this.hl_1 = arabicName;
    this.il_1 = phoneRegex;
  }
  protoOf(BosniaandHerzegovina).wd = function () {
    return this.cl_1;
  };
  protoOf(BosniaandHerzegovina).rd = function () {
    return this.dl_1;
  };
  protoOf(BosniaandHerzegovina).sd = function () {
    return this.el_1;
  };
  protoOf(BosniaandHerzegovina).td = function () {
    return this.fl_1;
  };
  protoOf(BosniaandHerzegovina).ud = function () {
    return this.gl_1;
  };
  protoOf(BosniaandHerzegovina).vd = function () {
    return this.hl_1;
  };
  protoOf(BosniaandHerzegovina).xd = function () {
    return this.il_1;
  };
  protoOf(BosniaandHerzegovina).toString = function () {
    return 'BosniaandHerzegovina(phoneNumPrefix=' + this.cl_1.toString() + ', isoCode2=' + this.dl_1 + ', isoCode3=' + this.el_1 + ', currency=' + toString(this.fl_1) + ', englishName=' + this.gl_1 + ', arabicName=' + this.hl_1 + ', phoneRegex=' + this.il_1 + ')';
  };
  protoOf(BosniaandHerzegovina).hashCode = function () {
    var result = this.cl_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.dl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.el_1) | 0;
    result = imul(result, 31) + hashCode(this.fl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.il_1) | 0;
    return result;
  };
  protoOf(BosniaandHerzegovina).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BosniaandHerzegovina))
      return false;
    var tmp0_other_with_cast = other instanceof BosniaandHerzegovina ? other : THROW_CCE();
    if (!this.cl_1.equals(tmp0_other_with_cast.cl_1))
      return false;
    if (!(this.dl_1 === tmp0_other_with_cast.dl_1))
      return false;
    if (!(this.el_1 === tmp0_other_with_cast.el_1))
      return false;
    if (!equals(this.fl_1, tmp0_other_with_cast.fl_1))
      return false;
    if (!(this.gl_1 === tmp0_other_with_cast.gl_1))
      return false;
    if (!(this.hl_1 === tmp0_other_with_cast.hl_1))
      return false;
    if (!(this.il_1 === tmp0_other_with_cast.il_1))
      return false;
    return true;
  };
  function Companion_32() {
  }
  var Companion_instance_32;
  function Companion_getInstance_32() {
    return Companion_instance_32;
  }
  function Botswana(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BWA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Botswana' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u062A\u0633\u0648\u0627\u0646\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.jl_1 = phoneNumPrefix;
    this.kl_1 = isoCode2;
    this.ll_1 = isoCode3;
    this.ml_1 = currency;
    this.nl_1 = englishName;
    this.ol_1 = arabicName;
    this.pl_1 = phoneRegex;
  }
  protoOf(Botswana).wd = function () {
    return this.jl_1;
  };
  protoOf(Botswana).rd = function () {
    return this.kl_1;
  };
  protoOf(Botswana).sd = function () {
    return this.ll_1;
  };
  protoOf(Botswana).td = function () {
    return this.ml_1;
  };
  protoOf(Botswana).ud = function () {
    return this.nl_1;
  };
  protoOf(Botswana).vd = function () {
    return this.ol_1;
  };
  protoOf(Botswana).xd = function () {
    return this.pl_1;
  };
  protoOf(Botswana).toString = function () {
    return 'Botswana(phoneNumPrefix=' + this.jl_1.toString() + ', isoCode2=' + this.kl_1 + ', isoCode3=' + this.ll_1 + ', currency=' + toString(this.ml_1) + ', englishName=' + this.nl_1 + ', arabicName=' + this.ol_1 + ', phoneRegex=' + this.pl_1 + ')';
  };
  protoOf(Botswana).hashCode = function () {
    var result = this.jl_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.kl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ll_1) | 0;
    result = imul(result, 31) + hashCode(this.ml_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ol_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pl_1) | 0;
    return result;
  };
  protoOf(Botswana).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Botswana))
      return false;
    var tmp0_other_with_cast = other instanceof Botswana ? other : THROW_CCE();
    if (!this.jl_1.equals(tmp0_other_with_cast.jl_1))
      return false;
    if (!(this.kl_1 === tmp0_other_with_cast.kl_1))
      return false;
    if (!(this.ll_1 === tmp0_other_with_cast.ll_1))
      return false;
    if (!equals(this.ml_1, tmp0_other_with_cast.ml_1))
      return false;
    if (!(this.nl_1 === tmp0_other_with_cast.nl_1))
      return false;
    if (!(this.ol_1 === tmp0_other_with_cast.ol_1))
      return false;
    if (!(this.pl_1 === tmp0_other_with_cast.pl_1))
      return false;
    return true;
  };
  function Companion_33() {
  }
  var Companion_instance_33;
  function Companion_getInstance_33() {
    return Companion_instance_33;
  }
  function BouvetIsland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BV' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BVT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bouvet Island' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u064A\u0631\u0629 \u0628\u0648\u0641\u064A\u0647' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ql_1 = phoneNumPrefix;
    this.rl_1 = isoCode2;
    this.sl_1 = isoCode3;
    this.tl_1 = currency;
    this.ul_1 = englishName;
    this.vl_1 = arabicName;
    this.wl_1 = phoneRegex;
  }
  protoOf(BouvetIsland).wd = function () {
    return this.ql_1;
  };
  protoOf(BouvetIsland).rd = function () {
    return this.rl_1;
  };
  protoOf(BouvetIsland).sd = function () {
    return this.sl_1;
  };
  protoOf(BouvetIsland).td = function () {
    return this.tl_1;
  };
  protoOf(BouvetIsland).ud = function () {
    return this.ul_1;
  };
  protoOf(BouvetIsland).vd = function () {
    return this.vl_1;
  };
  protoOf(BouvetIsland).xd = function () {
    return this.wl_1;
  };
  protoOf(BouvetIsland).toString = function () {
    return 'BouvetIsland(phoneNumPrefix=' + this.ql_1.toString() + ', isoCode2=' + this.rl_1 + ', isoCode3=' + this.sl_1 + ', currency=' + toString(this.tl_1) + ', englishName=' + this.ul_1 + ', arabicName=' + this.vl_1 + ', phoneRegex=' + this.wl_1 + ')';
  };
  protoOf(BouvetIsland).hashCode = function () {
    var result = this.ql_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.rl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sl_1) | 0;
    result = imul(result, 31) + hashCode(this.tl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ul_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wl_1) | 0;
    return result;
  };
  protoOf(BouvetIsland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BouvetIsland))
      return false;
    var tmp0_other_with_cast = other instanceof BouvetIsland ? other : THROW_CCE();
    if (!this.ql_1.equals(tmp0_other_with_cast.ql_1))
      return false;
    if (!(this.rl_1 === tmp0_other_with_cast.rl_1))
      return false;
    if (!(this.sl_1 === tmp0_other_with_cast.sl_1))
      return false;
    if (!equals(this.tl_1, tmp0_other_with_cast.tl_1))
      return false;
    if (!(this.ul_1 === tmp0_other_with_cast.ul_1))
      return false;
    if (!(this.vl_1 === tmp0_other_with_cast.vl_1))
      return false;
    if (!(this.wl_1 === tmp0_other_with_cast.wl_1))
      return false;
    return true;
  };
  function Companion_34() {
  }
  var Companion_instance_34;
  function Companion_getInstance_34() {
    return Companion_instance_34;
  }
  function Brazil(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BRA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Brazil' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.xl_1 = phoneNumPrefix;
    this.yl_1 = isoCode2;
    this.zl_1 = isoCode3;
    this.am_1 = currency;
    this.bm_1 = englishName;
    this.cm_1 = arabicName;
    this.dm_1 = phoneRegex;
  }
  protoOf(Brazil).wd = function () {
    return this.xl_1;
  };
  protoOf(Brazil).rd = function () {
    return this.yl_1;
  };
  protoOf(Brazil).sd = function () {
    return this.zl_1;
  };
  protoOf(Brazil).td = function () {
    return this.am_1;
  };
  protoOf(Brazil).ud = function () {
    return this.bm_1;
  };
  protoOf(Brazil).vd = function () {
    return this.cm_1;
  };
  protoOf(Brazil).xd = function () {
    return this.dm_1;
  };
  protoOf(Brazil).toString = function () {
    return 'Brazil(phoneNumPrefix=' + this.xl_1.toString() + ', isoCode2=' + this.yl_1 + ', isoCode3=' + this.zl_1 + ', currency=' + toString(this.am_1) + ', englishName=' + this.bm_1 + ', arabicName=' + this.cm_1 + ', phoneRegex=' + this.dm_1 + ')';
  };
  protoOf(Brazil).hashCode = function () {
    var result = this.xl_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.yl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zl_1) | 0;
    result = imul(result, 31) + hashCode(this.am_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dm_1) | 0;
    return result;
  };
  protoOf(Brazil).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Brazil))
      return false;
    var tmp0_other_with_cast = other instanceof Brazil ? other : THROW_CCE();
    if (!this.xl_1.equals(tmp0_other_with_cast.xl_1))
      return false;
    if (!(this.yl_1 === tmp0_other_with_cast.yl_1))
      return false;
    if (!(this.zl_1 === tmp0_other_with_cast.zl_1))
      return false;
    if (!equals(this.am_1, tmp0_other_with_cast.am_1))
      return false;
    if (!(this.bm_1 === tmp0_other_with_cast.bm_1))
      return false;
    if (!(this.cm_1 === tmp0_other_with_cast.cm_1))
      return false;
    if (!(this.dm_1 === tmp0_other_with_cast.dm_1))
      return false;
    return true;
  };
  function Companion_35() {
  }
  var Companion_instance_35;
  function Companion_getInstance_35() {
    return Companion_instance_35;
  }
  function BritishIndianOceanTerritory(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IOT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'British Indian Ocean Territory' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0642\u0644\u064A\u0645 \u0627\u0644\u0645\u062D\u064A\u0637 \u0627\u0644\u0647\u0646\u062F\u064A \u0627\u0644\u0628\u0631\u064A\u0637\u0627\u0646\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.em_1 = phoneNumPrefix;
    this.fm_1 = isoCode2;
    this.gm_1 = isoCode3;
    this.hm_1 = currency;
    this.im_1 = englishName;
    this.jm_1 = arabicName;
    this.km_1 = phoneRegex;
  }
  protoOf(BritishIndianOceanTerritory).wd = function () {
    return this.em_1;
  };
  protoOf(BritishIndianOceanTerritory).rd = function () {
    return this.fm_1;
  };
  protoOf(BritishIndianOceanTerritory).sd = function () {
    return this.gm_1;
  };
  protoOf(BritishIndianOceanTerritory).td = function () {
    return this.hm_1;
  };
  protoOf(BritishIndianOceanTerritory).ud = function () {
    return this.im_1;
  };
  protoOf(BritishIndianOceanTerritory).vd = function () {
    return this.jm_1;
  };
  protoOf(BritishIndianOceanTerritory).xd = function () {
    return this.km_1;
  };
  protoOf(BritishIndianOceanTerritory).toString = function () {
    return 'BritishIndianOceanTerritory(phoneNumPrefix=' + this.em_1.toString() + ', isoCode2=' + this.fm_1 + ', isoCode3=' + this.gm_1 + ', currency=' + toString(this.hm_1) + ', englishName=' + this.im_1 + ', arabicName=' + this.jm_1 + ', phoneRegex=' + this.km_1 + ')';
  };
  protoOf(BritishIndianOceanTerritory).hashCode = function () {
    var result = this.em_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.fm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gm_1) | 0;
    result = imul(result, 31) + hashCode(this.hm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.im_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.km_1) | 0;
    return result;
  };
  protoOf(BritishIndianOceanTerritory).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BritishIndianOceanTerritory))
      return false;
    var tmp0_other_with_cast = other instanceof BritishIndianOceanTerritory ? other : THROW_CCE();
    if (!this.em_1.equals(tmp0_other_with_cast.em_1))
      return false;
    if (!(this.fm_1 === tmp0_other_with_cast.fm_1))
      return false;
    if (!(this.gm_1 === tmp0_other_with_cast.gm_1))
      return false;
    if (!equals(this.hm_1, tmp0_other_with_cast.hm_1))
      return false;
    if (!(this.im_1 === tmp0_other_with_cast.im_1))
      return false;
    if (!(this.jm_1 === tmp0_other_with_cast.jm_1))
      return false;
    if (!(this.km_1 === tmp0_other_with_cast.km_1))
      return false;
    return true;
  };
  function Companion_36() {
  }
  var Companion_instance_36;
  function Companion_getInstance_36() {
    return Companion_instance_36;
  }
  function BruneiDarussalam(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BRN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Brunei Darussalam' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0631\u0648\u0646\u0627\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.lm_1 = phoneNumPrefix;
    this.mm_1 = isoCode2;
    this.nm_1 = isoCode3;
    this.om_1 = currency;
    this.pm_1 = englishName;
    this.qm_1 = arabicName;
    this.rm_1 = phoneRegex;
  }
  protoOf(BruneiDarussalam).wd = function () {
    return this.lm_1;
  };
  protoOf(BruneiDarussalam).rd = function () {
    return this.mm_1;
  };
  protoOf(BruneiDarussalam).sd = function () {
    return this.nm_1;
  };
  protoOf(BruneiDarussalam).td = function () {
    return this.om_1;
  };
  protoOf(BruneiDarussalam).ud = function () {
    return this.pm_1;
  };
  protoOf(BruneiDarussalam).vd = function () {
    return this.qm_1;
  };
  protoOf(BruneiDarussalam).xd = function () {
    return this.rm_1;
  };
  protoOf(BruneiDarussalam).toString = function () {
    return 'BruneiDarussalam(phoneNumPrefix=' + this.lm_1.toString() + ', isoCode2=' + this.mm_1 + ', isoCode3=' + this.nm_1 + ', currency=' + toString(this.om_1) + ', englishName=' + this.pm_1 + ', arabicName=' + this.qm_1 + ', phoneRegex=' + this.rm_1 + ')';
  };
  protoOf(BruneiDarussalam).hashCode = function () {
    var result = this.lm_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.mm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nm_1) | 0;
    result = imul(result, 31) + hashCode(this.om_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rm_1) | 0;
    return result;
  };
  protoOf(BruneiDarussalam).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BruneiDarussalam))
      return false;
    var tmp0_other_with_cast = other instanceof BruneiDarussalam ? other : THROW_CCE();
    if (!this.lm_1.equals(tmp0_other_with_cast.lm_1))
      return false;
    if (!(this.mm_1 === tmp0_other_with_cast.mm_1))
      return false;
    if (!(this.nm_1 === tmp0_other_with_cast.nm_1))
      return false;
    if (!equals(this.om_1, tmp0_other_with_cast.om_1))
      return false;
    if (!(this.pm_1 === tmp0_other_with_cast.pm_1))
      return false;
    if (!(this.qm_1 === tmp0_other_with_cast.qm_1))
      return false;
    if (!(this.rm_1 === tmp0_other_with_cast.rm_1))
      return false;
    return true;
  };
  function Companion_37() {
  }
  var Companion_instance_37;
  function Companion_getInstance_37() {
    return Companion_instance_37;
  }
  function Bulgaria(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BGR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Bulgaria' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0644\u063A\u0627\u0631\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.sm_1 = phoneNumPrefix;
    this.tm_1 = isoCode2;
    this.um_1 = isoCode3;
    this.vm_1 = currency;
    this.wm_1 = englishName;
    this.xm_1 = arabicName;
    this.ym_1 = phoneRegex;
  }
  protoOf(Bulgaria).wd = function () {
    return this.sm_1;
  };
  protoOf(Bulgaria).rd = function () {
    return this.tm_1;
  };
  protoOf(Bulgaria).sd = function () {
    return this.um_1;
  };
  protoOf(Bulgaria).td = function () {
    return this.vm_1;
  };
  protoOf(Bulgaria).ud = function () {
    return this.wm_1;
  };
  protoOf(Bulgaria).vd = function () {
    return this.xm_1;
  };
  protoOf(Bulgaria).xd = function () {
    return this.ym_1;
  };
  protoOf(Bulgaria).toString = function () {
    return 'Bulgaria(phoneNumPrefix=' + this.sm_1.toString() + ', isoCode2=' + this.tm_1 + ', isoCode3=' + this.um_1 + ', currency=' + toString(this.vm_1) + ', englishName=' + this.wm_1 + ', arabicName=' + this.xm_1 + ', phoneRegex=' + this.ym_1 + ')';
  };
  protoOf(Bulgaria).hashCode = function () {
    var result = this.sm_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.tm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.um_1) | 0;
    result = imul(result, 31) + hashCode(this.vm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xm_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ym_1) | 0;
    return result;
  };
  protoOf(Bulgaria).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bulgaria))
      return false;
    var tmp0_other_with_cast = other instanceof Bulgaria ? other : THROW_CCE();
    if (!this.sm_1.equals(tmp0_other_with_cast.sm_1))
      return false;
    if (!(this.tm_1 === tmp0_other_with_cast.tm_1))
      return false;
    if (!(this.um_1 === tmp0_other_with_cast.um_1))
      return false;
    if (!equals(this.vm_1, tmp0_other_with_cast.vm_1))
      return false;
    if (!(this.wm_1 === tmp0_other_with_cast.wm_1))
      return false;
    if (!(this.xm_1 === tmp0_other_with_cast.xm_1))
      return false;
    if (!(this.ym_1 === tmp0_other_with_cast.ym_1))
      return false;
    return true;
  };
  function Companion_38() {
  }
  var Companion_instance_38;
  function Companion_getInstance_38() {
    return Companion_instance_38;
  }
  function BurkinaFaso(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BFA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Burkina Faso' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u0631\u0643\u064A\u0646\u0627 \u0641\u0627\u0633\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.zm_1 = phoneNumPrefix;
    this.an_1 = isoCode2;
    this.bn_1 = isoCode3;
    this.cn_1 = currency;
    this.dn_1 = englishName;
    this.en_1 = arabicName;
    this.fn_1 = phoneRegex;
  }
  protoOf(BurkinaFaso).wd = function () {
    return this.zm_1;
  };
  protoOf(BurkinaFaso).rd = function () {
    return this.an_1;
  };
  protoOf(BurkinaFaso).sd = function () {
    return this.bn_1;
  };
  protoOf(BurkinaFaso).td = function () {
    return this.cn_1;
  };
  protoOf(BurkinaFaso).ud = function () {
    return this.dn_1;
  };
  protoOf(BurkinaFaso).vd = function () {
    return this.en_1;
  };
  protoOf(BurkinaFaso).xd = function () {
    return this.fn_1;
  };
  protoOf(BurkinaFaso).toString = function () {
    return 'BurkinaFaso(phoneNumPrefix=' + this.zm_1.toString() + ', isoCode2=' + this.an_1 + ', isoCode3=' + this.bn_1 + ', currency=' + toString(this.cn_1) + ', englishName=' + this.dn_1 + ', arabicName=' + this.en_1 + ', phoneRegex=' + this.fn_1 + ')';
  };
  protoOf(BurkinaFaso).hashCode = function () {
    var result = this.zm_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.an_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bn_1) | 0;
    result = imul(result, 31) + hashCode(this.cn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.en_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fn_1) | 0;
    return result;
  };
  protoOf(BurkinaFaso).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BurkinaFaso))
      return false;
    var tmp0_other_with_cast = other instanceof BurkinaFaso ? other : THROW_CCE();
    if (!this.zm_1.equals(tmp0_other_with_cast.zm_1))
      return false;
    if (!(this.an_1 === tmp0_other_with_cast.an_1))
      return false;
    if (!(this.bn_1 === tmp0_other_with_cast.bn_1))
      return false;
    if (!equals(this.cn_1, tmp0_other_with_cast.cn_1))
      return false;
    if (!(this.dn_1 === tmp0_other_with_cast.dn_1))
      return false;
    if (!(this.en_1 === tmp0_other_with_cast.en_1))
      return false;
    if (!(this.fn_1 === tmp0_other_with_cast.fn_1))
      return false;
    return true;
  };
  function Companion_39() {
  }
  var Companion_instance_39;
  function Companion_getInstance_39() {
    return Companion_instance_39;
  }
  function Burundi(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BDI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Burundi' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u0631\u0648\u0646\u062F\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.gn_1 = phoneNumPrefix;
    this.hn_1 = isoCode2;
    this.in_1 = isoCode3;
    this.jn_1 = currency;
    this.kn_1 = englishName;
    this.ln_1 = arabicName;
    this.mn_1 = phoneRegex;
  }
  protoOf(Burundi).wd = function () {
    return this.gn_1;
  };
  protoOf(Burundi).rd = function () {
    return this.hn_1;
  };
  protoOf(Burundi).sd = function () {
    return this.in_1;
  };
  protoOf(Burundi).td = function () {
    return this.jn_1;
  };
  protoOf(Burundi).ud = function () {
    return this.kn_1;
  };
  protoOf(Burundi).vd = function () {
    return this.ln_1;
  };
  protoOf(Burundi).xd = function () {
    return this.mn_1;
  };
  protoOf(Burundi).toString = function () {
    return 'Burundi(phoneNumPrefix=' + this.gn_1.toString() + ', isoCode2=' + this.hn_1 + ', isoCode3=' + this.in_1 + ', currency=' + toString(this.jn_1) + ', englishName=' + this.kn_1 + ', arabicName=' + this.ln_1 + ', phoneRegex=' + this.mn_1 + ')';
  };
  protoOf(Burundi).hashCode = function () {
    var result = this.gn_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.hn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.in_1) | 0;
    result = imul(result, 31) + hashCode(this.jn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ln_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mn_1) | 0;
    return result;
  };
  protoOf(Burundi).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Burundi))
      return false;
    var tmp0_other_with_cast = other instanceof Burundi ? other : THROW_CCE();
    if (!this.gn_1.equals(tmp0_other_with_cast.gn_1))
      return false;
    if (!(this.hn_1 === tmp0_other_with_cast.hn_1))
      return false;
    if (!(this.in_1 === tmp0_other_with_cast.in_1))
      return false;
    if (!equals(this.jn_1, tmp0_other_with_cast.jn_1))
      return false;
    if (!(this.kn_1 === tmp0_other_with_cast.kn_1))
      return false;
    if (!(this.ln_1 === tmp0_other_with_cast.ln_1))
      return false;
    if (!(this.mn_1 === tmp0_other_with_cast.mn_1))
      return false;
    return true;
  };
  function Companion_40() {
  }
  var Companion_instance_40;
  function Companion_getInstance_40() {
    return Companion_instance_40;
  }
  function Cambodia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KHM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cambodia' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0645\u0628\u0648\u062F\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.nn_1 = phoneNumPrefix;
    this.on_1 = isoCode2;
    this.pn_1 = isoCode3;
    this.qn_1 = currency;
    this.rn_1 = englishName;
    this.sn_1 = arabicName;
    this.tn_1 = phoneRegex;
  }
  protoOf(Cambodia).wd = function () {
    return this.nn_1;
  };
  protoOf(Cambodia).rd = function () {
    return this.on_1;
  };
  protoOf(Cambodia).sd = function () {
    return this.pn_1;
  };
  protoOf(Cambodia).td = function () {
    return this.qn_1;
  };
  protoOf(Cambodia).ud = function () {
    return this.rn_1;
  };
  protoOf(Cambodia).vd = function () {
    return this.sn_1;
  };
  protoOf(Cambodia).xd = function () {
    return this.tn_1;
  };
  protoOf(Cambodia).toString = function () {
    return 'Cambodia(phoneNumPrefix=' + this.nn_1.toString() + ', isoCode2=' + this.on_1 + ', isoCode3=' + this.pn_1 + ', currency=' + toString(this.qn_1) + ', englishName=' + this.rn_1 + ', arabicName=' + this.sn_1 + ', phoneRegex=' + this.tn_1 + ')';
  };
  protoOf(Cambodia).hashCode = function () {
    var result = this.nn_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.on_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pn_1) | 0;
    result = imul(result, 31) + hashCode(this.qn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tn_1) | 0;
    return result;
  };
  protoOf(Cambodia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Cambodia))
      return false;
    var tmp0_other_with_cast = other instanceof Cambodia ? other : THROW_CCE();
    if (!this.nn_1.equals(tmp0_other_with_cast.nn_1))
      return false;
    if (!(this.on_1 === tmp0_other_with_cast.on_1))
      return false;
    if (!(this.pn_1 === tmp0_other_with_cast.pn_1))
      return false;
    if (!equals(this.qn_1, tmp0_other_with_cast.qn_1))
      return false;
    if (!(this.rn_1 === tmp0_other_with_cast.rn_1))
      return false;
    if (!(this.sn_1 === tmp0_other_with_cast.sn_1))
      return false;
    if (!(this.tn_1 === tmp0_other_with_cast.tn_1))
      return false;
    return true;
  };
  function Companion_41() {
  }
  var Companion_instance_41;
  function Companion_getInstance_41() {
    return Companion_instance_41;
  }
  function Cameroon(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CMR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cameroon' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0648\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.un_1 = phoneNumPrefix;
    this.vn_1 = isoCode2;
    this.wn_1 = isoCode3;
    this.xn_1 = currency;
    this.yn_1 = englishName;
    this.zn_1 = arabicName;
    this.ao_1 = phoneRegex;
  }
  protoOf(Cameroon).wd = function () {
    return this.un_1;
  };
  protoOf(Cameroon).rd = function () {
    return this.vn_1;
  };
  protoOf(Cameroon).sd = function () {
    return this.wn_1;
  };
  protoOf(Cameroon).td = function () {
    return this.xn_1;
  };
  protoOf(Cameroon).ud = function () {
    return this.yn_1;
  };
  protoOf(Cameroon).vd = function () {
    return this.zn_1;
  };
  protoOf(Cameroon).xd = function () {
    return this.ao_1;
  };
  protoOf(Cameroon).toString = function () {
    return 'Cameroon(phoneNumPrefix=' + this.un_1.toString() + ', isoCode2=' + this.vn_1 + ', isoCode3=' + this.wn_1 + ', currency=' + toString(this.xn_1) + ', englishName=' + this.yn_1 + ', arabicName=' + this.zn_1 + ', phoneRegex=' + this.ao_1 + ')';
  };
  protoOf(Cameroon).hashCode = function () {
    var result = this.un_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.vn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wn_1) | 0;
    result = imul(result, 31) + hashCode(this.xn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zn_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ao_1) | 0;
    return result;
  };
  protoOf(Cameroon).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Cameroon))
      return false;
    var tmp0_other_with_cast = other instanceof Cameroon ? other : THROW_CCE();
    if (!this.un_1.equals(tmp0_other_with_cast.un_1))
      return false;
    if (!(this.vn_1 === tmp0_other_with_cast.vn_1))
      return false;
    if (!(this.wn_1 === tmp0_other_with_cast.wn_1))
      return false;
    if (!equals(this.xn_1, tmp0_other_with_cast.xn_1))
      return false;
    if (!(this.yn_1 === tmp0_other_with_cast.yn_1))
      return false;
    if (!(this.zn_1 === tmp0_other_with_cast.zn_1))
      return false;
    if (!(this.ao_1 === tmp0_other_with_cast.ao_1))
      return false;
    return true;
  };
  function Companion_42() {
  }
  var Companion_instance_42;
  function Companion_getInstance_42() {
    return Companion_instance_42;
  }
  function Canada(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CAN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Canada' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.bo_1 = phoneNumPrefix;
    this.co_1 = isoCode2;
    this.do_1 = isoCode3;
    this.eo_1 = currency;
    this.fo_1 = englishName;
    this.go_1 = arabicName;
    this.ho_1 = phoneRegex;
  }
  protoOf(Canada).wd = function () {
    return this.bo_1;
  };
  protoOf(Canada).rd = function () {
    return this.co_1;
  };
  protoOf(Canada).sd = function () {
    return this.do_1;
  };
  protoOf(Canada).td = function () {
    return this.eo_1;
  };
  protoOf(Canada).ud = function () {
    return this.fo_1;
  };
  protoOf(Canada).vd = function () {
    return this.go_1;
  };
  protoOf(Canada).xd = function () {
    return this.ho_1;
  };
  protoOf(Canada).toString = function () {
    return 'Canada(phoneNumPrefix=' + this.bo_1.toString() + ', isoCode2=' + this.co_1 + ', isoCode3=' + this.do_1 + ', currency=' + toString(this.eo_1) + ', englishName=' + this.fo_1 + ', arabicName=' + this.go_1 + ', phoneRegex=' + this.ho_1 + ')';
  };
  protoOf(Canada).hashCode = function () {
    var result = this.bo_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.co_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.do_1) | 0;
    result = imul(result, 31) + hashCode(this.eo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.go_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ho_1) | 0;
    return result;
  };
  protoOf(Canada).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Canada))
      return false;
    var tmp0_other_with_cast = other instanceof Canada ? other : THROW_CCE();
    if (!this.bo_1.equals(tmp0_other_with_cast.bo_1))
      return false;
    if (!(this.co_1 === tmp0_other_with_cast.co_1))
      return false;
    if (!(this.do_1 === tmp0_other_with_cast.do_1))
      return false;
    if (!equals(this.eo_1, tmp0_other_with_cast.eo_1))
      return false;
    if (!(this.fo_1 === tmp0_other_with_cast.fo_1))
      return false;
    if (!(this.go_1 === tmp0_other_with_cast.go_1))
      return false;
    if (!(this.ho_1 === tmp0_other_with_cast.ho_1))
      return false;
    return true;
  };
  function Companion_43() {
  }
  var Companion_instance_43;
  function Companion_getInstance_43() {
    return Companion_instance_43;
  }
  function CaboVerde(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CV' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CPV' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cabo Verde' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0631\u0623\u0633 \u0627\u0644\u0623\u062E\u0636\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.io_1 = phoneNumPrefix;
    this.jo_1 = isoCode2;
    this.ko_1 = isoCode3;
    this.lo_1 = currency;
    this.mo_1 = englishName;
    this.no_1 = arabicName;
    this.oo_1 = phoneRegex;
  }
  protoOf(CaboVerde).wd = function () {
    return this.io_1;
  };
  protoOf(CaboVerde).rd = function () {
    return this.jo_1;
  };
  protoOf(CaboVerde).sd = function () {
    return this.ko_1;
  };
  protoOf(CaboVerde).td = function () {
    return this.lo_1;
  };
  protoOf(CaboVerde).ud = function () {
    return this.mo_1;
  };
  protoOf(CaboVerde).vd = function () {
    return this.no_1;
  };
  protoOf(CaboVerde).xd = function () {
    return this.oo_1;
  };
  protoOf(CaboVerde).toString = function () {
    return 'CaboVerde(phoneNumPrefix=' + this.io_1.toString() + ', isoCode2=' + this.jo_1 + ', isoCode3=' + this.ko_1 + ', currency=' + toString(this.lo_1) + ', englishName=' + this.mo_1 + ', arabicName=' + this.no_1 + ', phoneRegex=' + this.oo_1 + ')';
  };
  protoOf(CaboVerde).hashCode = function () {
    var result = this.io_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.jo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ko_1) | 0;
    result = imul(result, 31) + hashCode(this.lo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.no_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oo_1) | 0;
    return result;
  };
  protoOf(CaboVerde).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CaboVerde))
      return false;
    var tmp0_other_with_cast = other instanceof CaboVerde ? other : THROW_CCE();
    if (!this.io_1.equals(tmp0_other_with_cast.io_1))
      return false;
    if (!(this.jo_1 === tmp0_other_with_cast.jo_1))
      return false;
    if (!(this.ko_1 === tmp0_other_with_cast.ko_1))
      return false;
    if (!equals(this.lo_1, tmp0_other_with_cast.lo_1))
      return false;
    if (!(this.mo_1 === tmp0_other_with_cast.mo_1))
      return false;
    if (!(this.no_1 === tmp0_other_with_cast.no_1))
      return false;
    if (!(this.oo_1 === tmp0_other_with_cast.oo_1))
      return false;
    return true;
  };
  function Companion_44() {
  }
  var Companion_instance_44;
  function Companion_getInstance_44() {
    return Companion_instance_44;
  }
  function CaymanIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CYM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cayman Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0643\u0627\u064A\u0645\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.po_1 = phoneNumPrefix;
    this.qo_1 = isoCode2;
    this.ro_1 = isoCode3;
    this.so_1 = currency;
    this.to_1 = englishName;
    this.uo_1 = arabicName;
    this.vo_1 = phoneRegex;
  }
  protoOf(CaymanIslands).wd = function () {
    return this.po_1;
  };
  protoOf(CaymanIslands).rd = function () {
    return this.qo_1;
  };
  protoOf(CaymanIslands).sd = function () {
    return this.ro_1;
  };
  protoOf(CaymanIslands).td = function () {
    return this.so_1;
  };
  protoOf(CaymanIslands).ud = function () {
    return this.to_1;
  };
  protoOf(CaymanIslands).vd = function () {
    return this.uo_1;
  };
  protoOf(CaymanIslands).xd = function () {
    return this.vo_1;
  };
  protoOf(CaymanIslands).toString = function () {
    return 'CaymanIslands(phoneNumPrefix=' + this.po_1.toString() + ', isoCode2=' + this.qo_1 + ', isoCode3=' + this.ro_1 + ', currency=' + toString(this.so_1) + ', englishName=' + this.to_1 + ', arabicName=' + this.uo_1 + ', phoneRegex=' + this.vo_1 + ')';
  };
  protoOf(CaymanIslands).hashCode = function () {
    var result = this.po_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.qo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ro_1) | 0;
    result = imul(result, 31) + hashCode(this.so_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.to_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vo_1) | 0;
    return result;
  };
  protoOf(CaymanIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CaymanIslands))
      return false;
    var tmp0_other_with_cast = other instanceof CaymanIslands ? other : THROW_CCE();
    if (!this.po_1.equals(tmp0_other_with_cast.po_1))
      return false;
    if (!(this.qo_1 === tmp0_other_with_cast.qo_1))
      return false;
    if (!(this.ro_1 === tmp0_other_with_cast.ro_1))
      return false;
    if (!equals(this.so_1, tmp0_other_with_cast.so_1))
      return false;
    if (!(this.to_1 === tmp0_other_with_cast.to_1))
      return false;
    if (!(this.uo_1 === tmp0_other_with_cast.uo_1))
      return false;
    if (!(this.vo_1 === tmp0_other_with_cast.vo_1))
      return false;
    return true;
  };
  function Companion_45() {
  }
  var Companion_instance_45;
  function Companion_getInstance_45() {
    return Companion_instance_45;
  }
  function CentralAfricanRepublic(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CAF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Central African Republic' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0623\u0641\u0631\u064A\u0642\u064A\u0627 \u0627\u0644\u0648\u0633\u0637\u0649' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.wo_1 = phoneNumPrefix;
    this.xo_1 = isoCode2;
    this.yo_1 = isoCode3;
    this.zo_1 = currency;
    this.ap_1 = englishName;
    this.bp_1 = arabicName;
    this.cp_1 = phoneRegex;
  }
  protoOf(CentralAfricanRepublic).wd = function () {
    return this.wo_1;
  };
  protoOf(CentralAfricanRepublic).rd = function () {
    return this.xo_1;
  };
  protoOf(CentralAfricanRepublic).sd = function () {
    return this.yo_1;
  };
  protoOf(CentralAfricanRepublic).td = function () {
    return this.zo_1;
  };
  protoOf(CentralAfricanRepublic).ud = function () {
    return this.ap_1;
  };
  protoOf(CentralAfricanRepublic).vd = function () {
    return this.bp_1;
  };
  protoOf(CentralAfricanRepublic).xd = function () {
    return this.cp_1;
  };
  protoOf(CentralAfricanRepublic).toString = function () {
    return 'CentralAfricanRepublic(phoneNumPrefix=' + this.wo_1.toString() + ', isoCode2=' + this.xo_1 + ', isoCode3=' + this.yo_1 + ', currency=' + toString(this.zo_1) + ', englishName=' + this.ap_1 + ', arabicName=' + this.bp_1 + ', phoneRegex=' + this.cp_1 + ')';
  };
  protoOf(CentralAfricanRepublic).hashCode = function () {
    var result = this.wo_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.xo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yo_1) | 0;
    result = imul(result, 31) + hashCode(this.zo_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ap_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cp_1) | 0;
    return result;
  };
  protoOf(CentralAfricanRepublic).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CentralAfricanRepublic))
      return false;
    var tmp0_other_with_cast = other instanceof CentralAfricanRepublic ? other : THROW_CCE();
    if (!this.wo_1.equals(tmp0_other_with_cast.wo_1))
      return false;
    if (!(this.xo_1 === tmp0_other_with_cast.xo_1))
      return false;
    if (!(this.yo_1 === tmp0_other_with_cast.yo_1))
      return false;
    if (!equals(this.zo_1, tmp0_other_with_cast.zo_1))
      return false;
    if (!(this.ap_1 === tmp0_other_with_cast.ap_1))
      return false;
    if (!(this.bp_1 === tmp0_other_with_cast.bp_1))
      return false;
    if (!(this.cp_1 === tmp0_other_with_cast.cp_1))
      return false;
    return true;
  };
  function Companion_46() {
  }
  var Companion_instance_46;
  function Companion_getInstance_46() {
    return Companion_instance_46;
  }
  function Chad(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TCD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Chad' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0634\u0627\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.dp_1 = phoneNumPrefix;
    this.ep_1 = isoCode2;
    this.fp_1 = isoCode3;
    this.gp_1 = currency;
    this.hp_1 = englishName;
    this.ip_1 = arabicName;
    this.jp_1 = phoneRegex;
  }
  protoOf(Chad).wd = function () {
    return this.dp_1;
  };
  protoOf(Chad).rd = function () {
    return this.ep_1;
  };
  protoOf(Chad).sd = function () {
    return this.fp_1;
  };
  protoOf(Chad).td = function () {
    return this.gp_1;
  };
  protoOf(Chad).ud = function () {
    return this.hp_1;
  };
  protoOf(Chad).vd = function () {
    return this.ip_1;
  };
  protoOf(Chad).xd = function () {
    return this.jp_1;
  };
  protoOf(Chad).toString = function () {
    return 'Chad(phoneNumPrefix=' + this.dp_1.toString() + ', isoCode2=' + this.ep_1 + ', isoCode3=' + this.fp_1 + ', currency=' + toString(this.gp_1) + ', englishName=' + this.hp_1 + ', arabicName=' + this.ip_1 + ', phoneRegex=' + this.jp_1 + ')';
  };
  protoOf(Chad).hashCode = function () {
    var result = this.dp_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ep_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fp_1) | 0;
    result = imul(result, 31) + hashCode(this.gp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ip_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jp_1) | 0;
    return result;
  };
  protoOf(Chad).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Chad))
      return false;
    var tmp0_other_with_cast = other instanceof Chad ? other : THROW_CCE();
    if (!this.dp_1.equals(tmp0_other_with_cast.dp_1))
      return false;
    if (!(this.ep_1 === tmp0_other_with_cast.ep_1))
      return false;
    if (!(this.fp_1 === tmp0_other_with_cast.fp_1))
      return false;
    if (!equals(this.gp_1, tmp0_other_with_cast.gp_1))
      return false;
    if (!(this.hp_1 === tmp0_other_with_cast.hp_1))
      return false;
    if (!(this.ip_1 === tmp0_other_with_cast.ip_1))
      return false;
    if (!(this.jp_1 === tmp0_other_with_cast.jp_1))
      return false;
    return true;
  };
  function Companion_47() {
  }
  var Companion_instance_47;
  function Companion_getInstance_47() {
    return Companion_instance_47;
  }
  function Chile(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CHL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Chile' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0634\u064A\u0644\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.kp_1 = phoneNumPrefix;
    this.lp_1 = isoCode2;
    this.mp_1 = isoCode3;
    this.np_1 = currency;
    this.op_1 = englishName;
    this.pp_1 = arabicName;
    this.qp_1 = phoneRegex;
  }
  protoOf(Chile).wd = function () {
    return this.kp_1;
  };
  protoOf(Chile).rd = function () {
    return this.lp_1;
  };
  protoOf(Chile).sd = function () {
    return this.mp_1;
  };
  protoOf(Chile).td = function () {
    return this.np_1;
  };
  protoOf(Chile).ud = function () {
    return this.op_1;
  };
  protoOf(Chile).vd = function () {
    return this.pp_1;
  };
  protoOf(Chile).xd = function () {
    return this.qp_1;
  };
  protoOf(Chile).toString = function () {
    return 'Chile(phoneNumPrefix=' + this.kp_1.toString() + ', isoCode2=' + this.lp_1 + ', isoCode3=' + this.mp_1 + ', currency=' + toString(this.np_1) + ', englishName=' + this.op_1 + ', arabicName=' + this.pp_1 + ', phoneRegex=' + this.qp_1 + ')';
  };
  protoOf(Chile).hashCode = function () {
    var result = this.kp_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.lp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mp_1) | 0;
    result = imul(result, 31) + hashCode(this.np_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.op_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qp_1) | 0;
    return result;
  };
  protoOf(Chile).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Chile))
      return false;
    var tmp0_other_with_cast = other instanceof Chile ? other : THROW_CCE();
    if (!this.kp_1.equals(tmp0_other_with_cast.kp_1))
      return false;
    if (!(this.lp_1 === tmp0_other_with_cast.lp_1))
      return false;
    if (!(this.mp_1 === tmp0_other_with_cast.mp_1))
      return false;
    if (!equals(this.np_1, tmp0_other_with_cast.np_1))
      return false;
    if (!(this.op_1 === tmp0_other_with_cast.op_1))
      return false;
    if (!(this.pp_1 === tmp0_other_with_cast.pp_1))
      return false;
    if (!(this.qp_1 === tmp0_other_with_cast.qp_1))
      return false;
    return true;
  };
  function Companion_48() {
  }
  var Companion_instance_48;
  function Companion_getInstance_48() {
    return Companion_instance_48;
  }
  function China(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(86, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CHN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'China' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0635\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(11) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '13123456789' : phoneNumberHint;
    this.x7_1 = phoneNumPrefix;
    this.y7_1 = isoCode2;
    this.z7_1 = isoCode3;
    this.a8_1 = currency;
    this.b8_1 = englishName;
    this.c8_1 = arabicName;
    this.d8_1 = phoneRegex;
    this.e8_1 = phoneNumberHint;
  }
  protoOf(China).wd = function () {
    return this.x7_1;
  };
  protoOf(China).rd = function () {
    return this.y7_1;
  };
  protoOf(China).sd = function () {
    return this.z7_1;
  };
  protoOf(China).td = function () {
    return this.a8_1;
  };
  protoOf(China).ud = function () {
    return this.b8_1;
  };
  protoOf(China).vd = function () {
    return this.c8_1;
  };
  protoOf(China).xd = function () {
    return this.d8_1;
  };
  protoOf(China).yd = function () {
    return this.e8_1;
  };
  protoOf(China).toString = function () {
    return 'China(phoneNumPrefix=' + this.x7_1.toString() + ', isoCode2=' + this.y7_1 + ', isoCode3=' + this.z7_1 + ', currency=' + toString(this.a8_1) + ', englishName=' + this.b8_1 + ', arabicName=' + this.c8_1 + ', phoneRegex=' + this.d8_1 + ', phoneNumberHint=' + this.e8_1 + ')';
  };
  protoOf(China).hashCode = function () {
    var result = this.x7_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.y7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z7_1) | 0;
    result = imul(result, 31) + hashCode(this.a8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e8_1) | 0;
    return result;
  };
  protoOf(China).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof China))
      return false;
    var tmp0_other_with_cast = other instanceof China ? other : THROW_CCE();
    if (!this.x7_1.equals(tmp0_other_with_cast.x7_1))
      return false;
    if (!(this.y7_1 === tmp0_other_with_cast.y7_1))
      return false;
    if (!(this.z7_1 === tmp0_other_with_cast.z7_1))
      return false;
    if (!equals(this.a8_1, tmp0_other_with_cast.a8_1))
      return false;
    if (!(this.b8_1 === tmp0_other_with_cast.b8_1))
      return false;
    if (!(this.c8_1 === tmp0_other_with_cast.c8_1))
      return false;
    if (!(this.d8_1 === tmp0_other_with_cast.d8_1))
      return false;
    if (!(this.e8_1 === tmp0_other_with_cast.e8_1))
      return false;
    return true;
  };
  function Companion_49() {
  }
  var Companion_instance_49;
  function Companion_getInstance_49() {
    return Companion_instance_49;
  }
  function ChristmasIsland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CX' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CXR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Christmas Island' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u064A\u0631\u0629 \u0643\u0631\u064A\u0633\u0645\u0627\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.rp_1 = phoneNumPrefix;
    this.sp_1 = isoCode2;
    this.tp_1 = isoCode3;
    this.up_1 = currency;
    this.vp_1 = englishName;
    this.wp_1 = arabicName;
    this.xp_1 = phoneRegex;
  }
  protoOf(ChristmasIsland).wd = function () {
    return this.rp_1;
  };
  protoOf(ChristmasIsland).rd = function () {
    return this.sp_1;
  };
  protoOf(ChristmasIsland).sd = function () {
    return this.tp_1;
  };
  protoOf(ChristmasIsland).td = function () {
    return this.up_1;
  };
  protoOf(ChristmasIsland).ud = function () {
    return this.vp_1;
  };
  protoOf(ChristmasIsland).vd = function () {
    return this.wp_1;
  };
  protoOf(ChristmasIsland).xd = function () {
    return this.xp_1;
  };
  protoOf(ChristmasIsland).toString = function () {
    return 'ChristmasIsland(phoneNumPrefix=' + this.rp_1.toString() + ', isoCode2=' + this.sp_1 + ', isoCode3=' + this.tp_1 + ', currency=' + toString(this.up_1) + ', englishName=' + this.vp_1 + ', arabicName=' + this.wp_1 + ', phoneRegex=' + this.xp_1 + ')';
  };
  protoOf(ChristmasIsland).hashCode = function () {
    var result = this.rp_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.sp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tp_1) | 0;
    result = imul(result, 31) + hashCode(this.up_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xp_1) | 0;
    return result;
  };
  protoOf(ChristmasIsland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChristmasIsland))
      return false;
    var tmp0_other_with_cast = other instanceof ChristmasIsland ? other : THROW_CCE();
    if (!this.rp_1.equals(tmp0_other_with_cast.rp_1))
      return false;
    if (!(this.sp_1 === tmp0_other_with_cast.sp_1))
      return false;
    if (!(this.tp_1 === tmp0_other_with_cast.tp_1))
      return false;
    if (!equals(this.up_1, tmp0_other_with_cast.up_1))
      return false;
    if (!(this.vp_1 === tmp0_other_with_cast.vp_1))
      return false;
    if (!(this.wp_1 === tmp0_other_with_cast.wp_1))
      return false;
    if (!(this.xp_1 === tmp0_other_with_cast.xp_1))
      return false;
    return true;
  };
  function Companion_50() {
  }
  var Companion_instance_50;
  function Companion_getInstance_50() {
    return Companion_instance_50;
  }
  function CocosKeelingIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CCK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cocos (Keeling) Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0643\u0648\u0643\u0648\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.yp_1 = phoneNumPrefix;
    this.zp_1 = isoCode2;
    this.aq_1 = isoCode3;
    this.bq_1 = currency;
    this.cq_1 = englishName;
    this.dq_1 = arabicName;
    this.eq_1 = phoneRegex;
  }
  protoOf(CocosKeelingIslands).wd = function () {
    return this.yp_1;
  };
  protoOf(CocosKeelingIslands).rd = function () {
    return this.zp_1;
  };
  protoOf(CocosKeelingIslands).sd = function () {
    return this.aq_1;
  };
  protoOf(CocosKeelingIslands).td = function () {
    return this.bq_1;
  };
  protoOf(CocosKeelingIslands).ud = function () {
    return this.cq_1;
  };
  protoOf(CocosKeelingIslands).vd = function () {
    return this.dq_1;
  };
  protoOf(CocosKeelingIslands).xd = function () {
    return this.eq_1;
  };
  protoOf(CocosKeelingIslands).toString = function () {
    return 'CocosKeelingIslands(phoneNumPrefix=' + this.yp_1.toString() + ', isoCode2=' + this.zp_1 + ', isoCode3=' + this.aq_1 + ', currency=' + toString(this.bq_1) + ', englishName=' + this.cq_1 + ', arabicName=' + this.dq_1 + ', phoneRegex=' + this.eq_1 + ')';
  };
  protoOf(CocosKeelingIslands).hashCode = function () {
    var result = this.yp_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.zp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.aq_1) | 0;
    result = imul(result, 31) + hashCode(this.bq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.eq_1) | 0;
    return result;
  };
  protoOf(CocosKeelingIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CocosKeelingIslands))
      return false;
    var tmp0_other_with_cast = other instanceof CocosKeelingIslands ? other : THROW_CCE();
    if (!this.yp_1.equals(tmp0_other_with_cast.yp_1))
      return false;
    if (!(this.zp_1 === tmp0_other_with_cast.zp_1))
      return false;
    if (!(this.aq_1 === tmp0_other_with_cast.aq_1))
      return false;
    if (!equals(this.bq_1, tmp0_other_with_cast.bq_1))
      return false;
    if (!(this.cq_1 === tmp0_other_with_cast.cq_1))
      return false;
    if (!(this.dq_1 === tmp0_other_with_cast.dq_1))
      return false;
    if (!(this.eq_1 === tmp0_other_with_cast.eq_1))
      return false;
    return true;
  };
  function Companion_51() {
  }
  var Companion_instance_51;
  function Companion_getInstance_51() {
    return Companion_instance_51;
  }
  function Colombia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'COL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Colombia' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0648\u0644\u0648\u0645\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.fq_1 = phoneNumPrefix;
    this.gq_1 = isoCode2;
    this.hq_1 = isoCode3;
    this.iq_1 = currency;
    this.jq_1 = englishName;
    this.kq_1 = arabicName;
    this.lq_1 = phoneRegex;
  }
  protoOf(Colombia).wd = function () {
    return this.fq_1;
  };
  protoOf(Colombia).rd = function () {
    return this.gq_1;
  };
  protoOf(Colombia).sd = function () {
    return this.hq_1;
  };
  protoOf(Colombia).td = function () {
    return this.iq_1;
  };
  protoOf(Colombia).ud = function () {
    return this.jq_1;
  };
  protoOf(Colombia).vd = function () {
    return this.kq_1;
  };
  protoOf(Colombia).xd = function () {
    return this.lq_1;
  };
  protoOf(Colombia).toString = function () {
    return 'Colombia(phoneNumPrefix=' + this.fq_1.toString() + ', isoCode2=' + this.gq_1 + ', isoCode3=' + this.hq_1 + ', currency=' + toString(this.iq_1) + ', englishName=' + this.jq_1 + ', arabicName=' + this.kq_1 + ', phoneRegex=' + this.lq_1 + ')';
  };
  protoOf(Colombia).hashCode = function () {
    var result = this.fq_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.gq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hq_1) | 0;
    result = imul(result, 31) + hashCode(this.iq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lq_1) | 0;
    return result;
  };
  protoOf(Colombia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Colombia))
      return false;
    var tmp0_other_with_cast = other instanceof Colombia ? other : THROW_CCE();
    if (!this.fq_1.equals(tmp0_other_with_cast.fq_1))
      return false;
    if (!(this.gq_1 === tmp0_other_with_cast.gq_1))
      return false;
    if (!(this.hq_1 === tmp0_other_with_cast.hq_1))
      return false;
    if (!equals(this.iq_1, tmp0_other_with_cast.iq_1))
      return false;
    if (!(this.jq_1 === tmp0_other_with_cast.jq_1))
      return false;
    if (!(this.kq_1 === tmp0_other_with_cast.kq_1))
      return false;
    if (!(this.lq_1 === tmp0_other_with_cast.lq_1))
      return false;
    return true;
  };
  function Companion_52() {
  }
  var Companion_instance_52;
  function Companion_getInstance_52() {
    return Companion_instance_52;
  }
  function Comoros(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'COM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Comoros' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.mq_1 = phoneNumPrefix;
    this.nq_1 = isoCode2;
    this.oq_1 = isoCode3;
    this.pq_1 = currency;
    this.qq_1 = englishName;
    this.rq_1 = arabicName;
    this.sq_1 = phoneRegex;
  }
  protoOf(Comoros).wd = function () {
    return this.mq_1;
  };
  protoOf(Comoros).rd = function () {
    return this.nq_1;
  };
  protoOf(Comoros).sd = function () {
    return this.oq_1;
  };
  protoOf(Comoros).td = function () {
    return this.pq_1;
  };
  protoOf(Comoros).ud = function () {
    return this.qq_1;
  };
  protoOf(Comoros).vd = function () {
    return this.rq_1;
  };
  protoOf(Comoros).xd = function () {
    return this.sq_1;
  };
  protoOf(Comoros).toString = function () {
    return 'Comoros(phoneNumPrefix=' + this.mq_1.toString() + ', isoCode2=' + this.nq_1 + ', isoCode3=' + this.oq_1 + ', currency=' + toString(this.pq_1) + ', englishName=' + this.qq_1 + ', arabicName=' + this.rq_1 + ', phoneRegex=' + this.sq_1 + ')';
  };
  protoOf(Comoros).hashCode = function () {
    var result = this.mq_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.nq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oq_1) | 0;
    result = imul(result, 31) + hashCode(this.pq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sq_1) | 0;
    return result;
  };
  protoOf(Comoros).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Comoros))
      return false;
    var tmp0_other_with_cast = other instanceof Comoros ? other : THROW_CCE();
    if (!this.mq_1.equals(tmp0_other_with_cast.mq_1))
      return false;
    if (!(this.nq_1 === tmp0_other_with_cast.nq_1))
      return false;
    if (!(this.oq_1 === tmp0_other_with_cast.oq_1))
      return false;
    if (!equals(this.pq_1, tmp0_other_with_cast.pq_1))
      return false;
    if (!(this.qq_1 === tmp0_other_with_cast.qq_1))
      return false;
    if (!(this.rq_1 === tmp0_other_with_cast.rq_1))
      return false;
    if (!(this.sq_1 === tmp0_other_with_cast.sq_1))
      return false;
    return true;
  };
  function Companion_53() {
  }
  var Companion_instance_53;
  function Companion_getInstance_53() {
    return Companion_instance_53;
  }
  function Congo(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'COG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Congo' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0643\u0648\u0646\u063A\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.tq_1 = phoneNumPrefix;
    this.uq_1 = isoCode2;
    this.vq_1 = isoCode3;
    this.wq_1 = currency;
    this.xq_1 = englishName;
    this.yq_1 = arabicName;
    this.zq_1 = phoneRegex;
  }
  protoOf(Congo).wd = function () {
    return this.tq_1;
  };
  protoOf(Congo).rd = function () {
    return this.uq_1;
  };
  protoOf(Congo).sd = function () {
    return this.vq_1;
  };
  protoOf(Congo).td = function () {
    return this.wq_1;
  };
  protoOf(Congo).ud = function () {
    return this.xq_1;
  };
  protoOf(Congo).vd = function () {
    return this.yq_1;
  };
  protoOf(Congo).xd = function () {
    return this.zq_1;
  };
  protoOf(Congo).toString = function () {
    return 'Congo(phoneNumPrefix=' + this.tq_1.toString() + ', isoCode2=' + this.uq_1 + ', isoCode3=' + this.vq_1 + ', currency=' + toString(this.wq_1) + ', englishName=' + this.xq_1 + ', arabicName=' + this.yq_1 + ', phoneRegex=' + this.zq_1 + ')';
  };
  protoOf(Congo).hashCode = function () {
    var result = this.tq_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.uq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vq_1) | 0;
    result = imul(result, 31) + hashCode(this.wq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zq_1) | 0;
    return result;
  };
  protoOf(Congo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Congo))
      return false;
    var tmp0_other_with_cast = other instanceof Congo ? other : THROW_CCE();
    if (!this.tq_1.equals(tmp0_other_with_cast.tq_1))
      return false;
    if (!(this.uq_1 === tmp0_other_with_cast.uq_1))
      return false;
    if (!(this.vq_1 === tmp0_other_with_cast.vq_1))
      return false;
    if (!equals(this.wq_1, tmp0_other_with_cast.wq_1))
      return false;
    if (!(this.xq_1 === tmp0_other_with_cast.xq_1))
      return false;
    if (!(this.yq_1 === tmp0_other_with_cast.yq_1))
      return false;
    if (!(this.zq_1 === tmp0_other_with_cast.zq_1))
      return false;
    return true;
  };
  function Companion_54() {
  }
  var Companion_instance_54;
  function Companion_getInstance_54() {
    return Companion_instance_54;
  }
  function CongoDemocraticRepublicofthe(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'COD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Congo, Democratic Republic of the' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0643\u0648\u0646\u063A\u0648 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ar_1 = phoneNumPrefix;
    this.br_1 = isoCode2;
    this.cr_1 = isoCode3;
    this.dr_1 = currency;
    this.er_1 = englishName;
    this.fr_1 = arabicName;
    this.gr_1 = phoneRegex;
  }
  protoOf(CongoDemocraticRepublicofthe).wd = function () {
    return this.ar_1;
  };
  protoOf(CongoDemocraticRepublicofthe).rd = function () {
    return this.br_1;
  };
  protoOf(CongoDemocraticRepublicofthe).sd = function () {
    return this.cr_1;
  };
  protoOf(CongoDemocraticRepublicofthe).td = function () {
    return this.dr_1;
  };
  protoOf(CongoDemocraticRepublicofthe).ud = function () {
    return this.er_1;
  };
  protoOf(CongoDemocraticRepublicofthe).vd = function () {
    return this.fr_1;
  };
  protoOf(CongoDemocraticRepublicofthe).xd = function () {
    return this.gr_1;
  };
  protoOf(CongoDemocraticRepublicofthe).toString = function () {
    return 'CongoDemocraticRepublicofthe(phoneNumPrefix=' + this.ar_1.toString() + ', isoCode2=' + this.br_1 + ', isoCode3=' + this.cr_1 + ', currency=' + toString(this.dr_1) + ', englishName=' + this.er_1 + ', arabicName=' + this.fr_1 + ', phoneRegex=' + this.gr_1 + ')';
  };
  protoOf(CongoDemocraticRepublicofthe).hashCode = function () {
    var result = this.ar_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.br_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cr_1) | 0;
    result = imul(result, 31) + hashCode(this.dr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.er_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gr_1) | 0;
    return result;
  };
  protoOf(CongoDemocraticRepublicofthe).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CongoDemocraticRepublicofthe))
      return false;
    var tmp0_other_with_cast = other instanceof CongoDemocraticRepublicofthe ? other : THROW_CCE();
    if (!this.ar_1.equals(tmp0_other_with_cast.ar_1))
      return false;
    if (!(this.br_1 === tmp0_other_with_cast.br_1))
      return false;
    if (!(this.cr_1 === tmp0_other_with_cast.cr_1))
      return false;
    if (!equals(this.dr_1, tmp0_other_with_cast.dr_1))
      return false;
    if (!(this.er_1 === tmp0_other_with_cast.er_1))
      return false;
    if (!(this.fr_1 === tmp0_other_with_cast.fr_1))
      return false;
    if (!(this.gr_1 === tmp0_other_with_cast.gr_1))
      return false;
    return true;
  };
  function Companion_55() {
  }
  var Companion_instance_55;
  function Companion_getInstance_55() {
    return Companion_instance_55;
  }
  function CookIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'COK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cook Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0643\u0648\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.hr_1 = phoneNumPrefix;
    this.ir_1 = isoCode2;
    this.jr_1 = isoCode3;
    this.kr_1 = currency;
    this.lr_1 = englishName;
    this.mr_1 = arabicName;
    this.nr_1 = phoneRegex;
  }
  protoOf(CookIslands).wd = function () {
    return this.hr_1;
  };
  protoOf(CookIslands).rd = function () {
    return this.ir_1;
  };
  protoOf(CookIslands).sd = function () {
    return this.jr_1;
  };
  protoOf(CookIslands).td = function () {
    return this.kr_1;
  };
  protoOf(CookIslands).ud = function () {
    return this.lr_1;
  };
  protoOf(CookIslands).vd = function () {
    return this.mr_1;
  };
  protoOf(CookIslands).xd = function () {
    return this.nr_1;
  };
  protoOf(CookIslands).toString = function () {
    return 'CookIslands(phoneNumPrefix=' + this.hr_1.toString() + ', isoCode2=' + this.ir_1 + ', isoCode3=' + this.jr_1 + ', currency=' + toString(this.kr_1) + ', englishName=' + this.lr_1 + ', arabicName=' + this.mr_1 + ', phoneRegex=' + this.nr_1 + ')';
  };
  protoOf(CookIslands).hashCode = function () {
    var result = this.hr_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ir_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jr_1) | 0;
    result = imul(result, 31) + hashCode(this.kr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nr_1) | 0;
    return result;
  };
  protoOf(CookIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CookIslands))
      return false;
    var tmp0_other_with_cast = other instanceof CookIslands ? other : THROW_CCE();
    if (!this.hr_1.equals(tmp0_other_with_cast.hr_1))
      return false;
    if (!(this.ir_1 === tmp0_other_with_cast.ir_1))
      return false;
    if (!(this.jr_1 === tmp0_other_with_cast.jr_1))
      return false;
    if (!equals(this.kr_1, tmp0_other_with_cast.kr_1))
      return false;
    if (!(this.lr_1 === tmp0_other_with_cast.lr_1))
      return false;
    if (!(this.mr_1 === tmp0_other_with_cast.mr_1))
      return false;
    if (!(this.nr_1 === tmp0_other_with_cast.nr_1))
      return false;
    return true;
  };
  function Companion_56() {
  }
  var Companion_instance_56;
  function Companion_getInstance_56() {
    return Companion_instance_56;
  }
  function CostaRica(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CRI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Costa Rica' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0648\u0633\u062A\u0627\u0631\u064A\u0643\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.or_1 = phoneNumPrefix;
    this.pr_1 = isoCode2;
    this.qr_1 = isoCode3;
    this.rr_1 = currency;
    this.sr_1 = englishName;
    this.tr_1 = arabicName;
    this.ur_1 = phoneRegex;
  }
  protoOf(CostaRica).wd = function () {
    return this.or_1;
  };
  protoOf(CostaRica).rd = function () {
    return this.pr_1;
  };
  protoOf(CostaRica).sd = function () {
    return this.qr_1;
  };
  protoOf(CostaRica).td = function () {
    return this.rr_1;
  };
  protoOf(CostaRica).ud = function () {
    return this.sr_1;
  };
  protoOf(CostaRica).vd = function () {
    return this.tr_1;
  };
  protoOf(CostaRica).xd = function () {
    return this.ur_1;
  };
  protoOf(CostaRica).toString = function () {
    return 'CostaRica(phoneNumPrefix=' + this.or_1.toString() + ', isoCode2=' + this.pr_1 + ', isoCode3=' + this.qr_1 + ', currency=' + toString(this.rr_1) + ', englishName=' + this.sr_1 + ', arabicName=' + this.tr_1 + ', phoneRegex=' + this.ur_1 + ')';
  };
  protoOf(CostaRica).hashCode = function () {
    var result = this.or_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.pr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qr_1) | 0;
    result = imul(result, 31) + hashCode(this.rr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ur_1) | 0;
    return result;
  };
  protoOf(CostaRica).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CostaRica))
      return false;
    var tmp0_other_with_cast = other instanceof CostaRica ? other : THROW_CCE();
    if (!this.or_1.equals(tmp0_other_with_cast.or_1))
      return false;
    if (!(this.pr_1 === tmp0_other_with_cast.pr_1))
      return false;
    if (!(this.qr_1 === tmp0_other_with_cast.qr_1))
      return false;
    if (!equals(this.rr_1, tmp0_other_with_cast.rr_1))
      return false;
    if (!(this.sr_1 === tmp0_other_with_cast.sr_1))
      return false;
    if (!(this.tr_1 === tmp0_other_with_cast.tr_1))
      return false;
    if (!(this.ur_1 === tmp0_other_with_cast.ur_1))
      return false;
    return true;
  };
  function Companion_57() {
  }
  var Companion_instance_57;
  function Companion_getInstance_57() {
    return Companion_instance_57;
  }
  function CotedIvoire(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CIV' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? "C\xF4te d'Ivoire" : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u062D\u0644 \u0627\u0644\u0639\u0627\u062C' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.vr_1 = phoneNumPrefix;
    this.wr_1 = isoCode2;
    this.xr_1 = isoCode3;
    this.yr_1 = currency;
    this.zr_1 = englishName;
    this.as_1 = arabicName;
    this.bs_1 = phoneRegex;
  }
  protoOf(CotedIvoire).wd = function () {
    return this.vr_1;
  };
  protoOf(CotedIvoire).rd = function () {
    return this.wr_1;
  };
  protoOf(CotedIvoire).sd = function () {
    return this.xr_1;
  };
  protoOf(CotedIvoire).td = function () {
    return this.yr_1;
  };
  protoOf(CotedIvoire).ud = function () {
    return this.zr_1;
  };
  protoOf(CotedIvoire).vd = function () {
    return this.as_1;
  };
  protoOf(CotedIvoire).xd = function () {
    return this.bs_1;
  };
  protoOf(CotedIvoire).toString = function () {
    return 'CotedIvoire(phoneNumPrefix=' + this.vr_1.toString() + ', isoCode2=' + this.wr_1 + ', isoCode3=' + this.xr_1 + ', currency=' + toString(this.yr_1) + ', englishName=' + this.zr_1 + ', arabicName=' + this.as_1 + ', phoneRegex=' + this.bs_1 + ')';
  };
  protoOf(CotedIvoire).hashCode = function () {
    var result = this.vr_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.wr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xr_1) | 0;
    result = imul(result, 31) + hashCode(this.yr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zr_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.as_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bs_1) | 0;
    return result;
  };
  protoOf(CotedIvoire).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CotedIvoire))
      return false;
    var tmp0_other_with_cast = other instanceof CotedIvoire ? other : THROW_CCE();
    if (!this.vr_1.equals(tmp0_other_with_cast.vr_1))
      return false;
    if (!(this.wr_1 === tmp0_other_with_cast.wr_1))
      return false;
    if (!(this.xr_1 === tmp0_other_with_cast.xr_1))
      return false;
    if (!equals(this.yr_1, tmp0_other_with_cast.yr_1))
      return false;
    if (!(this.zr_1 === tmp0_other_with_cast.zr_1))
      return false;
    if (!(this.as_1 === tmp0_other_with_cast.as_1))
      return false;
    if (!(this.bs_1 === tmp0_other_with_cast.bs_1))
      return false;
    return true;
  };
  function Companion_58() {
  }
  var Companion_instance_58;
  function Companion_getInstance_58() {
    return Companion_instance_58;
  }
  function Croatia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'HR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'HRV' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Croatia' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0631\u0648\u0627\u062A\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.cs_1 = phoneNumPrefix;
    this.ds_1 = isoCode2;
    this.es_1 = isoCode3;
    this.fs_1 = currency;
    this.gs_1 = englishName;
    this.hs_1 = arabicName;
    this.is_1 = phoneRegex;
  }
  protoOf(Croatia).wd = function () {
    return this.cs_1;
  };
  protoOf(Croatia).rd = function () {
    return this.ds_1;
  };
  protoOf(Croatia).sd = function () {
    return this.es_1;
  };
  protoOf(Croatia).td = function () {
    return this.fs_1;
  };
  protoOf(Croatia).ud = function () {
    return this.gs_1;
  };
  protoOf(Croatia).vd = function () {
    return this.hs_1;
  };
  protoOf(Croatia).xd = function () {
    return this.is_1;
  };
  protoOf(Croatia).toString = function () {
    return 'Croatia(phoneNumPrefix=' + this.cs_1.toString() + ', isoCode2=' + this.ds_1 + ', isoCode3=' + this.es_1 + ', currency=' + toString(this.fs_1) + ', englishName=' + this.gs_1 + ', arabicName=' + this.hs_1 + ', phoneRegex=' + this.is_1 + ')';
  };
  protoOf(Croatia).hashCode = function () {
    var result = this.cs_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ds_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.es_1) | 0;
    result = imul(result, 31) + hashCode(this.fs_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gs_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hs_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.is_1) | 0;
    return result;
  };
  protoOf(Croatia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Croatia))
      return false;
    var tmp0_other_with_cast = other instanceof Croatia ? other : THROW_CCE();
    if (!this.cs_1.equals(tmp0_other_with_cast.cs_1))
      return false;
    if (!(this.ds_1 === tmp0_other_with_cast.ds_1))
      return false;
    if (!(this.es_1 === tmp0_other_with_cast.es_1))
      return false;
    if (!equals(this.fs_1, tmp0_other_with_cast.fs_1))
      return false;
    if (!(this.gs_1 === tmp0_other_with_cast.gs_1))
      return false;
    if (!(this.hs_1 === tmp0_other_with_cast.hs_1))
      return false;
    if (!(this.is_1 === tmp0_other_with_cast.is_1))
      return false;
    return true;
  };
  function Companion_59() {
  }
  var Companion_instance_59;
  function Companion_getInstance_59() {
    return Companion_instance_59;
  }
  function Cuba(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CUB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cuba' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0648\u0628\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.js_1 = phoneNumPrefix;
    this.ks_1 = isoCode2;
    this.ls_1 = isoCode3;
    this.ms_1 = currency;
    this.ns_1 = englishName;
    this.os_1 = arabicName;
    this.ps_1 = phoneRegex;
  }
  protoOf(Cuba).wd = function () {
    return this.js_1;
  };
  protoOf(Cuba).rd = function () {
    return this.ks_1;
  };
  protoOf(Cuba).sd = function () {
    return this.ls_1;
  };
  protoOf(Cuba).td = function () {
    return this.ms_1;
  };
  protoOf(Cuba).ud = function () {
    return this.ns_1;
  };
  protoOf(Cuba).vd = function () {
    return this.os_1;
  };
  protoOf(Cuba).xd = function () {
    return this.ps_1;
  };
  protoOf(Cuba).toString = function () {
    return 'Cuba(phoneNumPrefix=' + this.js_1.toString() + ', isoCode2=' + this.ks_1 + ', isoCode3=' + this.ls_1 + ', currency=' + toString(this.ms_1) + ', englishName=' + this.ns_1 + ', arabicName=' + this.os_1 + ', phoneRegex=' + this.ps_1 + ')';
  };
  protoOf(Cuba).hashCode = function () {
    var result = this.js_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ks_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ls_1) | 0;
    result = imul(result, 31) + hashCode(this.ms_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ns_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.os_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ps_1) | 0;
    return result;
  };
  protoOf(Cuba).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Cuba))
      return false;
    var tmp0_other_with_cast = other instanceof Cuba ? other : THROW_CCE();
    if (!this.js_1.equals(tmp0_other_with_cast.js_1))
      return false;
    if (!(this.ks_1 === tmp0_other_with_cast.ks_1))
      return false;
    if (!(this.ls_1 === tmp0_other_with_cast.ls_1))
      return false;
    if (!equals(this.ms_1, tmp0_other_with_cast.ms_1))
      return false;
    if (!(this.ns_1 === tmp0_other_with_cast.ns_1))
      return false;
    if (!(this.os_1 === tmp0_other_with_cast.os_1))
      return false;
    if (!(this.ps_1 === tmp0_other_with_cast.ps_1))
      return false;
    return true;
  };
  function Companion_60() {
  }
  var Companion_instance_60;
  function Companion_getInstance_60() {
    return Companion_instance_60;
  }
  function Curacao(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CUW' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cura\xE7ao' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0648\u0631\u0627\u0633\u0627\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.qs_1 = phoneNumPrefix;
    this.rs_1 = isoCode2;
    this.ss_1 = isoCode3;
    this.ts_1 = currency;
    this.us_1 = englishName;
    this.vs_1 = arabicName;
    this.ws_1 = phoneRegex;
  }
  protoOf(Curacao).wd = function () {
    return this.qs_1;
  };
  protoOf(Curacao).rd = function () {
    return this.rs_1;
  };
  protoOf(Curacao).sd = function () {
    return this.ss_1;
  };
  protoOf(Curacao).td = function () {
    return this.ts_1;
  };
  protoOf(Curacao).ud = function () {
    return this.us_1;
  };
  protoOf(Curacao).vd = function () {
    return this.vs_1;
  };
  protoOf(Curacao).xd = function () {
    return this.ws_1;
  };
  protoOf(Curacao).toString = function () {
    return 'Curacao(phoneNumPrefix=' + this.qs_1.toString() + ', isoCode2=' + this.rs_1 + ', isoCode3=' + this.ss_1 + ', currency=' + toString(this.ts_1) + ', englishName=' + this.us_1 + ', arabicName=' + this.vs_1 + ', phoneRegex=' + this.ws_1 + ')';
  };
  protoOf(Curacao).hashCode = function () {
    var result = this.qs_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.rs_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ss_1) | 0;
    result = imul(result, 31) + hashCode(this.ts_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.us_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vs_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ws_1) | 0;
    return result;
  };
  protoOf(Curacao).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Curacao))
      return false;
    var tmp0_other_with_cast = other instanceof Curacao ? other : THROW_CCE();
    if (!this.qs_1.equals(tmp0_other_with_cast.qs_1))
      return false;
    if (!(this.rs_1 === tmp0_other_with_cast.rs_1))
      return false;
    if (!(this.ss_1 === tmp0_other_with_cast.ss_1))
      return false;
    if (!equals(this.ts_1, tmp0_other_with_cast.ts_1))
      return false;
    if (!(this.us_1 === tmp0_other_with_cast.us_1))
      return false;
    if (!(this.vs_1 === tmp0_other_with_cast.vs_1))
      return false;
    if (!(this.ws_1 === tmp0_other_with_cast.ws_1))
      return false;
    return true;
  };
  function Companion_61() {
  }
  var Companion_instance_61;
  function Companion_getInstance_61() {
    return Companion_instance_61;
  }
  function Cyprus(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CYP' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Cyprus' : englishName;
    arabicName = arabicName === VOID ? '\u0642\u0628\u0631\u0635' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.xs_1 = phoneNumPrefix;
    this.ys_1 = isoCode2;
    this.zs_1 = isoCode3;
    this.at_1 = currency;
    this.bt_1 = englishName;
    this.ct_1 = arabicName;
    this.dt_1 = phoneRegex;
  }
  protoOf(Cyprus).wd = function () {
    return this.xs_1;
  };
  protoOf(Cyprus).rd = function () {
    return this.ys_1;
  };
  protoOf(Cyprus).sd = function () {
    return this.zs_1;
  };
  protoOf(Cyprus).td = function () {
    return this.at_1;
  };
  protoOf(Cyprus).ud = function () {
    return this.bt_1;
  };
  protoOf(Cyprus).vd = function () {
    return this.ct_1;
  };
  protoOf(Cyprus).xd = function () {
    return this.dt_1;
  };
  protoOf(Cyprus).toString = function () {
    return 'Cyprus(phoneNumPrefix=' + this.xs_1.toString() + ', isoCode2=' + this.ys_1 + ', isoCode3=' + this.zs_1 + ', currency=' + toString(this.at_1) + ', englishName=' + this.bt_1 + ', arabicName=' + this.ct_1 + ', phoneRegex=' + this.dt_1 + ')';
  };
  protoOf(Cyprus).hashCode = function () {
    var result = this.xs_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ys_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zs_1) | 0;
    result = imul(result, 31) + hashCode(this.at_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ct_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dt_1) | 0;
    return result;
  };
  protoOf(Cyprus).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Cyprus))
      return false;
    var tmp0_other_with_cast = other instanceof Cyprus ? other : THROW_CCE();
    if (!this.xs_1.equals(tmp0_other_with_cast.xs_1))
      return false;
    if (!(this.ys_1 === tmp0_other_with_cast.ys_1))
      return false;
    if (!(this.zs_1 === tmp0_other_with_cast.zs_1))
      return false;
    if (!equals(this.at_1, tmp0_other_with_cast.at_1))
      return false;
    if (!(this.bt_1 === tmp0_other_with_cast.bt_1))
      return false;
    if (!(this.ct_1 === tmp0_other_with_cast.ct_1))
      return false;
    if (!(this.dt_1 === tmp0_other_with_cast.dt_1))
      return false;
    return true;
  };
  function Companion_62() {
  }
  var Companion_instance_62;
  function Companion_getInstance_62() {
    return Companion_instance_62;
  }
  function Czechia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CZE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Czechia' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0634\u064A\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.et_1 = phoneNumPrefix;
    this.ft_1 = isoCode2;
    this.gt_1 = isoCode3;
    this.ht_1 = currency;
    this.it_1 = englishName;
    this.jt_1 = arabicName;
    this.kt_1 = phoneRegex;
  }
  protoOf(Czechia).wd = function () {
    return this.et_1;
  };
  protoOf(Czechia).rd = function () {
    return this.ft_1;
  };
  protoOf(Czechia).sd = function () {
    return this.gt_1;
  };
  protoOf(Czechia).td = function () {
    return this.ht_1;
  };
  protoOf(Czechia).ud = function () {
    return this.it_1;
  };
  protoOf(Czechia).vd = function () {
    return this.jt_1;
  };
  protoOf(Czechia).xd = function () {
    return this.kt_1;
  };
  protoOf(Czechia).toString = function () {
    return 'Czechia(phoneNumPrefix=' + this.et_1.toString() + ', isoCode2=' + this.ft_1 + ', isoCode3=' + this.gt_1 + ', currency=' + toString(this.ht_1) + ', englishName=' + this.it_1 + ', arabicName=' + this.jt_1 + ', phoneRegex=' + this.kt_1 + ')';
  };
  protoOf(Czechia).hashCode = function () {
    var result = this.et_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ft_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gt_1) | 0;
    result = imul(result, 31) + hashCode(this.ht_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.it_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kt_1) | 0;
    return result;
  };
  protoOf(Czechia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Czechia))
      return false;
    var tmp0_other_with_cast = other instanceof Czechia ? other : THROW_CCE();
    if (!this.et_1.equals(tmp0_other_with_cast.et_1))
      return false;
    if (!(this.ft_1 === tmp0_other_with_cast.ft_1))
      return false;
    if (!(this.gt_1 === tmp0_other_with_cast.gt_1))
      return false;
    if (!equals(this.ht_1, tmp0_other_with_cast.ht_1))
      return false;
    if (!(this.it_1 === tmp0_other_with_cast.it_1))
      return false;
    if (!(this.jt_1 === tmp0_other_with_cast.jt_1))
      return false;
    if (!(this.kt_1 === tmp0_other_with_cast.kt_1))
      return false;
    return true;
  };
  function Companion_63() {
  }
  var Companion_instance_63;
  function Companion_getInstance_63() {
    return Companion_instance_63;
  }
  function Denmark(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'DK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'DNK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Denmark' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.lt_1 = phoneNumPrefix;
    this.mt_1 = isoCode2;
    this.nt_1 = isoCode3;
    this.ot_1 = currency;
    this.pt_1 = englishName;
    this.qt_1 = arabicName;
    this.rt_1 = phoneRegex;
  }
  protoOf(Denmark).wd = function () {
    return this.lt_1;
  };
  protoOf(Denmark).rd = function () {
    return this.mt_1;
  };
  protoOf(Denmark).sd = function () {
    return this.nt_1;
  };
  protoOf(Denmark).td = function () {
    return this.ot_1;
  };
  protoOf(Denmark).ud = function () {
    return this.pt_1;
  };
  protoOf(Denmark).vd = function () {
    return this.qt_1;
  };
  protoOf(Denmark).xd = function () {
    return this.rt_1;
  };
  protoOf(Denmark).toString = function () {
    return 'Denmark(phoneNumPrefix=' + this.lt_1.toString() + ', isoCode2=' + this.mt_1 + ', isoCode3=' + this.nt_1 + ', currency=' + toString(this.ot_1) + ', englishName=' + this.pt_1 + ', arabicName=' + this.qt_1 + ', phoneRegex=' + this.rt_1 + ')';
  };
  protoOf(Denmark).hashCode = function () {
    var result = this.lt_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.mt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nt_1) | 0;
    result = imul(result, 31) + hashCode(this.ot_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rt_1) | 0;
    return result;
  };
  protoOf(Denmark).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Denmark))
      return false;
    var tmp0_other_with_cast = other instanceof Denmark ? other : THROW_CCE();
    if (!this.lt_1.equals(tmp0_other_with_cast.lt_1))
      return false;
    if (!(this.mt_1 === tmp0_other_with_cast.mt_1))
      return false;
    if (!(this.nt_1 === tmp0_other_with_cast.nt_1))
      return false;
    if (!equals(this.ot_1, tmp0_other_with_cast.ot_1))
      return false;
    if (!(this.pt_1 === tmp0_other_with_cast.pt_1))
      return false;
    if (!(this.qt_1 === tmp0_other_with_cast.qt_1))
      return false;
    if (!(this.rt_1 === tmp0_other_with_cast.rt_1))
      return false;
    return true;
  };
  function Companion_64() {
  }
  var Companion_instance_64;
  function Companion_getInstance_64() {
    return Companion_instance_64;
  }
  function Djibouti(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'DJ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'DJI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Djibouti' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u064A\u0628\u0648\u062A\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.st_1 = phoneNumPrefix;
    this.tt_1 = isoCode2;
    this.ut_1 = isoCode3;
    this.vt_1 = currency;
    this.wt_1 = englishName;
    this.xt_1 = arabicName;
    this.yt_1 = phoneRegex;
  }
  protoOf(Djibouti).wd = function () {
    return this.st_1;
  };
  protoOf(Djibouti).rd = function () {
    return this.tt_1;
  };
  protoOf(Djibouti).sd = function () {
    return this.ut_1;
  };
  protoOf(Djibouti).td = function () {
    return this.vt_1;
  };
  protoOf(Djibouti).ud = function () {
    return this.wt_1;
  };
  protoOf(Djibouti).vd = function () {
    return this.xt_1;
  };
  protoOf(Djibouti).xd = function () {
    return this.yt_1;
  };
  protoOf(Djibouti).toString = function () {
    return 'Djibouti(phoneNumPrefix=' + this.st_1.toString() + ', isoCode2=' + this.tt_1 + ', isoCode3=' + this.ut_1 + ', currency=' + toString(this.vt_1) + ', englishName=' + this.wt_1 + ', arabicName=' + this.xt_1 + ', phoneRegex=' + this.yt_1 + ')';
  };
  protoOf(Djibouti).hashCode = function () {
    var result = this.st_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.tt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ut_1) | 0;
    result = imul(result, 31) + hashCode(this.vt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xt_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yt_1) | 0;
    return result;
  };
  protoOf(Djibouti).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Djibouti))
      return false;
    var tmp0_other_with_cast = other instanceof Djibouti ? other : THROW_CCE();
    if (!this.st_1.equals(tmp0_other_with_cast.st_1))
      return false;
    if (!(this.tt_1 === tmp0_other_with_cast.tt_1))
      return false;
    if (!(this.ut_1 === tmp0_other_with_cast.ut_1))
      return false;
    if (!equals(this.vt_1, tmp0_other_with_cast.vt_1))
      return false;
    if (!(this.wt_1 === tmp0_other_with_cast.wt_1))
      return false;
    if (!(this.xt_1 === tmp0_other_with_cast.xt_1))
      return false;
    if (!(this.yt_1 === tmp0_other_with_cast.yt_1))
      return false;
    return true;
  };
  function Companion_65() {
  }
  var Companion_instance_65;
  function Companion_getInstance_65() {
    return Companion_instance_65;
  }
  function Dominica(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'DM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'DMA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Dominica' : englishName;
    arabicName = arabicName === VOID ? '\u062F\u0648\u0645\u064A\u0646\u064A\u0643\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.zt_1 = phoneNumPrefix;
    this.au_1 = isoCode2;
    this.bu_1 = isoCode3;
    this.cu_1 = currency;
    this.du_1 = englishName;
    this.eu_1 = arabicName;
    this.fu_1 = phoneRegex;
  }
  protoOf(Dominica).wd = function () {
    return this.zt_1;
  };
  protoOf(Dominica).rd = function () {
    return this.au_1;
  };
  protoOf(Dominica).sd = function () {
    return this.bu_1;
  };
  protoOf(Dominica).td = function () {
    return this.cu_1;
  };
  protoOf(Dominica).ud = function () {
    return this.du_1;
  };
  protoOf(Dominica).vd = function () {
    return this.eu_1;
  };
  protoOf(Dominica).xd = function () {
    return this.fu_1;
  };
  protoOf(Dominica).toString = function () {
    return 'Dominica(phoneNumPrefix=' + this.zt_1.toString() + ', isoCode2=' + this.au_1 + ', isoCode3=' + this.bu_1 + ', currency=' + toString(this.cu_1) + ', englishName=' + this.du_1 + ', arabicName=' + this.eu_1 + ', phoneRegex=' + this.fu_1 + ')';
  };
  protoOf(Dominica).hashCode = function () {
    var result = this.zt_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.au_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bu_1) | 0;
    result = imul(result, 31) + hashCode(this.cu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.du_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.eu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fu_1) | 0;
    return result;
  };
  protoOf(Dominica).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Dominica))
      return false;
    var tmp0_other_with_cast = other instanceof Dominica ? other : THROW_CCE();
    if (!this.zt_1.equals(tmp0_other_with_cast.zt_1))
      return false;
    if (!(this.au_1 === tmp0_other_with_cast.au_1))
      return false;
    if (!(this.bu_1 === tmp0_other_with_cast.bu_1))
      return false;
    if (!equals(this.cu_1, tmp0_other_with_cast.cu_1))
      return false;
    if (!(this.du_1 === tmp0_other_with_cast.du_1))
      return false;
    if (!(this.eu_1 === tmp0_other_with_cast.eu_1))
      return false;
    if (!(this.fu_1 === tmp0_other_with_cast.fu_1))
      return false;
    return true;
  };
  function Companion_66() {
  }
  var Companion_instance_66;
  function Companion_getInstance_66() {
    return Companion_instance_66;
  }
  function DominicanRepublic(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'DO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'DOM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Dominican Republic' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062F\u0648\u0645\u064A\u0646\u064A\u0643\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.gu_1 = phoneNumPrefix;
    this.hu_1 = isoCode2;
    this.iu_1 = isoCode3;
    this.ju_1 = currency;
    this.ku_1 = englishName;
    this.lu_1 = arabicName;
    this.mu_1 = phoneRegex;
  }
  protoOf(DominicanRepublic).wd = function () {
    return this.gu_1;
  };
  protoOf(DominicanRepublic).rd = function () {
    return this.hu_1;
  };
  protoOf(DominicanRepublic).sd = function () {
    return this.iu_1;
  };
  protoOf(DominicanRepublic).td = function () {
    return this.ju_1;
  };
  protoOf(DominicanRepublic).ud = function () {
    return this.ku_1;
  };
  protoOf(DominicanRepublic).vd = function () {
    return this.lu_1;
  };
  protoOf(DominicanRepublic).xd = function () {
    return this.mu_1;
  };
  protoOf(DominicanRepublic).toString = function () {
    return 'DominicanRepublic(phoneNumPrefix=' + this.gu_1.toString() + ', isoCode2=' + this.hu_1 + ', isoCode3=' + this.iu_1 + ', currency=' + toString(this.ju_1) + ', englishName=' + this.ku_1 + ', arabicName=' + this.lu_1 + ', phoneRegex=' + this.mu_1 + ')';
  };
  protoOf(DominicanRepublic).hashCode = function () {
    var result = this.gu_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.hu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.iu_1) | 0;
    result = imul(result, 31) + hashCode(this.ju_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ku_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mu_1) | 0;
    return result;
  };
  protoOf(DominicanRepublic).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DominicanRepublic))
      return false;
    var tmp0_other_with_cast = other instanceof DominicanRepublic ? other : THROW_CCE();
    if (!this.gu_1.equals(tmp0_other_with_cast.gu_1))
      return false;
    if (!(this.hu_1 === tmp0_other_with_cast.hu_1))
      return false;
    if (!(this.iu_1 === tmp0_other_with_cast.iu_1))
      return false;
    if (!equals(this.ju_1, tmp0_other_with_cast.ju_1))
      return false;
    if (!(this.ku_1 === tmp0_other_with_cast.ku_1))
      return false;
    if (!(this.lu_1 === tmp0_other_with_cast.lu_1))
      return false;
    if (!(this.mu_1 === tmp0_other_with_cast.mu_1))
      return false;
    return true;
  };
  function Companion_67() {
  }
  var Companion_instance_67;
  function Companion_getInstance_67() {
    return Companion_instance_67;
  }
  function Ecuador(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'EC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ECU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Ecuador' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0625\u0643\u0648\u0627\u062F\u0648\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.nu_1 = phoneNumPrefix;
    this.ou_1 = isoCode2;
    this.pu_1 = isoCode3;
    this.qu_1 = currency;
    this.ru_1 = englishName;
    this.su_1 = arabicName;
    this.tu_1 = phoneRegex;
  }
  protoOf(Ecuador).wd = function () {
    return this.nu_1;
  };
  protoOf(Ecuador).rd = function () {
    return this.ou_1;
  };
  protoOf(Ecuador).sd = function () {
    return this.pu_1;
  };
  protoOf(Ecuador).td = function () {
    return this.qu_1;
  };
  protoOf(Ecuador).ud = function () {
    return this.ru_1;
  };
  protoOf(Ecuador).vd = function () {
    return this.su_1;
  };
  protoOf(Ecuador).xd = function () {
    return this.tu_1;
  };
  protoOf(Ecuador).toString = function () {
    return 'Ecuador(phoneNumPrefix=' + this.nu_1.toString() + ', isoCode2=' + this.ou_1 + ', isoCode3=' + this.pu_1 + ', currency=' + toString(this.qu_1) + ', englishName=' + this.ru_1 + ', arabicName=' + this.su_1 + ', phoneRegex=' + this.tu_1 + ')';
  };
  protoOf(Ecuador).hashCode = function () {
    var result = this.nu_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ou_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pu_1) | 0;
    result = imul(result, 31) + hashCode(this.qu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ru_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.su_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tu_1) | 0;
    return result;
  };
  protoOf(Ecuador).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ecuador))
      return false;
    var tmp0_other_with_cast = other instanceof Ecuador ? other : THROW_CCE();
    if (!this.nu_1.equals(tmp0_other_with_cast.nu_1))
      return false;
    if (!(this.ou_1 === tmp0_other_with_cast.ou_1))
      return false;
    if (!(this.pu_1 === tmp0_other_with_cast.pu_1))
      return false;
    if (!equals(this.qu_1, tmp0_other_with_cast.qu_1))
      return false;
    if (!(this.ru_1 === tmp0_other_with_cast.ru_1))
      return false;
    if (!(this.su_1 === tmp0_other_with_cast.su_1))
      return false;
    if (!(this.tu_1 === tmp0_other_with_cast.tu_1))
      return false;
    return true;
  };
  function Companion_68() {
  }
  var Companion_instance_68;
  function Companion_getInstance_68() {
    return Companion_instance_68;
  }
  function ElSalvador(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SV' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SLV' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'El Salvador' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0633\u0644\u0641\u0627\u062F\u0648\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.uu_1 = phoneNumPrefix;
    this.vu_1 = isoCode2;
    this.wu_1 = isoCode3;
    this.xu_1 = currency;
    this.yu_1 = englishName;
    this.zu_1 = arabicName;
    this.av_1 = phoneRegex;
  }
  protoOf(ElSalvador).wd = function () {
    return this.uu_1;
  };
  protoOf(ElSalvador).rd = function () {
    return this.vu_1;
  };
  protoOf(ElSalvador).sd = function () {
    return this.wu_1;
  };
  protoOf(ElSalvador).td = function () {
    return this.xu_1;
  };
  protoOf(ElSalvador).ud = function () {
    return this.yu_1;
  };
  protoOf(ElSalvador).vd = function () {
    return this.zu_1;
  };
  protoOf(ElSalvador).xd = function () {
    return this.av_1;
  };
  protoOf(ElSalvador).toString = function () {
    return 'ElSalvador(phoneNumPrefix=' + this.uu_1.toString() + ', isoCode2=' + this.vu_1 + ', isoCode3=' + this.wu_1 + ', currency=' + toString(this.xu_1) + ', englishName=' + this.yu_1 + ', arabicName=' + this.zu_1 + ', phoneRegex=' + this.av_1 + ')';
  };
  protoOf(ElSalvador).hashCode = function () {
    var result = this.uu_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.vu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wu_1) | 0;
    result = imul(result, 31) + hashCode(this.xu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zu_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.av_1) | 0;
    return result;
  };
  protoOf(ElSalvador).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ElSalvador))
      return false;
    var tmp0_other_with_cast = other instanceof ElSalvador ? other : THROW_CCE();
    if (!this.uu_1.equals(tmp0_other_with_cast.uu_1))
      return false;
    if (!(this.vu_1 === tmp0_other_with_cast.vu_1))
      return false;
    if (!(this.wu_1 === tmp0_other_with_cast.wu_1))
      return false;
    if (!equals(this.xu_1, tmp0_other_with_cast.xu_1))
      return false;
    if (!(this.yu_1 === tmp0_other_with_cast.yu_1))
      return false;
    if (!(this.zu_1 === tmp0_other_with_cast.zu_1))
      return false;
    if (!(this.av_1 === tmp0_other_with_cast.av_1))
      return false;
    return true;
  };
  function Companion_69() {
  }
  var Companion_instance_69;
  function Companion_getInstance_69() {
    return Companion_instance_69;
  }
  function EquatorialGuinea(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GQ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GNQ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Equatorial Guinea' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u064A\u0646\u064A\u0627 \u0627\u0644\u0627\u0633\u062A\u0648\u0627\u0626\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.bv_1 = phoneNumPrefix;
    this.cv_1 = isoCode2;
    this.dv_1 = isoCode3;
    this.ev_1 = currency;
    this.fv_1 = englishName;
    this.gv_1 = arabicName;
    this.hv_1 = phoneRegex;
  }
  protoOf(EquatorialGuinea).wd = function () {
    return this.bv_1;
  };
  protoOf(EquatorialGuinea).rd = function () {
    return this.cv_1;
  };
  protoOf(EquatorialGuinea).sd = function () {
    return this.dv_1;
  };
  protoOf(EquatorialGuinea).td = function () {
    return this.ev_1;
  };
  protoOf(EquatorialGuinea).ud = function () {
    return this.fv_1;
  };
  protoOf(EquatorialGuinea).vd = function () {
    return this.gv_1;
  };
  protoOf(EquatorialGuinea).xd = function () {
    return this.hv_1;
  };
  protoOf(EquatorialGuinea).toString = function () {
    return 'EquatorialGuinea(phoneNumPrefix=' + this.bv_1.toString() + ', isoCode2=' + this.cv_1 + ', isoCode3=' + this.dv_1 + ', currency=' + toString(this.ev_1) + ', englishName=' + this.fv_1 + ', arabicName=' + this.gv_1 + ', phoneRegex=' + this.hv_1 + ')';
  };
  protoOf(EquatorialGuinea).hashCode = function () {
    var result = this.bv_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.cv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dv_1) | 0;
    result = imul(result, 31) + hashCode(this.ev_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hv_1) | 0;
    return result;
  };
  protoOf(EquatorialGuinea).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EquatorialGuinea))
      return false;
    var tmp0_other_with_cast = other instanceof EquatorialGuinea ? other : THROW_CCE();
    if (!this.bv_1.equals(tmp0_other_with_cast.bv_1))
      return false;
    if (!(this.cv_1 === tmp0_other_with_cast.cv_1))
      return false;
    if (!(this.dv_1 === tmp0_other_with_cast.dv_1))
      return false;
    if (!equals(this.ev_1, tmp0_other_with_cast.ev_1))
      return false;
    if (!(this.fv_1 === tmp0_other_with_cast.fv_1))
      return false;
    if (!(this.gv_1 === tmp0_other_with_cast.gv_1))
      return false;
    if (!(this.hv_1 === tmp0_other_with_cast.hv_1))
      return false;
    return true;
  };
  function Companion_70() {
  }
  var Companion_instance_70;
  function Companion_getInstance_70() {
    return Companion_instance_70;
  }
  function Eritrea(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ER' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ERI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Eritrea' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0631\u064A\u062A\u0631\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.iv_1 = phoneNumPrefix;
    this.jv_1 = isoCode2;
    this.kv_1 = isoCode3;
    this.lv_1 = currency;
    this.mv_1 = englishName;
    this.nv_1 = arabicName;
    this.ov_1 = phoneRegex;
  }
  protoOf(Eritrea).wd = function () {
    return this.iv_1;
  };
  protoOf(Eritrea).rd = function () {
    return this.jv_1;
  };
  protoOf(Eritrea).sd = function () {
    return this.kv_1;
  };
  protoOf(Eritrea).td = function () {
    return this.lv_1;
  };
  protoOf(Eritrea).ud = function () {
    return this.mv_1;
  };
  protoOf(Eritrea).vd = function () {
    return this.nv_1;
  };
  protoOf(Eritrea).xd = function () {
    return this.ov_1;
  };
  protoOf(Eritrea).toString = function () {
    return 'Eritrea(phoneNumPrefix=' + this.iv_1.toString() + ', isoCode2=' + this.jv_1 + ', isoCode3=' + this.kv_1 + ', currency=' + toString(this.lv_1) + ', englishName=' + this.mv_1 + ', arabicName=' + this.nv_1 + ', phoneRegex=' + this.ov_1 + ')';
  };
  protoOf(Eritrea).hashCode = function () {
    var result = this.iv_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.jv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kv_1) | 0;
    result = imul(result, 31) + hashCode(this.lv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ov_1) | 0;
    return result;
  };
  protoOf(Eritrea).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Eritrea))
      return false;
    var tmp0_other_with_cast = other instanceof Eritrea ? other : THROW_CCE();
    if (!this.iv_1.equals(tmp0_other_with_cast.iv_1))
      return false;
    if (!(this.jv_1 === tmp0_other_with_cast.jv_1))
      return false;
    if (!(this.kv_1 === tmp0_other_with_cast.kv_1))
      return false;
    if (!equals(this.lv_1, tmp0_other_with_cast.lv_1))
      return false;
    if (!(this.mv_1 === tmp0_other_with_cast.mv_1))
      return false;
    if (!(this.nv_1 === tmp0_other_with_cast.nv_1))
      return false;
    if (!(this.ov_1 === tmp0_other_with_cast.ov_1))
      return false;
    return true;
  };
  function Companion_71() {
  }
  var Companion_instance_71;
  function Companion_getInstance_71() {
    return Companion_instance_71;
  }
  function Estonia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'EE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'EST' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Estonia' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0633\u062A\u0648\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.pv_1 = phoneNumPrefix;
    this.qv_1 = isoCode2;
    this.rv_1 = isoCode3;
    this.sv_1 = currency;
    this.tv_1 = englishName;
    this.uv_1 = arabicName;
    this.vv_1 = phoneRegex;
  }
  protoOf(Estonia).wd = function () {
    return this.pv_1;
  };
  protoOf(Estonia).rd = function () {
    return this.qv_1;
  };
  protoOf(Estonia).sd = function () {
    return this.rv_1;
  };
  protoOf(Estonia).td = function () {
    return this.sv_1;
  };
  protoOf(Estonia).ud = function () {
    return this.tv_1;
  };
  protoOf(Estonia).vd = function () {
    return this.uv_1;
  };
  protoOf(Estonia).xd = function () {
    return this.vv_1;
  };
  protoOf(Estonia).toString = function () {
    return 'Estonia(phoneNumPrefix=' + this.pv_1.toString() + ', isoCode2=' + this.qv_1 + ', isoCode3=' + this.rv_1 + ', currency=' + toString(this.sv_1) + ', englishName=' + this.tv_1 + ', arabicName=' + this.uv_1 + ', phoneRegex=' + this.vv_1 + ')';
  };
  protoOf(Estonia).hashCode = function () {
    var result = this.pv_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.qv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rv_1) | 0;
    result = imul(result, 31) + hashCode(this.sv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vv_1) | 0;
    return result;
  };
  protoOf(Estonia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Estonia))
      return false;
    var tmp0_other_with_cast = other instanceof Estonia ? other : THROW_CCE();
    if (!this.pv_1.equals(tmp0_other_with_cast.pv_1))
      return false;
    if (!(this.qv_1 === tmp0_other_with_cast.qv_1))
      return false;
    if (!(this.rv_1 === tmp0_other_with_cast.rv_1))
      return false;
    if (!equals(this.sv_1, tmp0_other_with_cast.sv_1))
      return false;
    if (!(this.tv_1 === tmp0_other_with_cast.tv_1))
      return false;
    if (!(this.uv_1 === tmp0_other_with_cast.uv_1))
      return false;
    if (!(this.vv_1 === tmp0_other_with_cast.vv_1))
      return false;
    return true;
  };
  function Companion_72() {
  }
  var Companion_instance_72;
  function Companion_getInstance_72() {
    return Companion_instance_72;
  }
  function Ethiopia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ET' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ETH' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Ethiopia' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u062B\u064A\u0648\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.wv_1 = phoneNumPrefix;
    this.xv_1 = isoCode2;
    this.yv_1 = isoCode3;
    this.zv_1 = currency;
    this.aw_1 = englishName;
    this.bw_1 = arabicName;
    this.cw_1 = phoneRegex;
  }
  protoOf(Ethiopia).wd = function () {
    return this.wv_1;
  };
  protoOf(Ethiopia).rd = function () {
    return this.xv_1;
  };
  protoOf(Ethiopia).sd = function () {
    return this.yv_1;
  };
  protoOf(Ethiopia).td = function () {
    return this.zv_1;
  };
  protoOf(Ethiopia).ud = function () {
    return this.aw_1;
  };
  protoOf(Ethiopia).vd = function () {
    return this.bw_1;
  };
  protoOf(Ethiopia).xd = function () {
    return this.cw_1;
  };
  protoOf(Ethiopia).toString = function () {
    return 'Ethiopia(phoneNumPrefix=' + this.wv_1.toString() + ', isoCode2=' + this.xv_1 + ', isoCode3=' + this.yv_1 + ', currency=' + toString(this.zv_1) + ', englishName=' + this.aw_1 + ', arabicName=' + this.bw_1 + ', phoneRegex=' + this.cw_1 + ')';
  };
  protoOf(Ethiopia).hashCode = function () {
    var result = this.wv_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.xv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yv_1) | 0;
    result = imul(result, 31) + hashCode(this.zv_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.aw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cw_1) | 0;
    return result;
  };
  protoOf(Ethiopia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ethiopia))
      return false;
    var tmp0_other_with_cast = other instanceof Ethiopia ? other : THROW_CCE();
    if (!this.wv_1.equals(tmp0_other_with_cast.wv_1))
      return false;
    if (!(this.xv_1 === tmp0_other_with_cast.xv_1))
      return false;
    if (!(this.yv_1 === tmp0_other_with_cast.yv_1))
      return false;
    if (!equals(this.zv_1, tmp0_other_with_cast.zv_1))
      return false;
    if (!(this.aw_1 === tmp0_other_with_cast.aw_1))
      return false;
    if (!(this.bw_1 === tmp0_other_with_cast.bw_1))
      return false;
    if (!(this.cw_1 === tmp0_other_with_cast.cw_1))
      return false;
    return true;
  };
  function Companion_73() {
  }
  var Companion_instance_73;
  function Companion_getInstance_73() {
    return Companion_instance_73;
  }
  function FalklandIslandsMalvinas(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'FK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'FLK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Falkland Islands (Malvinas)' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0641\u0648\u0643\u0644\u0627\u0646\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.dw_1 = phoneNumPrefix;
    this.ew_1 = isoCode2;
    this.fw_1 = isoCode3;
    this.gw_1 = currency;
    this.hw_1 = englishName;
    this.iw_1 = arabicName;
    this.jw_1 = phoneRegex;
  }
  protoOf(FalklandIslandsMalvinas).wd = function () {
    return this.dw_1;
  };
  protoOf(FalklandIslandsMalvinas).rd = function () {
    return this.ew_1;
  };
  protoOf(FalklandIslandsMalvinas).sd = function () {
    return this.fw_1;
  };
  protoOf(FalklandIslandsMalvinas).td = function () {
    return this.gw_1;
  };
  protoOf(FalklandIslandsMalvinas).ud = function () {
    return this.hw_1;
  };
  protoOf(FalklandIslandsMalvinas).vd = function () {
    return this.iw_1;
  };
  protoOf(FalklandIslandsMalvinas).xd = function () {
    return this.jw_1;
  };
  protoOf(FalklandIslandsMalvinas).toString = function () {
    return 'FalklandIslandsMalvinas(phoneNumPrefix=' + this.dw_1.toString() + ', isoCode2=' + this.ew_1 + ', isoCode3=' + this.fw_1 + ', currency=' + toString(this.gw_1) + ', englishName=' + this.hw_1 + ', arabicName=' + this.iw_1 + ', phoneRegex=' + this.jw_1 + ')';
  };
  protoOf(FalklandIslandsMalvinas).hashCode = function () {
    var result = this.dw_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ew_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fw_1) | 0;
    result = imul(result, 31) + hashCode(this.gw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.iw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jw_1) | 0;
    return result;
  };
  protoOf(FalklandIslandsMalvinas).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FalklandIslandsMalvinas))
      return false;
    var tmp0_other_with_cast = other instanceof FalklandIslandsMalvinas ? other : THROW_CCE();
    if (!this.dw_1.equals(tmp0_other_with_cast.dw_1))
      return false;
    if (!(this.ew_1 === tmp0_other_with_cast.ew_1))
      return false;
    if (!(this.fw_1 === tmp0_other_with_cast.fw_1))
      return false;
    if (!equals(this.gw_1, tmp0_other_with_cast.gw_1))
      return false;
    if (!(this.hw_1 === tmp0_other_with_cast.hw_1))
      return false;
    if (!(this.iw_1 === tmp0_other_with_cast.iw_1))
      return false;
    if (!(this.jw_1 === tmp0_other_with_cast.jw_1))
      return false;
    return true;
  };
  function Companion_74() {
  }
  var Companion_instance_74;
  function Companion_getInstance_74() {
    return Companion_instance_74;
  }
  function FaroeIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'FO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'FRO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Faroe Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0641\u0627\u0631\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.kw_1 = phoneNumPrefix;
    this.lw_1 = isoCode2;
    this.mw_1 = isoCode3;
    this.nw_1 = currency;
    this.ow_1 = englishName;
    this.pw_1 = arabicName;
    this.qw_1 = phoneRegex;
  }
  protoOf(FaroeIslands).wd = function () {
    return this.kw_1;
  };
  protoOf(FaroeIslands).rd = function () {
    return this.lw_1;
  };
  protoOf(FaroeIslands).sd = function () {
    return this.mw_1;
  };
  protoOf(FaroeIslands).td = function () {
    return this.nw_1;
  };
  protoOf(FaroeIslands).ud = function () {
    return this.ow_1;
  };
  protoOf(FaroeIslands).vd = function () {
    return this.pw_1;
  };
  protoOf(FaroeIslands).xd = function () {
    return this.qw_1;
  };
  protoOf(FaroeIslands).toString = function () {
    return 'FaroeIslands(phoneNumPrefix=' + this.kw_1.toString() + ', isoCode2=' + this.lw_1 + ', isoCode3=' + this.mw_1 + ', currency=' + toString(this.nw_1) + ', englishName=' + this.ow_1 + ', arabicName=' + this.pw_1 + ', phoneRegex=' + this.qw_1 + ')';
  };
  protoOf(FaroeIslands).hashCode = function () {
    var result = this.kw_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.lw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mw_1) | 0;
    result = imul(result, 31) + hashCode(this.nw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ow_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qw_1) | 0;
    return result;
  };
  protoOf(FaroeIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FaroeIslands))
      return false;
    var tmp0_other_with_cast = other instanceof FaroeIslands ? other : THROW_CCE();
    if (!this.kw_1.equals(tmp0_other_with_cast.kw_1))
      return false;
    if (!(this.lw_1 === tmp0_other_with_cast.lw_1))
      return false;
    if (!(this.mw_1 === tmp0_other_with_cast.mw_1))
      return false;
    if (!equals(this.nw_1, tmp0_other_with_cast.nw_1))
      return false;
    if (!(this.ow_1 === tmp0_other_with_cast.ow_1))
      return false;
    if (!(this.pw_1 === tmp0_other_with_cast.pw_1))
      return false;
    if (!(this.qw_1 === tmp0_other_with_cast.qw_1))
      return false;
    return true;
  };
  function Companion_75() {
  }
  var Companion_instance_75;
  function Companion_getInstance_75() {
    return Companion_instance_75;
  }
  function Fiji(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'FJ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'FJI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Fiji' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u064A\u062C\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.rw_1 = phoneNumPrefix;
    this.sw_1 = isoCode2;
    this.tw_1 = isoCode3;
    this.uw_1 = currency;
    this.vw_1 = englishName;
    this.ww_1 = arabicName;
    this.xw_1 = phoneRegex;
  }
  protoOf(Fiji).wd = function () {
    return this.rw_1;
  };
  protoOf(Fiji).rd = function () {
    return this.sw_1;
  };
  protoOf(Fiji).sd = function () {
    return this.tw_1;
  };
  protoOf(Fiji).td = function () {
    return this.uw_1;
  };
  protoOf(Fiji).ud = function () {
    return this.vw_1;
  };
  protoOf(Fiji).vd = function () {
    return this.ww_1;
  };
  protoOf(Fiji).xd = function () {
    return this.xw_1;
  };
  protoOf(Fiji).toString = function () {
    return 'Fiji(phoneNumPrefix=' + this.rw_1.toString() + ', isoCode2=' + this.sw_1 + ', isoCode3=' + this.tw_1 + ', currency=' + toString(this.uw_1) + ', englishName=' + this.vw_1 + ', arabicName=' + this.ww_1 + ', phoneRegex=' + this.xw_1 + ')';
  };
  protoOf(Fiji).hashCode = function () {
    var result = this.rw_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.sw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tw_1) | 0;
    result = imul(result, 31) + hashCode(this.uw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ww_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xw_1) | 0;
    return result;
  };
  protoOf(Fiji).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Fiji))
      return false;
    var tmp0_other_with_cast = other instanceof Fiji ? other : THROW_CCE();
    if (!this.rw_1.equals(tmp0_other_with_cast.rw_1))
      return false;
    if (!(this.sw_1 === tmp0_other_with_cast.sw_1))
      return false;
    if (!(this.tw_1 === tmp0_other_with_cast.tw_1))
      return false;
    if (!equals(this.uw_1, tmp0_other_with_cast.uw_1))
      return false;
    if (!(this.vw_1 === tmp0_other_with_cast.vw_1))
      return false;
    if (!(this.ww_1 === tmp0_other_with_cast.ww_1))
      return false;
    if (!(this.xw_1 === tmp0_other_with_cast.xw_1))
      return false;
    return true;
  };
  function Companion_76() {
  }
  var Companion_instance_76;
  function Companion_getInstance_76() {
    return Companion_instance_76;
  }
  function Finland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'FI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'FIN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Finland' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u0646\u0644\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.yw_1 = phoneNumPrefix;
    this.zw_1 = isoCode2;
    this.ax_1 = isoCode3;
    this.bx_1 = currency;
    this.cx_1 = englishName;
    this.dx_1 = arabicName;
    this.ex_1 = phoneRegex;
  }
  protoOf(Finland).wd = function () {
    return this.yw_1;
  };
  protoOf(Finland).rd = function () {
    return this.zw_1;
  };
  protoOf(Finland).sd = function () {
    return this.ax_1;
  };
  protoOf(Finland).td = function () {
    return this.bx_1;
  };
  protoOf(Finland).ud = function () {
    return this.cx_1;
  };
  protoOf(Finland).vd = function () {
    return this.dx_1;
  };
  protoOf(Finland).xd = function () {
    return this.ex_1;
  };
  protoOf(Finland).toString = function () {
    return 'Finland(phoneNumPrefix=' + this.yw_1.toString() + ', isoCode2=' + this.zw_1 + ', isoCode3=' + this.ax_1 + ', currency=' + toString(this.bx_1) + ', englishName=' + this.cx_1 + ', arabicName=' + this.dx_1 + ', phoneRegex=' + this.ex_1 + ')';
  };
  protoOf(Finland).hashCode = function () {
    var result = this.yw_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.zw_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ax_1) | 0;
    result = imul(result, 31) + hashCode(this.bx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ex_1) | 0;
    return result;
  };
  protoOf(Finland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Finland))
      return false;
    var tmp0_other_with_cast = other instanceof Finland ? other : THROW_CCE();
    if (!this.yw_1.equals(tmp0_other_with_cast.yw_1))
      return false;
    if (!(this.zw_1 === tmp0_other_with_cast.zw_1))
      return false;
    if (!(this.ax_1 === tmp0_other_with_cast.ax_1))
      return false;
    if (!equals(this.bx_1, tmp0_other_with_cast.bx_1))
      return false;
    if (!(this.cx_1 === tmp0_other_with_cast.cx_1))
      return false;
    if (!(this.dx_1 === tmp0_other_with_cast.dx_1))
      return false;
    if (!(this.ex_1 === tmp0_other_with_cast.ex_1))
      return false;
    return true;
  };
  function Companion_77() {
  }
  var Companion_instance_77;
  function Companion_getInstance_77() {
    return Companion_instance_77;
  }
  function France(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(33, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'FR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'FRA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'France' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u0631\u0646\u0633\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(9) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '612345678' : phoneNumberHint;
    this.z6_1 = phoneNumPrefix;
    this.a7_1 = isoCode2;
    this.b7_1 = isoCode3;
    this.c7_1 = currency;
    this.d7_1 = englishName;
    this.e7_1 = arabicName;
    this.f7_1 = phoneRegex;
    this.g7_1 = phoneNumberHint;
  }
  protoOf(France).wd = function () {
    return this.z6_1;
  };
  protoOf(France).rd = function () {
    return this.a7_1;
  };
  protoOf(France).sd = function () {
    return this.b7_1;
  };
  protoOf(France).td = function () {
    return this.c7_1;
  };
  protoOf(France).ud = function () {
    return this.d7_1;
  };
  protoOf(France).vd = function () {
    return this.e7_1;
  };
  protoOf(France).xd = function () {
    return this.f7_1;
  };
  protoOf(France).yd = function () {
    return this.g7_1;
  };
  protoOf(France).toString = function () {
    return 'France(phoneNumPrefix=' + this.z6_1.toString() + ', isoCode2=' + this.a7_1 + ', isoCode3=' + this.b7_1 + ', currency=' + toString(this.c7_1) + ', englishName=' + this.d7_1 + ', arabicName=' + this.e7_1 + ', phoneRegex=' + this.f7_1 + ', phoneNumberHint=' + this.g7_1 + ')';
  };
  protoOf(France).hashCode = function () {
    var result = this.z6_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b7_1) | 0;
    result = imul(result, 31) + hashCode(this.c7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g7_1) | 0;
    return result;
  };
  protoOf(France).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof France))
      return false;
    var tmp0_other_with_cast = other instanceof France ? other : THROW_CCE();
    if (!this.z6_1.equals(tmp0_other_with_cast.z6_1))
      return false;
    if (!(this.a7_1 === tmp0_other_with_cast.a7_1))
      return false;
    if (!(this.b7_1 === tmp0_other_with_cast.b7_1))
      return false;
    if (!equals(this.c7_1, tmp0_other_with_cast.c7_1))
      return false;
    if (!(this.d7_1 === tmp0_other_with_cast.d7_1))
      return false;
    if (!(this.e7_1 === tmp0_other_with_cast.e7_1))
      return false;
    if (!(this.f7_1 === tmp0_other_with_cast.f7_1))
      return false;
    if (!(this.g7_1 === tmp0_other_with_cast.g7_1))
      return false;
    return true;
  };
  function Companion_78() {
  }
  var Companion_instance_78;
  function Companion_getInstance_78() {
    return Companion_instance_78;
  }
  function FrenchGuiana(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GUF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'French Guiana' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0648\u064A\u0627\u0646\u0627 \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.fx_1 = phoneNumPrefix;
    this.gx_1 = isoCode2;
    this.hx_1 = isoCode3;
    this.ix_1 = currency;
    this.jx_1 = englishName;
    this.kx_1 = arabicName;
    this.lx_1 = phoneRegex;
  }
  protoOf(FrenchGuiana).wd = function () {
    return this.fx_1;
  };
  protoOf(FrenchGuiana).rd = function () {
    return this.gx_1;
  };
  protoOf(FrenchGuiana).sd = function () {
    return this.hx_1;
  };
  protoOf(FrenchGuiana).td = function () {
    return this.ix_1;
  };
  protoOf(FrenchGuiana).ud = function () {
    return this.jx_1;
  };
  protoOf(FrenchGuiana).vd = function () {
    return this.kx_1;
  };
  protoOf(FrenchGuiana).xd = function () {
    return this.lx_1;
  };
  protoOf(FrenchGuiana).toString = function () {
    return 'FrenchGuiana(phoneNumPrefix=' + this.fx_1.toString() + ', isoCode2=' + this.gx_1 + ', isoCode3=' + this.hx_1 + ', currency=' + toString(this.ix_1) + ', englishName=' + this.jx_1 + ', arabicName=' + this.kx_1 + ', phoneRegex=' + this.lx_1 + ')';
  };
  protoOf(FrenchGuiana).hashCode = function () {
    var result = this.fx_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.gx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hx_1) | 0;
    result = imul(result, 31) + hashCode(this.ix_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lx_1) | 0;
    return result;
  };
  protoOf(FrenchGuiana).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FrenchGuiana))
      return false;
    var tmp0_other_with_cast = other instanceof FrenchGuiana ? other : THROW_CCE();
    if (!this.fx_1.equals(tmp0_other_with_cast.fx_1))
      return false;
    if (!(this.gx_1 === tmp0_other_with_cast.gx_1))
      return false;
    if (!(this.hx_1 === tmp0_other_with_cast.hx_1))
      return false;
    if (!equals(this.ix_1, tmp0_other_with_cast.ix_1))
      return false;
    if (!(this.jx_1 === tmp0_other_with_cast.jx_1))
      return false;
    if (!(this.kx_1 === tmp0_other_with_cast.kx_1))
      return false;
    if (!(this.lx_1 === tmp0_other_with_cast.lx_1))
      return false;
    return true;
  };
  function Companion_79() {
  }
  var Companion_instance_79;
  function Companion_getInstance_79() {
    return Companion_instance_79;
  }
  function FrenchPolynesia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PYF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'French Polynesia' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u0644\u064A\u0646\u0632\u064A\u0627 \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.mx_1 = phoneNumPrefix;
    this.nx_1 = isoCode2;
    this.ox_1 = isoCode3;
    this.px_1 = currency;
    this.qx_1 = englishName;
    this.rx_1 = arabicName;
    this.sx_1 = phoneRegex;
  }
  protoOf(FrenchPolynesia).wd = function () {
    return this.mx_1;
  };
  protoOf(FrenchPolynesia).rd = function () {
    return this.nx_1;
  };
  protoOf(FrenchPolynesia).sd = function () {
    return this.ox_1;
  };
  protoOf(FrenchPolynesia).td = function () {
    return this.px_1;
  };
  protoOf(FrenchPolynesia).ud = function () {
    return this.qx_1;
  };
  protoOf(FrenchPolynesia).vd = function () {
    return this.rx_1;
  };
  protoOf(FrenchPolynesia).xd = function () {
    return this.sx_1;
  };
  protoOf(FrenchPolynesia).toString = function () {
    return 'FrenchPolynesia(phoneNumPrefix=' + this.mx_1.toString() + ', isoCode2=' + this.nx_1 + ', isoCode3=' + this.ox_1 + ', currency=' + toString(this.px_1) + ', englishName=' + this.qx_1 + ', arabicName=' + this.rx_1 + ', phoneRegex=' + this.sx_1 + ')';
  };
  protoOf(FrenchPolynesia).hashCode = function () {
    var result = this.mx_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.nx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ox_1) | 0;
    result = imul(result, 31) + hashCode(this.px_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sx_1) | 0;
    return result;
  };
  protoOf(FrenchPolynesia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FrenchPolynesia))
      return false;
    var tmp0_other_with_cast = other instanceof FrenchPolynesia ? other : THROW_CCE();
    if (!this.mx_1.equals(tmp0_other_with_cast.mx_1))
      return false;
    if (!(this.nx_1 === tmp0_other_with_cast.nx_1))
      return false;
    if (!(this.ox_1 === tmp0_other_with_cast.ox_1))
      return false;
    if (!equals(this.px_1, tmp0_other_with_cast.px_1))
      return false;
    if (!(this.qx_1 === tmp0_other_with_cast.qx_1))
      return false;
    if (!(this.rx_1 === tmp0_other_with_cast.rx_1))
      return false;
    if (!(this.sx_1 === tmp0_other_with_cast.sx_1))
      return false;
    return true;
  };
  function Companion_80() {
  }
  var Companion_instance_80;
  function Companion_getInstance_80() {
    return Companion_instance_80;
  }
  function FrenchSouthernTerritories(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ATF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'French Southern Territories' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0631\u0627\u0636 \u0641\u0631\u0646\u0633\u064A\u0629 \u062C\u0646\u0648\u0628\u064A\u0629 \u0648\u0623\u0646\u062A\u0627\u0631\u062A\u064A\u0643\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.tx_1 = phoneNumPrefix;
    this.ux_1 = isoCode2;
    this.vx_1 = isoCode3;
    this.wx_1 = currency;
    this.xx_1 = englishName;
    this.yx_1 = arabicName;
    this.zx_1 = phoneRegex;
  }
  protoOf(FrenchSouthernTerritories).wd = function () {
    return this.tx_1;
  };
  protoOf(FrenchSouthernTerritories).rd = function () {
    return this.ux_1;
  };
  protoOf(FrenchSouthernTerritories).sd = function () {
    return this.vx_1;
  };
  protoOf(FrenchSouthernTerritories).td = function () {
    return this.wx_1;
  };
  protoOf(FrenchSouthernTerritories).ud = function () {
    return this.xx_1;
  };
  protoOf(FrenchSouthernTerritories).vd = function () {
    return this.yx_1;
  };
  protoOf(FrenchSouthernTerritories).xd = function () {
    return this.zx_1;
  };
  protoOf(FrenchSouthernTerritories).toString = function () {
    return 'FrenchSouthernTerritories(phoneNumPrefix=' + this.tx_1.toString() + ', isoCode2=' + this.ux_1 + ', isoCode3=' + this.vx_1 + ', currency=' + toString(this.wx_1) + ', englishName=' + this.xx_1 + ', arabicName=' + this.yx_1 + ', phoneRegex=' + this.zx_1 + ')';
  };
  protoOf(FrenchSouthernTerritories).hashCode = function () {
    var result = this.tx_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ux_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vx_1) | 0;
    result = imul(result, 31) + hashCode(this.wx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zx_1) | 0;
    return result;
  };
  protoOf(FrenchSouthernTerritories).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FrenchSouthernTerritories))
      return false;
    var tmp0_other_with_cast = other instanceof FrenchSouthernTerritories ? other : THROW_CCE();
    if (!this.tx_1.equals(tmp0_other_with_cast.tx_1))
      return false;
    if (!(this.ux_1 === tmp0_other_with_cast.ux_1))
      return false;
    if (!(this.vx_1 === tmp0_other_with_cast.vx_1))
      return false;
    if (!equals(this.wx_1, tmp0_other_with_cast.wx_1))
      return false;
    if (!(this.xx_1 === tmp0_other_with_cast.xx_1))
      return false;
    if (!(this.yx_1 === tmp0_other_with_cast.yx_1))
      return false;
    if (!(this.zx_1 === tmp0_other_with_cast.zx_1))
      return false;
    return true;
  };
  function Companion_81() {
  }
  var Companion_instance_81;
  function Companion_getInstance_81() {
    return Companion_instance_81;
  }
  function Gabon(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GAB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Gabon' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u063A\u0627\u0628\u0648\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.ay_1 = phoneNumPrefix;
    this.by_1 = isoCode2;
    this.cy_1 = isoCode3;
    this.dy_1 = currency;
    this.ey_1 = englishName;
    this.fy_1 = arabicName;
    this.gy_1 = phoneRegex;
  }
  protoOf(Gabon).wd = function () {
    return this.ay_1;
  };
  protoOf(Gabon).rd = function () {
    return this.by_1;
  };
  protoOf(Gabon).sd = function () {
    return this.cy_1;
  };
  protoOf(Gabon).td = function () {
    return this.dy_1;
  };
  protoOf(Gabon).ud = function () {
    return this.ey_1;
  };
  protoOf(Gabon).vd = function () {
    return this.fy_1;
  };
  protoOf(Gabon).xd = function () {
    return this.gy_1;
  };
  protoOf(Gabon).toString = function () {
    return 'Gabon(phoneNumPrefix=' + this.ay_1.toString() + ', isoCode2=' + this.by_1 + ', isoCode3=' + this.cy_1 + ', currency=' + toString(this.dy_1) + ', englishName=' + this.ey_1 + ', arabicName=' + this.fy_1 + ', phoneRegex=' + this.gy_1 + ')';
  };
  protoOf(Gabon).hashCode = function () {
    var result = this.ay_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.by_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cy_1) | 0;
    result = imul(result, 31) + hashCode(this.dy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ey_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gy_1) | 0;
    return result;
  };
  protoOf(Gabon).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Gabon))
      return false;
    var tmp0_other_with_cast = other instanceof Gabon ? other : THROW_CCE();
    if (!this.ay_1.equals(tmp0_other_with_cast.ay_1))
      return false;
    if (!(this.by_1 === tmp0_other_with_cast.by_1))
      return false;
    if (!(this.cy_1 === tmp0_other_with_cast.cy_1))
      return false;
    if (!equals(this.dy_1, tmp0_other_with_cast.dy_1))
      return false;
    if (!(this.ey_1 === tmp0_other_with_cast.ey_1))
      return false;
    if (!(this.fy_1 === tmp0_other_with_cast.fy_1))
      return false;
    if (!(this.gy_1 === tmp0_other_with_cast.gy_1))
      return false;
    return true;
  };
  function Companion_82() {
  }
  var Companion_instance_82;
  function Companion_getInstance_82() {
    return Companion_instance_82;
  }
  function Gambia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GMB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Gambia' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0627\u0645\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.hy_1 = phoneNumPrefix;
    this.iy_1 = isoCode2;
    this.jy_1 = isoCode3;
    this.ky_1 = currency;
    this.ly_1 = englishName;
    this.my_1 = arabicName;
    this.ny_1 = phoneRegex;
  }
  protoOf(Gambia).wd = function () {
    return this.hy_1;
  };
  protoOf(Gambia).rd = function () {
    return this.iy_1;
  };
  protoOf(Gambia).sd = function () {
    return this.jy_1;
  };
  protoOf(Gambia).td = function () {
    return this.ky_1;
  };
  protoOf(Gambia).ud = function () {
    return this.ly_1;
  };
  protoOf(Gambia).vd = function () {
    return this.my_1;
  };
  protoOf(Gambia).xd = function () {
    return this.ny_1;
  };
  protoOf(Gambia).toString = function () {
    return 'Gambia(phoneNumPrefix=' + this.hy_1.toString() + ', isoCode2=' + this.iy_1 + ', isoCode3=' + this.jy_1 + ', currency=' + toString(this.ky_1) + ', englishName=' + this.ly_1 + ', arabicName=' + this.my_1 + ', phoneRegex=' + this.ny_1 + ')';
  };
  protoOf(Gambia).hashCode = function () {
    var result = this.hy_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.iy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jy_1) | 0;
    result = imul(result, 31) + hashCode(this.ky_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ly_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.my_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ny_1) | 0;
    return result;
  };
  protoOf(Gambia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Gambia))
      return false;
    var tmp0_other_with_cast = other instanceof Gambia ? other : THROW_CCE();
    if (!this.hy_1.equals(tmp0_other_with_cast.hy_1))
      return false;
    if (!(this.iy_1 === tmp0_other_with_cast.iy_1))
      return false;
    if (!(this.jy_1 === tmp0_other_with_cast.jy_1))
      return false;
    if (!equals(this.ky_1, tmp0_other_with_cast.ky_1))
      return false;
    if (!(this.ly_1 === tmp0_other_with_cast.ly_1))
      return false;
    if (!(this.my_1 === tmp0_other_with_cast.my_1))
      return false;
    if (!(this.ny_1 === tmp0_other_with_cast.ny_1))
      return false;
    return true;
  };
  function Companion_83() {
  }
  var Companion_instance_83;
  function Companion_getInstance_83() {
    return Companion_instance_83;
  }
  function Georgia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GEO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Georgia' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0648\u0631\u062C\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.oy_1 = phoneNumPrefix;
    this.py_1 = isoCode2;
    this.qy_1 = isoCode3;
    this.ry_1 = currency;
    this.sy_1 = englishName;
    this.ty_1 = arabicName;
    this.uy_1 = phoneRegex;
  }
  protoOf(Georgia).wd = function () {
    return this.oy_1;
  };
  protoOf(Georgia).rd = function () {
    return this.py_1;
  };
  protoOf(Georgia).sd = function () {
    return this.qy_1;
  };
  protoOf(Georgia).td = function () {
    return this.ry_1;
  };
  protoOf(Georgia).ud = function () {
    return this.sy_1;
  };
  protoOf(Georgia).vd = function () {
    return this.ty_1;
  };
  protoOf(Georgia).xd = function () {
    return this.uy_1;
  };
  protoOf(Georgia).toString = function () {
    return 'Georgia(phoneNumPrefix=' + this.oy_1.toString() + ', isoCode2=' + this.py_1 + ', isoCode3=' + this.qy_1 + ', currency=' + toString(this.ry_1) + ', englishName=' + this.sy_1 + ', arabicName=' + this.ty_1 + ', phoneRegex=' + this.uy_1 + ')';
  };
  protoOf(Georgia).hashCode = function () {
    var result = this.oy_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.py_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qy_1) | 0;
    result = imul(result, 31) + hashCode(this.ry_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ty_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uy_1) | 0;
    return result;
  };
  protoOf(Georgia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Georgia))
      return false;
    var tmp0_other_with_cast = other instanceof Georgia ? other : THROW_CCE();
    if (!this.oy_1.equals(tmp0_other_with_cast.oy_1))
      return false;
    if (!(this.py_1 === tmp0_other_with_cast.py_1))
      return false;
    if (!(this.qy_1 === tmp0_other_with_cast.qy_1))
      return false;
    if (!equals(this.ry_1, tmp0_other_with_cast.ry_1))
      return false;
    if (!(this.sy_1 === tmp0_other_with_cast.sy_1))
      return false;
    if (!(this.ty_1 === tmp0_other_with_cast.ty_1))
      return false;
    if (!(this.uy_1 === tmp0_other_with_cast.uy_1))
      return false;
    return true;
  };
  function Companion_84() {
  }
  var Companion_instance_84;
  function Companion_getInstance_84() {
    return Companion_instance_84;
  }
  function Germany(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(49, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'DE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'DEU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Germany' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0644\u0645\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(11) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '15123456789' : phoneNumberHint;
    this.h7_1 = phoneNumPrefix;
    this.i7_1 = isoCode2;
    this.j7_1 = isoCode3;
    this.k7_1 = currency;
    this.l7_1 = englishName;
    this.m7_1 = arabicName;
    this.n7_1 = phoneRegex;
    this.o7_1 = phoneNumberHint;
  }
  protoOf(Germany).wd = function () {
    return this.h7_1;
  };
  protoOf(Germany).rd = function () {
    return this.i7_1;
  };
  protoOf(Germany).sd = function () {
    return this.j7_1;
  };
  protoOf(Germany).td = function () {
    return this.k7_1;
  };
  protoOf(Germany).ud = function () {
    return this.l7_1;
  };
  protoOf(Germany).vd = function () {
    return this.m7_1;
  };
  protoOf(Germany).xd = function () {
    return this.n7_1;
  };
  protoOf(Germany).yd = function () {
    return this.o7_1;
  };
  protoOf(Germany).toString = function () {
    return 'Germany(phoneNumPrefix=' + this.h7_1.toString() + ', isoCode2=' + this.i7_1 + ', isoCode3=' + this.j7_1 + ', currency=' + toString(this.k7_1) + ', englishName=' + this.l7_1 + ', arabicName=' + this.m7_1 + ', phoneRegex=' + this.n7_1 + ', phoneNumberHint=' + this.o7_1 + ')';
  };
  protoOf(Germany).hashCode = function () {
    var result = this.h7_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j7_1) | 0;
    result = imul(result, 31) + hashCode(this.k7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o7_1) | 0;
    return result;
  };
  protoOf(Germany).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Germany))
      return false;
    var tmp0_other_with_cast = other instanceof Germany ? other : THROW_CCE();
    if (!this.h7_1.equals(tmp0_other_with_cast.h7_1))
      return false;
    if (!(this.i7_1 === tmp0_other_with_cast.i7_1))
      return false;
    if (!(this.j7_1 === tmp0_other_with_cast.j7_1))
      return false;
    if (!equals(this.k7_1, tmp0_other_with_cast.k7_1))
      return false;
    if (!(this.l7_1 === tmp0_other_with_cast.l7_1))
      return false;
    if (!(this.m7_1 === tmp0_other_with_cast.m7_1))
      return false;
    if (!(this.n7_1 === tmp0_other_with_cast.n7_1))
      return false;
    if (!(this.o7_1 === tmp0_other_with_cast.o7_1))
      return false;
    return true;
  };
  function Companion_85() {
  }
  var Companion_instance_85;
  function Companion_getInstance_85() {
    return Companion_instance_85;
  }
  function Ghana(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GHA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Ghana' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0627\u0646\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.vy_1 = phoneNumPrefix;
    this.wy_1 = isoCode2;
    this.xy_1 = isoCode3;
    this.yy_1 = currency;
    this.zy_1 = englishName;
    this.az_1 = arabicName;
    this.bz_1 = phoneRegex;
  }
  protoOf(Ghana).wd = function () {
    return this.vy_1;
  };
  protoOf(Ghana).rd = function () {
    return this.wy_1;
  };
  protoOf(Ghana).sd = function () {
    return this.xy_1;
  };
  protoOf(Ghana).td = function () {
    return this.yy_1;
  };
  protoOf(Ghana).ud = function () {
    return this.zy_1;
  };
  protoOf(Ghana).vd = function () {
    return this.az_1;
  };
  protoOf(Ghana).xd = function () {
    return this.bz_1;
  };
  protoOf(Ghana).toString = function () {
    return 'Ghana(phoneNumPrefix=' + this.vy_1.toString() + ', isoCode2=' + this.wy_1 + ', isoCode3=' + this.xy_1 + ', currency=' + toString(this.yy_1) + ', englishName=' + this.zy_1 + ', arabicName=' + this.az_1 + ', phoneRegex=' + this.bz_1 + ')';
  };
  protoOf(Ghana).hashCode = function () {
    var result = this.vy_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.wy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xy_1) | 0;
    result = imul(result, 31) + hashCode(this.yy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zy_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.az_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bz_1) | 0;
    return result;
  };
  protoOf(Ghana).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ghana))
      return false;
    var tmp0_other_with_cast = other instanceof Ghana ? other : THROW_CCE();
    if (!this.vy_1.equals(tmp0_other_with_cast.vy_1))
      return false;
    if (!(this.wy_1 === tmp0_other_with_cast.wy_1))
      return false;
    if (!(this.xy_1 === tmp0_other_with_cast.xy_1))
      return false;
    if (!equals(this.yy_1, tmp0_other_with_cast.yy_1))
      return false;
    if (!(this.zy_1 === tmp0_other_with_cast.zy_1))
      return false;
    if (!(this.az_1 === tmp0_other_with_cast.az_1))
      return false;
    if (!(this.bz_1 === tmp0_other_with_cast.bz_1))
      return false;
    return true;
  };
  function Companion_86() {
  }
  var Companion_instance_86;
  function Companion_getInstance_86() {
    return Companion_instance_86;
  }
  function Gibraltar(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GIB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Gibraltar' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0628\u0644 \u0637\u0627\u0631\u0642' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.cz_1 = phoneNumPrefix;
    this.dz_1 = isoCode2;
    this.ez_1 = isoCode3;
    this.fz_1 = currency;
    this.gz_1 = englishName;
    this.hz_1 = arabicName;
    this.iz_1 = phoneRegex;
  }
  protoOf(Gibraltar).wd = function () {
    return this.cz_1;
  };
  protoOf(Gibraltar).rd = function () {
    return this.dz_1;
  };
  protoOf(Gibraltar).sd = function () {
    return this.ez_1;
  };
  protoOf(Gibraltar).td = function () {
    return this.fz_1;
  };
  protoOf(Gibraltar).ud = function () {
    return this.gz_1;
  };
  protoOf(Gibraltar).vd = function () {
    return this.hz_1;
  };
  protoOf(Gibraltar).xd = function () {
    return this.iz_1;
  };
  protoOf(Gibraltar).toString = function () {
    return 'Gibraltar(phoneNumPrefix=' + this.cz_1.toString() + ', isoCode2=' + this.dz_1 + ', isoCode3=' + this.ez_1 + ', currency=' + toString(this.fz_1) + ', englishName=' + this.gz_1 + ', arabicName=' + this.hz_1 + ', phoneRegex=' + this.iz_1 + ')';
  };
  protoOf(Gibraltar).hashCode = function () {
    var result = this.cz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.dz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ez_1) | 0;
    result = imul(result, 31) + hashCode(this.fz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.iz_1) | 0;
    return result;
  };
  protoOf(Gibraltar).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Gibraltar))
      return false;
    var tmp0_other_with_cast = other instanceof Gibraltar ? other : THROW_CCE();
    if (!this.cz_1.equals(tmp0_other_with_cast.cz_1))
      return false;
    if (!(this.dz_1 === tmp0_other_with_cast.dz_1))
      return false;
    if (!(this.ez_1 === tmp0_other_with_cast.ez_1))
      return false;
    if (!equals(this.fz_1, tmp0_other_with_cast.fz_1))
      return false;
    if (!(this.gz_1 === tmp0_other_with_cast.gz_1))
      return false;
    if (!(this.hz_1 === tmp0_other_with_cast.hz_1))
      return false;
    if (!(this.iz_1 === tmp0_other_with_cast.iz_1))
      return false;
    return true;
  };
  function Companion_87() {
  }
  var Companion_instance_87;
  function Companion_getInstance_87() {
    return Companion_instance_87;
  }
  function Greece(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GRC' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Greece' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u064A\u0648\u0646\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.jz_1 = phoneNumPrefix;
    this.kz_1 = isoCode2;
    this.lz_1 = isoCode3;
    this.mz_1 = currency;
    this.nz_1 = englishName;
    this.oz_1 = arabicName;
    this.pz_1 = phoneRegex;
  }
  protoOf(Greece).wd = function () {
    return this.jz_1;
  };
  protoOf(Greece).rd = function () {
    return this.kz_1;
  };
  protoOf(Greece).sd = function () {
    return this.lz_1;
  };
  protoOf(Greece).td = function () {
    return this.mz_1;
  };
  protoOf(Greece).ud = function () {
    return this.nz_1;
  };
  protoOf(Greece).vd = function () {
    return this.oz_1;
  };
  protoOf(Greece).xd = function () {
    return this.pz_1;
  };
  protoOf(Greece).toString = function () {
    return 'Greece(phoneNumPrefix=' + this.jz_1.toString() + ', isoCode2=' + this.kz_1 + ', isoCode3=' + this.lz_1 + ', currency=' + toString(this.mz_1) + ', englishName=' + this.nz_1 + ', arabicName=' + this.oz_1 + ', phoneRegex=' + this.pz_1 + ')';
  };
  protoOf(Greece).hashCode = function () {
    var result = this.jz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.kz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lz_1) | 0;
    result = imul(result, 31) + hashCode(this.mz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pz_1) | 0;
    return result;
  };
  protoOf(Greece).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Greece))
      return false;
    var tmp0_other_with_cast = other instanceof Greece ? other : THROW_CCE();
    if (!this.jz_1.equals(tmp0_other_with_cast.jz_1))
      return false;
    if (!(this.kz_1 === tmp0_other_with_cast.kz_1))
      return false;
    if (!(this.lz_1 === tmp0_other_with_cast.lz_1))
      return false;
    if (!equals(this.mz_1, tmp0_other_with_cast.mz_1))
      return false;
    if (!(this.nz_1 === tmp0_other_with_cast.nz_1))
      return false;
    if (!(this.oz_1 === tmp0_other_with_cast.oz_1))
      return false;
    if (!(this.pz_1 === tmp0_other_with_cast.pz_1))
      return false;
    return true;
  };
  function Companion_88() {
  }
  var Companion_instance_88;
  function Companion_getInstance_88() {
    return Companion_instance_88;
  }
  function Greenland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GRL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Greenland' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0631\u064A\u0646\u0644\u0627\u0646\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.qz_1 = phoneNumPrefix;
    this.rz_1 = isoCode2;
    this.sz_1 = isoCode3;
    this.tz_1 = currency;
    this.uz_1 = englishName;
    this.vz_1 = arabicName;
    this.wz_1 = phoneRegex;
  }
  protoOf(Greenland).wd = function () {
    return this.qz_1;
  };
  protoOf(Greenland).rd = function () {
    return this.rz_1;
  };
  protoOf(Greenland).sd = function () {
    return this.sz_1;
  };
  protoOf(Greenland).td = function () {
    return this.tz_1;
  };
  protoOf(Greenland).ud = function () {
    return this.uz_1;
  };
  protoOf(Greenland).vd = function () {
    return this.vz_1;
  };
  protoOf(Greenland).xd = function () {
    return this.wz_1;
  };
  protoOf(Greenland).toString = function () {
    return 'Greenland(phoneNumPrefix=' + this.qz_1.toString() + ', isoCode2=' + this.rz_1 + ', isoCode3=' + this.sz_1 + ', currency=' + toString(this.tz_1) + ', englishName=' + this.uz_1 + ', arabicName=' + this.vz_1 + ', phoneRegex=' + this.wz_1 + ')';
  };
  protoOf(Greenland).hashCode = function () {
    var result = this.qz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.rz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sz_1) | 0;
    result = imul(result, 31) + hashCode(this.tz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wz_1) | 0;
    return result;
  };
  protoOf(Greenland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Greenland))
      return false;
    var tmp0_other_with_cast = other instanceof Greenland ? other : THROW_CCE();
    if (!this.qz_1.equals(tmp0_other_with_cast.qz_1))
      return false;
    if (!(this.rz_1 === tmp0_other_with_cast.rz_1))
      return false;
    if (!(this.sz_1 === tmp0_other_with_cast.sz_1))
      return false;
    if (!equals(this.tz_1, tmp0_other_with_cast.tz_1))
      return false;
    if (!(this.uz_1 === tmp0_other_with_cast.uz_1))
      return false;
    if (!(this.vz_1 === tmp0_other_with_cast.vz_1))
      return false;
    if (!(this.wz_1 === tmp0_other_with_cast.wz_1))
      return false;
    return true;
  };
  function Companion_89() {
  }
  var Companion_instance_89;
  function Companion_getInstance_89() {
    return Companion_instance_89;
  }
  function Grenada(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GRD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Grenada' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0631\u064A\u0646\u0627\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.xz_1 = phoneNumPrefix;
    this.yz_1 = isoCode2;
    this.zz_1 = isoCode3;
    this.a10_1 = currency;
    this.b10_1 = englishName;
    this.c10_1 = arabicName;
    this.d10_1 = phoneRegex;
  }
  protoOf(Grenada).wd = function () {
    return this.xz_1;
  };
  protoOf(Grenada).rd = function () {
    return this.yz_1;
  };
  protoOf(Grenada).sd = function () {
    return this.zz_1;
  };
  protoOf(Grenada).td = function () {
    return this.a10_1;
  };
  protoOf(Grenada).ud = function () {
    return this.b10_1;
  };
  protoOf(Grenada).vd = function () {
    return this.c10_1;
  };
  protoOf(Grenada).xd = function () {
    return this.d10_1;
  };
  protoOf(Grenada).toString = function () {
    return 'Grenada(phoneNumPrefix=' + this.xz_1.toString() + ', isoCode2=' + this.yz_1 + ', isoCode3=' + this.zz_1 + ', currency=' + toString(this.a10_1) + ', englishName=' + this.b10_1 + ', arabicName=' + this.c10_1 + ', phoneRegex=' + this.d10_1 + ')';
  };
  protoOf(Grenada).hashCode = function () {
    var result = this.xz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.yz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zz_1) | 0;
    result = imul(result, 31) + hashCode(this.a10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d10_1) | 0;
    return result;
  };
  protoOf(Grenada).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Grenada))
      return false;
    var tmp0_other_with_cast = other instanceof Grenada ? other : THROW_CCE();
    if (!this.xz_1.equals(tmp0_other_with_cast.xz_1))
      return false;
    if (!(this.yz_1 === tmp0_other_with_cast.yz_1))
      return false;
    if (!(this.zz_1 === tmp0_other_with_cast.zz_1))
      return false;
    if (!equals(this.a10_1, tmp0_other_with_cast.a10_1))
      return false;
    if (!(this.b10_1 === tmp0_other_with_cast.b10_1))
      return false;
    if (!(this.c10_1 === tmp0_other_with_cast.c10_1))
      return false;
    if (!(this.d10_1 === tmp0_other_with_cast.d10_1))
      return false;
    return true;
  };
  function Companion_90() {
  }
  var Companion_instance_90;
  function Companion_getInstance_90() {
    return Companion_instance_90;
  }
  function Guadeloupe(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GP' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GLP' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guadeloupe' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0648\u0627\u062F\u0644\u0648\u0628' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.e10_1 = phoneNumPrefix;
    this.f10_1 = isoCode2;
    this.g10_1 = isoCode3;
    this.h10_1 = currency;
    this.i10_1 = englishName;
    this.j10_1 = arabicName;
    this.k10_1 = phoneRegex;
  }
  protoOf(Guadeloupe).wd = function () {
    return this.e10_1;
  };
  protoOf(Guadeloupe).rd = function () {
    return this.f10_1;
  };
  protoOf(Guadeloupe).sd = function () {
    return this.g10_1;
  };
  protoOf(Guadeloupe).td = function () {
    return this.h10_1;
  };
  protoOf(Guadeloupe).ud = function () {
    return this.i10_1;
  };
  protoOf(Guadeloupe).vd = function () {
    return this.j10_1;
  };
  protoOf(Guadeloupe).xd = function () {
    return this.k10_1;
  };
  protoOf(Guadeloupe).toString = function () {
    return 'Guadeloupe(phoneNumPrefix=' + this.e10_1.toString() + ', isoCode2=' + this.f10_1 + ', isoCode3=' + this.g10_1 + ', currency=' + toString(this.h10_1) + ', englishName=' + this.i10_1 + ', arabicName=' + this.j10_1 + ', phoneRegex=' + this.k10_1 + ')';
  };
  protoOf(Guadeloupe).hashCode = function () {
    var result = this.e10_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.f10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g10_1) | 0;
    result = imul(result, 31) + hashCode(this.h10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k10_1) | 0;
    return result;
  };
  protoOf(Guadeloupe).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Guadeloupe))
      return false;
    var tmp0_other_with_cast = other instanceof Guadeloupe ? other : THROW_CCE();
    if (!this.e10_1.equals(tmp0_other_with_cast.e10_1))
      return false;
    if (!(this.f10_1 === tmp0_other_with_cast.f10_1))
      return false;
    if (!(this.g10_1 === tmp0_other_with_cast.g10_1))
      return false;
    if (!equals(this.h10_1, tmp0_other_with_cast.h10_1))
      return false;
    if (!(this.i10_1 === tmp0_other_with_cast.i10_1))
      return false;
    if (!(this.j10_1 === tmp0_other_with_cast.j10_1))
      return false;
    if (!(this.k10_1 === tmp0_other_with_cast.k10_1))
      return false;
    return true;
  };
  function Companion_91() {
  }
  var Companion_instance_91;
  function Companion_getInstance_91() {
    return Companion_instance_91;
  }
  function Guam(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GUM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guam' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0648\u0627\u0645' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.l10_1 = phoneNumPrefix;
    this.m10_1 = isoCode2;
    this.n10_1 = isoCode3;
    this.o10_1 = currency;
    this.p10_1 = englishName;
    this.q10_1 = arabicName;
    this.r10_1 = phoneRegex;
  }
  protoOf(Guam).wd = function () {
    return this.l10_1;
  };
  protoOf(Guam).rd = function () {
    return this.m10_1;
  };
  protoOf(Guam).sd = function () {
    return this.n10_1;
  };
  protoOf(Guam).td = function () {
    return this.o10_1;
  };
  protoOf(Guam).ud = function () {
    return this.p10_1;
  };
  protoOf(Guam).vd = function () {
    return this.q10_1;
  };
  protoOf(Guam).xd = function () {
    return this.r10_1;
  };
  protoOf(Guam).toString = function () {
    return 'Guam(phoneNumPrefix=' + this.l10_1.toString() + ', isoCode2=' + this.m10_1 + ', isoCode3=' + this.n10_1 + ', currency=' + toString(this.o10_1) + ', englishName=' + this.p10_1 + ', arabicName=' + this.q10_1 + ', phoneRegex=' + this.r10_1 + ')';
  };
  protoOf(Guam).hashCode = function () {
    var result = this.l10_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n10_1) | 0;
    result = imul(result, 31) + hashCode(this.o10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r10_1) | 0;
    return result;
  };
  protoOf(Guam).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Guam))
      return false;
    var tmp0_other_with_cast = other instanceof Guam ? other : THROW_CCE();
    if (!this.l10_1.equals(tmp0_other_with_cast.l10_1))
      return false;
    if (!(this.m10_1 === tmp0_other_with_cast.m10_1))
      return false;
    if (!(this.n10_1 === tmp0_other_with_cast.n10_1))
      return false;
    if (!equals(this.o10_1, tmp0_other_with_cast.o10_1))
      return false;
    if (!(this.p10_1 === tmp0_other_with_cast.p10_1))
      return false;
    if (!(this.q10_1 === tmp0_other_with_cast.q10_1))
      return false;
    if (!(this.r10_1 === tmp0_other_with_cast.r10_1))
      return false;
    return true;
  };
  function Companion_92() {
  }
  var Companion_instance_92;
  function Companion_getInstance_92() {
    return Companion_instance_92;
  }
  function Guatemala(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GTM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guatemala' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u0648\u0627\u062A\u064A\u0645\u0627\u0644\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.s10_1 = phoneNumPrefix;
    this.t10_1 = isoCode2;
    this.u10_1 = isoCode3;
    this.v10_1 = currency;
    this.w10_1 = englishName;
    this.x10_1 = arabicName;
    this.y10_1 = phoneRegex;
  }
  protoOf(Guatemala).wd = function () {
    return this.s10_1;
  };
  protoOf(Guatemala).rd = function () {
    return this.t10_1;
  };
  protoOf(Guatemala).sd = function () {
    return this.u10_1;
  };
  protoOf(Guatemala).td = function () {
    return this.v10_1;
  };
  protoOf(Guatemala).ud = function () {
    return this.w10_1;
  };
  protoOf(Guatemala).vd = function () {
    return this.x10_1;
  };
  protoOf(Guatemala).xd = function () {
    return this.y10_1;
  };
  protoOf(Guatemala).toString = function () {
    return 'Guatemala(phoneNumPrefix=' + this.s10_1.toString() + ', isoCode2=' + this.t10_1 + ', isoCode3=' + this.u10_1 + ', currency=' + toString(this.v10_1) + ', englishName=' + this.w10_1 + ', arabicName=' + this.x10_1 + ', phoneRegex=' + this.y10_1 + ')';
  };
  protoOf(Guatemala).hashCode = function () {
    var result = this.s10_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u10_1) | 0;
    result = imul(result, 31) + hashCode(this.v10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x10_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y10_1) | 0;
    return result;
  };
  protoOf(Guatemala).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Guatemala))
      return false;
    var tmp0_other_with_cast = other instanceof Guatemala ? other : THROW_CCE();
    if (!this.s10_1.equals(tmp0_other_with_cast.s10_1))
      return false;
    if (!(this.t10_1 === tmp0_other_with_cast.t10_1))
      return false;
    if (!(this.u10_1 === tmp0_other_with_cast.u10_1))
      return false;
    if (!equals(this.v10_1, tmp0_other_with_cast.v10_1))
      return false;
    if (!(this.w10_1 === tmp0_other_with_cast.w10_1))
      return false;
    if (!(this.x10_1 === tmp0_other_with_cast.x10_1))
      return false;
    if (!(this.y10_1 === tmp0_other_with_cast.y10_1))
      return false;
    return true;
  };
  function Companion_93() {
  }
  var Companion_instance_93;
  function Companion_getInstance_93() {
    return Companion_instance_93;
  }
  function Guernsey(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GGY' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guernsey' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u064A\u0631\u0646\u0632\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.z10_1 = phoneNumPrefix;
    this.a11_1 = isoCode2;
    this.b11_1 = isoCode3;
    this.c11_1 = currency;
    this.d11_1 = englishName;
    this.e11_1 = arabicName;
    this.f11_1 = phoneRegex;
  }
  protoOf(Guernsey).wd = function () {
    return this.z10_1;
  };
  protoOf(Guernsey).rd = function () {
    return this.a11_1;
  };
  protoOf(Guernsey).sd = function () {
    return this.b11_1;
  };
  protoOf(Guernsey).td = function () {
    return this.c11_1;
  };
  protoOf(Guernsey).ud = function () {
    return this.d11_1;
  };
  protoOf(Guernsey).vd = function () {
    return this.e11_1;
  };
  protoOf(Guernsey).xd = function () {
    return this.f11_1;
  };
  protoOf(Guernsey).toString = function () {
    return 'Guernsey(phoneNumPrefix=' + this.z10_1.toString() + ', isoCode2=' + this.a11_1 + ', isoCode3=' + this.b11_1 + ', currency=' + toString(this.c11_1) + ', englishName=' + this.d11_1 + ', arabicName=' + this.e11_1 + ', phoneRegex=' + this.f11_1 + ')';
  };
  protoOf(Guernsey).hashCode = function () {
    var result = this.z10_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b11_1) | 0;
    result = imul(result, 31) + hashCode(this.c11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f11_1) | 0;
    return result;
  };
  protoOf(Guernsey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Guernsey))
      return false;
    var tmp0_other_with_cast = other instanceof Guernsey ? other : THROW_CCE();
    if (!this.z10_1.equals(tmp0_other_with_cast.z10_1))
      return false;
    if (!(this.a11_1 === tmp0_other_with_cast.a11_1))
      return false;
    if (!(this.b11_1 === tmp0_other_with_cast.b11_1))
      return false;
    if (!equals(this.c11_1, tmp0_other_with_cast.c11_1))
      return false;
    if (!(this.d11_1 === tmp0_other_with_cast.d11_1))
      return false;
    if (!(this.e11_1 === tmp0_other_with_cast.e11_1))
      return false;
    if (!(this.f11_1 === tmp0_other_with_cast.f11_1))
      return false;
    return true;
  };
  function Companion_94() {
  }
  var Companion_instance_94;
  function Companion_getInstance_94() {
    return Companion_instance_94;
  }
  function Guinea(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GIN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guinea' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u064A\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.g11_1 = phoneNumPrefix;
    this.h11_1 = isoCode2;
    this.i11_1 = isoCode3;
    this.j11_1 = currency;
    this.k11_1 = englishName;
    this.l11_1 = arabicName;
    this.m11_1 = phoneRegex;
  }
  protoOf(Guinea).wd = function () {
    return this.g11_1;
  };
  protoOf(Guinea).rd = function () {
    return this.h11_1;
  };
  protoOf(Guinea).sd = function () {
    return this.i11_1;
  };
  protoOf(Guinea).td = function () {
    return this.j11_1;
  };
  protoOf(Guinea).ud = function () {
    return this.k11_1;
  };
  protoOf(Guinea).vd = function () {
    return this.l11_1;
  };
  protoOf(Guinea).xd = function () {
    return this.m11_1;
  };
  protoOf(Guinea).toString = function () {
    return 'Guinea(phoneNumPrefix=' + this.g11_1.toString() + ', isoCode2=' + this.h11_1 + ', isoCode3=' + this.i11_1 + ', currency=' + toString(this.j11_1) + ', englishName=' + this.k11_1 + ', arabicName=' + this.l11_1 + ', phoneRegex=' + this.m11_1 + ')';
  };
  protoOf(Guinea).hashCode = function () {
    var result = this.g11_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i11_1) | 0;
    result = imul(result, 31) + hashCode(this.j11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m11_1) | 0;
    return result;
  };
  protoOf(Guinea).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Guinea))
      return false;
    var tmp0_other_with_cast = other instanceof Guinea ? other : THROW_CCE();
    if (!this.g11_1.equals(tmp0_other_with_cast.g11_1))
      return false;
    if (!(this.h11_1 === tmp0_other_with_cast.h11_1))
      return false;
    if (!(this.i11_1 === tmp0_other_with_cast.i11_1))
      return false;
    if (!equals(this.j11_1, tmp0_other_with_cast.j11_1))
      return false;
    if (!(this.k11_1 === tmp0_other_with_cast.k11_1))
      return false;
    if (!(this.l11_1 === tmp0_other_with_cast.l11_1))
      return false;
    if (!(this.m11_1 === tmp0_other_with_cast.m11_1))
      return false;
    return true;
  };
  function Companion_95() {
  }
  var Companion_instance_95;
  function Companion_getInstance_95() {
    return Companion_instance_95;
  }
  function GuineaBissau(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GNB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guinea-Bissau' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u064A\u0646\u064A\u0627 \u0628\u064A\u0633\u0627\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.n11_1 = phoneNumPrefix;
    this.o11_1 = isoCode2;
    this.p11_1 = isoCode3;
    this.q11_1 = currency;
    this.r11_1 = englishName;
    this.s11_1 = arabicName;
    this.t11_1 = phoneRegex;
  }
  protoOf(GuineaBissau).wd = function () {
    return this.n11_1;
  };
  protoOf(GuineaBissau).rd = function () {
    return this.o11_1;
  };
  protoOf(GuineaBissau).sd = function () {
    return this.p11_1;
  };
  protoOf(GuineaBissau).td = function () {
    return this.q11_1;
  };
  protoOf(GuineaBissau).ud = function () {
    return this.r11_1;
  };
  protoOf(GuineaBissau).vd = function () {
    return this.s11_1;
  };
  protoOf(GuineaBissau).xd = function () {
    return this.t11_1;
  };
  protoOf(GuineaBissau).toString = function () {
    return 'GuineaBissau(phoneNumPrefix=' + this.n11_1.toString() + ', isoCode2=' + this.o11_1 + ', isoCode3=' + this.p11_1 + ', currency=' + toString(this.q11_1) + ', englishName=' + this.r11_1 + ', arabicName=' + this.s11_1 + ', phoneRegex=' + this.t11_1 + ')';
  };
  protoOf(GuineaBissau).hashCode = function () {
    var result = this.n11_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p11_1) | 0;
    result = imul(result, 31) + hashCode(this.q11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t11_1) | 0;
    return result;
  };
  protoOf(GuineaBissau).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GuineaBissau))
      return false;
    var tmp0_other_with_cast = other instanceof GuineaBissau ? other : THROW_CCE();
    if (!this.n11_1.equals(tmp0_other_with_cast.n11_1))
      return false;
    if (!(this.o11_1 === tmp0_other_with_cast.o11_1))
      return false;
    if (!(this.p11_1 === tmp0_other_with_cast.p11_1))
      return false;
    if (!equals(this.q11_1, tmp0_other_with_cast.q11_1))
      return false;
    if (!(this.r11_1 === tmp0_other_with_cast.r11_1))
      return false;
    if (!(this.s11_1 === tmp0_other_with_cast.s11_1))
      return false;
    if (!(this.t11_1 === tmp0_other_with_cast.t11_1))
      return false;
    return true;
  };
  function Companion_96() {
  }
  var Companion_instance_96;
  function Companion_getInstance_96() {
    return Companion_instance_96;
  }
  function Guyana(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GUY' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Guyana' : englishName;
    arabicName = arabicName === VOID ? '\u063A\u064A\u0627\u0646\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.u11_1 = phoneNumPrefix;
    this.v11_1 = isoCode2;
    this.w11_1 = isoCode3;
    this.x11_1 = currency;
    this.y11_1 = englishName;
    this.z11_1 = arabicName;
    this.a12_1 = phoneRegex;
  }
  protoOf(Guyana).wd = function () {
    return this.u11_1;
  };
  protoOf(Guyana).rd = function () {
    return this.v11_1;
  };
  protoOf(Guyana).sd = function () {
    return this.w11_1;
  };
  protoOf(Guyana).td = function () {
    return this.x11_1;
  };
  protoOf(Guyana).ud = function () {
    return this.y11_1;
  };
  protoOf(Guyana).vd = function () {
    return this.z11_1;
  };
  protoOf(Guyana).xd = function () {
    return this.a12_1;
  };
  protoOf(Guyana).toString = function () {
    return 'Guyana(phoneNumPrefix=' + this.u11_1.toString() + ', isoCode2=' + this.v11_1 + ', isoCode3=' + this.w11_1 + ', currency=' + toString(this.x11_1) + ', englishName=' + this.y11_1 + ', arabicName=' + this.z11_1 + ', phoneRegex=' + this.a12_1 + ')';
  };
  protoOf(Guyana).hashCode = function () {
    var result = this.u11_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.v11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w11_1) | 0;
    result = imul(result, 31) + hashCode(this.x11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z11_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a12_1) | 0;
    return result;
  };
  protoOf(Guyana).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Guyana))
      return false;
    var tmp0_other_with_cast = other instanceof Guyana ? other : THROW_CCE();
    if (!this.u11_1.equals(tmp0_other_with_cast.u11_1))
      return false;
    if (!(this.v11_1 === tmp0_other_with_cast.v11_1))
      return false;
    if (!(this.w11_1 === tmp0_other_with_cast.w11_1))
      return false;
    if (!equals(this.x11_1, tmp0_other_with_cast.x11_1))
      return false;
    if (!(this.y11_1 === tmp0_other_with_cast.y11_1))
      return false;
    if (!(this.z11_1 === tmp0_other_with_cast.z11_1))
      return false;
    if (!(this.a12_1 === tmp0_other_with_cast.a12_1))
      return false;
    return true;
  };
  function Companion_97() {
  }
  var Companion_instance_97;
  function Companion_getInstance_97() {
    return Companion_instance_97;
  }
  function Haiti(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'HT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'HTI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Haiti' : englishName;
    arabicName = arabicName === VOID ? '\u0647\u0627\u064A\u062A\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.b12_1 = phoneNumPrefix;
    this.c12_1 = isoCode2;
    this.d12_1 = isoCode3;
    this.e12_1 = currency;
    this.f12_1 = englishName;
    this.g12_1 = arabicName;
    this.h12_1 = phoneRegex;
  }
  protoOf(Haiti).wd = function () {
    return this.b12_1;
  };
  protoOf(Haiti).rd = function () {
    return this.c12_1;
  };
  protoOf(Haiti).sd = function () {
    return this.d12_1;
  };
  protoOf(Haiti).td = function () {
    return this.e12_1;
  };
  protoOf(Haiti).ud = function () {
    return this.f12_1;
  };
  protoOf(Haiti).vd = function () {
    return this.g12_1;
  };
  protoOf(Haiti).xd = function () {
    return this.h12_1;
  };
  protoOf(Haiti).toString = function () {
    return 'Haiti(phoneNumPrefix=' + this.b12_1.toString() + ', isoCode2=' + this.c12_1 + ', isoCode3=' + this.d12_1 + ', currency=' + toString(this.e12_1) + ', englishName=' + this.f12_1 + ', arabicName=' + this.g12_1 + ', phoneRegex=' + this.h12_1 + ')';
  };
  protoOf(Haiti).hashCode = function () {
    var result = this.b12_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d12_1) | 0;
    result = imul(result, 31) + hashCode(this.e12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h12_1) | 0;
    return result;
  };
  protoOf(Haiti).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Haiti))
      return false;
    var tmp0_other_with_cast = other instanceof Haiti ? other : THROW_CCE();
    if (!this.b12_1.equals(tmp0_other_with_cast.b12_1))
      return false;
    if (!(this.c12_1 === tmp0_other_with_cast.c12_1))
      return false;
    if (!(this.d12_1 === tmp0_other_with_cast.d12_1))
      return false;
    if (!equals(this.e12_1, tmp0_other_with_cast.e12_1))
      return false;
    if (!(this.f12_1 === tmp0_other_with_cast.f12_1))
      return false;
    if (!(this.g12_1 === tmp0_other_with_cast.g12_1))
      return false;
    if (!(this.h12_1 === tmp0_other_with_cast.h12_1))
      return false;
    return true;
  };
  function Companion_98() {
  }
  var Companion_instance_98;
  function Companion_getInstance_98() {
    return Companion_instance_98;
  }
  function HeardIslandandMcDonaldIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'HM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'HMD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Heard Island and McDonald Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u064A\u0631\u0629 \u0647\u064A\u0631\u062F \u0648\u062C\u0632\u0631 \u0645\u0627\u0643\u062F\u0648\u0646\u0627\u0644\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.i12_1 = phoneNumPrefix;
    this.j12_1 = isoCode2;
    this.k12_1 = isoCode3;
    this.l12_1 = currency;
    this.m12_1 = englishName;
    this.n12_1 = arabicName;
    this.o12_1 = phoneRegex;
  }
  protoOf(HeardIslandandMcDonaldIslands).wd = function () {
    return this.i12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).rd = function () {
    return this.j12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).sd = function () {
    return this.k12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).td = function () {
    return this.l12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).ud = function () {
    return this.m12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).vd = function () {
    return this.n12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).xd = function () {
    return this.o12_1;
  };
  protoOf(HeardIslandandMcDonaldIslands).toString = function () {
    return 'HeardIslandandMcDonaldIslands(phoneNumPrefix=' + this.i12_1.toString() + ', isoCode2=' + this.j12_1 + ', isoCode3=' + this.k12_1 + ', currency=' + toString(this.l12_1) + ', englishName=' + this.m12_1 + ', arabicName=' + this.n12_1 + ', phoneRegex=' + this.o12_1 + ')';
  };
  protoOf(HeardIslandandMcDonaldIslands).hashCode = function () {
    var result = this.i12_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k12_1) | 0;
    result = imul(result, 31) + hashCode(this.l12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o12_1) | 0;
    return result;
  };
  protoOf(HeardIslandandMcDonaldIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeardIslandandMcDonaldIslands))
      return false;
    var tmp0_other_with_cast = other instanceof HeardIslandandMcDonaldIslands ? other : THROW_CCE();
    if (!this.i12_1.equals(tmp0_other_with_cast.i12_1))
      return false;
    if (!(this.j12_1 === tmp0_other_with_cast.j12_1))
      return false;
    if (!(this.k12_1 === tmp0_other_with_cast.k12_1))
      return false;
    if (!equals(this.l12_1, tmp0_other_with_cast.l12_1))
      return false;
    if (!(this.m12_1 === tmp0_other_with_cast.m12_1))
      return false;
    if (!(this.n12_1 === tmp0_other_with_cast.n12_1))
      return false;
    if (!(this.o12_1 === tmp0_other_with_cast.o12_1))
      return false;
    return true;
  };
  function Companion_99() {
  }
  var Companion_instance_99;
  function Companion_getInstance_99() {
    return Companion_instance_99;
  }
  function HolySee(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VAT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Holy See' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0641\u0627\u062A\u064A\u0643\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.p12_1 = phoneNumPrefix;
    this.q12_1 = isoCode2;
    this.r12_1 = isoCode3;
    this.s12_1 = currency;
    this.t12_1 = englishName;
    this.u12_1 = arabicName;
    this.v12_1 = phoneRegex;
  }
  protoOf(HolySee).wd = function () {
    return this.p12_1;
  };
  protoOf(HolySee).rd = function () {
    return this.q12_1;
  };
  protoOf(HolySee).sd = function () {
    return this.r12_1;
  };
  protoOf(HolySee).td = function () {
    return this.s12_1;
  };
  protoOf(HolySee).ud = function () {
    return this.t12_1;
  };
  protoOf(HolySee).vd = function () {
    return this.u12_1;
  };
  protoOf(HolySee).xd = function () {
    return this.v12_1;
  };
  protoOf(HolySee).toString = function () {
    return 'HolySee(phoneNumPrefix=' + this.p12_1.toString() + ', isoCode2=' + this.q12_1 + ', isoCode3=' + this.r12_1 + ', currency=' + toString(this.s12_1) + ', englishName=' + this.t12_1 + ', arabicName=' + this.u12_1 + ', phoneRegex=' + this.v12_1 + ')';
  };
  protoOf(HolySee).hashCode = function () {
    var result = this.p12_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r12_1) | 0;
    result = imul(result, 31) + hashCode(this.s12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v12_1) | 0;
    return result;
  };
  protoOf(HolySee).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HolySee))
      return false;
    var tmp0_other_with_cast = other instanceof HolySee ? other : THROW_CCE();
    if (!this.p12_1.equals(tmp0_other_with_cast.p12_1))
      return false;
    if (!(this.q12_1 === tmp0_other_with_cast.q12_1))
      return false;
    if (!(this.r12_1 === tmp0_other_with_cast.r12_1))
      return false;
    if (!equals(this.s12_1, tmp0_other_with_cast.s12_1))
      return false;
    if (!(this.t12_1 === tmp0_other_with_cast.t12_1))
      return false;
    if (!(this.u12_1 === tmp0_other_with_cast.u12_1))
      return false;
    if (!(this.v12_1 === tmp0_other_with_cast.v12_1))
      return false;
    return true;
  };
  function Companion_100() {
  }
  var Companion_instance_100;
  function Companion_getInstance_100() {
    return Companion_instance_100;
  }
  function Honduras(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'HN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'HND' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Honduras' : englishName;
    arabicName = arabicName === VOID ? '\u0647\u0646\u062F\u0648\u0631\u0627\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.w12_1 = phoneNumPrefix;
    this.x12_1 = isoCode2;
    this.y12_1 = isoCode3;
    this.z12_1 = currency;
    this.a13_1 = englishName;
    this.b13_1 = arabicName;
    this.c13_1 = phoneRegex;
  }
  protoOf(Honduras).wd = function () {
    return this.w12_1;
  };
  protoOf(Honduras).rd = function () {
    return this.x12_1;
  };
  protoOf(Honduras).sd = function () {
    return this.y12_1;
  };
  protoOf(Honduras).td = function () {
    return this.z12_1;
  };
  protoOf(Honduras).ud = function () {
    return this.a13_1;
  };
  protoOf(Honduras).vd = function () {
    return this.b13_1;
  };
  protoOf(Honduras).xd = function () {
    return this.c13_1;
  };
  protoOf(Honduras).toString = function () {
    return 'Honduras(phoneNumPrefix=' + this.w12_1.toString() + ', isoCode2=' + this.x12_1 + ', isoCode3=' + this.y12_1 + ', currency=' + toString(this.z12_1) + ', englishName=' + this.a13_1 + ', arabicName=' + this.b13_1 + ', phoneRegex=' + this.c13_1 + ')';
  };
  protoOf(Honduras).hashCode = function () {
    var result = this.w12_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.x12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y12_1) | 0;
    result = imul(result, 31) + hashCode(this.z12_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c13_1) | 0;
    return result;
  };
  protoOf(Honduras).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Honduras))
      return false;
    var tmp0_other_with_cast = other instanceof Honduras ? other : THROW_CCE();
    if (!this.w12_1.equals(tmp0_other_with_cast.w12_1))
      return false;
    if (!(this.x12_1 === tmp0_other_with_cast.x12_1))
      return false;
    if (!(this.y12_1 === tmp0_other_with_cast.y12_1))
      return false;
    if (!equals(this.z12_1, tmp0_other_with_cast.z12_1))
      return false;
    if (!(this.a13_1 === tmp0_other_with_cast.a13_1))
      return false;
    if (!(this.b13_1 === tmp0_other_with_cast.b13_1))
      return false;
    if (!(this.c13_1 === tmp0_other_with_cast.c13_1))
      return false;
    return true;
  };
  function Companion_101() {
  }
  var Companion_instance_101;
  function Companion_getInstance_101() {
    return Companion_instance_101;
  }
  function HongKong(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'HK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'HKG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Hong Kong' : englishName;
    arabicName = arabicName === VOID ? '\u0647\u0648\u0646\u063A \u0643\u0648\u0646\u063A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.d13_1 = phoneNumPrefix;
    this.e13_1 = isoCode2;
    this.f13_1 = isoCode3;
    this.g13_1 = currency;
    this.h13_1 = englishName;
    this.i13_1 = arabicName;
    this.j13_1 = phoneRegex;
  }
  protoOf(HongKong).wd = function () {
    return this.d13_1;
  };
  protoOf(HongKong).rd = function () {
    return this.e13_1;
  };
  protoOf(HongKong).sd = function () {
    return this.f13_1;
  };
  protoOf(HongKong).td = function () {
    return this.g13_1;
  };
  protoOf(HongKong).ud = function () {
    return this.h13_1;
  };
  protoOf(HongKong).vd = function () {
    return this.i13_1;
  };
  protoOf(HongKong).xd = function () {
    return this.j13_1;
  };
  protoOf(HongKong).toString = function () {
    return 'HongKong(phoneNumPrefix=' + this.d13_1.toString() + ', isoCode2=' + this.e13_1 + ', isoCode3=' + this.f13_1 + ', currency=' + toString(this.g13_1) + ', englishName=' + this.h13_1 + ', arabicName=' + this.i13_1 + ', phoneRegex=' + this.j13_1 + ')';
  };
  protoOf(HongKong).hashCode = function () {
    var result = this.d13_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f13_1) | 0;
    result = imul(result, 31) + hashCode(this.g13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j13_1) | 0;
    return result;
  };
  protoOf(HongKong).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HongKong))
      return false;
    var tmp0_other_with_cast = other instanceof HongKong ? other : THROW_CCE();
    if (!this.d13_1.equals(tmp0_other_with_cast.d13_1))
      return false;
    if (!(this.e13_1 === tmp0_other_with_cast.e13_1))
      return false;
    if (!(this.f13_1 === tmp0_other_with_cast.f13_1))
      return false;
    if (!equals(this.g13_1, tmp0_other_with_cast.g13_1))
      return false;
    if (!(this.h13_1 === tmp0_other_with_cast.h13_1))
      return false;
    if (!(this.i13_1 === tmp0_other_with_cast.i13_1))
      return false;
    if (!(this.j13_1 === tmp0_other_with_cast.j13_1))
      return false;
    return true;
  };
  function Companion_102() {
  }
  var Companion_instance_102;
  function Companion_getInstance_102() {
    return Companion_instance_102;
  }
  function Hungary(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'HU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'HUN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Hungary' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0645\u062C\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.k13_1 = phoneNumPrefix;
    this.l13_1 = isoCode2;
    this.m13_1 = isoCode3;
    this.n13_1 = currency;
    this.o13_1 = englishName;
    this.p13_1 = arabicName;
    this.q13_1 = phoneRegex;
  }
  protoOf(Hungary).wd = function () {
    return this.k13_1;
  };
  protoOf(Hungary).rd = function () {
    return this.l13_1;
  };
  protoOf(Hungary).sd = function () {
    return this.m13_1;
  };
  protoOf(Hungary).td = function () {
    return this.n13_1;
  };
  protoOf(Hungary).ud = function () {
    return this.o13_1;
  };
  protoOf(Hungary).vd = function () {
    return this.p13_1;
  };
  protoOf(Hungary).xd = function () {
    return this.q13_1;
  };
  protoOf(Hungary).toString = function () {
    return 'Hungary(phoneNumPrefix=' + this.k13_1.toString() + ', isoCode2=' + this.l13_1 + ', isoCode3=' + this.m13_1 + ', currency=' + toString(this.n13_1) + ', englishName=' + this.o13_1 + ', arabicName=' + this.p13_1 + ', phoneRegex=' + this.q13_1 + ')';
  };
  protoOf(Hungary).hashCode = function () {
    var result = this.k13_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.l13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m13_1) | 0;
    result = imul(result, 31) + hashCode(this.n13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q13_1) | 0;
    return result;
  };
  protoOf(Hungary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Hungary))
      return false;
    var tmp0_other_with_cast = other instanceof Hungary ? other : THROW_CCE();
    if (!this.k13_1.equals(tmp0_other_with_cast.k13_1))
      return false;
    if (!(this.l13_1 === tmp0_other_with_cast.l13_1))
      return false;
    if (!(this.m13_1 === tmp0_other_with_cast.m13_1))
      return false;
    if (!equals(this.n13_1, tmp0_other_with_cast.n13_1))
      return false;
    if (!(this.o13_1 === tmp0_other_with_cast.o13_1))
      return false;
    if (!(this.p13_1 === tmp0_other_with_cast.p13_1))
      return false;
    if (!(this.q13_1 === tmp0_other_with_cast.q13_1))
      return false;
    return true;
  };
  function Companion_103() {
  }
  var Companion_instance_103;
  function Companion_getInstance_103() {
    return Companion_instance_103;
  }
  function Iceland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ISL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Iceland' : englishName;
    arabicName = arabicName === VOID ? '\u0622\u064A\u0633\u0644\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.r13_1 = phoneNumPrefix;
    this.s13_1 = isoCode2;
    this.t13_1 = isoCode3;
    this.u13_1 = currency;
    this.v13_1 = englishName;
    this.w13_1 = arabicName;
    this.x13_1 = phoneRegex;
  }
  protoOf(Iceland).wd = function () {
    return this.r13_1;
  };
  protoOf(Iceland).rd = function () {
    return this.s13_1;
  };
  protoOf(Iceland).sd = function () {
    return this.t13_1;
  };
  protoOf(Iceland).td = function () {
    return this.u13_1;
  };
  protoOf(Iceland).ud = function () {
    return this.v13_1;
  };
  protoOf(Iceland).vd = function () {
    return this.w13_1;
  };
  protoOf(Iceland).xd = function () {
    return this.x13_1;
  };
  protoOf(Iceland).toString = function () {
    return 'Iceland(phoneNumPrefix=' + this.r13_1.toString() + ', isoCode2=' + this.s13_1 + ', isoCode3=' + this.t13_1 + ', currency=' + toString(this.u13_1) + ', englishName=' + this.v13_1 + ', arabicName=' + this.w13_1 + ', phoneRegex=' + this.x13_1 + ')';
  };
  protoOf(Iceland).hashCode = function () {
    var result = this.r13_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.s13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t13_1) | 0;
    result = imul(result, 31) + hashCode(this.u13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x13_1) | 0;
    return result;
  };
  protoOf(Iceland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Iceland))
      return false;
    var tmp0_other_with_cast = other instanceof Iceland ? other : THROW_CCE();
    if (!this.r13_1.equals(tmp0_other_with_cast.r13_1))
      return false;
    if (!(this.s13_1 === tmp0_other_with_cast.s13_1))
      return false;
    if (!(this.t13_1 === tmp0_other_with_cast.t13_1))
      return false;
    if (!equals(this.u13_1, tmp0_other_with_cast.u13_1))
      return false;
    if (!(this.v13_1 === tmp0_other_with_cast.v13_1))
      return false;
    if (!(this.w13_1 === tmp0_other_with_cast.w13_1))
      return false;
    if (!(this.x13_1 === tmp0_other_with_cast.x13_1))
      return false;
    return true;
  };
  function Companion_104() {
  }
  var Companion_instance_104;
  function Companion_getInstance_104() {
    return Companion_instance_104;
  }
  function India(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(91, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IND' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'India' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0647\u0646\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '8123456789' : phoneNumberHint;
    this.ba_1 = phoneNumPrefix;
    this.ca_1 = isoCode2;
    this.da_1 = isoCode3;
    this.ea_1 = currency;
    this.fa_1 = englishName;
    this.ga_1 = arabicName;
    this.ha_1 = phoneRegex;
    this.ia_1 = phoneNumberHint;
  }
  protoOf(India).wd = function () {
    return this.ba_1;
  };
  protoOf(India).rd = function () {
    return this.ca_1;
  };
  protoOf(India).sd = function () {
    return this.da_1;
  };
  protoOf(India).td = function () {
    return this.ea_1;
  };
  protoOf(India).ud = function () {
    return this.fa_1;
  };
  protoOf(India).vd = function () {
    return this.ga_1;
  };
  protoOf(India).xd = function () {
    return this.ha_1;
  };
  protoOf(India).yd = function () {
    return this.ia_1;
  };
  protoOf(India).toString = function () {
    return 'India(phoneNumPrefix=' + this.ba_1.toString() + ', isoCode2=' + this.ca_1 + ', isoCode3=' + this.da_1 + ', currency=' + toString(this.ea_1) + ', englishName=' + this.fa_1 + ', arabicName=' + this.ga_1 + ', phoneRegex=' + this.ha_1 + ', phoneNumberHint=' + this.ia_1 + ')';
  };
  protoOf(India).hashCode = function () {
    var result = this.ba_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ca_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.da_1) | 0;
    result = imul(result, 31) + hashCode(this.ea_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fa_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ga_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ha_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ia_1) | 0;
    return result;
  };
  protoOf(India).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof India))
      return false;
    var tmp0_other_with_cast = other instanceof India ? other : THROW_CCE();
    if (!this.ba_1.equals(tmp0_other_with_cast.ba_1))
      return false;
    if (!(this.ca_1 === tmp0_other_with_cast.ca_1))
      return false;
    if (!(this.da_1 === tmp0_other_with_cast.da_1))
      return false;
    if (!equals(this.ea_1, tmp0_other_with_cast.ea_1))
      return false;
    if (!(this.fa_1 === tmp0_other_with_cast.fa_1))
      return false;
    if (!(this.ga_1 === tmp0_other_with_cast.ga_1))
      return false;
    if (!(this.ha_1 === tmp0_other_with_cast.ha_1))
      return false;
    if (!(this.ia_1 === tmp0_other_with_cast.ia_1))
      return false;
    return true;
  };
  function Companion_105() {
  }
  var Companion_instance_105;
  function Companion_getInstance_105() {
    return Companion_instance_105;
  }
  function Indonesia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ID' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IDN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Indonesia' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.y13_1 = phoneNumPrefix;
    this.z13_1 = isoCode2;
    this.a14_1 = isoCode3;
    this.b14_1 = currency;
    this.c14_1 = englishName;
    this.d14_1 = arabicName;
    this.e14_1 = phoneRegex;
  }
  protoOf(Indonesia).wd = function () {
    return this.y13_1;
  };
  protoOf(Indonesia).rd = function () {
    return this.z13_1;
  };
  protoOf(Indonesia).sd = function () {
    return this.a14_1;
  };
  protoOf(Indonesia).td = function () {
    return this.b14_1;
  };
  protoOf(Indonesia).ud = function () {
    return this.c14_1;
  };
  protoOf(Indonesia).vd = function () {
    return this.d14_1;
  };
  protoOf(Indonesia).xd = function () {
    return this.e14_1;
  };
  protoOf(Indonesia).toString = function () {
    return 'Indonesia(phoneNumPrefix=' + this.y13_1.toString() + ', isoCode2=' + this.z13_1 + ', isoCode3=' + this.a14_1 + ', currency=' + toString(this.b14_1) + ', englishName=' + this.c14_1 + ', arabicName=' + this.d14_1 + ', phoneRegex=' + this.e14_1 + ')';
  };
  protoOf(Indonesia).hashCode = function () {
    var result = this.y13_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.z13_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a14_1) | 0;
    result = imul(result, 31) + hashCode(this.b14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e14_1) | 0;
    return result;
  };
  protoOf(Indonesia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Indonesia))
      return false;
    var tmp0_other_with_cast = other instanceof Indonesia ? other : THROW_CCE();
    if (!this.y13_1.equals(tmp0_other_with_cast.y13_1))
      return false;
    if (!(this.z13_1 === tmp0_other_with_cast.z13_1))
      return false;
    if (!(this.a14_1 === tmp0_other_with_cast.a14_1))
      return false;
    if (!equals(this.b14_1, tmp0_other_with_cast.b14_1))
      return false;
    if (!(this.c14_1 === tmp0_other_with_cast.c14_1))
      return false;
    if (!(this.d14_1 === tmp0_other_with_cast.d14_1))
      return false;
    if (!(this.e14_1 === tmp0_other_with_cast.e14_1))
      return false;
    return true;
  };
  function Companion_106() {
  }
  var Companion_instance_106;
  function Companion_getInstance_106() {
    return Companion_instance_106;
  }
  function IranIslamicRepublicof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IRN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Iran (Islamic Republic of)' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u064A\u0631\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.f14_1 = phoneNumPrefix;
    this.g14_1 = isoCode2;
    this.h14_1 = isoCode3;
    this.i14_1 = currency;
    this.j14_1 = englishName;
    this.k14_1 = arabicName;
    this.l14_1 = phoneRegex;
  }
  protoOf(IranIslamicRepublicof).wd = function () {
    return this.f14_1;
  };
  protoOf(IranIslamicRepublicof).rd = function () {
    return this.g14_1;
  };
  protoOf(IranIslamicRepublicof).sd = function () {
    return this.h14_1;
  };
  protoOf(IranIslamicRepublicof).td = function () {
    return this.i14_1;
  };
  protoOf(IranIslamicRepublicof).ud = function () {
    return this.j14_1;
  };
  protoOf(IranIslamicRepublicof).vd = function () {
    return this.k14_1;
  };
  protoOf(IranIslamicRepublicof).xd = function () {
    return this.l14_1;
  };
  protoOf(IranIslamicRepublicof).toString = function () {
    return 'IranIslamicRepublicof(phoneNumPrefix=' + this.f14_1.toString() + ', isoCode2=' + this.g14_1 + ', isoCode3=' + this.h14_1 + ', currency=' + toString(this.i14_1) + ', englishName=' + this.j14_1 + ', arabicName=' + this.k14_1 + ', phoneRegex=' + this.l14_1 + ')';
  };
  protoOf(IranIslamicRepublicof).hashCode = function () {
    var result = this.f14_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h14_1) | 0;
    result = imul(result, 31) + hashCode(this.i14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l14_1) | 0;
    return result;
  };
  protoOf(IranIslamicRepublicof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IranIslamicRepublicof))
      return false;
    var tmp0_other_with_cast = other instanceof IranIslamicRepublicof ? other : THROW_CCE();
    if (!this.f14_1.equals(tmp0_other_with_cast.f14_1))
      return false;
    if (!(this.g14_1 === tmp0_other_with_cast.g14_1))
      return false;
    if (!(this.h14_1 === tmp0_other_with_cast.h14_1))
      return false;
    if (!equals(this.i14_1, tmp0_other_with_cast.i14_1))
      return false;
    if (!(this.j14_1 === tmp0_other_with_cast.j14_1))
      return false;
    if (!(this.k14_1 === tmp0_other_with_cast.k14_1))
      return false;
    if (!(this.l14_1 === tmp0_other_with_cast.l14_1))
      return false;
    return true;
  };
  function Companion_107() {
  }
  var Companion_instance_107;
  function Companion_getInstance_107() {
    return Companion_instance_107;
  }
  function Iraq(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    isoCode2 = isoCode2 === VOID ? 'IQ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IRQ' : isoCode3;
    currency = currency === VOID ? IQD_getInstance() : currency;
    englishName = englishName === VOID ? 'Iraq' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0639\u0631\u0627\u0642' : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(964, 0) : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? '^(((?:\\+|00)964)|(0)*)7\\d{9}$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '9647123456789' : phoneNumberHint;
    this.l5_1 = isoCode2;
    this.m5_1 = isoCode3;
    this.n5_1 = currency;
    this.o5_1 = englishName;
    this.p5_1 = arabicName;
    this.q5_1 = phoneNumPrefix;
    this.r5_1 = phoneRegex;
    this.s5_1 = phoneNumberHint;
  }
  protoOf(Iraq).rd = function () {
    return this.l5_1;
  };
  protoOf(Iraq).sd = function () {
    return this.m5_1;
  };
  protoOf(Iraq).td = function () {
    return this.n5_1;
  };
  protoOf(Iraq).ud = function () {
    return this.o5_1;
  };
  protoOf(Iraq).vd = function () {
    return this.p5_1;
  };
  protoOf(Iraq).wd = function () {
    return this.q5_1;
  };
  protoOf(Iraq).xd = function () {
    return this.r5_1;
  };
  protoOf(Iraq).yd = function () {
    return this.s5_1;
  };
  protoOf(Iraq).toString = function () {
    return 'Iraq(isoCode2=' + this.l5_1 + ', isoCode3=' + this.m5_1 + ', currency=' + toString(this.n5_1) + ', englishName=' + this.o5_1 + ', arabicName=' + this.p5_1 + ', phoneNumPrefix=' + this.q5_1.toString() + ', phoneRegex=' + this.r5_1 + ', phoneNumberHint=' + this.s5_1 + ')';
  };
  protoOf(Iraq).hashCode = function () {
    var result = getStringHashCode(this.l5_1);
    result = imul(result, 31) + getStringHashCode(this.m5_1) | 0;
    result = imul(result, 31) + hashCode(this.n5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p5_1) | 0;
    result = imul(result, 31) + this.q5_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.r5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s5_1) | 0;
    return result;
  };
  protoOf(Iraq).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Iraq))
      return false;
    var tmp0_other_with_cast = other instanceof Iraq ? other : THROW_CCE();
    if (!(this.l5_1 === tmp0_other_with_cast.l5_1))
      return false;
    if (!(this.m5_1 === tmp0_other_with_cast.m5_1))
      return false;
    if (!equals(this.n5_1, tmp0_other_with_cast.n5_1))
      return false;
    if (!(this.o5_1 === tmp0_other_with_cast.o5_1))
      return false;
    if (!(this.p5_1 === tmp0_other_with_cast.p5_1))
      return false;
    if (!this.q5_1.equals(tmp0_other_with_cast.q5_1))
      return false;
    if (!(this.r5_1 === tmp0_other_with_cast.r5_1))
      return false;
    if (!(this.s5_1 === tmp0_other_with_cast.s5_1))
      return false;
    return true;
  };
  function Companion_108() {
  }
  var Companion_instance_108;
  function Companion_getInstance_108() {
    return Companion_instance_108;
  }
  function Ireland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IRL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Ireland' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u064A\u0631\u0644\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.m14_1 = phoneNumPrefix;
    this.n14_1 = isoCode2;
    this.o14_1 = isoCode3;
    this.p14_1 = currency;
    this.q14_1 = englishName;
    this.r14_1 = arabicName;
    this.s14_1 = phoneRegex;
  }
  protoOf(Ireland).wd = function () {
    return this.m14_1;
  };
  protoOf(Ireland).rd = function () {
    return this.n14_1;
  };
  protoOf(Ireland).sd = function () {
    return this.o14_1;
  };
  protoOf(Ireland).td = function () {
    return this.p14_1;
  };
  protoOf(Ireland).ud = function () {
    return this.q14_1;
  };
  protoOf(Ireland).vd = function () {
    return this.r14_1;
  };
  protoOf(Ireland).xd = function () {
    return this.s14_1;
  };
  protoOf(Ireland).toString = function () {
    return 'Ireland(phoneNumPrefix=' + this.m14_1.toString() + ', isoCode2=' + this.n14_1 + ', isoCode3=' + this.o14_1 + ', currency=' + toString(this.p14_1) + ', englishName=' + this.q14_1 + ', arabicName=' + this.r14_1 + ', phoneRegex=' + this.s14_1 + ')';
  };
  protoOf(Ireland).hashCode = function () {
    var result = this.m14_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.n14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o14_1) | 0;
    result = imul(result, 31) + hashCode(this.p14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s14_1) | 0;
    return result;
  };
  protoOf(Ireland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ireland))
      return false;
    var tmp0_other_with_cast = other instanceof Ireland ? other : THROW_CCE();
    if (!this.m14_1.equals(tmp0_other_with_cast.m14_1))
      return false;
    if (!(this.n14_1 === tmp0_other_with_cast.n14_1))
      return false;
    if (!(this.o14_1 === tmp0_other_with_cast.o14_1))
      return false;
    if (!equals(this.p14_1, tmp0_other_with_cast.p14_1))
      return false;
    if (!(this.q14_1 === tmp0_other_with_cast.q14_1))
      return false;
    if (!(this.r14_1 === tmp0_other_with_cast.r14_1))
      return false;
    if (!(this.s14_1 === tmp0_other_with_cast.s14_1))
      return false;
    return true;
  };
  function Companion_109() {
  }
  var Companion_instance_109;
  function Companion_getInstance_109() {
    return Companion_instance_109;
  }
  function IsleofMan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'IMN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Isle of Man' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u064A\u0631\u0629 \u0645\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.t14_1 = phoneNumPrefix;
    this.u14_1 = isoCode2;
    this.v14_1 = isoCode3;
    this.w14_1 = currency;
    this.x14_1 = englishName;
    this.y14_1 = arabicName;
    this.z14_1 = phoneRegex;
  }
  protoOf(IsleofMan).wd = function () {
    return this.t14_1;
  };
  protoOf(IsleofMan).rd = function () {
    return this.u14_1;
  };
  protoOf(IsleofMan).sd = function () {
    return this.v14_1;
  };
  protoOf(IsleofMan).td = function () {
    return this.w14_1;
  };
  protoOf(IsleofMan).ud = function () {
    return this.x14_1;
  };
  protoOf(IsleofMan).vd = function () {
    return this.y14_1;
  };
  protoOf(IsleofMan).xd = function () {
    return this.z14_1;
  };
  protoOf(IsleofMan).toString = function () {
    return 'IsleofMan(phoneNumPrefix=' + this.t14_1.toString() + ', isoCode2=' + this.u14_1 + ', isoCode3=' + this.v14_1 + ', currency=' + toString(this.w14_1) + ', englishName=' + this.x14_1 + ', arabicName=' + this.y14_1 + ', phoneRegex=' + this.z14_1 + ')';
  };
  protoOf(IsleofMan).hashCode = function () {
    var result = this.t14_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v14_1) | 0;
    result = imul(result, 31) + hashCode(this.w14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y14_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z14_1) | 0;
    return result;
  };
  protoOf(IsleofMan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IsleofMan))
      return false;
    var tmp0_other_with_cast = other instanceof IsleofMan ? other : THROW_CCE();
    if (!this.t14_1.equals(tmp0_other_with_cast.t14_1))
      return false;
    if (!(this.u14_1 === tmp0_other_with_cast.u14_1))
      return false;
    if (!(this.v14_1 === tmp0_other_with_cast.v14_1))
      return false;
    if (!equals(this.w14_1, tmp0_other_with_cast.w14_1))
      return false;
    if (!(this.x14_1 === tmp0_other_with_cast.x14_1))
      return false;
    if (!(this.y14_1 === tmp0_other_with_cast.y14_1))
      return false;
    if (!(this.z14_1 === tmp0_other_with_cast.z14_1))
      return false;
    return true;
  };
  function Companion_110() {
  }
  var Companion_instance_110;
  function Companion_getInstance_110() {
    return Companion_instance_110;
  }
  function Israel(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ISR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Israel' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0633\u0631\u0627\u0626\u064A\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.a15_1 = phoneNumPrefix;
    this.b15_1 = isoCode2;
    this.c15_1 = isoCode3;
    this.d15_1 = currency;
    this.e15_1 = englishName;
    this.f15_1 = arabicName;
    this.g15_1 = phoneRegex;
  }
  protoOf(Israel).wd = function () {
    return this.a15_1;
  };
  protoOf(Israel).rd = function () {
    return this.b15_1;
  };
  protoOf(Israel).sd = function () {
    return this.c15_1;
  };
  protoOf(Israel).td = function () {
    return this.d15_1;
  };
  protoOf(Israel).ud = function () {
    return this.e15_1;
  };
  protoOf(Israel).vd = function () {
    return this.f15_1;
  };
  protoOf(Israel).xd = function () {
    return this.g15_1;
  };
  protoOf(Israel).toString = function () {
    return 'Israel(phoneNumPrefix=' + this.a15_1.toString() + ', isoCode2=' + this.b15_1 + ', isoCode3=' + this.c15_1 + ', currency=' + toString(this.d15_1) + ', englishName=' + this.e15_1 + ', arabicName=' + this.f15_1 + ', phoneRegex=' + this.g15_1 + ')';
  };
  protoOf(Israel).hashCode = function () {
    var result = this.a15_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c15_1) | 0;
    result = imul(result, 31) + hashCode(this.d15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g15_1) | 0;
    return result;
  };
  protoOf(Israel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Israel))
      return false;
    var tmp0_other_with_cast = other instanceof Israel ? other : THROW_CCE();
    if (!this.a15_1.equals(tmp0_other_with_cast.a15_1))
      return false;
    if (!(this.b15_1 === tmp0_other_with_cast.b15_1))
      return false;
    if (!(this.c15_1 === tmp0_other_with_cast.c15_1))
      return false;
    if (!equals(this.d15_1, tmp0_other_with_cast.d15_1))
      return false;
    if (!(this.e15_1 === tmp0_other_with_cast.e15_1))
      return false;
    if (!(this.f15_1 === tmp0_other_with_cast.f15_1))
      return false;
    if (!(this.g15_1 === tmp0_other_with_cast.g15_1))
      return false;
    return true;
  };
  function Companion_111() {
  }
  var Companion_instance_111;
  function Companion_getInstance_111() {
    return Companion_instance_111;
  }
  function Italy(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'IT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ITA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Italy' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u064A\u0637\u0627\u0644\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.h15_1 = phoneNumPrefix;
    this.i15_1 = isoCode2;
    this.j15_1 = isoCode3;
    this.k15_1 = currency;
    this.l15_1 = englishName;
    this.m15_1 = arabicName;
    this.n15_1 = phoneRegex;
  }
  protoOf(Italy).wd = function () {
    return this.h15_1;
  };
  protoOf(Italy).rd = function () {
    return this.i15_1;
  };
  protoOf(Italy).sd = function () {
    return this.j15_1;
  };
  protoOf(Italy).td = function () {
    return this.k15_1;
  };
  protoOf(Italy).ud = function () {
    return this.l15_1;
  };
  protoOf(Italy).vd = function () {
    return this.m15_1;
  };
  protoOf(Italy).xd = function () {
    return this.n15_1;
  };
  protoOf(Italy).toString = function () {
    return 'Italy(phoneNumPrefix=' + this.h15_1.toString() + ', isoCode2=' + this.i15_1 + ', isoCode3=' + this.j15_1 + ', currency=' + toString(this.k15_1) + ', englishName=' + this.l15_1 + ', arabicName=' + this.m15_1 + ', phoneRegex=' + this.n15_1 + ')';
  };
  protoOf(Italy).hashCode = function () {
    var result = this.h15_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j15_1) | 0;
    result = imul(result, 31) + hashCode(this.k15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n15_1) | 0;
    return result;
  };
  protoOf(Italy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Italy))
      return false;
    var tmp0_other_with_cast = other instanceof Italy ? other : THROW_CCE();
    if (!this.h15_1.equals(tmp0_other_with_cast.h15_1))
      return false;
    if (!(this.i15_1 === tmp0_other_with_cast.i15_1))
      return false;
    if (!(this.j15_1 === tmp0_other_with_cast.j15_1))
      return false;
    if (!equals(this.k15_1, tmp0_other_with_cast.k15_1))
      return false;
    if (!(this.l15_1 === tmp0_other_with_cast.l15_1))
      return false;
    if (!(this.m15_1 === tmp0_other_with_cast.m15_1))
      return false;
    if (!(this.n15_1 === tmp0_other_with_cast.n15_1))
      return false;
    return true;
  };
  function Companion_112() {
  }
  var Companion_instance_112;
  function Companion_getInstance_112() {
    return Companion_instance_112;
  }
  function Jamaica(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'JM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'JAM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Jamaica' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0627\u0645\u0627\u064A\u0643\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.o15_1 = phoneNumPrefix;
    this.p15_1 = isoCode2;
    this.q15_1 = isoCode3;
    this.r15_1 = currency;
    this.s15_1 = englishName;
    this.t15_1 = arabicName;
    this.u15_1 = phoneRegex;
  }
  protoOf(Jamaica).wd = function () {
    return this.o15_1;
  };
  protoOf(Jamaica).rd = function () {
    return this.p15_1;
  };
  protoOf(Jamaica).sd = function () {
    return this.q15_1;
  };
  protoOf(Jamaica).td = function () {
    return this.r15_1;
  };
  protoOf(Jamaica).ud = function () {
    return this.s15_1;
  };
  protoOf(Jamaica).vd = function () {
    return this.t15_1;
  };
  protoOf(Jamaica).xd = function () {
    return this.u15_1;
  };
  protoOf(Jamaica).toString = function () {
    return 'Jamaica(phoneNumPrefix=' + this.o15_1.toString() + ', isoCode2=' + this.p15_1 + ', isoCode3=' + this.q15_1 + ', currency=' + toString(this.r15_1) + ', englishName=' + this.s15_1 + ', arabicName=' + this.t15_1 + ', phoneRegex=' + this.u15_1 + ')';
  };
  protoOf(Jamaica).hashCode = function () {
    var result = this.o15_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q15_1) | 0;
    result = imul(result, 31) + hashCode(this.r15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u15_1) | 0;
    return result;
  };
  protoOf(Jamaica).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Jamaica))
      return false;
    var tmp0_other_with_cast = other instanceof Jamaica ? other : THROW_CCE();
    if (!this.o15_1.equals(tmp0_other_with_cast.o15_1))
      return false;
    if (!(this.p15_1 === tmp0_other_with_cast.p15_1))
      return false;
    if (!(this.q15_1 === tmp0_other_with_cast.q15_1))
      return false;
    if (!equals(this.r15_1, tmp0_other_with_cast.r15_1))
      return false;
    if (!(this.s15_1 === tmp0_other_with_cast.s15_1))
      return false;
    if (!(this.t15_1 === tmp0_other_with_cast.t15_1))
      return false;
    if (!(this.u15_1 === tmp0_other_with_cast.u15_1))
      return false;
    return true;
  };
  function Companion_113() {
  }
  var Companion_instance_113;
  function Companion_getInstance_113() {
    return Companion_instance_113;
  }
  function Japan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'JP' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'JPN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Japan' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u064A\u0627\u0628\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.v15_1 = phoneNumPrefix;
    this.w15_1 = isoCode2;
    this.x15_1 = isoCode3;
    this.y15_1 = currency;
    this.z15_1 = englishName;
    this.a16_1 = arabicName;
    this.b16_1 = phoneRegex;
  }
  protoOf(Japan).wd = function () {
    return this.v15_1;
  };
  protoOf(Japan).rd = function () {
    return this.w15_1;
  };
  protoOf(Japan).sd = function () {
    return this.x15_1;
  };
  protoOf(Japan).td = function () {
    return this.y15_1;
  };
  protoOf(Japan).ud = function () {
    return this.z15_1;
  };
  protoOf(Japan).vd = function () {
    return this.a16_1;
  };
  protoOf(Japan).xd = function () {
    return this.b16_1;
  };
  protoOf(Japan).toString = function () {
    return 'Japan(phoneNumPrefix=' + this.v15_1.toString() + ', isoCode2=' + this.w15_1 + ', isoCode3=' + this.x15_1 + ', currency=' + toString(this.y15_1) + ', englishName=' + this.z15_1 + ', arabicName=' + this.a16_1 + ', phoneRegex=' + this.b16_1 + ')';
  };
  protoOf(Japan).hashCode = function () {
    var result = this.v15_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x15_1) | 0;
    result = imul(result, 31) + hashCode(this.y15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z15_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b16_1) | 0;
    return result;
  };
  protoOf(Japan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Japan))
      return false;
    var tmp0_other_with_cast = other instanceof Japan ? other : THROW_CCE();
    if (!this.v15_1.equals(tmp0_other_with_cast.v15_1))
      return false;
    if (!(this.w15_1 === tmp0_other_with_cast.w15_1))
      return false;
    if (!(this.x15_1 === tmp0_other_with_cast.x15_1))
      return false;
    if (!equals(this.y15_1, tmp0_other_with_cast.y15_1))
      return false;
    if (!(this.z15_1 === tmp0_other_with_cast.z15_1))
      return false;
    if (!(this.a16_1 === tmp0_other_with_cast.a16_1))
      return false;
    if (!(this.b16_1 === tmp0_other_with_cast.b16_1))
      return false;
    return true;
  };
  function Companion_114() {
  }
  var Companion_instance_114;
  function Companion_getInstance_114() {
    return Companion_instance_114;
  }
  function Jersey(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'JE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'JEY' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Jersey' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u064A\u0631\u0632\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.c16_1 = phoneNumPrefix;
    this.d16_1 = isoCode2;
    this.e16_1 = isoCode3;
    this.f16_1 = currency;
    this.g16_1 = englishName;
    this.h16_1 = arabicName;
    this.i16_1 = phoneRegex;
  }
  protoOf(Jersey).wd = function () {
    return this.c16_1;
  };
  protoOf(Jersey).rd = function () {
    return this.d16_1;
  };
  protoOf(Jersey).sd = function () {
    return this.e16_1;
  };
  protoOf(Jersey).td = function () {
    return this.f16_1;
  };
  protoOf(Jersey).ud = function () {
    return this.g16_1;
  };
  protoOf(Jersey).vd = function () {
    return this.h16_1;
  };
  protoOf(Jersey).xd = function () {
    return this.i16_1;
  };
  protoOf(Jersey).toString = function () {
    return 'Jersey(phoneNumPrefix=' + this.c16_1.toString() + ', isoCode2=' + this.d16_1 + ', isoCode3=' + this.e16_1 + ', currency=' + toString(this.f16_1) + ', englishName=' + this.g16_1 + ', arabicName=' + this.h16_1 + ', phoneRegex=' + this.i16_1 + ')';
  };
  protoOf(Jersey).hashCode = function () {
    var result = this.c16_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.d16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e16_1) | 0;
    result = imul(result, 31) + hashCode(this.f16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i16_1) | 0;
    return result;
  };
  protoOf(Jersey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Jersey))
      return false;
    var tmp0_other_with_cast = other instanceof Jersey ? other : THROW_CCE();
    if (!this.c16_1.equals(tmp0_other_with_cast.c16_1))
      return false;
    if (!(this.d16_1 === tmp0_other_with_cast.d16_1))
      return false;
    if (!(this.e16_1 === tmp0_other_with_cast.e16_1))
      return false;
    if (!equals(this.f16_1, tmp0_other_with_cast.f16_1))
      return false;
    if (!(this.g16_1 === tmp0_other_with_cast.g16_1))
      return false;
    if (!(this.h16_1 === tmp0_other_with_cast.h16_1))
      return false;
    if (!(this.i16_1 === tmp0_other_with_cast.i16_1))
      return false;
    return true;
  };
  function Companion_115() {
  }
  var Companion_instance_115;
  function Companion_getInstance_115() {
    return Companion_instance_115;
  }
  function Jordan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(962, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'JO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'JOR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Jordan' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0623\u0631\u062F\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(9) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '790123456' : phoneNumberHint;
    this.v8_1 = phoneNumPrefix;
    this.w8_1 = isoCode2;
    this.x8_1 = isoCode3;
    this.y8_1 = currency;
    this.z8_1 = englishName;
    this.a9_1 = arabicName;
    this.b9_1 = phoneRegex;
    this.c9_1 = phoneNumberHint;
  }
  protoOf(Jordan).wd = function () {
    return this.v8_1;
  };
  protoOf(Jordan).rd = function () {
    return this.w8_1;
  };
  protoOf(Jordan).sd = function () {
    return this.x8_1;
  };
  protoOf(Jordan).td = function () {
    return this.y8_1;
  };
  protoOf(Jordan).ud = function () {
    return this.z8_1;
  };
  protoOf(Jordan).vd = function () {
    return this.a9_1;
  };
  protoOf(Jordan).xd = function () {
    return this.b9_1;
  };
  protoOf(Jordan).yd = function () {
    return this.c9_1;
  };
  protoOf(Jordan).toString = function () {
    return 'Jordan(phoneNumPrefix=' + this.v8_1.toString() + ', isoCode2=' + this.w8_1 + ', isoCode3=' + this.x8_1 + ', currency=' + toString(this.y8_1) + ', englishName=' + this.z8_1 + ', arabicName=' + this.a9_1 + ', phoneRegex=' + this.b9_1 + ', phoneNumberHint=' + this.c9_1 + ')';
  };
  protoOf(Jordan).hashCode = function () {
    var result = this.v8_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x8_1) | 0;
    result = imul(result, 31) + hashCode(this.y8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c9_1) | 0;
    return result;
  };
  protoOf(Jordan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Jordan))
      return false;
    var tmp0_other_with_cast = other instanceof Jordan ? other : THROW_CCE();
    if (!this.v8_1.equals(tmp0_other_with_cast.v8_1))
      return false;
    if (!(this.w8_1 === tmp0_other_with_cast.w8_1))
      return false;
    if (!(this.x8_1 === tmp0_other_with_cast.x8_1))
      return false;
    if (!equals(this.y8_1, tmp0_other_with_cast.y8_1))
      return false;
    if (!(this.z8_1 === tmp0_other_with_cast.z8_1))
      return false;
    if (!(this.a9_1 === tmp0_other_with_cast.a9_1))
      return false;
    if (!(this.b9_1 === tmp0_other_with_cast.b9_1))
      return false;
    if (!(this.c9_1 === tmp0_other_with_cast.c9_1))
      return false;
    return true;
  };
  function Companion_116() {
  }
  var Companion_instance_116;
  function Companion_getInstance_116() {
    return Companion_instance_116;
  }
  function Kazakhstan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KAZ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Kazakhstan' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.j16_1 = phoneNumPrefix;
    this.k16_1 = isoCode2;
    this.l16_1 = isoCode3;
    this.m16_1 = currency;
    this.n16_1 = englishName;
    this.o16_1 = arabicName;
    this.p16_1 = phoneRegex;
  }
  protoOf(Kazakhstan).wd = function () {
    return this.j16_1;
  };
  protoOf(Kazakhstan).rd = function () {
    return this.k16_1;
  };
  protoOf(Kazakhstan).sd = function () {
    return this.l16_1;
  };
  protoOf(Kazakhstan).td = function () {
    return this.m16_1;
  };
  protoOf(Kazakhstan).ud = function () {
    return this.n16_1;
  };
  protoOf(Kazakhstan).vd = function () {
    return this.o16_1;
  };
  protoOf(Kazakhstan).xd = function () {
    return this.p16_1;
  };
  protoOf(Kazakhstan).toString = function () {
    return 'Kazakhstan(phoneNumPrefix=' + this.j16_1.toString() + ', isoCode2=' + this.k16_1 + ', isoCode3=' + this.l16_1 + ', currency=' + toString(this.m16_1) + ', englishName=' + this.n16_1 + ', arabicName=' + this.o16_1 + ', phoneRegex=' + this.p16_1 + ')';
  };
  protoOf(Kazakhstan).hashCode = function () {
    var result = this.j16_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.k16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l16_1) | 0;
    result = imul(result, 31) + hashCode(this.m16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p16_1) | 0;
    return result;
  };
  protoOf(Kazakhstan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Kazakhstan))
      return false;
    var tmp0_other_with_cast = other instanceof Kazakhstan ? other : THROW_CCE();
    if (!this.j16_1.equals(tmp0_other_with_cast.j16_1))
      return false;
    if (!(this.k16_1 === tmp0_other_with_cast.k16_1))
      return false;
    if (!(this.l16_1 === tmp0_other_with_cast.l16_1))
      return false;
    if (!equals(this.m16_1, tmp0_other_with_cast.m16_1))
      return false;
    if (!(this.n16_1 === tmp0_other_with_cast.n16_1))
      return false;
    if (!(this.o16_1 === tmp0_other_with_cast.o16_1))
      return false;
    if (!(this.p16_1 === tmp0_other_with_cast.p16_1))
      return false;
    return true;
  };
  function Companion_117() {
  }
  var Companion_instance_117;
  function Companion_getInstance_117() {
    return Companion_instance_117;
  }
  function Kenya(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(254, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KEN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Kenya' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u064A\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(9) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '712123456' : phoneNumberHint;
    this.nc_1 = phoneNumPrefix;
    this.oc_1 = isoCode2;
    this.pc_1 = isoCode3;
    this.qc_1 = currency;
    this.rc_1 = englishName;
    this.sc_1 = arabicName;
    this.tc_1 = phoneRegex;
    this.uc_1 = phoneNumberHint;
  }
  protoOf(Kenya).wd = function () {
    return this.nc_1;
  };
  protoOf(Kenya).rd = function () {
    return this.oc_1;
  };
  protoOf(Kenya).sd = function () {
    return this.pc_1;
  };
  protoOf(Kenya).td = function () {
    return this.qc_1;
  };
  protoOf(Kenya).ud = function () {
    return this.rc_1;
  };
  protoOf(Kenya).vd = function () {
    return this.sc_1;
  };
  protoOf(Kenya).xd = function () {
    return this.tc_1;
  };
  protoOf(Kenya).yd = function () {
    return this.uc_1;
  };
  protoOf(Kenya).toString = function () {
    return 'Kenya(phoneNumPrefix=' + this.nc_1.toString() + ', isoCode2=' + this.oc_1 + ', isoCode3=' + this.pc_1 + ', currency=' + toString(this.qc_1) + ', englishName=' + this.rc_1 + ', arabicName=' + this.sc_1 + ', phoneRegex=' + this.tc_1 + ', phoneNumberHint=' + this.uc_1 + ')';
  };
  protoOf(Kenya).hashCode = function () {
    var result = this.nc_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.oc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pc_1) | 0;
    result = imul(result, 31) + hashCode(this.qc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.sc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.uc_1) | 0;
    return result;
  };
  protoOf(Kenya).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Kenya))
      return false;
    var tmp0_other_with_cast = other instanceof Kenya ? other : THROW_CCE();
    if (!this.nc_1.equals(tmp0_other_with_cast.nc_1))
      return false;
    if (!(this.oc_1 === tmp0_other_with_cast.oc_1))
      return false;
    if (!(this.pc_1 === tmp0_other_with_cast.pc_1))
      return false;
    if (!equals(this.qc_1, tmp0_other_with_cast.qc_1))
      return false;
    if (!(this.rc_1 === tmp0_other_with_cast.rc_1))
      return false;
    if (!(this.sc_1 === tmp0_other_with_cast.sc_1))
      return false;
    if (!(this.tc_1 === tmp0_other_with_cast.tc_1))
      return false;
    if (!(this.uc_1 === tmp0_other_with_cast.uc_1))
      return false;
    return true;
  };
  function Companion_118() {
  }
  var Companion_instance_118;
  function Companion_getInstance_118() {
    return Companion_instance_118;
  }
  function Kiribati(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KIR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Kiribati' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u064A\u0631\u064A\u0628\u0627\u062A\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.q16_1 = phoneNumPrefix;
    this.r16_1 = isoCode2;
    this.s16_1 = isoCode3;
    this.t16_1 = currency;
    this.u16_1 = englishName;
    this.v16_1 = arabicName;
    this.w16_1 = phoneRegex;
  }
  protoOf(Kiribati).wd = function () {
    return this.q16_1;
  };
  protoOf(Kiribati).rd = function () {
    return this.r16_1;
  };
  protoOf(Kiribati).sd = function () {
    return this.s16_1;
  };
  protoOf(Kiribati).td = function () {
    return this.t16_1;
  };
  protoOf(Kiribati).ud = function () {
    return this.u16_1;
  };
  protoOf(Kiribati).vd = function () {
    return this.v16_1;
  };
  protoOf(Kiribati).xd = function () {
    return this.w16_1;
  };
  protoOf(Kiribati).toString = function () {
    return 'Kiribati(phoneNumPrefix=' + this.q16_1.toString() + ', isoCode2=' + this.r16_1 + ', isoCode3=' + this.s16_1 + ', currency=' + toString(this.t16_1) + ', englishName=' + this.u16_1 + ', arabicName=' + this.v16_1 + ', phoneRegex=' + this.w16_1 + ')';
  };
  protoOf(Kiribati).hashCode = function () {
    var result = this.q16_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s16_1) | 0;
    result = imul(result, 31) + hashCode(this.t16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w16_1) | 0;
    return result;
  };
  protoOf(Kiribati).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Kiribati))
      return false;
    var tmp0_other_with_cast = other instanceof Kiribati ? other : THROW_CCE();
    if (!this.q16_1.equals(tmp0_other_with_cast.q16_1))
      return false;
    if (!(this.r16_1 === tmp0_other_with_cast.r16_1))
      return false;
    if (!(this.s16_1 === tmp0_other_with_cast.s16_1))
      return false;
    if (!equals(this.t16_1, tmp0_other_with_cast.t16_1))
      return false;
    if (!(this.u16_1 === tmp0_other_with_cast.u16_1))
      return false;
    if (!(this.v16_1 === tmp0_other_with_cast.v16_1))
      return false;
    if (!(this.w16_1 === tmp0_other_with_cast.w16_1))
      return false;
    return true;
  };
  function Companion_119() {
  }
  var Companion_instance_119;
  function Companion_getInstance_119() {
    return Companion_instance_119;
  }
  function KoreaDemocraticPeoplesRepublicof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KP' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PRK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? "Korea (Democratic People's Republic of)" : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0648\u0631\u064A\u0627 \u0627\u0644\u0634\u0645\u0627\u0644\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.x16_1 = phoneNumPrefix;
    this.y16_1 = isoCode2;
    this.z16_1 = isoCode3;
    this.a17_1 = currency;
    this.b17_1 = englishName;
    this.c17_1 = arabicName;
    this.d17_1 = phoneRegex;
  }
  protoOf(KoreaDemocraticPeoplesRepublicof).wd = function () {
    return this.x16_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).rd = function () {
    return this.y16_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).sd = function () {
    return this.z16_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).td = function () {
    return this.a17_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).ud = function () {
    return this.b17_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).vd = function () {
    return this.c17_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).xd = function () {
    return this.d17_1;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).toString = function () {
    return 'KoreaDemocraticPeoplesRepublicof(phoneNumPrefix=' + this.x16_1.toString() + ', isoCode2=' + this.y16_1 + ', isoCode3=' + this.z16_1 + ', currency=' + toString(this.a17_1) + ', englishName=' + this.b17_1 + ', arabicName=' + this.c17_1 + ', phoneRegex=' + this.d17_1 + ')';
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).hashCode = function () {
    var result = this.x16_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.y16_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z16_1) | 0;
    result = imul(result, 31) + hashCode(this.a17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d17_1) | 0;
    return result;
  };
  protoOf(KoreaDemocraticPeoplesRepublicof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KoreaDemocraticPeoplesRepublicof))
      return false;
    var tmp0_other_with_cast = other instanceof KoreaDemocraticPeoplesRepublicof ? other : THROW_CCE();
    if (!this.x16_1.equals(tmp0_other_with_cast.x16_1))
      return false;
    if (!(this.y16_1 === tmp0_other_with_cast.y16_1))
      return false;
    if (!(this.z16_1 === tmp0_other_with_cast.z16_1))
      return false;
    if (!equals(this.a17_1, tmp0_other_with_cast.a17_1))
      return false;
    if (!(this.b17_1 === tmp0_other_with_cast.b17_1))
      return false;
    if (!(this.c17_1 === tmp0_other_with_cast.c17_1))
      return false;
    if (!(this.d17_1 === tmp0_other_with_cast.d17_1))
      return false;
    return true;
  };
  function Companion_120() {
  }
  var Companion_instance_120;
  function Companion_getInstance_120() {
    return Companion_instance_120;
  }
  function KoreaRepublicof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KOR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Korea, Republic of' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0648\u0631\u064A\u0627 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.e17_1 = phoneNumPrefix;
    this.f17_1 = isoCode2;
    this.g17_1 = isoCode3;
    this.h17_1 = currency;
    this.i17_1 = englishName;
    this.j17_1 = arabicName;
    this.k17_1 = phoneRegex;
  }
  protoOf(KoreaRepublicof).wd = function () {
    return this.e17_1;
  };
  protoOf(KoreaRepublicof).rd = function () {
    return this.f17_1;
  };
  protoOf(KoreaRepublicof).sd = function () {
    return this.g17_1;
  };
  protoOf(KoreaRepublicof).td = function () {
    return this.h17_1;
  };
  protoOf(KoreaRepublicof).ud = function () {
    return this.i17_1;
  };
  protoOf(KoreaRepublicof).vd = function () {
    return this.j17_1;
  };
  protoOf(KoreaRepublicof).xd = function () {
    return this.k17_1;
  };
  protoOf(KoreaRepublicof).toString = function () {
    return 'KoreaRepublicof(phoneNumPrefix=' + this.e17_1.toString() + ', isoCode2=' + this.f17_1 + ', isoCode3=' + this.g17_1 + ', currency=' + toString(this.h17_1) + ', englishName=' + this.i17_1 + ', arabicName=' + this.j17_1 + ', phoneRegex=' + this.k17_1 + ')';
  };
  protoOf(KoreaRepublicof).hashCode = function () {
    var result = this.e17_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.f17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g17_1) | 0;
    result = imul(result, 31) + hashCode(this.h17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k17_1) | 0;
    return result;
  };
  protoOf(KoreaRepublicof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KoreaRepublicof))
      return false;
    var tmp0_other_with_cast = other instanceof KoreaRepublicof ? other : THROW_CCE();
    if (!this.e17_1.equals(tmp0_other_with_cast.e17_1))
      return false;
    if (!(this.f17_1 === tmp0_other_with_cast.f17_1))
      return false;
    if (!(this.g17_1 === tmp0_other_with_cast.g17_1))
      return false;
    if (!equals(this.h17_1, tmp0_other_with_cast.h17_1))
      return false;
    if (!(this.i17_1 === tmp0_other_with_cast.i17_1))
      return false;
    if (!(this.j17_1 === tmp0_other_with_cast.j17_1))
      return false;
    if (!(this.k17_1 === tmp0_other_with_cast.k17_1))
      return false;
    return true;
  };
  function Companion_121() {
  }
  var Companion_instance_121;
  function Companion_getInstance_121() {
    return Companion_instance_121;
  }
  function Kuwait(isoCode2, isoCode3, currency, englishName, arabicName, phoneNumPrefix, phoneRegex, phoneNumberHint) {
    isoCode2 = isoCode2 === VOID ? 'KW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KWT' : isoCode3;
    currency = currency === VOID ? KWD_getInstance() : currency;
    englishName = englishName === VOID ? 'Kuwait' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0643\u0648\u064A\u062A' : arabicName;
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(965, 0) : phoneNumPrefix;
    phoneRegex = phoneRegex === VOID ? '^(00965|965|\\+965|0)?[569]([0-9]{7})$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '96551234567' : phoneNumberHint;
    this.d5_1 = isoCode2;
    this.e5_1 = isoCode3;
    this.f5_1 = currency;
    this.g5_1 = englishName;
    this.h5_1 = arabicName;
    this.i5_1 = phoneNumPrefix;
    this.j5_1 = phoneRegex;
    this.k5_1 = phoneNumberHint;
  }
  protoOf(Kuwait).rd = function () {
    return this.d5_1;
  };
  protoOf(Kuwait).sd = function () {
    return this.e5_1;
  };
  protoOf(Kuwait).td = function () {
    return this.f5_1;
  };
  protoOf(Kuwait).ud = function () {
    return this.g5_1;
  };
  protoOf(Kuwait).vd = function () {
    return this.h5_1;
  };
  protoOf(Kuwait).wd = function () {
    return this.i5_1;
  };
  protoOf(Kuwait).xd = function () {
    return this.j5_1;
  };
  protoOf(Kuwait).yd = function () {
    return this.k5_1;
  };
  protoOf(Kuwait).toString = function () {
    return 'Kuwait(isoCode2=' + this.d5_1 + ', isoCode3=' + this.e5_1 + ', currency=' + toString(this.f5_1) + ', englishName=' + this.g5_1 + ', arabicName=' + this.h5_1 + ', phoneNumPrefix=' + this.i5_1.toString() + ', phoneRegex=' + this.j5_1 + ', phoneNumberHint=' + this.k5_1 + ')';
  };
  protoOf(Kuwait).hashCode = function () {
    var result = getStringHashCode(this.d5_1);
    result = imul(result, 31) + getStringHashCode(this.e5_1) | 0;
    result = imul(result, 31) + hashCode(this.f5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h5_1) | 0;
    result = imul(result, 31) + this.i5_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.j5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k5_1) | 0;
    return result;
  };
  protoOf(Kuwait).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Kuwait))
      return false;
    var tmp0_other_with_cast = other instanceof Kuwait ? other : THROW_CCE();
    if (!(this.d5_1 === tmp0_other_with_cast.d5_1))
      return false;
    if (!(this.e5_1 === tmp0_other_with_cast.e5_1))
      return false;
    if (!equals(this.f5_1, tmp0_other_with_cast.f5_1))
      return false;
    if (!(this.g5_1 === tmp0_other_with_cast.g5_1))
      return false;
    if (!(this.h5_1 === tmp0_other_with_cast.h5_1))
      return false;
    if (!this.i5_1.equals(tmp0_other_with_cast.i5_1))
      return false;
    if (!(this.j5_1 === tmp0_other_with_cast.j5_1))
      return false;
    if (!(this.k5_1 === tmp0_other_with_cast.k5_1))
      return false;
    return true;
  };
  function Companion_122() {
  }
  var Companion_instance_122;
  function Companion_getInstance_122() {
    return Companion_instance_122;
  }
  function Kyrgyzstan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KGZ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Kyrgyzstan' : englishName;
    arabicName = arabicName === VOID ? '\u0642\u064A\u0631\u063A\u064A\u0632\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.l17_1 = phoneNumPrefix;
    this.m17_1 = isoCode2;
    this.n17_1 = isoCode3;
    this.o17_1 = currency;
    this.p17_1 = englishName;
    this.q17_1 = arabicName;
    this.r17_1 = phoneRegex;
  }
  protoOf(Kyrgyzstan).wd = function () {
    return this.l17_1;
  };
  protoOf(Kyrgyzstan).rd = function () {
    return this.m17_1;
  };
  protoOf(Kyrgyzstan).sd = function () {
    return this.n17_1;
  };
  protoOf(Kyrgyzstan).td = function () {
    return this.o17_1;
  };
  protoOf(Kyrgyzstan).ud = function () {
    return this.p17_1;
  };
  protoOf(Kyrgyzstan).vd = function () {
    return this.q17_1;
  };
  protoOf(Kyrgyzstan).xd = function () {
    return this.r17_1;
  };
  protoOf(Kyrgyzstan).toString = function () {
    return 'Kyrgyzstan(phoneNumPrefix=' + this.l17_1.toString() + ', isoCode2=' + this.m17_1 + ', isoCode3=' + this.n17_1 + ', currency=' + toString(this.o17_1) + ', englishName=' + this.p17_1 + ', arabicName=' + this.q17_1 + ', phoneRegex=' + this.r17_1 + ')';
  };
  protoOf(Kyrgyzstan).hashCode = function () {
    var result = this.l17_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n17_1) | 0;
    result = imul(result, 31) + hashCode(this.o17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r17_1) | 0;
    return result;
  };
  protoOf(Kyrgyzstan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Kyrgyzstan))
      return false;
    var tmp0_other_with_cast = other instanceof Kyrgyzstan ? other : THROW_CCE();
    if (!this.l17_1.equals(tmp0_other_with_cast.l17_1))
      return false;
    if (!(this.m17_1 === tmp0_other_with_cast.m17_1))
      return false;
    if (!(this.n17_1 === tmp0_other_with_cast.n17_1))
      return false;
    if (!equals(this.o17_1, tmp0_other_with_cast.o17_1))
      return false;
    if (!(this.p17_1 === tmp0_other_with_cast.p17_1))
      return false;
    if (!(this.q17_1 === tmp0_other_with_cast.q17_1))
      return false;
    if (!(this.r17_1 === tmp0_other_with_cast.r17_1))
      return false;
    return true;
  };
  function Companion_123() {
  }
  var Companion_instance_123;
  function Companion_getInstance_123() {
    return Companion_instance_123;
  }
  function LaoPeoplesDemocraticRepublic(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LAO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? "Lao People's Democratic Republic" : englishName;
    arabicName = arabicName === VOID ? '\u0644\u0627\u0648\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.s17_1 = phoneNumPrefix;
    this.t17_1 = isoCode2;
    this.u17_1 = isoCode3;
    this.v17_1 = currency;
    this.w17_1 = englishName;
    this.x17_1 = arabicName;
    this.y17_1 = phoneRegex;
  }
  protoOf(LaoPeoplesDemocraticRepublic).wd = function () {
    return this.s17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).rd = function () {
    return this.t17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).sd = function () {
    return this.u17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).td = function () {
    return this.v17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).ud = function () {
    return this.w17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).vd = function () {
    return this.x17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).xd = function () {
    return this.y17_1;
  };
  protoOf(LaoPeoplesDemocraticRepublic).toString = function () {
    return 'LaoPeoplesDemocraticRepublic(phoneNumPrefix=' + this.s17_1.toString() + ', isoCode2=' + this.t17_1 + ', isoCode3=' + this.u17_1 + ', currency=' + toString(this.v17_1) + ', englishName=' + this.w17_1 + ', arabicName=' + this.x17_1 + ', phoneRegex=' + this.y17_1 + ')';
  };
  protoOf(LaoPeoplesDemocraticRepublic).hashCode = function () {
    var result = this.s17_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u17_1) | 0;
    result = imul(result, 31) + hashCode(this.v17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x17_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y17_1) | 0;
    return result;
  };
  protoOf(LaoPeoplesDemocraticRepublic).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LaoPeoplesDemocraticRepublic))
      return false;
    var tmp0_other_with_cast = other instanceof LaoPeoplesDemocraticRepublic ? other : THROW_CCE();
    if (!this.s17_1.equals(tmp0_other_with_cast.s17_1))
      return false;
    if (!(this.t17_1 === tmp0_other_with_cast.t17_1))
      return false;
    if (!(this.u17_1 === tmp0_other_with_cast.u17_1))
      return false;
    if (!equals(this.v17_1, tmp0_other_with_cast.v17_1))
      return false;
    if (!(this.w17_1 === tmp0_other_with_cast.w17_1))
      return false;
    if (!(this.x17_1 === tmp0_other_with_cast.x17_1))
      return false;
    if (!(this.y17_1 === tmp0_other_with_cast.y17_1))
      return false;
    return true;
  };
  function Companion_124() {
  }
  var Companion_instance_124;
  function Companion_getInstance_124() {
    return Companion_instance_124;
  }
  function Latvia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LV' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LVA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Latvia' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u0627\u062A\u0641\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.z17_1 = phoneNumPrefix;
    this.a18_1 = isoCode2;
    this.b18_1 = isoCode3;
    this.c18_1 = currency;
    this.d18_1 = englishName;
    this.e18_1 = arabicName;
    this.f18_1 = phoneRegex;
  }
  protoOf(Latvia).wd = function () {
    return this.z17_1;
  };
  protoOf(Latvia).rd = function () {
    return this.a18_1;
  };
  protoOf(Latvia).sd = function () {
    return this.b18_1;
  };
  protoOf(Latvia).td = function () {
    return this.c18_1;
  };
  protoOf(Latvia).ud = function () {
    return this.d18_1;
  };
  protoOf(Latvia).vd = function () {
    return this.e18_1;
  };
  protoOf(Latvia).xd = function () {
    return this.f18_1;
  };
  protoOf(Latvia).toString = function () {
    return 'Latvia(phoneNumPrefix=' + this.z17_1.toString() + ', isoCode2=' + this.a18_1 + ', isoCode3=' + this.b18_1 + ', currency=' + toString(this.c18_1) + ', englishName=' + this.d18_1 + ', arabicName=' + this.e18_1 + ', phoneRegex=' + this.f18_1 + ')';
  };
  protoOf(Latvia).hashCode = function () {
    var result = this.z17_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b18_1) | 0;
    result = imul(result, 31) + hashCode(this.c18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f18_1) | 0;
    return result;
  };
  protoOf(Latvia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Latvia))
      return false;
    var tmp0_other_with_cast = other instanceof Latvia ? other : THROW_CCE();
    if (!this.z17_1.equals(tmp0_other_with_cast.z17_1))
      return false;
    if (!(this.a18_1 === tmp0_other_with_cast.a18_1))
      return false;
    if (!(this.b18_1 === tmp0_other_with_cast.b18_1))
      return false;
    if (!equals(this.c18_1, tmp0_other_with_cast.c18_1))
      return false;
    if (!(this.d18_1 === tmp0_other_with_cast.d18_1))
      return false;
    if (!(this.e18_1 === tmp0_other_with_cast.e18_1))
      return false;
    if (!(this.f18_1 === tmp0_other_with_cast.f18_1))
      return false;
    return true;
  };
  function Companion_125() {
  }
  var Companion_instance_125;
  function Companion_getInstance_125() {
    return Companion_instance_125;
  }
  function Lebanon(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(961, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LB' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LBN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Lebanon' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u0628\u0646\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(8) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '71123456' : phoneNumberHint;
    this.n8_1 = phoneNumPrefix;
    this.o8_1 = isoCode2;
    this.p8_1 = isoCode3;
    this.q8_1 = currency;
    this.r8_1 = englishName;
    this.s8_1 = arabicName;
    this.t8_1 = phoneRegex;
    this.u8_1 = phoneNumberHint;
  }
  protoOf(Lebanon).wd = function () {
    return this.n8_1;
  };
  protoOf(Lebanon).rd = function () {
    return this.o8_1;
  };
  protoOf(Lebanon).sd = function () {
    return this.p8_1;
  };
  protoOf(Lebanon).td = function () {
    return this.q8_1;
  };
  protoOf(Lebanon).ud = function () {
    return this.r8_1;
  };
  protoOf(Lebanon).vd = function () {
    return this.s8_1;
  };
  protoOf(Lebanon).xd = function () {
    return this.t8_1;
  };
  protoOf(Lebanon).yd = function () {
    return this.u8_1;
  };
  protoOf(Lebanon).toString = function () {
    return 'Lebanon(phoneNumPrefix=' + this.n8_1.toString() + ', isoCode2=' + this.o8_1 + ', isoCode3=' + this.p8_1 + ', currency=' + toString(this.q8_1) + ', englishName=' + this.r8_1 + ', arabicName=' + this.s8_1 + ', phoneRegex=' + this.t8_1 + ', phoneNumberHint=' + this.u8_1 + ')';
  };
  protoOf(Lebanon).hashCode = function () {
    var result = this.n8_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p8_1) | 0;
    result = imul(result, 31) + hashCode(this.q8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u8_1) | 0;
    return result;
  };
  protoOf(Lebanon).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lebanon))
      return false;
    var tmp0_other_with_cast = other instanceof Lebanon ? other : THROW_CCE();
    if (!this.n8_1.equals(tmp0_other_with_cast.n8_1))
      return false;
    if (!(this.o8_1 === tmp0_other_with_cast.o8_1))
      return false;
    if (!(this.p8_1 === tmp0_other_with_cast.p8_1))
      return false;
    if (!equals(this.q8_1, tmp0_other_with_cast.q8_1))
      return false;
    if (!(this.r8_1 === tmp0_other_with_cast.r8_1))
      return false;
    if (!(this.s8_1 === tmp0_other_with_cast.s8_1))
      return false;
    if (!(this.t8_1 === tmp0_other_with_cast.t8_1))
      return false;
    if (!(this.u8_1 === tmp0_other_with_cast.u8_1))
      return false;
    return true;
  };
  function Companion_126() {
  }
  var Companion_instance_126;
  function Companion_getInstance_126() {
    return Companion_instance_126;
  }
  function Lesotho(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LSO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Lesotho' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u064A\u0633\u0648\u062A\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.g18_1 = phoneNumPrefix;
    this.h18_1 = isoCode2;
    this.i18_1 = isoCode3;
    this.j18_1 = currency;
    this.k18_1 = englishName;
    this.l18_1 = arabicName;
    this.m18_1 = phoneRegex;
  }
  protoOf(Lesotho).wd = function () {
    return this.g18_1;
  };
  protoOf(Lesotho).rd = function () {
    return this.h18_1;
  };
  protoOf(Lesotho).sd = function () {
    return this.i18_1;
  };
  protoOf(Lesotho).td = function () {
    return this.j18_1;
  };
  protoOf(Lesotho).ud = function () {
    return this.k18_1;
  };
  protoOf(Lesotho).vd = function () {
    return this.l18_1;
  };
  protoOf(Lesotho).xd = function () {
    return this.m18_1;
  };
  protoOf(Lesotho).toString = function () {
    return 'Lesotho(phoneNumPrefix=' + this.g18_1.toString() + ', isoCode2=' + this.h18_1 + ', isoCode3=' + this.i18_1 + ', currency=' + toString(this.j18_1) + ', englishName=' + this.k18_1 + ', arabicName=' + this.l18_1 + ', phoneRegex=' + this.m18_1 + ')';
  };
  protoOf(Lesotho).hashCode = function () {
    var result = this.g18_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i18_1) | 0;
    result = imul(result, 31) + hashCode(this.j18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m18_1) | 0;
    return result;
  };
  protoOf(Lesotho).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lesotho))
      return false;
    var tmp0_other_with_cast = other instanceof Lesotho ? other : THROW_CCE();
    if (!this.g18_1.equals(tmp0_other_with_cast.g18_1))
      return false;
    if (!(this.h18_1 === tmp0_other_with_cast.h18_1))
      return false;
    if (!(this.i18_1 === tmp0_other_with_cast.i18_1))
      return false;
    if (!equals(this.j18_1, tmp0_other_with_cast.j18_1))
      return false;
    if (!(this.k18_1 === tmp0_other_with_cast.k18_1))
      return false;
    if (!(this.l18_1 === tmp0_other_with_cast.l18_1))
      return false;
    if (!(this.m18_1 === tmp0_other_with_cast.m18_1))
      return false;
    return true;
  };
  function Companion_127() {
  }
  var Companion_instance_127;
  function Companion_getInstance_127() {
    return Companion_instance_127;
  }
  function Liberia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LBR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Liberia' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u064A\u0628\u064A\u0631\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.n18_1 = phoneNumPrefix;
    this.o18_1 = isoCode2;
    this.p18_1 = isoCode3;
    this.q18_1 = currency;
    this.r18_1 = englishName;
    this.s18_1 = arabicName;
    this.t18_1 = phoneRegex;
  }
  protoOf(Liberia).wd = function () {
    return this.n18_1;
  };
  protoOf(Liberia).rd = function () {
    return this.o18_1;
  };
  protoOf(Liberia).sd = function () {
    return this.p18_1;
  };
  protoOf(Liberia).td = function () {
    return this.q18_1;
  };
  protoOf(Liberia).ud = function () {
    return this.r18_1;
  };
  protoOf(Liberia).vd = function () {
    return this.s18_1;
  };
  protoOf(Liberia).xd = function () {
    return this.t18_1;
  };
  protoOf(Liberia).toString = function () {
    return 'Liberia(phoneNumPrefix=' + this.n18_1.toString() + ', isoCode2=' + this.o18_1 + ', isoCode3=' + this.p18_1 + ', currency=' + toString(this.q18_1) + ', englishName=' + this.r18_1 + ', arabicName=' + this.s18_1 + ', phoneRegex=' + this.t18_1 + ')';
  };
  protoOf(Liberia).hashCode = function () {
    var result = this.n18_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p18_1) | 0;
    result = imul(result, 31) + hashCode(this.q18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t18_1) | 0;
    return result;
  };
  protoOf(Liberia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Liberia))
      return false;
    var tmp0_other_with_cast = other instanceof Liberia ? other : THROW_CCE();
    if (!this.n18_1.equals(tmp0_other_with_cast.n18_1))
      return false;
    if (!(this.o18_1 === tmp0_other_with_cast.o18_1))
      return false;
    if (!(this.p18_1 === tmp0_other_with_cast.p18_1))
      return false;
    if (!equals(this.q18_1, tmp0_other_with_cast.q18_1))
      return false;
    if (!(this.r18_1 === tmp0_other_with_cast.r18_1))
      return false;
    if (!(this.s18_1 === tmp0_other_with_cast.s18_1))
      return false;
    if (!(this.t18_1 === tmp0_other_with_cast.t18_1))
      return false;
    return true;
  };
  function Companion_128() {
  }
  var Companion_instance_128;
  function Companion_getInstance_128() {
    return Companion_instance_128;
  }
  function Libya(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(218, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LBY' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Libya' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u064A\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(9) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '912345678' : phoneNumberHint;
    this.fc_1 = phoneNumPrefix;
    this.gc_1 = isoCode2;
    this.hc_1 = isoCode3;
    this.ic_1 = currency;
    this.jc_1 = englishName;
    this.kc_1 = arabicName;
    this.lc_1 = phoneRegex;
    this.mc_1 = phoneNumberHint;
  }
  protoOf(Libya).wd = function () {
    return this.fc_1;
  };
  protoOf(Libya).rd = function () {
    return this.gc_1;
  };
  protoOf(Libya).sd = function () {
    return this.hc_1;
  };
  protoOf(Libya).td = function () {
    return this.ic_1;
  };
  protoOf(Libya).ud = function () {
    return this.jc_1;
  };
  protoOf(Libya).vd = function () {
    return this.kc_1;
  };
  protoOf(Libya).xd = function () {
    return this.lc_1;
  };
  protoOf(Libya).yd = function () {
    return this.mc_1;
  };
  protoOf(Libya).toString = function () {
    return 'Libya(phoneNumPrefix=' + this.fc_1.toString() + ', isoCode2=' + this.gc_1 + ', isoCode3=' + this.hc_1 + ', currency=' + toString(this.ic_1) + ', englishName=' + this.jc_1 + ', arabicName=' + this.kc_1 + ', phoneRegex=' + this.lc_1 + ', phoneNumberHint=' + this.mc_1 + ')';
  };
  protoOf(Libya).hashCode = function () {
    var result = this.fc_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.gc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hc_1) | 0;
    result = imul(result, 31) + hashCode(this.ic_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mc_1) | 0;
    return result;
  };
  protoOf(Libya).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Libya))
      return false;
    var tmp0_other_with_cast = other instanceof Libya ? other : THROW_CCE();
    if (!this.fc_1.equals(tmp0_other_with_cast.fc_1))
      return false;
    if (!(this.gc_1 === tmp0_other_with_cast.gc_1))
      return false;
    if (!(this.hc_1 === tmp0_other_with_cast.hc_1))
      return false;
    if (!equals(this.ic_1, tmp0_other_with_cast.ic_1))
      return false;
    if (!(this.jc_1 === tmp0_other_with_cast.jc_1))
      return false;
    if (!(this.kc_1 === tmp0_other_with_cast.kc_1))
      return false;
    if (!(this.lc_1 === tmp0_other_with_cast.lc_1))
      return false;
    if (!(this.mc_1 === tmp0_other_with_cast.mc_1))
      return false;
    return true;
  };
  function Companion_129() {
  }
  var Companion_instance_129;
  function Companion_getInstance_129() {
    return Companion_instance_129;
  }
  function Liechtenstein(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LIE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Liechtenstein' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u064A\u062E\u062A\u0646\u0634\u062A\u0627\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.u18_1 = phoneNumPrefix;
    this.v18_1 = isoCode2;
    this.w18_1 = isoCode3;
    this.x18_1 = currency;
    this.y18_1 = englishName;
    this.z18_1 = arabicName;
    this.a19_1 = phoneRegex;
  }
  protoOf(Liechtenstein).wd = function () {
    return this.u18_1;
  };
  protoOf(Liechtenstein).rd = function () {
    return this.v18_1;
  };
  protoOf(Liechtenstein).sd = function () {
    return this.w18_1;
  };
  protoOf(Liechtenstein).td = function () {
    return this.x18_1;
  };
  protoOf(Liechtenstein).ud = function () {
    return this.y18_1;
  };
  protoOf(Liechtenstein).vd = function () {
    return this.z18_1;
  };
  protoOf(Liechtenstein).xd = function () {
    return this.a19_1;
  };
  protoOf(Liechtenstein).toString = function () {
    return 'Liechtenstein(phoneNumPrefix=' + this.u18_1.toString() + ', isoCode2=' + this.v18_1 + ', isoCode3=' + this.w18_1 + ', currency=' + toString(this.x18_1) + ', englishName=' + this.y18_1 + ', arabicName=' + this.z18_1 + ', phoneRegex=' + this.a19_1 + ')';
  };
  protoOf(Liechtenstein).hashCode = function () {
    var result = this.u18_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.v18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w18_1) | 0;
    result = imul(result, 31) + hashCode(this.x18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z18_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a19_1) | 0;
    return result;
  };
  protoOf(Liechtenstein).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Liechtenstein))
      return false;
    var tmp0_other_with_cast = other instanceof Liechtenstein ? other : THROW_CCE();
    if (!this.u18_1.equals(tmp0_other_with_cast.u18_1))
      return false;
    if (!(this.v18_1 === tmp0_other_with_cast.v18_1))
      return false;
    if (!(this.w18_1 === tmp0_other_with_cast.w18_1))
      return false;
    if (!equals(this.x18_1, tmp0_other_with_cast.x18_1))
      return false;
    if (!(this.y18_1 === tmp0_other_with_cast.y18_1))
      return false;
    if (!(this.z18_1 === tmp0_other_with_cast.z18_1))
      return false;
    if (!(this.a19_1 === tmp0_other_with_cast.a19_1))
      return false;
    return true;
  };
  function Companion_130() {
  }
  var Companion_instance_130;
  function Companion_getInstance_130() {
    return Companion_instance_130;
  }
  function Lithuania(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LTU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Lithuania' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u064A\u062A\u0648\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.b19_1 = phoneNumPrefix;
    this.c19_1 = isoCode2;
    this.d19_1 = isoCode3;
    this.e19_1 = currency;
    this.f19_1 = englishName;
    this.g19_1 = arabicName;
    this.h19_1 = phoneRegex;
  }
  protoOf(Lithuania).wd = function () {
    return this.b19_1;
  };
  protoOf(Lithuania).rd = function () {
    return this.c19_1;
  };
  protoOf(Lithuania).sd = function () {
    return this.d19_1;
  };
  protoOf(Lithuania).td = function () {
    return this.e19_1;
  };
  protoOf(Lithuania).ud = function () {
    return this.f19_1;
  };
  protoOf(Lithuania).vd = function () {
    return this.g19_1;
  };
  protoOf(Lithuania).xd = function () {
    return this.h19_1;
  };
  protoOf(Lithuania).toString = function () {
    return 'Lithuania(phoneNumPrefix=' + this.b19_1.toString() + ', isoCode2=' + this.c19_1 + ', isoCode3=' + this.d19_1 + ', currency=' + toString(this.e19_1) + ', englishName=' + this.f19_1 + ', arabicName=' + this.g19_1 + ', phoneRegex=' + this.h19_1 + ')';
  };
  protoOf(Lithuania).hashCode = function () {
    var result = this.b19_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d19_1) | 0;
    result = imul(result, 31) + hashCode(this.e19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h19_1) | 0;
    return result;
  };
  protoOf(Lithuania).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lithuania))
      return false;
    var tmp0_other_with_cast = other instanceof Lithuania ? other : THROW_CCE();
    if (!this.b19_1.equals(tmp0_other_with_cast.b19_1))
      return false;
    if (!(this.c19_1 === tmp0_other_with_cast.c19_1))
      return false;
    if (!(this.d19_1 === tmp0_other_with_cast.d19_1))
      return false;
    if (!equals(this.e19_1, tmp0_other_with_cast.e19_1))
      return false;
    if (!(this.f19_1 === tmp0_other_with_cast.f19_1))
      return false;
    if (!(this.g19_1 === tmp0_other_with_cast.g19_1))
      return false;
    if (!(this.h19_1 === tmp0_other_with_cast.h19_1))
      return false;
    return true;
  };
  function Companion_131() {
  }
  var Companion_instance_131;
  function Companion_getInstance_131() {
    return Companion_instance_131;
  }
  function Luxembourg(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LUX' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Luxembourg' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u0648\u0643\u0633\u0645\u0628\u0648\u0631\u063A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.i19_1 = phoneNumPrefix;
    this.j19_1 = isoCode2;
    this.k19_1 = isoCode3;
    this.l19_1 = currency;
    this.m19_1 = englishName;
    this.n19_1 = arabicName;
    this.o19_1 = phoneRegex;
  }
  protoOf(Luxembourg).wd = function () {
    return this.i19_1;
  };
  protoOf(Luxembourg).rd = function () {
    return this.j19_1;
  };
  protoOf(Luxembourg).sd = function () {
    return this.k19_1;
  };
  protoOf(Luxembourg).td = function () {
    return this.l19_1;
  };
  protoOf(Luxembourg).ud = function () {
    return this.m19_1;
  };
  protoOf(Luxembourg).vd = function () {
    return this.n19_1;
  };
  protoOf(Luxembourg).xd = function () {
    return this.o19_1;
  };
  protoOf(Luxembourg).toString = function () {
    return 'Luxembourg(phoneNumPrefix=' + this.i19_1.toString() + ', isoCode2=' + this.j19_1 + ', isoCode3=' + this.k19_1 + ', currency=' + toString(this.l19_1) + ', englishName=' + this.m19_1 + ', arabicName=' + this.n19_1 + ', phoneRegex=' + this.o19_1 + ')';
  };
  protoOf(Luxembourg).hashCode = function () {
    var result = this.i19_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k19_1) | 0;
    result = imul(result, 31) + hashCode(this.l19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o19_1) | 0;
    return result;
  };
  protoOf(Luxembourg).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Luxembourg))
      return false;
    var tmp0_other_with_cast = other instanceof Luxembourg ? other : THROW_CCE();
    if (!this.i19_1.equals(tmp0_other_with_cast.i19_1))
      return false;
    if (!(this.j19_1 === tmp0_other_with_cast.j19_1))
      return false;
    if (!(this.k19_1 === tmp0_other_with_cast.k19_1))
      return false;
    if (!equals(this.l19_1, tmp0_other_with_cast.l19_1))
      return false;
    if (!(this.m19_1 === tmp0_other_with_cast.m19_1))
      return false;
    if (!(this.n19_1 === tmp0_other_with_cast.n19_1))
      return false;
    if (!(this.o19_1 === tmp0_other_with_cast.o19_1))
      return false;
    return true;
  };
  function Companion_132() {
  }
  var Companion_instance_132;
  function Companion_getInstance_132() {
    return Companion_instance_132;
  }
  function Macao(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MAC' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Macao' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u0643\u0627\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.p19_1 = phoneNumPrefix;
    this.q19_1 = isoCode2;
    this.r19_1 = isoCode3;
    this.s19_1 = currency;
    this.t19_1 = englishName;
    this.u19_1 = arabicName;
    this.v19_1 = phoneRegex;
  }
  protoOf(Macao).wd = function () {
    return this.p19_1;
  };
  protoOf(Macao).rd = function () {
    return this.q19_1;
  };
  protoOf(Macao).sd = function () {
    return this.r19_1;
  };
  protoOf(Macao).td = function () {
    return this.s19_1;
  };
  protoOf(Macao).ud = function () {
    return this.t19_1;
  };
  protoOf(Macao).vd = function () {
    return this.u19_1;
  };
  protoOf(Macao).xd = function () {
    return this.v19_1;
  };
  protoOf(Macao).toString = function () {
    return 'Macao(phoneNumPrefix=' + this.p19_1.toString() + ', isoCode2=' + this.q19_1 + ', isoCode3=' + this.r19_1 + ', currency=' + toString(this.s19_1) + ', englishName=' + this.t19_1 + ', arabicName=' + this.u19_1 + ', phoneRegex=' + this.v19_1 + ')';
  };
  protoOf(Macao).hashCode = function () {
    var result = this.p19_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r19_1) | 0;
    result = imul(result, 31) + hashCode(this.s19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v19_1) | 0;
    return result;
  };
  protoOf(Macao).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Macao))
      return false;
    var tmp0_other_with_cast = other instanceof Macao ? other : THROW_CCE();
    if (!this.p19_1.equals(tmp0_other_with_cast.p19_1))
      return false;
    if (!(this.q19_1 === tmp0_other_with_cast.q19_1))
      return false;
    if (!(this.r19_1 === tmp0_other_with_cast.r19_1))
      return false;
    if (!equals(this.s19_1, tmp0_other_with_cast.s19_1))
      return false;
    if (!(this.t19_1 === tmp0_other_with_cast.t19_1))
      return false;
    if (!(this.u19_1 === tmp0_other_with_cast.u19_1))
      return false;
    if (!(this.v19_1 === tmp0_other_with_cast.v19_1))
      return false;
    return true;
  };
  function Companion_133() {
  }
  var Companion_instance_133;
  function Companion_getInstance_133() {
    return Companion_instance_133;
  }
  function NorthMacedonia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MKD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'North Macedonia' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0642\u062F\u0648\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.w19_1 = phoneNumPrefix;
    this.x19_1 = isoCode2;
    this.y19_1 = isoCode3;
    this.z19_1 = currency;
    this.a1a_1 = englishName;
    this.b1a_1 = arabicName;
    this.c1a_1 = phoneRegex;
  }
  protoOf(NorthMacedonia).wd = function () {
    return this.w19_1;
  };
  protoOf(NorthMacedonia).rd = function () {
    return this.x19_1;
  };
  protoOf(NorthMacedonia).sd = function () {
    return this.y19_1;
  };
  protoOf(NorthMacedonia).td = function () {
    return this.z19_1;
  };
  protoOf(NorthMacedonia).ud = function () {
    return this.a1a_1;
  };
  protoOf(NorthMacedonia).vd = function () {
    return this.b1a_1;
  };
  protoOf(NorthMacedonia).xd = function () {
    return this.c1a_1;
  };
  protoOf(NorthMacedonia).toString = function () {
    return 'NorthMacedonia(phoneNumPrefix=' + this.w19_1.toString() + ', isoCode2=' + this.x19_1 + ', isoCode3=' + this.y19_1 + ', currency=' + toString(this.z19_1) + ', englishName=' + this.a1a_1 + ', arabicName=' + this.b1a_1 + ', phoneRegex=' + this.c1a_1 + ')';
  };
  protoOf(NorthMacedonia).hashCode = function () {
    var result = this.w19_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.x19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y19_1) | 0;
    result = imul(result, 31) + hashCode(this.z19_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1a_1) | 0;
    return result;
  };
  protoOf(NorthMacedonia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NorthMacedonia))
      return false;
    var tmp0_other_with_cast = other instanceof NorthMacedonia ? other : THROW_CCE();
    if (!this.w19_1.equals(tmp0_other_with_cast.w19_1))
      return false;
    if (!(this.x19_1 === tmp0_other_with_cast.x19_1))
      return false;
    if (!(this.y19_1 === tmp0_other_with_cast.y19_1))
      return false;
    if (!equals(this.z19_1, tmp0_other_with_cast.z19_1))
      return false;
    if (!(this.a1a_1 === tmp0_other_with_cast.a1a_1))
      return false;
    if (!(this.b1a_1 === tmp0_other_with_cast.b1a_1))
      return false;
    if (!(this.c1a_1 === tmp0_other_with_cast.c1a_1))
      return false;
    return true;
  };
  function Companion_134() {
  }
  var Companion_instance_134;
  function Companion_getInstance_134() {
    return Companion_instance_134;
  }
  function Madagascar(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MDG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Madagascar' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u062F\u063A\u0634\u0642\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.d1a_1 = phoneNumPrefix;
    this.e1a_1 = isoCode2;
    this.f1a_1 = isoCode3;
    this.g1a_1 = currency;
    this.h1a_1 = englishName;
    this.i1a_1 = arabicName;
    this.j1a_1 = phoneRegex;
  }
  protoOf(Madagascar).wd = function () {
    return this.d1a_1;
  };
  protoOf(Madagascar).rd = function () {
    return this.e1a_1;
  };
  protoOf(Madagascar).sd = function () {
    return this.f1a_1;
  };
  protoOf(Madagascar).td = function () {
    return this.g1a_1;
  };
  protoOf(Madagascar).ud = function () {
    return this.h1a_1;
  };
  protoOf(Madagascar).vd = function () {
    return this.i1a_1;
  };
  protoOf(Madagascar).xd = function () {
    return this.j1a_1;
  };
  protoOf(Madagascar).toString = function () {
    return 'Madagascar(phoneNumPrefix=' + this.d1a_1.toString() + ', isoCode2=' + this.e1a_1 + ', isoCode3=' + this.f1a_1 + ', currency=' + toString(this.g1a_1) + ', englishName=' + this.h1a_1 + ', arabicName=' + this.i1a_1 + ', phoneRegex=' + this.j1a_1 + ')';
  };
  protoOf(Madagascar).hashCode = function () {
    var result = this.d1a_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1a_1) | 0;
    result = imul(result, 31) + hashCode(this.g1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1a_1) | 0;
    return result;
  };
  protoOf(Madagascar).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Madagascar))
      return false;
    var tmp0_other_with_cast = other instanceof Madagascar ? other : THROW_CCE();
    if (!this.d1a_1.equals(tmp0_other_with_cast.d1a_1))
      return false;
    if (!(this.e1a_1 === tmp0_other_with_cast.e1a_1))
      return false;
    if (!(this.f1a_1 === tmp0_other_with_cast.f1a_1))
      return false;
    if (!equals(this.g1a_1, tmp0_other_with_cast.g1a_1))
      return false;
    if (!(this.h1a_1 === tmp0_other_with_cast.h1a_1))
      return false;
    if (!(this.i1a_1 === tmp0_other_with_cast.i1a_1))
      return false;
    if (!(this.j1a_1 === tmp0_other_with_cast.j1a_1))
      return false;
    return true;
  };
  function Companion_135() {
  }
  var Companion_instance_135;
  function Companion_getInstance_135() {
    return Companion_instance_135;
  }
  function Malawi(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MWI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Malawi' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u0644\u0627\u0648\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.k1a_1 = phoneNumPrefix;
    this.l1a_1 = isoCode2;
    this.m1a_1 = isoCode3;
    this.n1a_1 = currency;
    this.o1a_1 = englishName;
    this.p1a_1 = arabicName;
    this.q1a_1 = phoneRegex;
  }
  protoOf(Malawi).wd = function () {
    return this.k1a_1;
  };
  protoOf(Malawi).rd = function () {
    return this.l1a_1;
  };
  protoOf(Malawi).sd = function () {
    return this.m1a_1;
  };
  protoOf(Malawi).td = function () {
    return this.n1a_1;
  };
  protoOf(Malawi).ud = function () {
    return this.o1a_1;
  };
  protoOf(Malawi).vd = function () {
    return this.p1a_1;
  };
  protoOf(Malawi).xd = function () {
    return this.q1a_1;
  };
  protoOf(Malawi).toString = function () {
    return 'Malawi(phoneNumPrefix=' + this.k1a_1.toString() + ', isoCode2=' + this.l1a_1 + ', isoCode3=' + this.m1a_1 + ', currency=' + toString(this.n1a_1) + ', englishName=' + this.o1a_1 + ', arabicName=' + this.p1a_1 + ', phoneRegex=' + this.q1a_1 + ')';
  };
  protoOf(Malawi).hashCode = function () {
    var result = this.k1a_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.l1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1a_1) | 0;
    result = imul(result, 31) + hashCode(this.n1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1a_1) | 0;
    return result;
  };
  protoOf(Malawi).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Malawi))
      return false;
    var tmp0_other_with_cast = other instanceof Malawi ? other : THROW_CCE();
    if (!this.k1a_1.equals(tmp0_other_with_cast.k1a_1))
      return false;
    if (!(this.l1a_1 === tmp0_other_with_cast.l1a_1))
      return false;
    if (!(this.m1a_1 === tmp0_other_with_cast.m1a_1))
      return false;
    if (!equals(this.n1a_1, tmp0_other_with_cast.n1a_1))
      return false;
    if (!(this.o1a_1 === tmp0_other_with_cast.o1a_1))
      return false;
    if (!(this.p1a_1 === tmp0_other_with_cast.p1a_1))
      return false;
    if (!(this.q1a_1 === tmp0_other_with_cast.q1a_1))
      return false;
    return true;
  };
  function Companion_136() {
  }
  var Companion_instance_136;
  function Companion_getInstance_136() {
    return Companion_instance_136;
  }
  function Malaysia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MYS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Malaysia' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u0644\u064A\u0632\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.r1a_1 = phoneNumPrefix;
    this.s1a_1 = isoCode2;
    this.t1a_1 = isoCode3;
    this.u1a_1 = currency;
    this.v1a_1 = englishName;
    this.w1a_1 = arabicName;
    this.x1a_1 = phoneRegex;
  }
  protoOf(Malaysia).wd = function () {
    return this.r1a_1;
  };
  protoOf(Malaysia).rd = function () {
    return this.s1a_1;
  };
  protoOf(Malaysia).sd = function () {
    return this.t1a_1;
  };
  protoOf(Malaysia).td = function () {
    return this.u1a_1;
  };
  protoOf(Malaysia).ud = function () {
    return this.v1a_1;
  };
  protoOf(Malaysia).vd = function () {
    return this.w1a_1;
  };
  protoOf(Malaysia).xd = function () {
    return this.x1a_1;
  };
  protoOf(Malaysia).toString = function () {
    return 'Malaysia(phoneNumPrefix=' + this.r1a_1.toString() + ', isoCode2=' + this.s1a_1 + ', isoCode3=' + this.t1a_1 + ', currency=' + toString(this.u1a_1) + ', englishName=' + this.v1a_1 + ', arabicName=' + this.w1a_1 + ', phoneRegex=' + this.x1a_1 + ')';
  };
  protoOf(Malaysia).hashCode = function () {
    var result = this.r1a_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.s1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1a_1) | 0;
    result = imul(result, 31) + hashCode(this.u1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1a_1) | 0;
    return result;
  };
  protoOf(Malaysia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Malaysia))
      return false;
    var tmp0_other_with_cast = other instanceof Malaysia ? other : THROW_CCE();
    if (!this.r1a_1.equals(tmp0_other_with_cast.r1a_1))
      return false;
    if (!(this.s1a_1 === tmp0_other_with_cast.s1a_1))
      return false;
    if (!(this.t1a_1 === tmp0_other_with_cast.t1a_1))
      return false;
    if (!equals(this.u1a_1, tmp0_other_with_cast.u1a_1))
      return false;
    if (!(this.v1a_1 === tmp0_other_with_cast.v1a_1))
      return false;
    if (!(this.w1a_1 === tmp0_other_with_cast.w1a_1))
      return false;
    if (!(this.x1a_1 === tmp0_other_with_cast.x1a_1))
      return false;
    return true;
  };
  function Companion_137() {
  }
  var Companion_instance_137;
  function Companion_getInstance_137() {
    return Companion_instance_137;
  }
  function Maldives(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MV' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MDV' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Maldives' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0627\u0644\u0645\u0627\u0644\u062F\u064A\u0641' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.y1a_1 = phoneNumPrefix;
    this.z1a_1 = isoCode2;
    this.a1b_1 = isoCode3;
    this.b1b_1 = currency;
    this.c1b_1 = englishName;
    this.d1b_1 = arabicName;
    this.e1b_1 = phoneRegex;
  }
  protoOf(Maldives).wd = function () {
    return this.y1a_1;
  };
  protoOf(Maldives).rd = function () {
    return this.z1a_1;
  };
  protoOf(Maldives).sd = function () {
    return this.a1b_1;
  };
  protoOf(Maldives).td = function () {
    return this.b1b_1;
  };
  protoOf(Maldives).ud = function () {
    return this.c1b_1;
  };
  protoOf(Maldives).vd = function () {
    return this.d1b_1;
  };
  protoOf(Maldives).xd = function () {
    return this.e1b_1;
  };
  protoOf(Maldives).toString = function () {
    return 'Maldives(phoneNumPrefix=' + this.y1a_1.toString() + ', isoCode2=' + this.z1a_1 + ', isoCode3=' + this.a1b_1 + ', currency=' + toString(this.b1b_1) + ', englishName=' + this.c1b_1 + ', arabicName=' + this.d1b_1 + ', phoneRegex=' + this.e1b_1 + ')';
  };
  protoOf(Maldives).hashCode = function () {
    var result = this.y1a_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.z1a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1b_1) | 0;
    result = imul(result, 31) + hashCode(this.b1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1b_1) | 0;
    return result;
  };
  protoOf(Maldives).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Maldives))
      return false;
    var tmp0_other_with_cast = other instanceof Maldives ? other : THROW_CCE();
    if (!this.y1a_1.equals(tmp0_other_with_cast.y1a_1))
      return false;
    if (!(this.z1a_1 === tmp0_other_with_cast.z1a_1))
      return false;
    if (!(this.a1b_1 === tmp0_other_with_cast.a1b_1))
      return false;
    if (!equals(this.b1b_1, tmp0_other_with_cast.b1b_1))
      return false;
    if (!(this.c1b_1 === tmp0_other_with_cast.c1b_1))
      return false;
    if (!(this.d1b_1 === tmp0_other_with_cast.d1b_1))
      return false;
    if (!(this.e1b_1 === tmp0_other_with_cast.e1b_1))
      return false;
    return true;
  };
  function Companion_138() {
  }
  var Companion_instance_138;
  function Companion_getInstance_138() {
    return Companion_instance_138;
  }
  function Mali(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ML' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MLI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mali' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u0644\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.f1b_1 = phoneNumPrefix;
    this.g1b_1 = isoCode2;
    this.h1b_1 = isoCode3;
    this.i1b_1 = currency;
    this.j1b_1 = englishName;
    this.k1b_1 = arabicName;
    this.l1b_1 = phoneRegex;
  }
  protoOf(Mali).wd = function () {
    return this.f1b_1;
  };
  protoOf(Mali).rd = function () {
    return this.g1b_1;
  };
  protoOf(Mali).sd = function () {
    return this.h1b_1;
  };
  protoOf(Mali).td = function () {
    return this.i1b_1;
  };
  protoOf(Mali).ud = function () {
    return this.j1b_1;
  };
  protoOf(Mali).vd = function () {
    return this.k1b_1;
  };
  protoOf(Mali).xd = function () {
    return this.l1b_1;
  };
  protoOf(Mali).toString = function () {
    return 'Mali(phoneNumPrefix=' + this.f1b_1.toString() + ', isoCode2=' + this.g1b_1 + ', isoCode3=' + this.h1b_1 + ', currency=' + toString(this.i1b_1) + ', englishName=' + this.j1b_1 + ', arabicName=' + this.k1b_1 + ', phoneRegex=' + this.l1b_1 + ')';
  };
  protoOf(Mali).hashCode = function () {
    var result = this.f1b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1b_1) | 0;
    result = imul(result, 31) + hashCode(this.i1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1b_1) | 0;
    return result;
  };
  protoOf(Mali).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mali))
      return false;
    var tmp0_other_with_cast = other instanceof Mali ? other : THROW_CCE();
    if (!this.f1b_1.equals(tmp0_other_with_cast.f1b_1))
      return false;
    if (!(this.g1b_1 === tmp0_other_with_cast.g1b_1))
      return false;
    if (!(this.h1b_1 === tmp0_other_with_cast.h1b_1))
      return false;
    if (!equals(this.i1b_1, tmp0_other_with_cast.i1b_1))
      return false;
    if (!(this.j1b_1 === tmp0_other_with_cast.j1b_1))
      return false;
    if (!(this.k1b_1 === tmp0_other_with_cast.k1b_1))
      return false;
    if (!(this.l1b_1 === tmp0_other_with_cast.l1b_1))
      return false;
    return true;
  };
  function Companion_139() {
  }
  var Companion_instance_139;
  function Companion_getInstance_139() {
    return Companion_instance_139;
  }
  function Malta(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MLT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Malta' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u0644\u0637\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.m1b_1 = phoneNumPrefix;
    this.n1b_1 = isoCode2;
    this.o1b_1 = isoCode3;
    this.p1b_1 = currency;
    this.q1b_1 = englishName;
    this.r1b_1 = arabicName;
    this.s1b_1 = phoneRegex;
  }
  protoOf(Malta).wd = function () {
    return this.m1b_1;
  };
  protoOf(Malta).rd = function () {
    return this.n1b_1;
  };
  protoOf(Malta).sd = function () {
    return this.o1b_1;
  };
  protoOf(Malta).td = function () {
    return this.p1b_1;
  };
  protoOf(Malta).ud = function () {
    return this.q1b_1;
  };
  protoOf(Malta).vd = function () {
    return this.r1b_1;
  };
  protoOf(Malta).xd = function () {
    return this.s1b_1;
  };
  protoOf(Malta).toString = function () {
    return 'Malta(phoneNumPrefix=' + this.m1b_1.toString() + ', isoCode2=' + this.n1b_1 + ', isoCode3=' + this.o1b_1 + ', currency=' + toString(this.p1b_1) + ', englishName=' + this.q1b_1 + ', arabicName=' + this.r1b_1 + ', phoneRegex=' + this.s1b_1 + ')';
  };
  protoOf(Malta).hashCode = function () {
    var result = this.m1b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.n1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1b_1) | 0;
    result = imul(result, 31) + hashCode(this.p1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1b_1) | 0;
    return result;
  };
  protoOf(Malta).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Malta))
      return false;
    var tmp0_other_with_cast = other instanceof Malta ? other : THROW_CCE();
    if (!this.m1b_1.equals(tmp0_other_with_cast.m1b_1))
      return false;
    if (!(this.n1b_1 === tmp0_other_with_cast.n1b_1))
      return false;
    if (!(this.o1b_1 === tmp0_other_with_cast.o1b_1))
      return false;
    if (!equals(this.p1b_1, tmp0_other_with_cast.p1b_1))
      return false;
    if (!(this.q1b_1 === tmp0_other_with_cast.q1b_1))
      return false;
    if (!(this.r1b_1 === tmp0_other_with_cast.r1b_1))
      return false;
    if (!(this.s1b_1 === tmp0_other_with_cast.s1b_1))
      return false;
    return true;
  };
  function Companion_140() {
  }
  var Companion_instance_140;
  function Companion_getInstance_140() {
    return Companion_instance_140;
  }
  function MarshallIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MHL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Marshall Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0645\u0627\u0631\u0634\u0627\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.t1b_1 = phoneNumPrefix;
    this.u1b_1 = isoCode2;
    this.v1b_1 = isoCode3;
    this.w1b_1 = currency;
    this.x1b_1 = englishName;
    this.y1b_1 = arabicName;
    this.z1b_1 = phoneRegex;
  }
  protoOf(MarshallIslands).wd = function () {
    return this.t1b_1;
  };
  protoOf(MarshallIslands).rd = function () {
    return this.u1b_1;
  };
  protoOf(MarshallIslands).sd = function () {
    return this.v1b_1;
  };
  protoOf(MarshallIslands).td = function () {
    return this.w1b_1;
  };
  protoOf(MarshallIslands).ud = function () {
    return this.x1b_1;
  };
  protoOf(MarshallIslands).vd = function () {
    return this.y1b_1;
  };
  protoOf(MarshallIslands).xd = function () {
    return this.z1b_1;
  };
  protoOf(MarshallIslands).toString = function () {
    return 'MarshallIslands(phoneNumPrefix=' + this.t1b_1.toString() + ', isoCode2=' + this.u1b_1 + ', isoCode3=' + this.v1b_1 + ', currency=' + toString(this.w1b_1) + ', englishName=' + this.x1b_1 + ', arabicName=' + this.y1b_1 + ', phoneRegex=' + this.z1b_1 + ')';
  };
  protoOf(MarshallIslands).hashCode = function () {
    var result = this.t1b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1b_1) | 0;
    result = imul(result, 31) + hashCode(this.w1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1b_1) | 0;
    return result;
  };
  protoOf(MarshallIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarshallIslands))
      return false;
    var tmp0_other_with_cast = other instanceof MarshallIslands ? other : THROW_CCE();
    if (!this.t1b_1.equals(tmp0_other_with_cast.t1b_1))
      return false;
    if (!(this.u1b_1 === tmp0_other_with_cast.u1b_1))
      return false;
    if (!(this.v1b_1 === tmp0_other_with_cast.v1b_1))
      return false;
    if (!equals(this.w1b_1, tmp0_other_with_cast.w1b_1))
      return false;
    if (!(this.x1b_1 === tmp0_other_with_cast.x1b_1))
      return false;
    if (!(this.y1b_1 === tmp0_other_with_cast.y1b_1))
      return false;
    if (!(this.z1b_1 === tmp0_other_with_cast.z1b_1))
      return false;
    return true;
  };
  function Companion_141() {
  }
  var Companion_instance_141;
  function Companion_getInstance_141() {
    return Companion_instance_141;
  }
  function Martinique(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MQ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MTQ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Martinique' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u0631\u062A\u064A\u0646\u064A\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.a1c_1 = phoneNumPrefix;
    this.b1c_1 = isoCode2;
    this.c1c_1 = isoCode3;
    this.d1c_1 = currency;
    this.e1c_1 = englishName;
    this.f1c_1 = arabicName;
    this.g1c_1 = phoneRegex;
  }
  protoOf(Martinique).wd = function () {
    return this.a1c_1;
  };
  protoOf(Martinique).rd = function () {
    return this.b1c_1;
  };
  protoOf(Martinique).sd = function () {
    return this.c1c_1;
  };
  protoOf(Martinique).td = function () {
    return this.d1c_1;
  };
  protoOf(Martinique).ud = function () {
    return this.e1c_1;
  };
  protoOf(Martinique).vd = function () {
    return this.f1c_1;
  };
  protoOf(Martinique).xd = function () {
    return this.g1c_1;
  };
  protoOf(Martinique).toString = function () {
    return 'Martinique(phoneNumPrefix=' + this.a1c_1.toString() + ', isoCode2=' + this.b1c_1 + ', isoCode3=' + this.c1c_1 + ', currency=' + toString(this.d1c_1) + ', englishName=' + this.e1c_1 + ', arabicName=' + this.f1c_1 + ', phoneRegex=' + this.g1c_1 + ')';
  };
  protoOf(Martinique).hashCode = function () {
    var result = this.a1c_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1c_1) | 0;
    result = imul(result, 31) + hashCode(this.d1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1c_1) | 0;
    return result;
  };
  protoOf(Martinique).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Martinique))
      return false;
    var tmp0_other_with_cast = other instanceof Martinique ? other : THROW_CCE();
    if (!this.a1c_1.equals(tmp0_other_with_cast.a1c_1))
      return false;
    if (!(this.b1c_1 === tmp0_other_with_cast.b1c_1))
      return false;
    if (!(this.c1c_1 === tmp0_other_with_cast.c1c_1))
      return false;
    if (!equals(this.d1c_1, tmp0_other_with_cast.d1c_1))
      return false;
    if (!(this.e1c_1 === tmp0_other_with_cast.e1c_1))
      return false;
    if (!(this.f1c_1 === tmp0_other_with_cast.f1c_1))
      return false;
    if (!(this.g1c_1 === tmp0_other_with_cast.g1c_1))
      return false;
    return true;
  };
  function Companion_142() {
  }
  var Companion_instance_142;
  function Companion_getInstance_142() {
    return Companion_instance_142;
  }
  function Mauritania(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MRT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mauritania' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.h1c_1 = phoneNumPrefix;
    this.i1c_1 = isoCode2;
    this.j1c_1 = isoCode3;
    this.k1c_1 = currency;
    this.l1c_1 = englishName;
    this.m1c_1 = arabicName;
    this.n1c_1 = phoneRegex;
  }
  protoOf(Mauritania).wd = function () {
    return this.h1c_1;
  };
  protoOf(Mauritania).rd = function () {
    return this.i1c_1;
  };
  protoOf(Mauritania).sd = function () {
    return this.j1c_1;
  };
  protoOf(Mauritania).td = function () {
    return this.k1c_1;
  };
  protoOf(Mauritania).ud = function () {
    return this.l1c_1;
  };
  protoOf(Mauritania).vd = function () {
    return this.m1c_1;
  };
  protoOf(Mauritania).xd = function () {
    return this.n1c_1;
  };
  protoOf(Mauritania).toString = function () {
    return 'Mauritania(phoneNumPrefix=' + this.h1c_1.toString() + ', isoCode2=' + this.i1c_1 + ', isoCode3=' + this.j1c_1 + ', currency=' + toString(this.k1c_1) + ', englishName=' + this.l1c_1 + ', arabicName=' + this.m1c_1 + ', phoneRegex=' + this.n1c_1 + ')';
  };
  protoOf(Mauritania).hashCode = function () {
    var result = this.h1c_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1c_1) | 0;
    result = imul(result, 31) + hashCode(this.k1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1c_1) | 0;
    return result;
  };
  protoOf(Mauritania).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mauritania))
      return false;
    var tmp0_other_with_cast = other instanceof Mauritania ? other : THROW_CCE();
    if (!this.h1c_1.equals(tmp0_other_with_cast.h1c_1))
      return false;
    if (!(this.i1c_1 === tmp0_other_with_cast.i1c_1))
      return false;
    if (!(this.j1c_1 === tmp0_other_with_cast.j1c_1))
      return false;
    if (!equals(this.k1c_1, tmp0_other_with_cast.k1c_1))
      return false;
    if (!(this.l1c_1 === tmp0_other_with_cast.l1c_1))
      return false;
    if (!(this.m1c_1 === tmp0_other_with_cast.m1c_1))
      return false;
    if (!(this.n1c_1 === tmp0_other_with_cast.n1c_1))
      return false;
    return true;
  };
  function Companion_143() {
  }
  var Companion_instance_143;
  function Companion_getInstance_143() {
    return Companion_instance_143;
  }
  function Mauritius(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MUS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mauritius' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0648\u0631\u064A\u0634\u064A\u0648\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.o1c_1 = phoneNumPrefix;
    this.p1c_1 = isoCode2;
    this.q1c_1 = isoCode3;
    this.r1c_1 = currency;
    this.s1c_1 = englishName;
    this.t1c_1 = arabicName;
    this.u1c_1 = phoneRegex;
  }
  protoOf(Mauritius).wd = function () {
    return this.o1c_1;
  };
  protoOf(Mauritius).rd = function () {
    return this.p1c_1;
  };
  protoOf(Mauritius).sd = function () {
    return this.q1c_1;
  };
  protoOf(Mauritius).td = function () {
    return this.r1c_1;
  };
  protoOf(Mauritius).ud = function () {
    return this.s1c_1;
  };
  protoOf(Mauritius).vd = function () {
    return this.t1c_1;
  };
  protoOf(Mauritius).xd = function () {
    return this.u1c_1;
  };
  protoOf(Mauritius).toString = function () {
    return 'Mauritius(phoneNumPrefix=' + this.o1c_1.toString() + ', isoCode2=' + this.p1c_1 + ', isoCode3=' + this.q1c_1 + ', currency=' + toString(this.r1c_1) + ', englishName=' + this.s1c_1 + ', arabicName=' + this.t1c_1 + ', phoneRegex=' + this.u1c_1 + ')';
  };
  protoOf(Mauritius).hashCode = function () {
    var result = this.o1c_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1c_1) | 0;
    result = imul(result, 31) + hashCode(this.r1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1c_1) | 0;
    return result;
  };
  protoOf(Mauritius).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mauritius))
      return false;
    var tmp0_other_with_cast = other instanceof Mauritius ? other : THROW_CCE();
    if (!this.o1c_1.equals(tmp0_other_with_cast.o1c_1))
      return false;
    if (!(this.p1c_1 === tmp0_other_with_cast.p1c_1))
      return false;
    if (!(this.q1c_1 === tmp0_other_with_cast.q1c_1))
      return false;
    if (!equals(this.r1c_1, tmp0_other_with_cast.r1c_1))
      return false;
    if (!(this.s1c_1 === tmp0_other_with_cast.s1c_1))
      return false;
    if (!(this.t1c_1 === tmp0_other_with_cast.t1c_1))
      return false;
    if (!(this.u1c_1 === tmp0_other_with_cast.u1c_1))
      return false;
    return true;
  };
  function Companion_144() {
  }
  var Companion_instance_144;
  function Companion_getInstance_144() {
    return Companion_instance_144;
  }
  function Mayotte(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'YT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MYT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mayotte' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0627\u064A\u0648\u062A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.v1c_1 = phoneNumPrefix;
    this.w1c_1 = isoCode2;
    this.x1c_1 = isoCode3;
    this.y1c_1 = currency;
    this.z1c_1 = englishName;
    this.a1d_1 = arabicName;
    this.b1d_1 = phoneRegex;
  }
  protoOf(Mayotte).wd = function () {
    return this.v1c_1;
  };
  protoOf(Mayotte).rd = function () {
    return this.w1c_1;
  };
  protoOf(Mayotte).sd = function () {
    return this.x1c_1;
  };
  protoOf(Mayotte).td = function () {
    return this.y1c_1;
  };
  protoOf(Mayotte).ud = function () {
    return this.z1c_1;
  };
  protoOf(Mayotte).vd = function () {
    return this.a1d_1;
  };
  protoOf(Mayotte).xd = function () {
    return this.b1d_1;
  };
  protoOf(Mayotte).toString = function () {
    return 'Mayotte(phoneNumPrefix=' + this.v1c_1.toString() + ', isoCode2=' + this.w1c_1 + ', isoCode3=' + this.x1c_1 + ', currency=' + toString(this.y1c_1) + ', englishName=' + this.z1c_1 + ', arabicName=' + this.a1d_1 + ', phoneRegex=' + this.b1d_1 + ')';
  };
  protoOf(Mayotte).hashCode = function () {
    var result = this.v1c_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1c_1) | 0;
    result = imul(result, 31) + hashCode(this.y1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1d_1) | 0;
    return result;
  };
  protoOf(Mayotte).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mayotte))
      return false;
    var tmp0_other_with_cast = other instanceof Mayotte ? other : THROW_CCE();
    if (!this.v1c_1.equals(tmp0_other_with_cast.v1c_1))
      return false;
    if (!(this.w1c_1 === tmp0_other_with_cast.w1c_1))
      return false;
    if (!(this.x1c_1 === tmp0_other_with_cast.x1c_1))
      return false;
    if (!equals(this.y1c_1, tmp0_other_with_cast.y1c_1))
      return false;
    if (!(this.z1c_1 === tmp0_other_with_cast.z1c_1))
      return false;
    if (!(this.a1d_1 === tmp0_other_with_cast.a1d_1))
      return false;
    if (!(this.b1d_1 === tmp0_other_with_cast.b1d_1))
      return false;
    return true;
  };
  function Companion_145() {
  }
  var Companion_instance_145;
  function Companion_getInstance_145() {
    return Companion_instance_145;
  }
  function Mexico(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MX' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MEX' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mexico' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0645\u0643\u0633\u064A\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.c1d_1 = phoneNumPrefix;
    this.d1d_1 = isoCode2;
    this.e1d_1 = isoCode3;
    this.f1d_1 = currency;
    this.g1d_1 = englishName;
    this.h1d_1 = arabicName;
    this.i1d_1 = phoneRegex;
  }
  protoOf(Mexico).wd = function () {
    return this.c1d_1;
  };
  protoOf(Mexico).rd = function () {
    return this.d1d_1;
  };
  protoOf(Mexico).sd = function () {
    return this.e1d_1;
  };
  protoOf(Mexico).td = function () {
    return this.f1d_1;
  };
  protoOf(Mexico).ud = function () {
    return this.g1d_1;
  };
  protoOf(Mexico).vd = function () {
    return this.h1d_1;
  };
  protoOf(Mexico).xd = function () {
    return this.i1d_1;
  };
  protoOf(Mexico).toString = function () {
    return 'Mexico(phoneNumPrefix=' + this.c1d_1.toString() + ', isoCode2=' + this.d1d_1 + ', isoCode3=' + this.e1d_1 + ', currency=' + toString(this.f1d_1) + ', englishName=' + this.g1d_1 + ', arabicName=' + this.h1d_1 + ', phoneRegex=' + this.i1d_1 + ')';
  };
  protoOf(Mexico).hashCode = function () {
    var result = this.c1d_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.d1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1d_1) | 0;
    result = imul(result, 31) + hashCode(this.f1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1d_1) | 0;
    return result;
  };
  protoOf(Mexico).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mexico))
      return false;
    var tmp0_other_with_cast = other instanceof Mexico ? other : THROW_CCE();
    if (!this.c1d_1.equals(tmp0_other_with_cast.c1d_1))
      return false;
    if (!(this.d1d_1 === tmp0_other_with_cast.d1d_1))
      return false;
    if (!(this.e1d_1 === tmp0_other_with_cast.e1d_1))
      return false;
    if (!equals(this.f1d_1, tmp0_other_with_cast.f1d_1))
      return false;
    if (!(this.g1d_1 === tmp0_other_with_cast.g1d_1))
      return false;
    if (!(this.h1d_1 === tmp0_other_with_cast.h1d_1))
      return false;
    if (!(this.i1d_1 === tmp0_other_with_cast.i1d_1))
      return false;
    return true;
  };
  function Companion_146() {
  }
  var Companion_instance_146;
  function Companion_getInstance_146() {
    return Companion_instance_146;
  }
  function MicronesiaFederatedStatesof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'FM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'FSM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Micronesia (Federated States of)' : englishName;
    arabicName = arabicName === VOID ? '\u0648\u0644\u0627\u064A\u0627\u062A \u0645\u064A\u0643\u0631\u0648\u0646\u064A\u0633\u064A\u0627 \u0627\u0644\u0645\u062A\u062D\u062F\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.j1d_1 = phoneNumPrefix;
    this.k1d_1 = isoCode2;
    this.l1d_1 = isoCode3;
    this.m1d_1 = currency;
    this.n1d_1 = englishName;
    this.o1d_1 = arabicName;
    this.p1d_1 = phoneRegex;
  }
  protoOf(MicronesiaFederatedStatesof).wd = function () {
    return this.j1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).rd = function () {
    return this.k1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).sd = function () {
    return this.l1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).td = function () {
    return this.m1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).ud = function () {
    return this.n1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).vd = function () {
    return this.o1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).xd = function () {
    return this.p1d_1;
  };
  protoOf(MicronesiaFederatedStatesof).toString = function () {
    return 'MicronesiaFederatedStatesof(phoneNumPrefix=' + this.j1d_1.toString() + ', isoCode2=' + this.k1d_1 + ', isoCode3=' + this.l1d_1 + ', currency=' + toString(this.m1d_1) + ', englishName=' + this.n1d_1 + ', arabicName=' + this.o1d_1 + ', phoneRegex=' + this.p1d_1 + ')';
  };
  protoOf(MicronesiaFederatedStatesof).hashCode = function () {
    var result = this.j1d_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.k1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1d_1) | 0;
    result = imul(result, 31) + hashCode(this.m1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1d_1) | 0;
    return result;
  };
  protoOf(MicronesiaFederatedStatesof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MicronesiaFederatedStatesof))
      return false;
    var tmp0_other_with_cast = other instanceof MicronesiaFederatedStatesof ? other : THROW_CCE();
    if (!this.j1d_1.equals(tmp0_other_with_cast.j1d_1))
      return false;
    if (!(this.k1d_1 === tmp0_other_with_cast.k1d_1))
      return false;
    if (!(this.l1d_1 === tmp0_other_with_cast.l1d_1))
      return false;
    if (!equals(this.m1d_1, tmp0_other_with_cast.m1d_1))
      return false;
    if (!(this.n1d_1 === tmp0_other_with_cast.n1d_1))
      return false;
    if (!(this.o1d_1 === tmp0_other_with_cast.o1d_1))
      return false;
    if (!(this.p1d_1 === tmp0_other_with_cast.p1d_1))
      return false;
    return true;
  };
  function Companion_147() {
  }
  var Companion_instance_147;
  function Companion_getInstance_147() {
    return Companion_instance_147;
  }
  function Morocco(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(212, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MAR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Morocco' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0645\u063A\u0631\u0628' : arabicName;
    phoneRegex = phoneRegex === VOID ? '^[67]([0-9]{8})$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '650123456' : phoneNumberHint;
    this.xb_1 = phoneNumPrefix;
    this.yb_1 = isoCode2;
    this.zb_1 = isoCode3;
    this.ac_1 = currency;
    this.bc_1 = englishName;
    this.cc_1 = arabicName;
    this.dc_1 = phoneRegex;
    this.ec_1 = phoneNumberHint;
  }
  protoOf(Morocco).wd = function () {
    return this.xb_1;
  };
  protoOf(Morocco).rd = function () {
    return this.yb_1;
  };
  protoOf(Morocco).sd = function () {
    return this.zb_1;
  };
  protoOf(Morocco).td = function () {
    return this.ac_1;
  };
  protoOf(Morocco).ud = function () {
    return this.bc_1;
  };
  protoOf(Morocco).vd = function () {
    return this.cc_1;
  };
  protoOf(Morocco).xd = function () {
    return this.dc_1;
  };
  protoOf(Morocco).yd = function () {
    return this.ec_1;
  };
  protoOf(Morocco).toString = function () {
    return 'Morocco(phoneNumPrefix=' + this.xb_1.toString() + ', isoCode2=' + this.yb_1 + ', isoCode3=' + this.zb_1 + ', currency=' + toString(this.ac_1) + ', englishName=' + this.bc_1 + ', arabicName=' + this.cc_1 + ', phoneRegex=' + this.dc_1 + ', phoneNumberHint=' + this.ec_1 + ')';
  };
  protoOf(Morocco).hashCode = function () {
    var result = this.xb_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.yb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.zb_1) | 0;
    result = imul(result, 31) + hashCode(this.ac_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ec_1) | 0;
    return result;
  };
  protoOf(Morocco).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Morocco))
      return false;
    var tmp0_other_with_cast = other instanceof Morocco ? other : THROW_CCE();
    if (!this.xb_1.equals(tmp0_other_with_cast.xb_1))
      return false;
    if (!(this.yb_1 === tmp0_other_with_cast.yb_1))
      return false;
    if (!(this.zb_1 === tmp0_other_with_cast.zb_1))
      return false;
    if (!equals(this.ac_1, tmp0_other_with_cast.ac_1))
      return false;
    if (!(this.bc_1 === tmp0_other_with_cast.bc_1))
      return false;
    if (!(this.cc_1 === tmp0_other_with_cast.cc_1))
      return false;
    if (!(this.dc_1 === tmp0_other_with_cast.dc_1))
      return false;
    if (!(this.ec_1 === tmp0_other_with_cast.ec_1))
      return false;
    return true;
  };
  function Companion_148() {
  }
  var Companion_instance_148;
  function Companion_getInstance_148() {
    return Companion_instance_148;
  }
  function MoldovaRepublicof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MDA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Moldova, Republic of' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0648\u0644\u062F\u0648\u0641\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.q1d_1 = phoneNumPrefix;
    this.r1d_1 = isoCode2;
    this.s1d_1 = isoCode3;
    this.t1d_1 = currency;
    this.u1d_1 = englishName;
    this.v1d_1 = arabicName;
    this.w1d_1 = phoneRegex;
  }
  protoOf(MoldovaRepublicof).wd = function () {
    return this.q1d_1;
  };
  protoOf(MoldovaRepublicof).rd = function () {
    return this.r1d_1;
  };
  protoOf(MoldovaRepublicof).sd = function () {
    return this.s1d_1;
  };
  protoOf(MoldovaRepublicof).td = function () {
    return this.t1d_1;
  };
  protoOf(MoldovaRepublicof).ud = function () {
    return this.u1d_1;
  };
  protoOf(MoldovaRepublicof).vd = function () {
    return this.v1d_1;
  };
  protoOf(MoldovaRepublicof).xd = function () {
    return this.w1d_1;
  };
  protoOf(MoldovaRepublicof).toString = function () {
    return 'MoldovaRepublicof(phoneNumPrefix=' + this.q1d_1.toString() + ', isoCode2=' + this.r1d_1 + ', isoCode3=' + this.s1d_1 + ', currency=' + toString(this.t1d_1) + ', englishName=' + this.u1d_1 + ', arabicName=' + this.v1d_1 + ', phoneRegex=' + this.w1d_1 + ')';
  };
  protoOf(MoldovaRepublicof).hashCode = function () {
    var result = this.q1d_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1d_1) | 0;
    result = imul(result, 31) + hashCode(this.t1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1d_1) | 0;
    return result;
  };
  protoOf(MoldovaRepublicof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MoldovaRepublicof))
      return false;
    var tmp0_other_with_cast = other instanceof MoldovaRepublicof ? other : THROW_CCE();
    if (!this.q1d_1.equals(tmp0_other_with_cast.q1d_1))
      return false;
    if (!(this.r1d_1 === tmp0_other_with_cast.r1d_1))
      return false;
    if (!(this.s1d_1 === tmp0_other_with_cast.s1d_1))
      return false;
    if (!equals(this.t1d_1, tmp0_other_with_cast.t1d_1))
      return false;
    if (!(this.u1d_1 === tmp0_other_with_cast.u1d_1))
      return false;
    if (!(this.v1d_1 === tmp0_other_with_cast.v1d_1))
      return false;
    if (!(this.w1d_1 === tmp0_other_with_cast.w1d_1))
      return false;
    return true;
  };
  function Companion_149() {
  }
  var Companion_instance_149;
  function Companion_getInstance_149() {
    return Companion_instance_149;
  }
  function Monaco(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MCO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Monaco' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0648\u0646\u0627\u0643\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.x1d_1 = phoneNumPrefix;
    this.y1d_1 = isoCode2;
    this.z1d_1 = isoCode3;
    this.a1e_1 = currency;
    this.b1e_1 = englishName;
    this.c1e_1 = arabicName;
    this.d1e_1 = phoneRegex;
  }
  protoOf(Monaco).wd = function () {
    return this.x1d_1;
  };
  protoOf(Monaco).rd = function () {
    return this.y1d_1;
  };
  protoOf(Monaco).sd = function () {
    return this.z1d_1;
  };
  protoOf(Monaco).td = function () {
    return this.a1e_1;
  };
  protoOf(Monaco).ud = function () {
    return this.b1e_1;
  };
  protoOf(Monaco).vd = function () {
    return this.c1e_1;
  };
  protoOf(Monaco).xd = function () {
    return this.d1e_1;
  };
  protoOf(Monaco).toString = function () {
    return 'Monaco(phoneNumPrefix=' + this.x1d_1.toString() + ', isoCode2=' + this.y1d_1 + ', isoCode3=' + this.z1d_1 + ', currency=' + toString(this.a1e_1) + ', englishName=' + this.b1e_1 + ', arabicName=' + this.c1e_1 + ', phoneRegex=' + this.d1e_1 + ')';
  };
  protoOf(Monaco).hashCode = function () {
    var result = this.x1d_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.y1d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1d_1) | 0;
    result = imul(result, 31) + hashCode(this.a1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1e_1) | 0;
    return result;
  };
  protoOf(Monaco).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Monaco))
      return false;
    var tmp0_other_with_cast = other instanceof Monaco ? other : THROW_CCE();
    if (!this.x1d_1.equals(tmp0_other_with_cast.x1d_1))
      return false;
    if (!(this.y1d_1 === tmp0_other_with_cast.y1d_1))
      return false;
    if (!(this.z1d_1 === tmp0_other_with_cast.z1d_1))
      return false;
    if (!equals(this.a1e_1, tmp0_other_with_cast.a1e_1))
      return false;
    if (!(this.b1e_1 === tmp0_other_with_cast.b1e_1))
      return false;
    if (!(this.c1e_1 === tmp0_other_with_cast.c1e_1))
      return false;
    if (!(this.d1e_1 === tmp0_other_with_cast.d1e_1))
      return false;
    return true;
  };
  function Companion_150() {
  }
  var Companion_instance_150;
  function Companion_getInstance_150() {
    return Companion_instance_150;
  }
  function Mongolia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MNG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mongolia' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0646\u063A\u0648\u0644\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.e1e_1 = phoneNumPrefix;
    this.f1e_1 = isoCode2;
    this.g1e_1 = isoCode3;
    this.h1e_1 = currency;
    this.i1e_1 = englishName;
    this.j1e_1 = arabicName;
    this.k1e_1 = phoneRegex;
  }
  protoOf(Mongolia).wd = function () {
    return this.e1e_1;
  };
  protoOf(Mongolia).rd = function () {
    return this.f1e_1;
  };
  protoOf(Mongolia).sd = function () {
    return this.g1e_1;
  };
  protoOf(Mongolia).td = function () {
    return this.h1e_1;
  };
  protoOf(Mongolia).ud = function () {
    return this.i1e_1;
  };
  protoOf(Mongolia).vd = function () {
    return this.j1e_1;
  };
  protoOf(Mongolia).xd = function () {
    return this.k1e_1;
  };
  protoOf(Mongolia).toString = function () {
    return 'Mongolia(phoneNumPrefix=' + this.e1e_1.toString() + ', isoCode2=' + this.f1e_1 + ', isoCode3=' + this.g1e_1 + ', currency=' + toString(this.h1e_1) + ', englishName=' + this.i1e_1 + ', arabicName=' + this.j1e_1 + ', phoneRegex=' + this.k1e_1 + ')';
  };
  protoOf(Mongolia).hashCode = function () {
    var result = this.e1e_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.f1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1e_1) | 0;
    result = imul(result, 31) + hashCode(this.h1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1e_1) | 0;
    return result;
  };
  protoOf(Mongolia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mongolia))
      return false;
    var tmp0_other_with_cast = other instanceof Mongolia ? other : THROW_CCE();
    if (!this.e1e_1.equals(tmp0_other_with_cast.e1e_1))
      return false;
    if (!(this.f1e_1 === tmp0_other_with_cast.f1e_1))
      return false;
    if (!(this.g1e_1 === tmp0_other_with_cast.g1e_1))
      return false;
    if (!equals(this.h1e_1, tmp0_other_with_cast.h1e_1))
      return false;
    if (!(this.i1e_1 === tmp0_other_with_cast.i1e_1))
      return false;
    if (!(this.j1e_1 === tmp0_other_with_cast.j1e_1))
      return false;
    if (!(this.k1e_1 === tmp0_other_with_cast.k1e_1))
      return false;
    return true;
  };
  function Companion_151() {
  }
  var Companion_instance_151;
  function Companion_getInstance_151() {
    return Companion_instance_151;
  }
  function Montenegro(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ME' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MNE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Montenegro' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u062C\u0628\u0644 \u0627\u0644\u0623\u0633\u0648\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.l1e_1 = phoneNumPrefix;
    this.m1e_1 = isoCode2;
    this.n1e_1 = isoCode3;
    this.o1e_1 = currency;
    this.p1e_1 = englishName;
    this.q1e_1 = arabicName;
    this.r1e_1 = phoneRegex;
  }
  protoOf(Montenegro).wd = function () {
    return this.l1e_1;
  };
  protoOf(Montenegro).rd = function () {
    return this.m1e_1;
  };
  protoOf(Montenegro).sd = function () {
    return this.n1e_1;
  };
  protoOf(Montenegro).td = function () {
    return this.o1e_1;
  };
  protoOf(Montenegro).ud = function () {
    return this.p1e_1;
  };
  protoOf(Montenegro).vd = function () {
    return this.q1e_1;
  };
  protoOf(Montenegro).xd = function () {
    return this.r1e_1;
  };
  protoOf(Montenegro).toString = function () {
    return 'Montenegro(phoneNumPrefix=' + this.l1e_1.toString() + ', isoCode2=' + this.m1e_1 + ', isoCode3=' + this.n1e_1 + ', currency=' + toString(this.o1e_1) + ', englishName=' + this.p1e_1 + ', arabicName=' + this.q1e_1 + ', phoneRegex=' + this.r1e_1 + ')';
  };
  protoOf(Montenegro).hashCode = function () {
    var result = this.l1e_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1e_1) | 0;
    result = imul(result, 31) + hashCode(this.o1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1e_1) | 0;
    return result;
  };
  protoOf(Montenegro).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Montenegro))
      return false;
    var tmp0_other_with_cast = other instanceof Montenegro ? other : THROW_CCE();
    if (!this.l1e_1.equals(tmp0_other_with_cast.l1e_1))
      return false;
    if (!(this.m1e_1 === tmp0_other_with_cast.m1e_1))
      return false;
    if (!(this.n1e_1 === tmp0_other_with_cast.n1e_1))
      return false;
    if (!equals(this.o1e_1, tmp0_other_with_cast.o1e_1))
      return false;
    if (!(this.p1e_1 === tmp0_other_with_cast.p1e_1))
      return false;
    if (!(this.q1e_1 === tmp0_other_with_cast.q1e_1))
      return false;
    if (!(this.r1e_1 === tmp0_other_with_cast.r1e_1))
      return false;
    return true;
  };
  function Companion_152() {
  }
  var Companion_instance_152;
  function Companion_getInstance_152() {
    return Companion_instance_152;
  }
  function Montserrat(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MSR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Montserrat' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0648\u0646\u062A\u0633\u0631\u0627\u062A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.s1e_1 = phoneNumPrefix;
    this.t1e_1 = isoCode2;
    this.u1e_1 = isoCode3;
    this.v1e_1 = currency;
    this.w1e_1 = englishName;
    this.x1e_1 = arabicName;
    this.y1e_1 = phoneRegex;
  }
  protoOf(Montserrat).wd = function () {
    return this.s1e_1;
  };
  protoOf(Montserrat).rd = function () {
    return this.t1e_1;
  };
  protoOf(Montserrat).sd = function () {
    return this.u1e_1;
  };
  protoOf(Montserrat).td = function () {
    return this.v1e_1;
  };
  protoOf(Montserrat).ud = function () {
    return this.w1e_1;
  };
  protoOf(Montserrat).vd = function () {
    return this.x1e_1;
  };
  protoOf(Montserrat).xd = function () {
    return this.y1e_1;
  };
  protoOf(Montserrat).toString = function () {
    return 'Montserrat(phoneNumPrefix=' + this.s1e_1.toString() + ', isoCode2=' + this.t1e_1 + ', isoCode3=' + this.u1e_1 + ', currency=' + toString(this.v1e_1) + ', englishName=' + this.w1e_1 + ', arabicName=' + this.x1e_1 + ', phoneRegex=' + this.y1e_1 + ')';
  };
  protoOf(Montserrat).hashCode = function () {
    var result = this.s1e_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1e_1) | 0;
    result = imul(result, 31) + hashCode(this.v1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1e_1) | 0;
    return result;
  };
  protoOf(Montserrat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Montserrat))
      return false;
    var tmp0_other_with_cast = other instanceof Montserrat ? other : THROW_CCE();
    if (!this.s1e_1.equals(tmp0_other_with_cast.s1e_1))
      return false;
    if (!(this.t1e_1 === tmp0_other_with_cast.t1e_1))
      return false;
    if (!(this.u1e_1 === tmp0_other_with_cast.u1e_1))
      return false;
    if (!equals(this.v1e_1, tmp0_other_with_cast.v1e_1))
      return false;
    if (!(this.w1e_1 === tmp0_other_with_cast.w1e_1))
      return false;
    if (!(this.x1e_1 === tmp0_other_with_cast.x1e_1))
      return false;
    if (!(this.y1e_1 === tmp0_other_with_cast.y1e_1))
      return false;
    return true;
  };
  function Companion_153() {
  }
  var Companion_instance_153;
  function Companion_getInstance_153() {
    return Companion_instance_153;
  }
  function Mozambique(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MOZ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Mozambique' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u0648\u0632\u0645\u0628\u064A\u0642' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.z1e_1 = phoneNumPrefix;
    this.a1f_1 = isoCode2;
    this.b1f_1 = isoCode3;
    this.c1f_1 = currency;
    this.d1f_1 = englishName;
    this.e1f_1 = arabicName;
    this.f1f_1 = phoneRegex;
  }
  protoOf(Mozambique).wd = function () {
    return this.z1e_1;
  };
  protoOf(Mozambique).rd = function () {
    return this.a1f_1;
  };
  protoOf(Mozambique).sd = function () {
    return this.b1f_1;
  };
  protoOf(Mozambique).td = function () {
    return this.c1f_1;
  };
  protoOf(Mozambique).ud = function () {
    return this.d1f_1;
  };
  protoOf(Mozambique).vd = function () {
    return this.e1f_1;
  };
  protoOf(Mozambique).xd = function () {
    return this.f1f_1;
  };
  protoOf(Mozambique).toString = function () {
    return 'Mozambique(phoneNumPrefix=' + this.z1e_1.toString() + ', isoCode2=' + this.a1f_1 + ', isoCode3=' + this.b1f_1 + ', currency=' + toString(this.c1f_1) + ', englishName=' + this.d1f_1 + ', arabicName=' + this.e1f_1 + ', phoneRegex=' + this.f1f_1 + ')';
  };
  protoOf(Mozambique).hashCode = function () {
    var result = this.z1e_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1f_1) | 0;
    result = imul(result, 31) + hashCode(this.c1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1f_1) | 0;
    return result;
  };
  protoOf(Mozambique).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mozambique))
      return false;
    var tmp0_other_with_cast = other instanceof Mozambique ? other : THROW_CCE();
    if (!this.z1e_1.equals(tmp0_other_with_cast.z1e_1))
      return false;
    if (!(this.a1f_1 === tmp0_other_with_cast.a1f_1))
      return false;
    if (!(this.b1f_1 === tmp0_other_with_cast.b1f_1))
      return false;
    if (!equals(this.c1f_1, tmp0_other_with_cast.c1f_1))
      return false;
    if (!(this.d1f_1 === tmp0_other_with_cast.d1f_1))
      return false;
    if (!(this.e1f_1 === tmp0_other_with_cast.e1f_1))
      return false;
    if (!(this.f1f_1 === tmp0_other_with_cast.f1f_1))
      return false;
    return true;
  };
  function Companion_154() {
  }
  var Companion_instance_154;
  function Companion_getInstance_154() {
    return Companion_instance_154;
  }
  function Myanmar(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MMR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Myanmar' : englishName;
    arabicName = arabicName === VOID ? '\u0645\u064A\u0627\u0646\u0645\u0627\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.g1f_1 = phoneNumPrefix;
    this.h1f_1 = isoCode2;
    this.i1f_1 = isoCode3;
    this.j1f_1 = currency;
    this.k1f_1 = englishName;
    this.l1f_1 = arabicName;
    this.m1f_1 = phoneRegex;
  }
  protoOf(Myanmar).wd = function () {
    return this.g1f_1;
  };
  protoOf(Myanmar).rd = function () {
    return this.h1f_1;
  };
  protoOf(Myanmar).sd = function () {
    return this.i1f_1;
  };
  protoOf(Myanmar).td = function () {
    return this.j1f_1;
  };
  protoOf(Myanmar).ud = function () {
    return this.k1f_1;
  };
  protoOf(Myanmar).vd = function () {
    return this.l1f_1;
  };
  protoOf(Myanmar).xd = function () {
    return this.m1f_1;
  };
  protoOf(Myanmar).toString = function () {
    return 'Myanmar(phoneNumPrefix=' + this.g1f_1.toString() + ', isoCode2=' + this.h1f_1 + ', isoCode3=' + this.i1f_1 + ', currency=' + toString(this.j1f_1) + ', englishName=' + this.k1f_1 + ', arabicName=' + this.l1f_1 + ', phoneRegex=' + this.m1f_1 + ')';
  };
  protoOf(Myanmar).hashCode = function () {
    var result = this.g1f_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1f_1) | 0;
    result = imul(result, 31) + hashCode(this.j1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1f_1) | 0;
    return result;
  };
  protoOf(Myanmar).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Myanmar))
      return false;
    var tmp0_other_with_cast = other instanceof Myanmar ? other : THROW_CCE();
    if (!this.g1f_1.equals(tmp0_other_with_cast.g1f_1))
      return false;
    if (!(this.h1f_1 === tmp0_other_with_cast.h1f_1))
      return false;
    if (!(this.i1f_1 === tmp0_other_with_cast.i1f_1))
      return false;
    if (!equals(this.j1f_1, tmp0_other_with_cast.j1f_1))
      return false;
    if (!(this.k1f_1 === tmp0_other_with_cast.k1f_1))
      return false;
    if (!(this.l1f_1 === tmp0_other_with_cast.l1f_1))
      return false;
    if (!(this.m1f_1 === tmp0_other_with_cast.m1f_1))
      return false;
    return true;
  };
  function Companion_155() {
  }
  var Companion_instance_155;
  function Companion_getInstance_155() {
    return Companion_instance_155;
  }
  function Namibia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NAM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Namibia' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u0627\u0645\u064A\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.n1f_1 = phoneNumPrefix;
    this.o1f_1 = isoCode2;
    this.p1f_1 = isoCode3;
    this.q1f_1 = currency;
    this.r1f_1 = englishName;
    this.s1f_1 = arabicName;
    this.t1f_1 = phoneRegex;
  }
  protoOf(Namibia).wd = function () {
    return this.n1f_1;
  };
  protoOf(Namibia).rd = function () {
    return this.o1f_1;
  };
  protoOf(Namibia).sd = function () {
    return this.p1f_1;
  };
  protoOf(Namibia).td = function () {
    return this.q1f_1;
  };
  protoOf(Namibia).ud = function () {
    return this.r1f_1;
  };
  protoOf(Namibia).vd = function () {
    return this.s1f_1;
  };
  protoOf(Namibia).xd = function () {
    return this.t1f_1;
  };
  protoOf(Namibia).toString = function () {
    return 'Namibia(phoneNumPrefix=' + this.n1f_1.toString() + ', isoCode2=' + this.o1f_1 + ', isoCode3=' + this.p1f_1 + ', currency=' + toString(this.q1f_1) + ', englishName=' + this.r1f_1 + ', arabicName=' + this.s1f_1 + ', phoneRegex=' + this.t1f_1 + ')';
  };
  protoOf(Namibia).hashCode = function () {
    var result = this.n1f_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1f_1) | 0;
    result = imul(result, 31) + hashCode(this.q1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1f_1) | 0;
    return result;
  };
  protoOf(Namibia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Namibia))
      return false;
    var tmp0_other_with_cast = other instanceof Namibia ? other : THROW_CCE();
    if (!this.n1f_1.equals(tmp0_other_with_cast.n1f_1))
      return false;
    if (!(this.o1f_1 === tmp0_other_with_cast.o1f_1))
      return false;
    if (!(this.p1f_1 === tmp0_other_with_cast.p1f_1))
      return false;
    if (!equals(this.q1f_1, tmp0_other_with_cast.q1f_1))
      return false;
    if (!(this.r1f_1 === tmp0_other_with_cast.r1f_1))
      return false;
    if (!(this.s1f_1 === tmp0_other_with_cast.s1f_1))
      return false;
    if (!(this.t1f_1 === tmp0_other_with_cast.t1f_1))
      return false;
    return true;
  };
  function Companion_156() {
  }
  var Companion_instance_156;
  function Companion_getInstance_156() {
    return Companion_instance_156;
  }
  function Nauru(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NRU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Nauru' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u0627\u0648\u0631\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.u1f_1 = phoneNumPrefix;
    this.v1f_1 = isoCode2;
    this.w1f_1 = isoCode3;
    this.x1f_1 = currency;
    this.y1f_1 = englishName;
    this.z1f_1 = arabicName;
    this.a1g_1 = phoneRegex;
  }
  protoOf(Nauru).wd = function () {
    return this.u1f_1;
  };
  protoOf(Nauru).rd = function () {
    return this.v1f_1;
  };
  protoOf(Nauru).sd = function () {
    return this.w1f_1;
  };
  protoOf(Nauru).td = function () {
    return this.x1f_1;
  };
  protoOf(Nauru).ud = function () {
    return this.y1f_1;
  };
  protoOf(Nauru).vd = function () {
    return this.z1f_1;
  };
  protoOf(Nauru).xd = function () {
    return this.a1g_1;
  };
  protoOf(Nauru).toString = function () {
    return 'Nauru(phoneNumPrefix=' + this.u1f_1.toString() + ', isoCode2=' + this.v1f_1 + ', isoCode3=' + this.w1f_1 + ', currency=' + toString(this.x1f_1) + ', englishName=' + this.y1f_1 + ', arabicName=' + this.z1f_1 + ', phoneRegex=' + this.a1g_1 + ')';
  };
  protoOf(Nauru).hashCode = function () {
    var result = this.u1f_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.v1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1f_1) | 0;
    result = imul(result, 31) + hashCode(this.x1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1g_1) | 0;
    return result;
  };
  protoOf(Nauru).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Nauru))
      return false;
    var tmp0_other_with_cast = other instanceof Nauru ? other : THROW_CCE();
    if (!this.u1f_1.equals(tmp0_other_with_cast.u1f_1))
      return false;
    if (!(this.v1f_1 === tmp0_other_with_cast.v1f_1))
      return false;
    if (!(this.w1f_1 === tmp0_other_with_cast.w1f_1))
      return false;
    if (!equals(this.x1f_1, tmp0_other_with_cast.x1f_1))
      return false;
    if (!(this.y1f_1 === tmp0_other_with_cast.y1f_1))
      return false;
    if (!(this.z1f_1 === tmp0_other_with_cast.z1f_1))
      return false;
    if (!(this.a1g_1 === tmp0_other_with_cast.a1g_1))
      return false;
    return true;
  };
  function Companion_157() {
  }
  var Companion_instance_157;
  function Companion_getInstance_157() {
    return Companion_instance_157;
  }
  function Nepal(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(977, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NP' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NPL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Nepal' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u064A\u0628\u0627\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '9841234567' : phoneNumberHint;
    this.f8_1 = phoneNumPrefix;
    this.g8_1 = isoCode2;
    this.h8_1 = isoCode3;
    this.i8_1 = currency;
    this.j8_1 = englishName;
    this.k8_1 = arabicName;
    this.l8_1 = phoneRegex;
    this.m8_1 = phoneNumberHint;
  }
  protoOf(Nepal).wd = function () {
    return this.f8_1;
  };
  protoOf(Nepal).rd = function () {
    return this.g8_1;
  };
  protoOf(Nepal).sd = function () {
    return this.h8_1;
  };
  protoOf(Nepal).td = function () {
    return this.i8_1;
  };
  protoOf(Nepal).ud = function () {
    return this.j8_1;
  };
  protoOf(Nepal).vd = function () {
    return this.k8_1;
  };
  protoOf(Nepal).xd = function () {
    return this.l8_1;
  };
  protoOf(Nepal).yd = function () {
    return this.m8_1;
  };
  protoOf(Nepal).toString = function () {
    return 'Nepal(phoneNumPrefix=' + this.f8_1.toString() + ', isoCode2=' + this.g8_1 + ', isoCode3=' + this.h8_1 + ', currency=' + toString(this.i8_1) + ', englishName=' + this.j8_1 + ', arabicName=' + this.k8_1 + ', phoneRegex=' + this.l8_1 + ', phoneNumberHint=' + this.m8_1 + ')';
  };
  protoOf(Nepal).hashCode = function () {
    var result = this.f8_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h8_1) | 0;
    result = imul(result, 31) + hashCode(this.i8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l8_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m8_1) | 0;
    return result;
  };
  protoOf(Nepal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Nepal))
      return false;
    var tmp0_other_with_cast = other instanceof Nepal ? other : THROW_CCE();
    if (!this.f8_1.equals(tmp0_other_with_cast.f8_1))
      return false;
    if (!(this.g8_1 === tmp0_other_with_cast.g8_1))
      return false;
    if (!(this.h8_1 === tmp0_other_with_cast.h8_1))
      return false;
    if (!equals(this.i8_1, tmp0_other_with_cast.i8_1))
      return false;
    if (!(this.j8_1 === tmp0_other_with_cast.j8_1))
      return false;
    if (!(this.k8_1 === tmp0_other_with_cast.k8_1))
      return false;
    if (!(this.l8_1 === tmp0_other_with_cast.l8_1))
      return false;
    if (!(this.m8_1 === tmp0_other_with_cast.m8_1))
      return false;
    return true;
  };
  function Companion_158() {
  }
  var Companion_instance_158;
  function Companion_getInstance_158() {
    return Companion_instance_158;
  }
  function Netherlands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NLD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Netherlands' : englishName;
    arabicName = arabicName === VOID ? '\u0647\u0648\u0644\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.b1g_1 = phoneNumPrefix;
    this.c1g_1 = isoCode2;
    this.d1g_1 = isoCode3;
    this.e1g_1 = currency;
    this.f1g_1 = englishName;
    this.g1g_1 = arabicName;
    this.h1g_1 = phoneRegex;
  }
  protoOf(Netherlands).wd = function () {
    return this.b1g_1;
  };
  protoOf(Netherlands).rd = function () {
    return this.c1g_1;
  };
  protoOf(Netherlands).sd = function () {
    return this.d1g_1;
  };
  protoOf(Netherlands).td = function () {
    return this.e1g_1;
  };
  protoOf(Netherlands).ud = function () {
    return this.f1g_1;
  };
  protoOf(Netherlands).vd = function () {
    return this.g1g_1;
  };
  protoOf(Netherlands).xd = function () {
    return this.h1g_1;
  };
  protoOf(Netherlands).toString = function () {
    return 'Netherlands(phoneNumPrefix=' + this.b1g_1.toString() + ', isoCode2=' + this.c1g_1 + ', isoCode3=' + this.d1g_1 + ', currency=' + toString(this.e1g_1) + ', englishName=' + this.f1g_1 + ', arabicName=' + this.g1g_1 + ', phoneRegex=' + this.h1g_1 + ')';
  };
  protoOf(Netherlands).hashCode = function () {
    var result = this.b1g_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1g_1) | 0;
    result = imul(result, 31) + hashCode(this.e1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1g_1) | 0;
    return result;
  };
  protoOf(Netherlands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Netherlands))
      return false;
    var tmp0_other_with_cast = other instanceof Netherlands ? other : THROW_CCE();
    if (!this.b1g_1.equals(tmp0_other_with_cast.b1g_1))
      return false;
    if (!(this.c1g_1 === tmp0_other_with_cast.c1g_1))
      return false;
    if (!(this.d1g_1 === tmp0_other_with_cast.d1g_1))
      return false;
    if (!equals(this.e1g_1, tmp0_other_with_cast.e1g_1))
      return false;
    if (!(this.f1g_1 === tmp0_other_with_cast.f1g_1))
      return false;
    if (!(this.g1g_1 === tmp0_other_with_cast.g1g_1))
      return false;
    if (!(this.h1g_1 === tmp0_other_with_cast.h1g_1))
      return false;
    return true;
  };
  function Companion_159() {
  }
  var Companion_instance_159;
  function Companion_getInstance_159() {
    return Companion_instance_159;
  }
  function NewCaledonia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NCL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'New Caledonia' : englishName;
    arabicName = arabicName === VOID ? '\u0643\u0627\u0644\u064A\u062F\u0648\u0646\u064A\u0627 \u0627\u0644\u062C\u062F\u064A\u062F\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.i1g_1 = phoneNumPrefix;
    this.j1g_1 = isoCode2;
    this.k1g_1 = isoCode3;
    this.l1g_1 = currency;
    this.m1g_1 = englishName;
    this.n1g_1 = arabicName;
    this.o1g_1 = phoneRegex;
  }
  protoOf(NewCaledonia).wd = function () {
    return this.i1g_1;
  };
  protoOf(NewCaledonia).rd = function () {
    return this.j1g_1;
  };
  protoOf(NewCaledonia).sd = function () {
    return this.k1g_1;
  };
  protoOf(NewCaledonia).td = function () {
    return this.l1g_1;
  };
  protoOf(NewCaledonia).ud = function () {
    return this.m1g_1;
  };
  protoOf(NewCaledonia).vd = function () {
    return this.n1g_1;
  };
  protoOf(NewCaledonia).xd = function () {
    return this.o1g_1;
  };
  protoOf(NewCaledonia).toString = function () {
    return 'NewCaledonia(phoneNumPrefix=' + this.i1g_1.toString() + ', isoCode2=' + this.j1g_1 + ', isoCode3=' + this.k1g_1 + ', currency=' + toString(this.l1g_1) + ', englishName=' + this.m1g_1 + ', arabicName=' + this.n1g_1 + ', phoneRegex=' + this.o1g_1 + ')';
  };
  protoOf(NewCaledonia).hashCode = function () {
    var result = this.i1g_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1g_1) | 0;
    result = imul(result, 31) + hashCode(this.l1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1g_1) | 0;
    return result;
  };
  protoOf(NewCaledonia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NewCaledonia))
      return false;
    var tmp0_other_with_cast = other instanceof NewCaledonia ? other : THROW_CCE();
    if (!this.i1g_1.equals(tmp0_other_with_cast.i1g_1))
      return false;
    if (!(this.j1g_1 === tmp0_other_with_cast.j1g_1))
      return false;
    if (!(this.k1g_1 === tmp0_other_with_cast.k1g_1))
      return false;
    if (!equals(this.l1g_1, tmp0_other_with_cast.l1g_1))
      return false;
    if (!(this.m1g_1 === tmp0_other_with_cast.m1g_1))
      return false;
    if (!(this.n1g_1 === tmp0_other_with_cast.n1g_1))
      return false;
    if (!(this.o1g_1 === tmp0_other_with_cast.o1g_1))
      return false;
    return true;
  };
  function Companion_160() {
  }
  var Companion_instance_160;
  function Companion_getInstance_160() {
    return Companion_instance_160;
  }
  function NewZealand(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NZL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'New Zealand' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.p1g_1 = phoneNumPrefix;
    this.q1g_1 = isoCode2;
    this.r1g_1 = isoCode3;
    this.s1g_1 = currency;
    this.t1g_1 = englishName;
    this.u1g_1 = arabicName;
    this.v1g_1 = phoneRegex;
  }
  protoOf(NewZealand).wd = function () {
    return this.p1g_1;
  };
  protoOf(NewZealand).rd = function () {
    return this.q1g_1;
  };
  protoOf(NewZealand).sd = function () {
    return this.r1g_1;
  };
  protoOf(NewZealand).td = function () {
    return this.s1g_1;
  };
  protoOf(NewZealand).ud = function () {
    return this.t1g_1;
  };
  protoOf(NewZealand).vd = function () {
    return this.u1g_1;
  };
  protoOf(NewZealand).xd = function () {
    return this.v1g_1;
  };
  protoOf(NewZealand).toString = function () {
    return 'NewZealand(phoneNumPrefix=' + this.p1g_1.toString() + ', isoCode2=' + this.q1g_1 + ', isoCode3=' + this.r1g_1 + ', currency=' + toString(this.s1g_1) + ', englishName=' + this.t1g_1 + ', arabicName=' + this.u1g_1 + ', phoneRegex=' + this.v1g_1 + ')';
  };
  protoOf(NewZealand).hashCode = function () {
    var result = this.p1g_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1g_1) | 0;
    result = imul(result, 31) + hashCode(this.s1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1g_1) | 0;
    return result;
  };
  protoOf(NewZealand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NewZealand))
      return false;
    var tmp0_other_with_cast = other instanceof NewZealand ? other : THROW_CCE();
    if (!this.p1g_1.equals(tmp0_other_with_cast.p1g_1))
      return false;
    if (!(this.q1g_1 === tmp0_other_with_cast.q1g_1))
      return false;
    if (!(this.r1g_1 === tmp0_other_with_cast.r1g_1))
      return false;
    if (!equals(this.s1g_1, tmp0_other_with_cast.s1g_1))
      return false;
    if (!(this.t1g_1 === tmp0_other_with_cast.t1g_1))
      return false;
    if (!(this.u1g_1 === tmp0_other_with_cast.u1g_1))
      return false;
    if (!(this.v1g_1 === tmp0_other_with_cast.v1g_1))
      return false;
    return true;
  };
  function Companion_161() {
  }
  var Companion_instance_161;
  function Companion_getInstance_161() {
    return Companion_instance_161;
  }
  function Nicaragua(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NIC' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Nicaragua' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u064A\u0643\u0627\u0631\u0627\u063A\u0648\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.w1g_1 = phoneNumPrefix;
    this.x1g_1 = isoCode2;
    this.y1g_1 = isoCode3;
    this.z1g_1 = currency;
    this.a1h_1 = englishName;
    this.b1h_1 = arabicName;
    this.c1h_1 = phoneRegex;
  }
  protoOf(Nicaragua).wd = function () {
    return this.w1g_1;
  };
  protoOf(Nicaragua).rd = function () {
    return this.x1g_1;
  };
  protoOf(Nicaragua).sd = function () {
    return this.y1g_1;
  };
  protoOf(Nicaragua).td = function () {
    return this.z1g_1;
  };
  protoOf(Nicaragua).ud = function () {
    return this.a1h_1;
  };
  protoOf(Nicaragua).vd = function () {
    return this.b1h_1;
  };
  protoOf(Nicaragua).xd = function () {
    return this.c1h_1;
  };
  protoOf(Nicaragua).toString = function () {
    return 'Nicaragua(phoneNumPrefix=' + this.w1g_1.toString() + ', isoCode2=' + this.x1g_1 + ', isoCode3=' + this.y1g_1 + ', currency=' + toString(this.z1g_1) + ', englishName=' + this.a1h_1 + ', arabicName=' + this.b1h_1 + ', phoneRegex=' + this.c1h_1 + ')';
  };
  protoOf(Nicaragua).hashCode = function () {
    var result = this.w1g_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.x1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1g_1) | 0;
    result = imul(result, 31) + hashCode(this.z1g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1h_1) | 0;
    return result;
  };
  protoOf(Nicaragua).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Nicaragua))
      return false;
    var tmp0_other_with_cast = other instanceof Nicaragua ? other : THROW_CCE();
    if (!this.w1g_1.equals(tmp0_other_with_cast.w1g_1))
      return false;
    if (!(this.x1g_1 === tmp0_other_with_cast.x1g_1))
      return false;
    if (!(this.y1g_1 === tmp0_other_with_cast.y1g_1))
      return false;
    if (!equals(this.z1g_1, tmp0_other_with_cast.z1g_1))
      return false;
    if (!(this.a1h_1 === tmp0_other_with_cast.a1h_1))
      return false;
    if (!(this.b1h_1 === tmp0_other_with_cast.b1h_1))
      return false;
    if (!(this.c1h_1 === tmp0_other_with_cast.c1h_1))
      return false;
    return true;
  };
  function Companion_162() {
  }
  var Companion_instance_162;
  function Companion_getInstance_162() {
    return Companion_instance_162;
  }
  function Niger(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NER' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Niger' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0646\u064A\u062C\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.d1h_1 = phoneNumPrefix;
    this.e1h_1 = isoCode2;
    this.f1h_1 = isoCode3;
    this.g1h_1 = currency;
    this.h1h_1 = englishName;
    this.i1h_1 = arabicName;
    this.j1h_1 = phoneRegex;
  }
  protoOf(Niger).wd = function () {
    return this.d1h_1;
  };
  protoOf(Niger).rd = function () {
    return this.e1h_1;
  };
  protoOf(Niger).sd = function () {
    return this.f1h_1;
  };
  protoOf(Niger).td = function () {
    return this.g1h_1;
  };
  protoOf(Niger).ud = function () {
    return this.h1h_1;
  };
  protoOf(Niger).vd = function () {
    return this.i1h_1;
  };
  protoOf(Niger).xd = function () {
    return this.j1h_1;
  };
  protoOf(Niger).toString = function () {
    return 'Niger(phoneNumPrefix=' + this.d1h_1.toString() + ', isoCode2=' + this.e1h_1 + ', isoCode3=' + this.f1h_1 + ', currency=' + toString(this.g1h_1) + ', englishName=' + this.h1h_1 + ', arabicName=' + this.i1h_1 + ', phoneRegex=' + this.j1h_1 + ')';
  };
  protoOf(Niger).hashCode = function () {
    var result = this.d1h_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1h_1) | 0;
    result = imul(result, 31) + hashCode(this.g1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1h_1) | 0;
    return result;
  };
  protoOf(Niger).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Niger))
      return false;
    var tmp0_other_with_cast = other instanceof Niger ? other : THROW_CCE();
    if (!this.d1h_1.equals(tmp0_other_with_cast.d1h_1))
      return false;
    if (!(this.e1h_1 === tmp0_other_with_cast.e1h_1))
      return false;
    if (!(this.f1h_1 === tmp0_other_with_cast.f1h_1))
      return false;
    if (!equals(this.g1h_1, tmp0_other_with_cast.g1h_1))
      return false;
    if (!(this.h1h_1 === tmp0_other_with_cast.h1h_1))
      return false;
    if (!(this.i1h_1 === tmp0_other_with_cast.i1h_1))
      return false;
    if (!(this.j1h_1 === tmp0_other_with_cast.j1h_1))
      return false;
    return true;
  };
  function Companion_163() {
  }
  var Companion_instance_163;
  function Companion_getInstance_163() {
    return Companion_instance_163;
  }
  function Nigeria(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(234, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NGA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Nigeria' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u064A\u062C\u064A\u0631\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '8021234567' : phoneNumberHint;
    this.pb_1 = phoneNumPrefix;
    this.qb_1 = isoCode2;
    this.rb_1 = isoCode3;
    this.sb_1 = currency;
    this.tb_1 = englishName;
    this.ub_1 = arabicName;
    this.vb_1 = phoneRegex;
    this.wb_1 = phoneNumberHint;
  }
  protoOf(Nigeria).wd = function () {
    return this.pb_1;
  };
  protoOf(Nigeria).rd = function () {
    return this.qb_1;
  };
  protoOf(Nigeria).sd = function () {
    return this.rb_1;
  };
  protoOf(Nigeria).td = function () {
    return this.sb_1;
  };
  protoOf(Nigeria).ud = function () {
    return this.tb_1;
  };
  protoOf(Nigeria).vd = function () {
    return this.ub_1;
  };
  protoOf(Nigeria).xd = function () {
    return this.vb_1;
  };
  protoOf(Nigeria).yd = function () {
    return this.wb_1;
  };
  protoOf(Nigeria).toString = function () {
    return 'Nigeria(phoneNumPrefix=' + this.pb_1.toString() + ', isoCode2=' + this.qb_1 + ', isoCode3=' + this.rb_1 + ', currency=' + toString(this.sb_1) + ', englishName=' + this.tb_1 + ', arabicName=' + this.ub_1 + ', phoneRegex=' + this.vb_1 + ', phoneNumberHint=' + this.wb_1 + ')';
  };
  protoOf(Nigeria).hashCode = function () {
    var result = this.pb_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.qb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rb_1) | 0;
    result = imul(result, 31) + hashCode(this.sb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ub_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wb_1) | 0;
    return result;
  };
  protoOf(Nigeria).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Nigeria))
      return false;
    var tmp0_other_with_cast = other instanceof Nigeria ? other : THROW_CCE();
    if (!this.pb_1.equals(tmp0_other_with_cast.pb_1))
      return false;
    if (!(this.qb_1 === tmp0_other_with_cast.qb_1))
      return false;
    if (!(this.rb_1 === tmp0_other_with_cast.rb_1))
      return false;
    if (!equals(this.sb_1, tmp0_other_with_cast.sb_1))
      return false;
    if (!(this.tb_1 === tmp0_other_with_cast.tb_1))
      return false;
    if (!(this.ub_1 === tmp0_other_with_cast.ub_1))
      return false;
    if (!(this.vb_1 === tmp0_other_with_cast.vb_1))
      return false;
    if (!(this.wb_1 === tmp0_other_with_cast.wb_1))
      return false;
    return true;
  };
  function Companion_164() {
  }
  var Companion_instance_164;
  function Companion_getInstance_164() {
    return Companion_instance_164;
  }
  function Niue(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NIU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Niue' : englishName;
    arabicName = arabicName === VOID ? '\u0646\u064A\u064A\u0648\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.k1h_1 = phoneNumPrefix;
    this.l1h_1 = isoCode2;
    this.m1h_1 = isoCode3;
    this.n1h_1 = currency;
    this.o1h_1 = englishName;
    this.p1h_1 = arabicName;
    this.q1h_1 = phoneRegex;
  }
  protoOf(Niue).wd = function () {
    return this.k1h_1;
  };
  protoOf(Niue).rd = function () {
    return this.l1h_1;
  };
  protoOf(Niue).sd = function () {
    return this.m1h_1;
  };
  protoOf(Niue).td = function () {
    return this.n1h_1;
  };
  protoOf(Niue).ud = function () {
    return this.o1h_1;
  };
  protoOf(Niue).vd = function () {
    return this.p1h_1;
  };
  protoOf(Niue).xd = function () {
    return this.q1h_1;
  };
  protoOf(Niue).toString = function () {
    return 'Niue(phoneNumPrefix=' + this.k1h_1.toString() + ', isoCode2=' + this.l1h_1 + ', isoCode3=' + this.m1h_1 + ', currency=' + toString(this.n1h_1) + ', englishName=' + this.o1h_1 + ', arabicName=' + this.p1h_1 + ', phoneRegex=' + this.q1h_1 + ')';
  };
  protoOf(Niue).hashCode = function () {
    var result = this.k1h_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.l1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1h_1) | 0;
    result = imul(result, 31) + hashCode(this.n1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1h_1) | 0;
    return result;
  };
  protoOf(Niue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Niue))
      return false;
    var tmp0_other_with_cast = other instanceof Niue ? other : THROW_CCE();
    if (!this.k1h_1.equals(tmp0_other_with_cast.k1h_1))
      return false;
    if (!(this.l1h_1 === tmp0_other_with_cast.l1h_1))
      return false;
    if (!(this.m1h_1 === tmp0_other_with_cast.m1h_1))
      return false;
    if (!equals(this.n1h_1, tmp0_other_with_cast.n1h_1))
      return false;
    if (!(this.o1h_1 === tmp0_other_with_cast.o1h_1))
      return false;
    if (!(this.p1h_1 === tmp0_other_with_cast.p1h_1))
      return false;
    if (!(this.q1h_1 === tmp0_other_with_cast.q1h_1))
      return false;
    return true;
  };
  function Companion_165() {
  }
  var Companion_instance_165;
  function Companion_getInstance_165() {
    return Companion_instance_165;
  }
  function NorfolkIsland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NFK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Norfolk Island' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u064A\u0631\u0629 \u0646\u0648\u0631\u0641\u0648\u0644\u0643' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.r1h_1 = phoneNumPrefix;
    this.s1h_1 = isoCode2;
    this.t1h_1 = isoCode3;
    this.u1h_1 = currency;
    this.v1h_1 = englishName;
    this.w1h_1 = arabicName;
    this.x1h_1 = phoneRegex;
  }
  protoOf(NorfolkIsland).wd = function () {
    return this.r1h_1;
  };
  protoOf(NorfolkIsland).rd = function () {
    return this.s1h_1;
  };
  protoOf(NorfolkIsland).sd = function () {
    return this.t1h_1;
  };
  protoOf(NorfolkIsland).td = function () {
    return this.u1h_1;
  };
  protoOf(NorfolkIsland).ud = function () {
    return this.v1h_1;
  };
  protoOf(NorfolkIsland).vd = function () {
    return this.w1h_1;
  };
  protoOf(NorfolkIsland).xd = function () {
    return this.x1h_1;
  };
  protoOf(NorfolkIsland).toString = function () {
    return 'NorfolkIsland(phoneNumPrefix=' + this.r1h_1.toString() + ', isoCode2=' + this.s1h_1 + ', isoCode3=' + this.t1h_1 + ', currency=' + toString(this.u1h_1) + ', englishName=' + this.v1h_1 + ', arabicName=' + this.w1h_1 + ', phoneRegex=' + this.x1h_1 + ')';
  };
  protoOf(NorfolkIsland).hashCode = function () {
    var result = this.r1h_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.s1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1h_1) | 0;
    result = imul(result, 31) + hashCode(this.u1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1h_1) | 0;
    return result;
  };
  protoOf(NorfolkIsland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NorfolkIsland))
      return false;
    var tmp0_other_with_cast = other instanceof NorfolkIsland ? other : THROW_CCE();
    if (!this.r1h_1.equals(tmp0_other_with_cast.r1h_1))
      return false;
    if (!(this.s1h_1 === tmp0_other_with_cast.s1h_1))
      return false;
    if (!(this.t1h_1 === tmp0_other_with_cast.t1h_1))
      return false;
    if (!equals(this.u1h_1, tmp0_other_with_cast.u1h_1))
      return false;
    if (!(this.v1h_1 === tmp0_other_with_cast.v1h_1))
      return false;
    if (!(this.w1h_1 === tmp0_other_with_cast.w1h_1))
      return false;
    if (!(this.x1h_1 === tmp0_other_with_cast.x1h_1))
      return false;
    return true;
  };
  function Companion_166() {
  }
  var Companion_instance_166;
  function Companion_getInstance_166() {
    return Companion_instance_166;
  }
  function NorthernMarianaIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MP' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MNP' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Northern Mariana Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0645\u0627\u0631\u064A\u0627\u0646\u0627 \u0627\u0644\u0634\u0645\u0627\u0644\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.y1h_1 = phoneNumPrefix;
    this.z1h_1 = isoCode2;
    this.a1i_1 = isoCode3;
    this.b1i_1 = currency;
    this.c1i_1 = englishName;
    this.d1i_1 = arabicName;
    this.e1i_1 = phoneRegex;
  }
  protoOf(NorthernMarianaIslands).wd = function () {
    return this.y1h_1;
  };
  protoOf(NorthernMarianaIslands).rd = function () {
    return this.z1h_1;
  };
  protoOf(NorthernMarianaIslands).sd = function () {
    return this.a1i_1;
  };
  protoOf(NorthernMarianaIslands).td = function () {
    return this.b1i_1;
  };
  protoOf(NorthernMarianaIslands).ud = function () {
    return this.c1i_1;
  };
  protoOf(NorthernMarianaIslands).vd = function () {
    return this.d1i_1;
  };
  protoOf(NorthernMarianaIslands).xd = function () {
    return this.e1i_1;
  };
  protoOf(NorthernMarianaIslands).toString = function () {
    return 'NorthernMarianaIslands(phoneNumPrefix=' + this.y1h_1.toString() + ', isoCode2=' + this.z1h_1 + ', isoCode3=' + this.a1i_1 + ', currency=' + toString(this.b1i_1) + ', englishName=' + this.c1i_1 + ', arabicName=' + this.d1i_1 + ', phoneRegex=' + this.e1i_1 + ')';
  };
  protoOf(NorthernMarianaIslands).hashCode = function () {
    var result = this.y1h_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.z1h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1i_1) | 0;
    result = imul(result, 31) + hashCode(this.b1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1i_1) | 0;
    return result;
  };
  protoOf(NorthernMarianaIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NorthernMarianaIslands))
      return false;
    var tmp0_other_with_cast = other instanceof NorthernMarianaIslands ? other : THROW_CCE();
    if (!this.y1h_1.equals(tmp0_other_with_cast.y1h_1))
      return false;
    if (!(this.z1h_1 === tmp0_other_with_cast.z1h_1))
      return false;
    if (!(this.a1i_1 === tmp0_other_with_cast.a1i_1))
      return false;
    if (!equals(this.b1i_1, tmp0_other_with_cast.b1i_1))
      return false;
    if (!(this.c1i_1 === tmp0_other_with_cast.c1i_1))
      return false;
    if (!(this.d1i_1 === tmp0_other_with_cast.d1i_1))
      return false;
    if (!(this.e1i_1 === tmp0_other_with_cast.e1i_1))
      return false;
    return true;
  };
  function Companion_167() {
  }
  var Companion_instance_167;
  function Companion_getInstance_167() {
    return Companion_instance_167;
  }
  function Norway(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'NO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'NOR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Norway' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0646\u0631\u0648\u064A\u062C' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.f1i_1 = phoneNumPrefix;
    this.g1i_1 = isoCode2;
    this.h1i_1 = isoCode3;
    this.i1i_1 = currency;
    this.j1i_1 = englishName;
    this.k1i_1 = arabicName;
    this.l1i_1 = phoneRegex;
  }
  protoOf(Norway).wd = function () {
    return this.f1i_1;
  };
  protoOf(Norway).rd = function () {
    return this.g1i_1;
  };
  protoOf(Norway).sd = function () {
    return this.h1i_1;
  };
  protoOf(Norway).td = function () {
    return this.i1i_1;
  };
  protoOf(Norway).ud = function () {
    return this.j1i_1;
  };
  protoOf(Norway).vd = function () {
    return this.k1i_1;
  };
  protoOf(Norway).xd = function () {
    return this.l1i_1;
  };
  protoOf(Norway).toString = function () {
    return 'Norway(phoneNumPrefix=' + this.f1i_1.toString() + ', isoCode2=' + this.g1i_1 + ', isoCode3=' + this.h1i_1 + ', currency=' + toString(this.i1i_1) + ', englishName=' + this.j1i_1 + ', arabicName=' + this.k1i_1 + ', phoneRegex=' + this.l1i_1 + ')';
  };
  protoOf(Norway).hashCode = function () {
    var result = this.f1i_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1i_1) | 0;
    result = imul(result, 31) + hashCode(this.i1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1i_1) | 0;
    return result;
  };
  protoOf(Norway).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Norway))
      return false;
    var tmp0_other_with_cast = other instanceof Norway ? other : THROW_CCE();
    if (!this.f1i_1.equals(tmp0_other_with_cast.f1i_1))
      return false;
    if (!(this.g1i_1 === tmp0_other_with_cast.g1i_1))
      return false;
    if (!(this.h1i_1 === tmp0_other_with_cast.h1i_1))
      return false;
    if (!equals(this.i1i_1, tmp0_other_with_cast.i1i_1))
      return false;
    if (!(this.j1i_1 === tmp0_other_with_cast.j1i_1))
      return false;
    if (!(this.k1i_1 === tmp0_other_with_cast.k1i_1))
      return false;
    if (!(this.l1i_1 === tmp0_other_with_cast.l1i_1))
      return false;
    return true;
  };
  function Companion_168() {
  }
  var Companion_instance_168;
  function Companion_getInstance_168() {
    return Companion_instance_168;
  }
  function Oman(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(968, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'OM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'OMN' : isoCode3;
    currency = currency === VOID ? OMR_getInstance() : currency;
    englishName = englishName === VOID ? 'Oman' : englishName;
    arabicName = arabicName === VOID ? '\u0639\u0645\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? '^(00968|968|\\+968)?[279]([0-9]{7})$' : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '96821234567' : phoneNumberHint;
    this.v4_1 = phoneNumPrefix;
    this.w4_1 = isoCode2;
    this.x4_1 = isoCode3;
    this.y4_1 = currency;
    this.z4_1 = englishName;
    this.a5_1 = arabicName;
    this.b5_1 = phoneRegex;
    this.c5_1 = phoneNumberHint;
  }
  protoOf(Oman).wd = function () {
    return this.v4_1;
  };
  protoOf(Oman).rd = function () {
    return this.w4_1;
  };
  protoOf(Oman).sd = function () {
    return this.x4_1;
  };
  protoOf(Oman).td = function () {
    return this.y4_1;
  };
  protoOf(Oman).ud = function () {
    return this.z4_1;
  };
  protoOf(Oman).vd = function () {
    return this.a5_1;
  };
  protoOf(Oman).xd = function () {
    return this.b5_1;
  };
  protoOf(Oman).yd = function () {
    return this.c5_1;
  };
  protoOf(Oman).toString = function () {
    return 'Oman(phoneNumPrefix=' + this.v4_1.toString() + ', isoCode2=' + this.w4_1 + ', isoCode3=' + this.x4_1 + ', currency=' + toString(this.y4_1) + ', englishName=' + this.z4_1 + ', arabicName=' + this.a5_1 + ', phoneRegex=' + this.b5_1 + ', phoneNumberHint=' + this.c5_1 + ')';
  };
  protoOf(Oman).hashCode = function () {
    var result = this.v4_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w4_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x4_1) | 0;
    result = imul(result, 31) + hashCode(this.y4_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z4_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c5_1) | 0;
    return result;
  };
  protoOf(Oman).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Oman))
      return false;
    var tmp0_other_with_cast = other instanceof Oman ? other : THROW_CCE();
    if (!this.v4_1.equals(tmp0_other_with_cast.v4_1))
      return false;
    if (!(this.w4_1 === tmp0_other_with_cast.w4_1))
      return false;
    if (!(this.x4_1 === tmp0_other_with_cast.x4_1))
      return false;
    if (!equals(this.y4_1, tmp0_other_with_cast.y4_1))
      return false;
    if (!(this.z4_1 === tmp0_other_with_cast.z4_1))
      return false;
    if (!(this.a5_1 === tmp0_other_with_cast.a5_1))
      return false;
    if (!(this.b5_1 === tmp0_other_with_cast.b5_1))
      return false;
    if (!(this.c5_1 === tmp0_other_with_cast.c5_1))
      return false;
    return true;
  };
  function Companion_169() {
  }
  var Companion_instance_169;
  function Companion_getInstance_169() {
    return Companion_instance_169;
  }
  function Pakistan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(92, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PAK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Pakistan' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0627\u0643\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '3012345678' : phoneNumberHint;
    this.t9_1 = phoneNumPrefix;
    this.u9_1 = isoCode2;
    this.v9_1 = isoCode3;
    this.w9_1 = currency;
    this.x9_1 = englishName;
    this.y9_1 = arabicName;
    this.z9_1 = phoneRegex;
    this.aa_1 = phoneNumberHint;
  }
  protoOf(Pakistan).wd = function () {
    return this.t9_1;
  };
  protoOf(Pakistan).rd = function () {
    return this.u9_1;
  };
  protoOf(Pakistan).sd = function () {
    return this.v9_1;
  };
  protoOf(Pakistan).td = function () {
    return this.w9_1;
  };
  protoOf(Pakistan).ud = function () {
    return this.x9_1;
  };
  protoOf(Pakistan).vd = function () {
    return this.y9_1;
  };
  protoOf(Pakistan).xd = function () {
    return this.z9_1;
  };
  protoOf(Pakistan).yd = function () {
    return this.aa_1;
  };
  protoOf(Pakistan).toString = function () {
    return 'Pakistan(phoneNumPrefix=' + this.t9_1.toString() + ', isoCode2=' + this.u9_1 + ', isoCode3=' + this.v9_1 + ', currency=' + toString(this.w9_1) + ', englishName=' + this.x9_1 + ', arabicName=' + this.y9_1 + ', phoneRegex=' + this.z9_1 + ', phoneNumberHint=' + this.aa_1 + ')';
  };
  protoOf(Pakistan).hashCode = function () {
    var result = this.t9_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v9_1) | 0;
    result = imul(result, 31) + hashCode(this.w9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.aa_1) | 0;
    return result;
  };
  protoOf(Pakistan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pakistan))
      return false;
    var tmp0_other_with_cast = other instanceof Pakistan ? other : THROW_CCE();
    if (!this.t9_1.equals(tmp0_other_with_cast.t9_1))
      return false;
    if (!(this.u9_1 === tmp0_other_with_cast.u9_1))
      return false;
    if (!(this.v9_1 === tmp0_other_with_cast.v9_1))
      return false;
    if (!equals(this.w9_1, tmp0_other_with_cast.w9_1))
      return false;
    if (!(this.x9_1 === tmp0_other_with_cast.x9_1))
      return false;
    if (!(this.y9_1 === tmp0_other_with_cast.y9_1))
      return false;
    if (!(this.z9_1 === tmp0_other_with_cast.z9_1))
      return false;
    if (!(this.aa_1 === tmp0_other_with_cast.aa_1))
      return false;
    return true;
  };
  function Companion_170() {
  }
  var Companion_instance_170;
  function Companion_getInstance_170() {
    return Companion_instance_170;
  }
  function Palau(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PLW' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Palau' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0627\u0644\u0627\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.m1i_1 = phoneNumPrefix;
    this.n1i_1 = isoCode2;
    this.o1i_1 = isoCode3;
    this.p1i_1 = currency;
    this.q1i_1 = englishName;
    this.r1i_1 = arabicName;
    this.s1i_1 = phoneRegex;
  }
  protoOf(Palau).wd = function () {
    return this.m1i_1;
  };
  protoOf(Palau).rd = function () {
    return this.n1i_1;
  };
  protoOf(Palau).sd = function () {
    return this.o1i_1;
  };
  protoOf(Palau).td = function () {
    return this.p1i_1;
  };
  protoOf(Palau).ud = function () {
    return this.q1i_1;
  };
  protoOf(Palau).vd = function () {
    return this.r1i_1;
  };
  protoOf(Palau).xd = function () {
    return this.s1i_1;
  };
  protoOf(Palau).toString = function () {
    return 'Palau(phoneNumPrefix=' + this.m1i_1.toString() + ', isoCode2=' + this.n1i_1 + ', isoCode3=' + this.o1i_1 + ', currency=' + toString(this.p1i_1) + ', englishName=' + this.q1i_1 + ', arabicName=' + this.r1i_1 + ', phoneRegex=' + this.s1i_1 + ')';
  };
  protoOf(Palau).hashCode = function () {
    var result = this.m1i_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.n1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1i_1) | 0;
    result = imul(result, 31) + hashCode(this.p1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1i_1) | 0;
    return result;
  };
  protoOf(Palau).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Palau))
      return false;
    var tmp0_other_with_cast = other instanceof Palau ? other : THROW_CCE();
    if (!this.m1i_1.equals(tmp0_other_with_cast.m1i_1))
      return false;
    if (!(this.n1i_1 === tmp0_other_with_cast.n1i_1))
      return false;
    if (!(this.o1i_1 === tmp0_other_with_cast.o1i_1))
      return false;
    if (!equals(this.p1i_1, tmp0_other_with_cast.p1i_1))
      return false;
    if (!(this.q1i_1 === tmp0_other_with_cast.q1i_1))
      return false;
    if (!(this.r1i_1 === tmp0_other_with_cast.r1i_1))
      return false;
    if (!(this.s1i_1 === tmp0_other_with_cast.s1i_1))
      return false;
    return true;
  };
  function Companion_171() {
  }
  var Companion_instance_171;
  function Companion_getInstance_171() {
    return Companion_instance_171;
  }
  function PalestineStateof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PSE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Palestine, State of' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u0644\u0633\u0637\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.t1i_1 = phoneNumPrefix;
    this.u1i_1 = isoCode2;
    this.v1i_1 = isoCode3;
    this.w1i_1 = currency;
    this.x1i_1 = englishName;
    this.y1i_1 = arabicName;
    this.z1i_1 = phoneRegex;
  }
  protoOf(PalestineStateof).wd = function () {
    return this.t1i_1;
  };
  protoOf(PalestineStateof).rd = function () {
    return this.u1i_1;
  };
  protoOf(PalestineStateof).sd = function () {
    return this.v1i_1;
  };
  protoOf(PalestineStateof).td = function () {
    return this.w1i_1;
  };
  protoOf(PalestineStateof).ud = function () {
    return this.x1i_1;
  };
  protoOf(PalestineStateof).vd = function () {
    return this.y1i_1;
  };
  protoOf(PalestineStateof).xd = function () {
    return this.z1i_1;
  };
  protoOf(PalestineStateof).toString = function () {
    return 'PalestineStateof(phoneNumPrefix=' + this.t1i_1.toString() + ', isoCode2=' + this.u1i_1 + ', isoCode3=' + this.v1i_1 + ', currency=' + toString(this.w1i_1) + ', englishName=' + this.x1i_1 + ', arabicName=' + this.y1i_1 + ', phoneRegex=' + this.z1i_1 + ')';
  };
  protoOf(PalestineStateof).hashCode = function () {
    var result = this.t1i_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1i_1) | 0;
    result = imul(result, 31) + hashCode(this.w1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1i_1) | 0;
    return result;
  };
  protoOf(PalestineStateof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PalestineStateof))
      return false;
    var tmp0_other_with_cast = other instanceof PalestineStateof ? other : THROW_CCE();
    if (!this.t1i_1.equals(tmp0_other_with_cast.t1i_1))
      return false;
    if (!(this.u1i_1 === tmp0_other_with_cast.u1i_1))
      return false;
    if (!(this.v1i_1 === tmp0_other_with_cast.v1i_1))
      return false;
    if (!equals(this.w1i_1, tmp0_other_with_cast.w1i_1))
      return false;
    if (!(this.x1i_1 === tmp0_other_with_cast.x1i_1))
      return false;
    if (!(this.y1i_1 === tmp0_other_with_cast.y1i_1))
      return false;
    if (!(this.z1i_1 === tmp0_other_with_cast.z1i_1))
      return false;
    return true;
  };
  function Companion_172() {
  }
  var Companion_instance_172;
  function Companion_getInstance_172() {
    return Companion_instance_172;
  }
  function Panama(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PAN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Panama' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0646\u0645\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.a1j_1 = phoneNumPrefix;
    this.b1j_1 = isoCode2;
    this.c1j_1 = isoCode3;
    this.d1j_1 = currency;
    this.e1j_1 = englishName;
    this.f1j_1 = arabicName;
    this.g1j_1 = phoneRegex;
  }
  protoOf(Panama).wd = function () {
    return this.a1j_1;
  };
  protoOf(Panama).rd = function () {
    return this.b1j_1;
  };
  protoOf(Panama).sd = function () {
    return this.c1j_1;
  };
  protoOf(Panama).td = function () {
    return this.d1j_1;
  };
  protoOf(Panama).ud = function () {
    return this.e1j_1;
  };
  protoOf(Panama).vd = function () {
    return this.f1j_1;
  };
  protoOf(Panama).xd = function () {
    return this.g1j_1;
  };
  protoOf(Panama).toString = function () {
    return 'Panama(phoneNumPrefix=' + this.a1j_1.toString() + ', isoCode2=' + this.b1j_1 + ', isoCode3=' + this.c1j_1 + ', currency=' + toString(this.d1j_1) + ', englishName=' + this.e1j_1 + ', arabicName=' + this.f1j_1 + ', phoneRegex=' + this.g1j_1 + ')';
  };
  protoOf(Panama).hashCode = function () {
    var result = this.a1j_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1j_1) | 0;
    result = imul(result, 31) + hashCode(this.d1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1j_1) | 0;
    return result;
  };
  protoOf(Panama).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Panama))
      return false;
    var tmp0_other_with_cast = other instanceof Panama ? other : THROW_CCE();
    if (!this.a1j_1.equals(tmp0_other_with_cast.a1j_1))
      return false;
    if (!(this.b1j_1 === tmp0_other_with_cast.b1j_1))
      return false;
    if (!(this.c1j_1 === tmp0_other_with_cast.c1j_1))
      return false;
    if (!equals(this.d1j_1, tmp0_other_with_cast.d1j_1))
      return false;
    if (!(this.e1j_1 === tmp0_other_with_cast.e1j_1))
      return false;
    if (!(this.f1j_1 === tmp0_other_with_cast.f1j_1))
      return false;
    if (!(this.g1j_1 === tmp0_other_with_cast.g1j_1))
      return false;
    return true;
  };
  function Companion_173() {
  }
  var Companion_instance_173;
  function Companion_getInstance_173() {
    return Companion_instance_173;
  }
  function PapuaNewGuinea(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PNG' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Papua New Guinea' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0627\u0628\u0648\u0627 \u063A\u064A\u0646\u064A\u0627 \u0627\u0644\u062C\u062F\u064A\u062F\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.h1j_1 = phoneNumPrefix;
    this.i1j_1 = isoCode2;
    this.j1j_1 = isoCode3;
    this.k1j_1 = currency;
    this.l1j_1 = englishName;
    this.m1j_1 = arabicName;
    this.n1j_1 = phoneRegex;
  }
  protoOf(PapuaNewGuinea).wd = function () {
    return this.h1j_1;
  };
  protoOf(PapuaNewGuinea).rd = function () {
    return this.i1j_1;
  };
  protoOf(PapuaNewGuinea).sd = function () {
    return this.j1j_1;
  };
  protoOf(PapuaNewGuinea).td = function () {
    return this.k1j_1;
  };
  protoOf(PapuaNewGuinea).ud = function () {
    return this.l1j_1;
  };
  protoOf(PapuaNewGuinea).vd = function () {
    return this.m1j_1;
  };
  protoOf(PapuaNewGuinea).xd = function () {
    return this.n1j_1;
  };
  protoOf(PapuaNewGuinea).toString = function () {
    return 'PapuaNewGuinea(phoneNumPrefix=' + this.h1j_1.toString() + ', isoCode2=' + this.i1j_1 + ', isoCode3=' + this.j1j_1 + ', currency=' + toString(this.k1j_1) + ', englishName=' + this.l1j_1 + ', arabicName=' + this.m1j_1 + ', phoneRegex=' + this.n1j_1 + ')';
  };
  protoOf(PapuaNewGuinea).hashCode = function () {
    var result = this.h1j_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1j_1) | 0;
    result = imul(result, 31) + hashCode(this.k1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1j_1) | 0;
    return result;
  };
  protoOf(PapuaNewGuinea).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PapuaNewGuinea))
      return false;
    var tmp0_other_with_cast = other instanceof PapuaNewGuinea ? other : THROW_CCE();
    if (!this.h1j_1.equals(tmp0_other_with_cast.h1j_1))
      return false;
    if (!(this.i1j_1 === tmp0_other_with_cast.i1j_1))
      return false;
    if (!(this.j1j_1 === tmp0_other_with_cast.j1j_1))
      return false;
    if (!equals(this.k1j_1, tmp0_other_with_cast.k1j_1))
      return false;
    if (!(this.l1j_1 === tmp0_other_with_cast.l1j_1))
      return false;
    if (!(this.m1j_1 === tmp0_other_with_cast.m1j_1))
      return false;
    if (!(this.n1j_1 === tmp0_other_with_cast.n1j_1))
      return false;
    return true;
  };
  function Companion_174() {
  }
  var Companion_instance_174;
  function Companion_getInstance_174() {
    return Companion_instance_174;
  }
  function Paraguay(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PRY' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Paraguay' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0627\u0631\u0627\u063A\u0648\u0627\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.o1j_1 = phoneNumPrefix;
    this.p1j_1 = isoCode2;
    this.q1j_1 = isoCode3;
    this.r1j_1 = currency;
    this.s1j_1 = englishName;
    this.t1j_1 = arabicName;
    this.u1j_1 = phoneRegex;
  }
  protoOf(Paraguay).wd = function () {
    return this.o1j_1;
  };
  protoOf(Paraguay).rd = function () {
    return this.p1j_1;
  };
  protoOf(Paraguay).sd = function () {
    return this.q1j_1;
  };
  protoOf(Paraguay).td = function () {
    return this.r1j_1;
  };
  protoOf(Paraguay).ud = function () {
    return this.s1j_1;
  };
  protoOf(Paraguay).vd = function () {
    return this.t1j_1;
  };
  protoOf(Paraguay).xd = function () {
    return this.u1j_1;
  };
  protoOf(Paraguay).toString = function () {
    return 'Paraguay(phoneNumPrefix=' + this.o1j_1.toString() + ', isoCode2=' + this.p1j_1 + ', isoCode3=' + this.q1j_1 + ', currency=' + toString(this.r1j_1) + ', englishName=' + this.s1j_1 + ', arabicName=' + this.t1j_1 + ', phoneRegex=' + this.u1j_1 + ')';
  };
  protoOf(Paraguay).hashCode = function () {
    var result = this.o1j_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1j_1) | 0;
    result = imul(result, 31) + hashCode(this.r1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1j_1) | 0;
    return result;
  };
  protoOf(Paraguay).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Paraguay))
      return false;
    var tmp0_other_with_cast = other instanceof Paraguay ? other : THROW_CCE();
    if (!this.o1j_1.equals(tmp0_other_with_cast.o1j_1))
      return false;
    if (!(this.p1j_1 === tmp0_other_with_cast.p1j_1))
      return false;
    if (!(this.q1j_1 === tmp0_other_with_cast.q1j_1))
      return false;
    if (!equals(this.r1j_1, tmp0_other_with_cast.r1j_1))
      return false;
    if (!(this.s1j_1 === tmp0_other_with_cast.s1j_1))
      return false;
    if (!(this.t1j_1 === tmp0_other_with_cast.t1j_1))
      return false;
    if (!(this.u1j_1 === tmp0_other_with_cast.u1j_1))
      return false;
    return true;
  };
  function Companion_175() {
  }
  var Companion_instance_175;
  function Companion_getInstance_175() {
    return Companion_instance_175;
  }
  function Peru(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PER' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Peru' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u064A\u0631\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.v1j_1 = phoneNumPrefix;
    this.w1j_1 = isoCode2;
    this.x1j_1 = isoCode3;
    this.y1j_1 = currency;
    this.z1j_1 = englishName;
    this.a1k_1 = arabicName;
    this.b1k_1 = phoneRegex;
  }
  protoOf(Peru).wd = function () {
    return this.v1j_1;
  };
  protoOf(Peru).rd = function () {
    return this.w1j_1;
  };
  protoOf(Peru).sd = function () {
    return this.x1j_1;
  };
  protoOf(Peru).td = function () {
    return this.y1j_1;
  };
  protoOf(Peru).ud = function () {
    return this.z1j_1;
  };
  protoOf(Peru).vd = function () {
    return this.a1k_1;
  };
  protoOf(Peru).xd = function () {
    return this.b1k_1;
  };
  protoOf(Peru).toString = function () {
    return 'Peru(phoneNumPrefix=' + this.v1j_1.toString() + ', isoCode2=' + this.w1j_1 + ', isoCode3=' + this.x1j_1 + ', currency=' + toString(this.y1j_1) + ', englishName=' + this.z1j_1 + ', arabicName=' + this.a1k_1 + ', phoneRegex=' + this.b1k_1 + ')';
  };
  protoOf(Peru).hashCode = function () {
    var result = this.v1j_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1j_1) | 0;
    result = imul(result, 31) + hashCode(this.y1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1k_1) | 0;
    return result;
  };
  protoOf(Peru).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Peru))
      return false;
    var tmp0_other_with_cast = other instanceof Peru ? other : THROW_CCE();
    if (!this.v1j_1.equals(tmp0_other_with_cast.v1j_1))
      return false;
    if (!(this.w1j_1 === tmp0_other_with_cast.w1j_1))
      return false;
    if (!(this.x1j_1 === tmp0_other_with_cast.x1j_1))
      return false;
    if (!equals(this.y1j_1, tmp0_other_with_cast.y1j_1))
      return false;
    if (!(this.z1j_1 === tmp0_other_with_cast.z1j_1))
      return false;
    if (!(this.a1k_1 === tmp0_other_with_cast.a1k_1))
      return false;
    if (!(this.b1k_1 === tmp0_other_with_cast.b1k_1))
      return false;
    return true;
  };
  function Companion_176() {
  }
  var Companion_instance_176;
  function Companion_getInstance_176() {
    return Companion_instance_176;
  }
  function Philippines(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(63, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PHL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Philippines' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0641\u0644\u0628\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? ': Country9051234567' : phoneNumberHint;
    this.d9_1 = phoneNumPrefix;
    this.e9_1 = isoCode2;
    this.f9_1 = isoCode3;
    this.g9_1 = currency;
    this.h9_1 = englishName;
    this.i9_1 = arabicName;
    this.j9_1 = phoneRegex;
    this.k9_1 = phoneNumberHint;
  }
  protoOf(Philippines).wd = function () {
    return this.d9_1;
  };
  protoOf(Philippines).rd = function () {
    return this.e9_1;
  };
  protoOf(Philippines).sd = function () {
    return this.f9_1;
  };
  protoOf(Philippines).td = function () {
    return this.g9_1;
  };
  protoOf(Philippines).ud = function () {
    return this.h9_1;
  };
  protoOf(Philippines).vd = function () {
    return this.i9_1;
  };
  protoOf(Philippines).xd = function () {
    return this.j9_1;
  };
  protoOf(Philippines).yd = function () {
    return this.k9_1;
  };
  protoOf(Philippines).toString = function () {
    return 'Philippines(phoneNumPrefix=' + this.d9_1.toString() + ', isoCode2=' + this.e9_1 + ', isoCode3=' + this.f9_1 + ', currency=' + toString(this.g9_1) + ', englishName=' + this.h9_1 + ', arabicName=' + this.i9_1 + ', phoneRegex=' + this.j9_1 + ', phoneNumberHint=' + this.k9_1 + ')';
  };
  protoOf(Philippines).hashCode = function () {
    var result = this.d9_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f9_1) | 0;
    result = imul(result, 31) + hashCode(this.g9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k9_1) | 0;
    return result;
  };
  protoOf(Philippines).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Philippines))
      return false;
    var tmp0_other_with_cast = other instanceof Philippines ? other : THROW_CCE();
    if (!this.d9_1.equals(tmp0_other_with_cast.d9_1))
      return false;
    if (!(this.e9_1 === tmp0_other_with_cast.e9_1))
      return false;
    if (!(this.f9_1 === tmp0_other_with_cast.f9_1))
      return false;
    if (!equals(this.g9_1, tmp0_other_with_cast.g9_1))
      return false;
    if (!(this.h9_1 === tmp0_other_with_cast.h9_1))
      return false;
    if (!(this.i9_1 === tmp0_other_with_cast.i9_1))
      return false;
    if (!(this.j9_1 === tmp0_other_with_cast.j9_1))
      return false;
    if (!(this.k9_1 === tmp0_other_with_cast.k9_1))
      return false;
    return true;
  };
  function Companion_177() {
  }
  var Companion_instance_177;
  function Companion_getInstance_177() {
    return Companion_instance_177;
  }
  function Pitcairn(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PCN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Pitcairn' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0628\u064A\u062A\u0643\u064A\u0631\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.c1k_1 = phoneNumPrefix;
    this.d1k_1 = isoCode2;
    this.e1k_1 = isoCode3;
    this.f1k_1 = currency;
    this.g1k_1 = englishName;
    this.h1k_1 = arabicName;
    this.i1k_1 = phoneRegex;
  }
  protoOf(Pitcairn).wd = function () {
    return this.c1k_1;
  };
  protoOf(Pitcairn).rd = function () {
    return this.d1k_1;
  };
  protoOf(Pitcairn).sd = function () {
    return this.e1k_1;
  };
  protoOf(Pitcairn).td = function () {
    return this.f1k_1;
  };
  protoOf(Pitcairn).ud = function () {
    return this.g1k_1;
  };
  protoOf(Pitcairn).vd = function () {
    return this.h1k_1;
  };
  protoOf(Pitcairn).xd = function () {
    return this.i1k_1;
  };
  protoOf(Pitcairn).toString = function () {
    return 'Pitcairn(phoneNumPrefix=' + this.c1k_1.toString() + ', isoCode2=' + this.d1k_1 + ', isoCode3=' + this.e1k_1 + ', currency=' + toString(this.f1k_1) + ', englishName=' + this.g1k_1 + ', arabicName=' + this.h1k_1 + ', phoneRegex=' + this.i1k_1 + ')';
  };
  protoOf(Pitcairn).hashCode = function () {
    var result = this.c1k_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.d1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1k_1) | 0;
    result = imul(result, 31) + hashCode(this.f1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1k_1) | 0;
    return result;
  };
  protoOf(Pitcairn).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pitcairn))
      return false;
    var tmp0_other_with_cast = other instanceof Pitcairn ? other : THROW_CCE();
    if (!this.c1k_1.equals(tmp0_other_with_cast.c1k_1))
      return false;
    if (!(this.d1k_1 === tmp0_other_with_cast.d1k_1))
      return false;
    if (!(this.e1k_1 === tmp0_other_with_cast.e1k_1))
      return false;
    if (!equals(this.f1k_1, tmp0_other_with_cast.f1k_1))
      return false;
    if (!(this.g1k_1 === tmp0_other_with_cast.g1k_1))
      return false;
    if (!(this.h1k_1 === tmp0_other_with_cast.h1k_1))
      return false;
    if (!(this.i1k_1 === tmp0_other_with_cast.i1k_1))
      return false;
    return true;
  };
  function Companion_178() {
  }
  var Companion_instance_178;
  function Companion_getInstance_178() {
    return Companion_instance_178;
  }
  function Poland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'POL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Poland' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u0644\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.j1k_1 = phoneNumPrefix;
    this.k1k_1 = isoCode2;
    this.l1k_1 = isoCode3;
    this.m1k_1 = currency;
    this.n1k_1 = englishName;
    this.o1k_1 = arabicName;
    this.p1k_1 = phoneRegex;
  }
  protoOf(Poland).wd = function () {
    return this.j1k_1;
  };
  protoOf(Poland).rd = function () {
    return this.k1k_1;
  };
  protoOf(Poland).sd = function () {
    return this.l1k_1;
  };
  protoOf(Poland).td = function () {
    return this.m1k_1;
  };
  protoOf(Poland).ud = function () {
    return this.n1k_1;
  };
  protoOf(Poland).vd = function () {
    return this.o1k_1;
  };
  protoOf(Poland).xd = function () {
    return this.p1k_1;
  };
  protoOf(Poland).toString = function () {
    return 'Poland(phoneNumPrefix=' + this.j1k_1.toString() + ', isoCode2=' + this.k1k_1 + ', isoCode3=' + this.l1k_1 + ', currency=' + toString(this.m1k_1) + ', englishName=' + this.n1k_1 + ', arabicName=' + this.o1k_1 + ', phoneRegex=' + this.p1k_1 + ')';
  };
  protoOf(Poland).hashCode = function () {
    var result = this.j1k_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.k1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1k_1) | 0;
    result = imul(result, 31) + hashCode(this.m1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1k_1) | 0;
    return result;
  };
  protoOf(Poland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Poland))
      return false;
    var tmp0_other_with_cast = other instanceof Poland ? other : THROW_CCE();
    if (!this.j1k_1.equals(tmp0_other_with_cast.j1k_1))
      return false;
    if (!(this.k1k_1 === tmp0_other_with_cast.k1k_1))
      return false;
    if (!(this.l1k_1 === tmp0_other_with_cast.l1k_1))
      return false;
    if (!equals(this.m1k_1, tmp0_other_with_cast.m1k_1))
      return false;
    if (!(this.n1k_1 === tmp0_other_with_cast.n1k_1))
      return false;
    if (!(this.o1k_1 === tmp0_other_with_cast.o1k_1))
      return false;
    if (!(this.p1k_1 === tmp0_other_with_cast.p1k_1))
      return false;
    return true;
  };
  function Companion_179() {
  }
  var Companion_instance_179;
  function Companion_getInstance_179() {
    return Companion_instance_179;
  }
  function Portugal(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PRT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Portugal' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0628\u0631\u062A\u063A\u0627\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.q1k_1 = phoneNumPrefix;
    this.r1k_1 = isoCode2;
    this.s1k_1 = isoCode3;
    this.t1k_1 = currency;
    this.u1k_1 = englishName;
    this.v1k_1 = arabicName;
    this.w1k_1 = phoneRegex;
  }
  protoOf(Portugal).wd = function () {
    return this.q1k_1;
  };
  protoOf(Portugal).rd = function () {
    return this.r1k_1;
  };
  protoOf(Portugal).sd = function () {
    return this.s1k_1;
  };
  protoOf(Portugal).td = function () {
    return this.t1k_1;
  };
  protoOf(Portugal).ud = function () {
    return this.u1k_1;
  };
  protoOf(Portugal).vd = function () {
    return this.v1k_1;
  };
  protoOf(Portugal).xd = function () {
    return this.w1k_1;
  };
  protoOf(Portugal).toString = function () {
    return 'Portugal(phoneNumPrefix=' + this.q1k_1.toString() + ', isoCode2=' + this.r1k_1 + ', isoCode3=' + this.s1k_1 + ', currency=' + toString(this.t1k_1) + ', englishName=' + this.u1k_1 + ', arabicName=' + this.v1k_1 + ', phoneRegex=' + this.w1k_1 + ')';
  };
  protoOf(Portugal).hashCode = function () {
    var result = this.q1k_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1k_1) | 0;
    result = imul(result, 31) + hashCode(this.t1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1k_1) | 0;
    return result;
  };
  protoOf(Portugal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Portugal))
      return false;
    var tmp0_other_with_cast = other instanceof Portugal ? other : THROW_CCE();
    if (!this.q1k_1.equals(tmp0_other_with_cast.q1k_1))
      return false;
    if (!(this.r1k_1 === tmp0_other_with_cast.r1k_1))
      return false;
    if (!(this.s1k_1 === tmp0_other_with_cast.s1k_1))
      return false;
    if (!equals(this.t1k_1, tmp0_other_with_cast.t1k_1))
      return false;
    if (!(this.u1k_1 === tmp0_other_with_cast.u1k_1))
      return false;
    if (!(this.v1k_1 === tmp0_other_with_cast.v1k_1))
      return false;
    if (!(this.w1k_1 === tmp0_other_with_cast.w1k_1))
      return false;
    return true;
  };
  function Companion_180() {
  }
  var Companion_instance_180;
  function Companion_getInstance_180() {
    return Companion_instance_180;
  }
  function PuertoRico(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'PRI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Puerto Rico' : englishName;
    arabicName = arabicName === VOID ? '\u0628\u0648\u0631\u062A\u0648\u0631\u064A\u0643\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.x1k_1 = phoneNumPrefix;
    this.y1k_1 = isoCode2;
    this.z1k_1 = isoCode3;
    this.a1l_1 = currency;
    this.b1l_1 = englishName;
    this.c1l_1 = arabicName;
    this.d1l_1 = phoneRegex;
  }
  protoOf(PuertoRico).wd = function () {
    return this.x1k_1;
  };
  protoOf(PuertoRico).rd = function () {
    return this.y1k_1;
  };
  protoOf(PuertoRico).sd = function () {
    return this.z1k_1;
  };
  protoOf(PuertoRico).td = function () {
    return this.a1l_1;
  };
  protoOf(PuertoRico).ud = function () {
    return this.b1l_1;
  };
  protoOf(PuertoRico).vd = function () {
    return this.c1l_1;
  };
  protoOf(PuertoRico).xd = function () {
    return this.d1l_1;
  };
  protoOf(PuertoRico).toString = function () {
    return 'PuertoRico(phoneNumPrefix=' + this.x1k_1.toString() + ', isoCode2=' + this.y1k_1 + ', isoCode3=' + this.z1k_1 + ', currency=' + toString(this.a1l_1) + ', englishName=' + this.b1l_1 + ', arabicName=' + this.c1l_1 + ', phoneRegex=' + this.d1l_1 + ')';
  };
  protoOf(PuertoRico).hashCode = function () {
    var result = this.x1k_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.y1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1k_1) | 0;
    result = imul(result, 31) + hashCode(this.a1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1l_1) | 0;
    return result;
  };
  protoOf(PuertoRico).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PuertoRico))
      return false;
    var tmp0_other_with_cast = other instanceof PuertoRico ? other : THROW_CCE();
    if (!this.x1k_1.equals(tmp0_other_with_cast.x1k_1))
      return false;
    if (!(this.y1k_1 === tmp0_other_with_cast.y1k_1))
      return false;
    if (!(this.z1k_1 === tmp0_other_with_cast.z1k_1))
      return false;
    if (!equals(this.a1l_1, tmp0_other_with_cast.a1l_1))
      return false;
    if (!(this.b1l_1 === tmp0_other_with_cast.b1l_1))
      return false;
    if (!(this.c1l_1 === tmp0_other_with_cast.c1l_1))
      return false;
    if (!(this.d1l_1 === tmp0_other_with_cast.d1l_1))
      return false;
    return true;
  };
  function Companion_181() {
  }
  var Companion_instance_181;
  function Companion_getInstance_181() {
    return Companion_instance_181;
  }
  function Qatar(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(974, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'QA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'QAT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Qatar' : englishName;
    arabicName = arabicName === VOID ? '\u0642\u0637\u0631' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(8) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '33123456' : phoneNumberHint;
    this.hb_1 = phoneNumPrefix;
    this.ib_1 = isoCode2;
    this.jb_1 = isoCode3;
    this.kb_1 = currency;
    this.lb_1 = englishName;
    this.mb_1 = arabicName;
    this.nb_1 = phoneRegex;
    this.ob_1 = phoneNumberHint;
  }
  protoOf(Qatar).wd = function () {
    return this.hb_1;
  };
  protoOf(Qatar).rd = function () {
    return this.ib_1;
  };
  protoOf(Qatar).sd = function () {
    return this.jb_1;
  };
  protoOf(Qatar).td = function () {
    return this.kb_1;
  };
  protoOf(Qatar).ud = function () {
    return this.lb_1;
  };
  protoOf(Qatar).vd = function () {
    return this.mb_1;
  };
  protoOf(Qatar).xd = function () {
    return this.nb_1;
  };
  protoOf(Qatar).yd = function () {
    return this.ob_1;
  };
  protoOf(Qatar).toString = function () {
    return 'Qatar(phoneNumPrefix=' + this.hb_1.toString() + ', isoCode2=' + this.ib_1 + ', isoCode3=' + this.jb_1 + ', currency=' + toString(this.kb_1) + ', englishName=' + this.lb_1 + ', arabicName=' + this.mb_1 + ', phoneRegex=' + this.nb_1 + ', phoneNumberHint=' + this.ob_1 + ')';
  };
  protoOf(Qatar).hashCode = function () {
    var result = this.hb_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ib_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jb_1) | 0;
    result = imul(result, 31) + hashCode(this.kb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ob_1) | 0;
    return result;
  };
  protoOf(Qatar).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Qatar))
      return false;
    var tmp0_other_with_cast = other instanceof Qatar ? other : THROW_CCE();
    if (!this.hb_1.equals(tmp0_other_with_cast.hb_1))
      return false;
    if (!(this.ib_1 === tmp0_other_with_cast.ib_1))
      return false;
    if (!(this.jb_1 === tmp0_other_with_cast.jb_1))
      return false;
    if (!equals(this.kb_1, tmp0_other_with_cast.kb_1))
      return false;
    if (!(this.lb_1 === tmp0_other_with_cast.lb_1))
      return false;
    if (!(this.mb_1 === tmp0_other_with_cast.mb_1))
      return false;
    if (!(this.nb_1 === tmp0_other_with_cast.nb_1))
      return false;
    if (!(this.ob_1 === tmp0_other_with_cast.ob_1))
      return false;
    return true;
  };
  function Companion_182() {
  }
  var Companion_instance_182;
  function Companion_getInstance_182() {
    return Companion_instance_182;
  }
  function Reunion(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'RE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'REU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'R\xE9union' : englishName;
    arabicName = arabicName === VOID ? '\u0644\u0627 \u0631\u064A\u0648\u0646\u064A\u0648\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.e1l_1 = phoneNumPrefix;
    this.f1l_1 = isoCode2;
    this.g1l_1 = isoCode3;
    this.h1l_1 = currency;
    this.i1l_1 = englishName;
    this.j1l_1 = arabicName;
    this.k1l_1 = phoneRegex;
  }
  protoOf(Reunion).wd = function () {
    return this.e1l_1;
  };
  protoOf(Reunion).rd = function () {
    return this.f1l_1;
  };
  protoOf(Reunion).sd = function () {
    return this.g1l_1;
  };
  protoOf(Reunion).td = function () {
    return this.h1l_1;
  };
  protoOf(Reunion).ud = function () {
    return this.i1l_1;
  };
  protoOf(Reunion).vd = function () {
    return this.j1l_1;
  };
  protoOf(Reunion).xd = function () {
    return this.k1l_1;
  };
  protoOf(Reunion).toString = function () {
    return 'Reunion(phoneNumPrefix=' + this.e1l_1.toString() + ', isoCode2=' + this.f1l_1 + ', isoCode3=' + this.g1l_1 + ', currency=' + toString(this.h1l_1) + ', englishName=' + this.i1l_1 + ', arabicName=' + this.j1l_1 + ', phoneRegex=' + this.k1l_1 + ')';
  };
  protoOf(Reunion).hashCode = function () {
    var result = this.e1l_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.f1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1l_1) | 0;
    result = imul(result, 31) + hashCode(this.h1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1l_1) | 0;
    return result;
  };
  protoOf(Reunion).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Reunion))
      return false;
    var tmp0_other_with_cast = other instanceof Reunion ? other : THROW_CCE();
    if (!this.e1l_1.equals(tmp0_other_with_cast.e1l_1))
      return false;
    if (!(this.f1l_1 === tmp0_other_with_cast.f1l_1))
      return false;
    if (!(this.g1l_1 === tmp0_other_with_cast.g1l_1))
      return false;
    if (!equals(this.h1l_1, tmp0_other_with_cast.h1l_1))
      return false;
    if (!(this.i1l_1 === tmp0_other_with_cast.i1l_1))
      return false;
    if (!(this.j1l_1 === tmp0_other_with_cast.j1l_1))
      return false;
    if (!(this.k1l_1 === tmp0_other_with_cast.k1l_1))
      return false;
    return true;
  };
  function Companion_183() {
  }
  var Companion_instance_183;
  function Companion_getInstance_183() {
    return Companion_instance_183;
  }
  function Romania(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'RO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ROU' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Romania' : englishName;
    arabicName = arabicName === VOID ? '\u0631\u0648\u0645\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.l1l_1 = phoneNumPrefix;
    this.m1l_1 = isoCode2;
    this.n1l_1 = isoCode3;
    this.o1l_1 = currency;
    this.p1l_1 = englishName;
    this.q1l_1 = arabicName;
    this.r1l_1 = phoneRegex;
  }
  protoOf(Romania).wd = function () {
    return this.l1l_1;
  };
  protoOf(Romania).rd = function () {
    return this.m1l_1;
  };
  protoOf(Romania).sd = function () {
    return this.n1l_1;
  };
  protoOf(Romania).td = function () {
    return this.o1l_1;
  };
  protoOf(Romania).ud = function () {
    return this.p1l_1;
  };
  protoOf(Romania).vd = function () {
    return this.q1l_1;
  };
  protoOf(Romania).xd = function () {
    return this.r1l_1;
  };
  protoOf(Romania).toString = function () {
    return 'Romania(phoneNumPrefix=' + this.l1l_1.toString() + ', isoCode2=' + this.m1l_1 + ', isoCode3=' + this.n1l_1 + ', currency=' + toString(this.o1l_1) + ', englishName=' + this.p1l_1 + ', arabicName=' + this.q1l_1 + ', phoneRegex=' + this.r1l_1 + ')';
  };
  protoOf(Romania).hashCode = function () {
    var result = this.l1l_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1l_1) | 0;
    result = imul(result, 31) + hashCode(this.o1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1l_1) | 0;
    return result;
  };
  protoOf(Romania).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Romania))
      return false;
    var tmp0_other_with_cast = other instanceof Romania ? other : THROW_CCE();
    if (!this.l1l_1.equals(tmp0_other_with_cast.l1l_1))
      return false;
    if (!(this.m1l_1 === tmp0_other_with_cast.m1l_1))
      return false;
    if (!(this.n1l_1 === tmp0_other_with_cast.n1l_1))
      return false;
    if (!equals(this.o1l_1, tmp0_other_with_cast.o1l_1))
      return false;
    if (!(this.p1l_1 === tmp0_other_with_cast.p1l_1))
      return false;
    if (!(this.q1l_1 === tmp0_other_with_cast.q1l_1))
      return false;
    if (!(this.r1l_1 === tmp0_other_with_cast.r1l_1))
      return false;
    return true;
  };
  function Companion_184() {
  }
  var Companion_instance_184;
  function Companion_getInstance_184() {
    return Companion_instance_184;
  }
  function RussianFederation(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'RU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'RUS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Russian Federation' : englishName;
    arabicName = arabicName === VOID ? '\u0631\u0648\u0633\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.s1l_1 = phoneNumPrefix;
    this.t1l_1 = isoCode2;
    this.u1l_1 = isoCode3;
    this.v1l_1 = currency;
    this.w1l_1 = englishName;
    this.x1l_1 = arabicName;
    this.y1l_1 = phoneRegex;
  }
  protoOf(RussianFederation).wd = function () {
    return this.s1l_1;
  };
  protoOf(RussianFederation).rd = function () {
    return this.t1l_1;
  };
  protoOf(RussianFederation).sd = function () {
    return this.u1l_1;
  };
  protoOf(RussianFederation).td = function () {
    return this.v1l_1;
  };
  protoOf(RussianFederation).ud = function () {
    return this.w1l_1;
  };
  protoOf(RussianFederation).vd = function () {
    return this.x1l_1;
  };
  protoOf(RussianFederation).xd = function () {
    return this.y1l_1;
  };
  protoOf(RussianFederation).toString = function () {
    return 'RussianFederation(phoneNumPrefix=' + this.s1l_1.toString() + ', isoCode2=' + this.t1l_1 + ', isoCode3=' + this.u1l_1 + ', currency=' + toString(this.v1l_1) + ', englishName=' + this.w1l_1 + ', arabicName=' + this.x1l_1 + ', phoneRegex=' + this.y1l_1 + ')';
  };
  protoOf(RussianFederation).hashCode = function () {
    var result = this.s1l_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1l_1) | 0;
    result = imul(result, 31) + hashCode(this.v1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1l_1) | 0;
    return result;
  };
  protoOf(RussianFederation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RussianFederation))
      return false;
    var tmp0_other_with_cast = other instanceof RussianFederation ? other : THROW_CCE();
    if (!this.s1l_1.equals(tmp0_other_with_cast.s1l_1))
      return false;
    if (!(this.t1l_1 === tmp0_other_with_cast.t1l_1))
      return false;
    if (!(this.u1l_1 === tmp0_other_with_cast.u1l_1))
      return false;
    if (!equals(this.v1l_1, tmp0_other_with_cast.v1l_1))
      return false;
    if (!(this.w1l_1 === tmp0_other_with_cast.w1l_1))
      return false;
    if (!(this.x1l_1 === tmp0_other_with_cast.x1l_1))
      return false;
    if (!(this.y1l_1 === tmp0_other_with_cast.y1l_1))
      return false;
    return true;
  };
  function Companion_185() {
  }
  var Companion_instance_185;
  function Companion_getInstance_185() {
    return Companion_instance_185;
  }
  function Rwanda(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'RW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'RWA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Rwanda' : englishName;
    arabicName = arabicName === VOID ? '\u0631\u0648\u0627\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.z1l_1 = phoneNumPrefix;
    this.a1m_1 = isoCode2;
    this.b1m_1 = isoCode3;
    this.c1m_1 = currency;
    this.d1m_1 = englishName;
    this.e1m_1 = arabicName;
    this.f1m_1 = phoneRegex;
  }
  protoOf(Rwanda).wd = function () {
    return this.z1l_1;
  };
  protoOf(Rwanda).rd = function () {
    return this.a1m_1;
  };
  protoOf(Rwanda).sd = function () {
    return this.b1m_1;
  };
  protoOf(Rwanda).td = function () {
    return this.c1m_1;
  };
  protoOf(Rwanda).ud = function () {
    return this.d1m_1;
  };
  protoOf(Rwanda).vd = function () {
    return this.e1m_1;
  };
  protoOf(Rwanda).xd = function () {
    return this.f1m_1;
  };
  protoOf(Rwanda).toString = function () {
    return 'Rwanda(phoneNumPrefix=' + this.z1l_1.toString() + ', isoCode2=' + this.a1m_1 + ', isoCode3=' + this.b1m_1 + ', currency=' + toString(this.c1m_1) + ', englishName=' + this.d1m_1 + ', arabicName=' + this.e1m_1 + ', phoneRegex=' + this.f1m_1 + ')';
  };
  protoOf(Rwanda).hashCode = function () {
    var result = this.z1l_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1m_1) | 0;
    result = imul(result, 31) + hashCode(this.c1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1m_1) | 0;
    return result;
  };
  protoOf(Rwanda).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rwanda))
      return false;
    var tmp0_other_with_cast = other instanceof Rwanda ? other : THROW_CCE();
    if (!this.z1l_1.equals(tmp0_other_with_cast.z1l_1))
      return false;
    if (!(this.a1m_1 === tmp0_other_with_cast.a1m_1))
      return false;
    if (!(this.b1m_1 === tmp0_other_with_cast.b1m_1))
      return false;
    if (!equals(this.c1m_1, tmp0_other_with_cast.c1m_1))
      return false;
    if (!(this.d1m_1 === tmp0_other_with_cast.d1m_1))
      return false;
    if (!(this.e1m_1 === tmp0_other_with_cast.e1m_1))
      return false;
    if (!(this.f1m_1 === tmp0_other_with_cast.f1m_1))
      return false;
    return true;
  };
  function Companion_186() {
  }
  var Companion_instance_186;
  function Companion_getInstance_186() {
    return Companion_instance_186;
  }
  function SaintBarthelemy(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'BL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'BLM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Barth\xE9lemy' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646 \u0628\u0627\u0631\u062A\u064A\u0644\u0645\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.g1m_1 = phoneNumPrefix;
    this.h1m_1 = isoCode2;
    this.i1m_1 = isoCode3;
    this.j1m_1 = currency;
    this.k1m_1 = englishName;
    this.l1m_1 = arabicName;
    this.m1m_1 = phoneRegex;
  }
  protoOf(SaintBarthelemy).wd = function () {
    return this.g1m_1;
  };
  protoOf(SaintBarthelemy).rd = function () {
    return this.h1m_1;
  };
  protoOf(SaintBarthelemy).sd = function () {
    return this.i1m_1;
  };
  protoOf(SaintBarthelemy).td = function () {
    return this.j1m_1;
  };
  protoOf(SaintBarthelemy).ud = function () {
    return this.k1m_1;
  };
  protoOf(SaintBarthelemy).vd = function () {
    return this.l1m_1;
  };
  protoOf(SaintBarthelemy).xd = function () {
    return this.m1m_1;
  };
  protoOf(SaintBarthelemy).toString = function () {
    return 'SaintBarthelemy(phoneNumPrefix=' + this.g1m_1.toString() + ', isoCode2=' + this.h1m_1 + ', isoCode3=' + this.i1m_1 + ', currency=' + toString(this.j1m_1) + ', englishName=' + this.k1m_1 + ', arabicName=' + this.l1m_1 + ', phoneRegex=' + this.m1m_1 + ')';
  };
  protoOf(SaintBarthelemy).hashCode = function () {
    var result = this.g1m_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1m_1) | 0;
    result = imul(result, 31) + hashCode(this.j1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1m_1) | 0;
    return result;
  };
  protoOf(SaintBarthelemy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintBarthelemy))
      return false;
    var tmp0_other_with_cast = other instanceof SaintBarthelemy ? other : THROW_CCE();
    if (!this.g1m_1.equals(tmp0_other_with_cast.g1m_1))
      return false;
    if (!(this.h1m_1 === tmp0_other_with_cast.h1m_1))
      return false;
    if (!(this.i1m_1 === tmp0_other_with_cast.i1m_1))
      return false;
    if (!equals(this.j1m_1, tmp0_other_with_cast.j1m_1))
      return false;
    if (!(this.k1m_1 === tmp0_other_with_cast.k1m_1))
      return false;
    if (!(this.l1m_1 === tmp0_other_with_cast.l1m_1))
      return false;
    if (!(this.m1m_1 === tmp0_other_with_cast.m1m_1))
      return false;
    return true;
  };
  function Companion_187() {
  }
  var Companion_instance_187;
  function Companion_getInstance_187() {
    return Companion_instance_187;
  }
  function SaintHelenaAscensionandTristandaCunha(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SHN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Helena, Ascension and Tristan da Cunha' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646\u062A \u0647\u064A\u0644\u0627\u0646\u0629 \u0648\u0623\u0633\u064A\u0646\u0634\u064A\u0646 \u0648\u062A\u0631\u064A\u0633\u062A\u0627\u0646 \u062F\u0627 \u0643\u0648\u0646\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.n1m_1 = phoneNumPrefix;
    this.o1m_1 = isoCode2;
    this.p1m_1 = isoCode3;
    this.q1m_1 = currency;
    this.r1m_1 = englishName;
    this.s1m_1 = arabicName;
    this.t1m_1 = phoneRegex;
  }
  protoOf(SaintHelenaAscensionandTristandaCunha).wd = function () {
    return this.n1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).rd = function () {
    return this.o1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).sd = function () {
    return this.p1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).td = function () {
    return this.q1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).ud = function () {
    return this.r1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).vd = function () {
    return this.s1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).xd = function () {
    return this.t1m_1;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).toString = function () {
    return 'SaintHelenaAscensionandTristandaCunha(phoneNumPrefix=' + this.n1m_1.toString() + ', isoCode2=' + this.o1m_1 + ', isoCode3=' + this.p1m_1 + ', currency=' + toString(this.q1m_1) + ', englishName=' + this.r1m_1 + ', arabicName=' + this.s1m_1 + ', phoneRegex=' + this.t1m_1 + ')';
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).hashCode = function () {
    var result = this.n1m_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1m_1) | 0;
    result = imul(result, 31) + hashCode(this.q1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1m_1) | 0;
    return result;
  };
  protoOf(SaintHelenaAscensionandTristandaCunha).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintHelenaAscensionandTristandaCunha))
      return false;
    var tmp0_other_with_cast = other instanceof SaintHelenaAscensionandTristandaCunha ? other : THROW_CCE();
    if (!this.n1m_1.equals(tmp0_other_with_cast.n1m_1))
      return false;
    if (!(this.o1m_1 === tmp0_other_with_cast.o1m_1))
      return false;
    if (!(this.p1m_1 === tmp0_other_with_cast.p1m_1))
      return false;
    if (!equals(this.q1m_1, tmp0_other_with_cast.q1m_1))
      return false;
    if (!(this.r1m_1 === tmp0_other_with_cast.r1m_1))
      return false;
    if (!(this.s1m_1 === tmp0_other_with_cast.s1m_1))
      return false;
    if (!(this.t1m_1 === tmp0_other_with_cast.t1m_1))
      return false;
    return true;
  };
  function Companion_188() {
  }
  var Companion_instance_188;
  function Companion_getInstance_188() {
    return Companion_instance_188;
  }
  function SaintKittsandNevis(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'KN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'KNA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Kitts and Nevis' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646\u062A \u0643\u064A\u062A\u0633 \u0648\u0646\u064A\u0641\u064A\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.u1m_1 = phoneNumPrefix;
    this.v1m_1 = isoCode2;
    this.w1m_1 = isoCode3;
    this.x1m_1 = currency;
    this.y1m_1 = englishName;
    this.z1m_1 = arabicName;
    this.a1n_1 = phoneRegex;
  }
  protoOf(SaintKittsandNevis).wd = function () {
    return this.u1m_1;
  };
  protoOf(SaintKittsandNevis).rd = function () {
    return this.v1m_1;
  };
  protoOf(SaintKittsandNevis).sd = function () {
    return this.w1m_1;
  };
  protoOf(SaintKittsandNevis).td = function () {
    return this.x1m_1;
  };
  protoOf(SaintKittsandNevis).ud = function () {
    return this.y1m_1;
  };
  protoOf(SaintKittsandNevis).vd = function () {
    return this.z1m_1;
  };
  protoOf(SaintKittsandNevis).xd = function () {
    return this.a1n_1;
  };
  protoOf(SaintKittsandNevis).toString = function () {
    return 'SaintKittsandNevis(phoneNumPrefix=' + this.u1m_1.toString() + ', isoCode2=' + this.v1m_1 + ', isoCode3=' + this.w1m_1 + ', currency=' + toString(this.x1m_1) + ', englishName=' + this.y1m_1 + ', arabicName=' + this.z1m_1 + ', phoneRegex=' + this.a1n_1 + ')';
  };
  protoOf(SaintKittsandNevis).hashCode = function () {
    var result = this.u1m_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.v1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1m_1) | 0;
    result = imul(result, 31) + hashCode(this.x1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1n_1) | 0;
    return result;
  };
  protoOf(SaintKittsandNevis).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintKittsandNevis))
      return false;
    var tmp0_other_with_cast = other instanceof SaintKittsandNevis ? other : THROW_CCE();
    if (!this.u1m_1.equals(tmp0_other_with_cast.u1m_1))
      return false;
    if (!(this.v1m_1 === tmp0_other_with_cast.v1m_1))
      return false;
    if (!(this.w1m_1 === tmp0_other_with_cast.w1m_1))
      return false;
    if (!equals(this.x1m_1, tmp0_other_with_cast.x1m_1))
      return false;
    if (!(this.y1m_1 === tmp0_other_with_cast.y1m_1))
      return false;
    if (!(this.z1m_1 === tmp0_other_with_cast.z1m_1))
      return false;
    if (!(this.a1n_1 === tmp0_other_with_cast.a1n_1))
      return false;
    return true;
  };
  function Companion_189() {
  }
  var Companion_instance_189;
  function Companion_getInstance_189() {
    return Companion_instance_189;
  }
  function SaintLucia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LCA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Lucia' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646\u062A \u0644\u0648\u0633\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.b1n_1 = phoneNumPrefix;
    this.c1n_1 = isoCode2;
    this.d1n_1 = isoCode3;
    this.e1n_1 = currency;
    this.f1n_1 = englishName;
    this.g1n_1 = arabicName;
    this.h1n_1 = phoneRegex;
  }
  protoOf(SaintLucia).wd = function () {
    return this.b1n_1;
  };
  protoOf(SaintLucia).rd = function () {
    return this.c1n_1;
  };
  protoOf(SaintLucia).sd = function () {
    return this.d1n_1;
  };
  protoOf(SaintLucia).td = function () {
    return this.e1n_1;
  };
  protoOf(SaintLucia).ud = function () {
    return this.f1n_1;
  };
  protoOf(SaintLucia).vd = function () {
    return this.g1n_1;
  };
  protoOf(SaintLucia).xd = function () {
    return this.h1n_1;
  };
  protoOf(SaintLucia).toString = function () {
    return 'SaintLucia(phoneNumPrefix=' + this.b1n_1.toString() + ', isoCode2=' + this.c1n_1 + ', isoCode3=' + this.d1n_1 + ', currency=' + toString(this.e1n_1) + ', englishName=' + this.f1n_1 + ', arabicName=' + this.g1n_1 + ', phoneRegex=' + this.h1n_1 + ')';
  };
  protoOf(SaintLucia).hashCode = function () {
    var result = this.b1n_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1n_1) | 0;
    result = imul(result, 31) + hashCode(this.e1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1n_1) | 0;
    return result;
  };
  protoOf(SaintLucia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintLucia))
      return false;
    var tmp0_other_with_cast = other instanceof SaintLucia ? other : THROW_CCE();
    if (!this.b1n_1.equals(tmp0_other_with_cast.b1n_1))
      return false;
    if (!(this.c1n_1 === tmp0_other_with_cast.c1n_1))
      return false;
    if (!(this.d1n_1 === tmp0_other_with_cast.d1n_1))
      return false;
    if (!equals(this.e1n_1, tmp0_other_with_cast.e1n_1))
      return false;
    if (!(this.f1n_1 === tmp0_other_with_cast.f1n_1))
      return false;
    if (!(this.g1n_1 === tmp0_other_with_cast.g1n_1))
      return false;
    if (!(this.h1n_1 === tmp0_other_with_cast.h1n_1))
      return false;
    return true;
  };
  function Companion_190() {
  }
  var Companion_instance_190;
  function Companion_getInstance_190() {
    return Companion_instance_190;
  }
  function SaintMartinFrenchpart(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'MF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'MAF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Martin (French part)' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u062C\u0645\u0639 \u0633\u0627\u0646 \u0645\u0627\u0631\u062A\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.i1n_1 = phoneNumPrefix;
    this.j1n_1 = isoCode2;
    this.k1n_1 = isoCode3;
    this.l1n_1 = currency;
    this.m1n_1 = englishName;
    this.n1n_1 = arabicName;
    this.o1n_1 = phoneRegex;
  }
  protoOf(SaintMartinFrenchpart).wd = function () {
    return this.i1n_1;
  };
  protoOf(SaintMartinFrenchpart).rd = function () {
    return this.j1n_1;
  };
  protoOf(SaintMartinFrenchpart).sd = function () {
    return this.k1n_1;
  };
  protoOf(SaintMartinFrenchpart).td = function () {
    return this.l1n_1;
  };
  protoOf(SaintMartinFrenchpart).ud = function () {
    return this.m1n_1;
  };
  protoOf(SaintMartinFrenchpart).vd = function () {
    return this.n1n_1;
  };
  protoOf(SaintMartinFrenchpart).xd = function () {
    return this.o1n_1;
  };
  protoOf(SaintMartinFrenchpart).toString = function () {
    return 'SaintMartinFrenchpart(phoneNumPrefix=' + this.i1n_1.toString() + ', isoCode2=' + this.j1n_1 + ', isoCode3=' + this.k1n_1 + ', currency=' + toString(this.l1n_1) + ', englishName=' + this.m1n_1 + ', arabicName=' + this.n1n_1 + ', phoneRegex=' + this.o1n_1 + ')';
  };
  protoOf(SaintMartinFrenchpart).hashCode = function () {
    var result = this.i1n_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1n_1) | 0;
    result = imul(result, 31) + hashCode(this.l1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1n_1) | 0;
    return result;
  };
  protoOf(SaintMartinFrenchpart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintMartinFrenchpart))
      return false;
    var tmp0_other_with_cast = other instanceof SaintMartinFrenchpart ? other : THROW_CCE();
    if (!this.i1n_1.equals(tmp0_other_with_cast.i1n_1))
      return false;
    if (!(this.j1n_1 === tmp0_other_with_cast.j1n_1))
      return false;
    if (!(this.k1n_1 === tmp0_other_with_cast.k1n_1))
      return false;
    if (!equals(this.l1n_1, tmp0_other_with_cast.l1n_1))
      return false;
    if (!(this.m1n_1 === tmp0_other_with_cast.m1n_1))
      return false;
    if (!(this.n1n_1 === tmp0_other_with_cast.n1n_1))
      return false;
    if (!(this.o1n_1 === tmp0_other_with_cast.o1n_1))
      return false;
    return true;
  };
  function Companion_191() {
  }
  var Companion_instance_191;
  function Companion_getInstance_191() {
    return Companion_instance_191;
  }
  function SaintPierreandMiquelon(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'PM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SPM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Pierre and Miquelon' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646 \u0628\u064A\u064A\u0631 \u0648\u0645\u064A\u0643\u0644\u0648\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.p1n_1 = phoneNumPrefix;
    this.q1n_1 = isoCode2;
    this.r1n_1 = isoCode3;
    this.s1n_1 = currency;
    this.t1n_1 = englishName;
    this.u1n_1 = arabicName;
    this.v1n_1 = phoneRegex;
  }
  protoOf(SaintPierreandMiquelon).wd = function () {
    return this.p1n_1;
  };
  protoOf(SaintPierreandMiquelon).rd = function () {
    return this.q1n_1;
  };
  protoOf(SaintPierreandMiquelon).sd = function () {
    return this.r1n_1;
  };
  protoOf(SaintPierreandMiquelon).td = function () {
    return this.s1n_1;
  };
  protoOf(SaintPierreandMiquelon).ud = function () {
    return this.t1n_1;
  };
  protoOf(SaintPierreandMiquelon).vd = function () {
    return this.u1n_1;
  };
  protoOf(SaintPierreandMiquelon).xd = function () {
    return this.v1n_1;
  };
  protoOf(SaintPierreandMiquelon).toString = function () {
    return 'SaintPierreandMiquelon(phoneNumPrefix=' + this.p1n_1.toString() + ', isoCode2=' + this.q1n_1 + ', isoCode3=' + this.r1n_1 + ', currency=' + toString(this.s1n_1) + ', englishName=' + this.t1n_1 + ', arabicName=' + this.u1n_1 + ', phoneRegex=' + this.v1n_1 + ')';
  };
  protoOf(SaintPierreandMiquelon).hashCode = function () {
    var result = this.p1n_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1n_1) | 0;
    result = imul(result, 31) + hashCode(this.s1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1n_1) | 0;
    return result;
  };
  protoOf(SaintPierreandMiquelon).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintPierreandMiquelon))
      return false;
    var tmp0_other_with_cast = other instanceof SaintPierreandMiquelon ? other : THROW_CCE();
    if (!this.p1n_1.equals(tmp0_other_with_cast.p1n_1))
      return false;
    if (!(this.q1n_1 === tmp0_other_with_cast.q1n_1))
      return false;
    if (!(this.r1n_1 === tmp0_other_with_cast.r1n_1))
      return false;
    if (!equals(this.s1n_1, tmp0_other_with_cast.s1n_1))
      return false;
    if (!(this.t1n_1 === tmp0_other_with_cast.t1n_1))
      return false;
    if (!(this.u1n_1 === tmp0_other_with_cast.u1n_1))
      return false;
    if (!(this.v1n_1 === tmp0_other_with_cast.v1n_1))
      return false;
    return true;
  };
  function Companion_192() {
  }
  var Companion_instance_192;
  function Companion_getInstance_192() {
    return Companion_instance_192;
  }
  function SaintVincentandtheGrenadines(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VCT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Saint Vincent and the Grenadines' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646\u062A \u0641\u064A\u0646\u0633\u0646\u062A \u0648\u0627\u0644\u063A\u0631\u064A\u0646\u0627\u062F\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.w1n_1 = phoneNumPrefix;
    this.x1n_1 = isoCode2;
    this.y1n_1 = isoCode3;
    this.z1n_1 = currency;
    this.a1o_1 = englishName;
    this.b1o_1 = arabicName;
    this.c1o_1 = phoneRegex;
  }
  protoOf(SaintVincentandtheGrenadines).wd = function () {
    return this.w1n_1;
  };
  protoOf(SaintVincentandtheGrenadines).rd = function () {
    return this.x1n_1;
  };
  protoOf(SaintVincentandtheGrenadines).sd = function () {
    return this.y1n_1;
  };
  protoOf(SaintVincentandtheGrenadines).td = function () {
    return this.z1n_1;
  };
  protoOf(SaintVincentandtheGrenadines).ud = function () {
    return this.a1o_1;
  };
  protoOf(SaintVincentandtheGrenadines).vd = function () {
    return this.b1o_1;
  };
  protoOf(SaintVincentandtheGrenadines).xd = function () {
    return this.c1o_1;
  };
  protoOf(SaintVincentandtheGrenadines).toString = function () {
    return 'SaintVincentandtheGrenadines(phoneNumPrefix=' + this.w1n_1.toString() + ', isoCode2=' + this.x1n_1 + ', isoCode3=' + this.y1n_1 + ', currency=' + toString(this.z1n_1) + ', englishName=' + this.a1o_1 + ', arabicName=' + this.b1o_1 + ', phoneRegex=' + this.c1o_1 + ')';
  };
  protoOf(SaintVincentandtheGrenadines).hashCode = function () {
    var result = this.w1n_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.x1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1n_1) | 0;
    result = imul(result, 31) + hashCode(this.z1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1o_1) | 0;
    return result;
  };
  protoOf(SaintVincentandtheGrenadines).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaintVincentandtheGrenadines))
      return false;
    var tmp0_other_with_cast = other instanceof SaintVincentandtheGrenadines ? other : THROW_CCE();
    if (!this.w1n_1.equals(tmp0_other_with_cast.w1n_1))
      return false;
    if (!(this.x1n_1 === tmp0_other_with_cast.x1n_1))
      return false;
    if (!(this.y1n_1 === tmp0_other_with_cast.y1n_1))
      return false;
    if (!equals(this.z1n_1, tmp0_other_with_cast.z1n_1))
      return false;
    if (!(this.a1o_1 === tmp0_other_with_cast.a1o_1))
      return false;
    if (!(this.b1o_1 === tmp0_other_with_cast.b1o_1))
      return false;
    if (!(this.c1o_1 === tmp0_other_with_cast.c1o_1))
      return false;
    return true;
  };
  function Companion_193() {
  }
  var Companion_instance_193;
  function Companion_getInstance_193() {
    return Companion_instance_193;
  }
  function Samoa(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'WS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'WSM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Samoa' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0645\u0648\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.d1o_1 = phoneNumPrefix;
    this.e1o_1 = isoCode2;
    this.f1o_1 = isoCode3;
    this.g1o_1 = currency;
    this.h1o_1 = englishName;
    this.i1o_1 = arabicName;
    this.j1o_1 = phoneRegex;
  }
  protoOf(Samoa).wd = function () {
    return this.d1o_1;
  };
  protoOf(Samoa).rd = function () {
    return this.e1o_1;
  };
  protoOf(Samoa).sd = function () {
    return this.f1o_1;
  };
  protoOf(Samoa).td = function () {
    return this.g1o_1;
  };
  protoOf(Samoa).ud = function () {
    return this.h1o_1;
  };
  protoOf(Samoa).vd = function () {
    return this.i1o_1;
  };
  protoOf(Samoa).xd = function () {
    return this.j1o_1;
  };
  protoOf(Samoa).toString = function () {
    return 'Samoa(phoneNumPrefix=' + this.d1o_1.toString() + ', isoCode2=' + this.e1o_1 + ', isoCode3=' + this.f1o_1 + ', currency=' + toString(this.g1o_1) + ', englishName=' + this.h1o_1 + ', arabicName=' + this.i1o_1 + ', phoneRegex=' + this.j1o_1 + ')';
  };
  protoOf(Samoa).hashCode = function () {
    var result = this.d1o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1o_1) | 0;
    result = imul(result, 31) + hashCode(this.g1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1o_1) | 0;
    return result;
  };
  protoOf(Samoa).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Samoa))
      return false;
    var tmp0_other_with_cast = other instanceof Samoa ? other : THROW_CCE();
    if (!this.d1o_1.equals(tmp0_other_with_cast.d1o_1))
      return false;
    if (!(this.e1o_1 === tmp0_other_with_cast.e1o_1))
      return false;
    if (!(this.f1o_1 === tmp0_other_with_cast.f1o_1))
      return false;
    if (!equals(this.g1o_1, tmp0_other_with_cast.g1o_1))
      return false;
    if (!(this.h1o_1 === tmp0_other_with_cast.h1o_1))
      return false;
    if (!(this.i1o_1 === tmp0_other_with_cast.i1o_1))
      return false;
    if (!(this.j1o_1 === tmp0_other_with_cast.j1o_1))
      return false;
    return true;
  };
  function Companion_194() {
  }
  var Companion_instance_194;
  function Companion_getInstance_194() {
    return Companion_instance_194;
  }
  function SanMarino(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SMR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'San Marino' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0646 \u0645\u0627\u0631\u064A\u0646\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.k1o_1 = phoneNumPrefix;
    this.l1o_1 = isoCode2;
    this.m1o_1 = isoCode3;
    this.n1o_1 = currency;
    this.o1o_1 = englishName;
    this.p1o_1 = arabicName;
    this.q1o_1 = phoneRegex;
  }
  protoOf(SanMarino).wd = function () {
    return this.k1o_1;
  };
  protoOf(SanMarino).rd = function () {
    return this.l1o_1;
  };
  protoOf(SanMarino).sd = function () {
    return this.m1o_1;
  };
  protoOf(SanMarino).td = function () {
    return this.n1o_1;
  };
  protoOf(SanMarino).ud = function () {
    return this.o1o_1;
  };
  protoOf(SanMarino).vd = function () {
    return this.p1o_1;
  };
  protoOf(SanMarino).xd = function () {
    return this.q1o_1;
  };
  protoOf(SanMarino).toString = function () {
    return 'SanMarino(phoneNumPrefix=' + this.k1o_1.toString() + ', isoCode2=' + this.l1o_1 + ', isoCode3=' + this.m1o_1 + ', currency=' + toString(this.n1o_1) + ', englishName=' + this.o1o_1 + ', arabicName=' + this.p1o_1 + ', phoneRegex=' + this.q1o_1 + ')';
  };
  protoOf(SanMarino).hashCode = function () {
    var result = this.k1o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.l1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1o_1) | 0;
    result = imul(result, 31) + hashCode(this.n1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1o_1) | 0;
    return result;
  };
  protoOf(SanMarino).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SanMarino))
      return false;
    var tmp0_other_with_cast = other instanceof SanMarino ? other : THROW_CCE();
    if (!this.k1o_1.equals(tmp0_other_with_cast.k1o_1))
      return false;
    if (!(this.l1o_1 === tmp0_other_with_cast.l1o_1))
      return false;
    if (!(this.m1o_1 === tmp0_other_with_cast.m1o_1))
      return false;
    if (!equals(this.n1o_1, tmp0_other_with_cast.n1o_1))
      return false;
    if (!(this.o1o_1 === tmp0_other_with_cast.o1o_1))
      return false;
    if (!(this.p1o_1 === tmp0_other_with_cast.p1o_1))
      return false;
    if (!(this.q1o_1 === tmp0_other_with_cast.q1o_1))
      return false;
    return true;
  };
  function Companion_195() {
  }
  var Companion_instance_195;
  function Companion_getInstance_195() {
    return Companion_instance_195;
  }
  function SaoTomeandPrincipe(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ST' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'STP' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Sao Tome and Principe' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0627\u0648 \u062A\u0648\u0645\u064A \u0648\u0628\u0631\u064A\u0646\u0633\u064A\u0628' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.r1o_1 = phoneNumPrefix;
    this.s1o_1 = isoCode2;
    this.t1o_1 = isoCode3;
    this.u1o_1 = currency;
    this.v1o_1 = englishName;
    this.w1o_1 = arabicName;
    this.x1o_1 = phoneRegex;
  }
  protoOf(SaoTomeandPrincipe).wd = function () {
    return this.r1o_1;
  };
  protoOf(SaoTomeandPrincipe).rd = function () {
    return this.s1o_1;
  };
  protoOf(SaoTomeandPrincipe).sd = function () {
    return this.t1o_1;
  };
  protoOf(SaoTomeandPrincipe).td = function () {
    return this.u1o_1;
  };
  protoOf(SaoTomeandPrincipe).ud = function () {
    return this.v1o_1;
  };
  protoOf(SaoTomeandPrincipe).vd = function () {
    return this.w1o_1;
  };
  protoOf(SaoTomeandPrincipe).xd = function () {
    return this.x1o_1;
  };
  protoOf(SaoTomeandPrincipe).toString = function () {
    return 'SaoTomeandPrincipe(phoneNumPrefix=' + this.r1o_1.toString() + ', isoCode2=' + this.s1o_1 + ', isoCode3=' + this.t1o_1 + ', currency=' + toString(this.u1o_1) + ', englishName=' + this.v1o_1 + ', arabicName=' + this.w1o_1 + ', phoneRegex=' + this.x1o_1 + ')';
  };
  protoOf(SaoTomeandPrincipe).hashCode = function () {
    var result = this.r1o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.s1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1o_1) | 0;
    result = imul(result, 31) + hashCode(this.u1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1o_1) | 0;
    return result;
  };
  protoOf(SaoTomeandPrincipe).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaoTomeandPrincipe))
      return false;
    var tmp0_other_with_cast = other instanceof SaoTomeandPrincipe ? other : THROW_CCE();
    if (!this.r1o_1.equals(tmp0_other_with_cast.r1o_1))
      return false;
    if (!(this.s1o_1 === tmp0_other_with_cast.s1o_1))
      return false;
    if (!(this.t1o_1 === tmp0_other_with_cast.t1o_1))
      return false;
    if (!equals(this.u1o_1, tmp0_other_with_cast.u1o_1))
      return false;
    if (!(this.v1o_1 === tmp0_other_with_cast.v1o_1))
      return false;
    if (!(this.w1o_1 === tmp0_other_with_cast.w1o_1))
      return false;
    if (!(this.x1o_1 === tmp0_other_with_cast.x1o_1))
      return false;
    return true;
  };
  function Companion_196() {
  }
  var Companion_instance_196;
  function Companion_getInstance_196() {
    return Companion_instance_196;
  }
  function Senegal(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SEN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Senegal' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0633\u0646\u063A\u0627\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.y1o_1 = phoneNumPrefix;
    this.z1o_1 = isoCode2;
    this.a1p_1 = isoCode3;
    this.b1p_1 = currency;
    this.c1p_1 = englishName;
    this.d1p_1 = arabicName;
    this.e1p_1 = phoneRegex;
  }
  protoOf(Senegal).wd = function () {
    return this.y1o_1;
  };
  protoOf(Senegal).rd = function () {
    return this.z1o_1;
  };
  protoOf(Senegal).sd = function () {
    return this.a1p_1;
  };
  protoOf(Senegal).td = function () {
    return this.b1p_1;
  };
  protoOf(Senegal).ud = function () {
    return this.c1p_1;
  };
  protoOf(Senegal).vd = function () {
    return this.d1p_1;
  };
  protoOf(Senegal).xd = function () {
    return this.e1p_1;
  };
  protoOf(Senegal).toString = function () {
    return 'Senegal(phoneNumPrefix=' + this.y1o_1.toString() + ', isoCode2=' + this.z1o_1 + ', isoCode3=' + this.a1p_1 + ', currency=' + toString(this.b1p_1) + ', englishName=' + this.c1p_1 + ', arabicName=' + this.d1p_1 + ', phoneRegex=' + this.e1p_1 + ')';
  };
  protoOf(Senegal).hashCode = function () {
    var result = this.y1o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.z1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1p_1) | 0;
    result = imul(result, 31) + hashCode(this.b1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1p_1) | 0;
    return result;
  };
  protoOf(Senegal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Senegal))
      return false;
    var tmp0_other_with_cast = other instanceof Senegal ? other : THROW_CCE();
    if (!this.y1o_1.equals(tmp0_other_with_cast.y1o_1))
      return false;
    if (!(this.z1o_1 === tmp0_other_with_cast.z1o_1))
      return false;
    if (!(this.a1p_1 === tmp0_other_with_cast.a1p_1))
      return false;
    if (!equals(this.b1p_1, tmp0_other_with_cast.b1p_1))
      return false;
    if (!(this.c1p_1 === tmp0_other_with_cast.c1p_1))
      return false;
    if (!(this.d1p_1 === tmp0_other_with_cast.d1p_1))
      return false;
    if (!(this.e1p_1 === tmp0_other_with_cast.e1p_1))
      return false;
    return true;
  };
  function Companion_197() {
  }
  var Companion_instance_197;
  function Companion_getInstance_197() {
    return Companion_instance_197;
  }
  function Serbia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'RS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SRB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Serbia' : englishName;
    arabicName = arabicName === VOID ? '\u0635\u0631\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.f1p_1 = phoneNumPrefix;
    this.g1p_1 = isoCode2;
    this.h1p_1 = isoCode3;
    this.i1p_1 = currency;
    this.j1p_1 = englishName;
    this.k1p_1 = arabicName;
    this.l1p_1 = phoneRegex;
  }
  protoOf(Serbia).wd = function () {
    return this.f1p_1;
  };
  protoOf(Serbia).rd = function () {
    return this.g1p_1;
  };
  protoOf(Serbia).sd = function () {
    return this.h1p_1;
  };
  protoOf(Serbia).td = function () {
    return this.i1p_1;
  };
  protoOf(Serbia).ud = function () {
    return this.j1p_1;
  };
  protoOf(Serbia).vd = function () {
    return this.k1p_1;
  };
  protoOf(Serbia).xd = function () {
    return this.l1p_1;
  };
  protoOf(Serbia).toString = function () {
    return 'Serbia(phoneNumPrefix=' + this.f1p_1.toString() + ', isoCode2=' + this.g1p_1 + ', isoCode3=' + this.h1p_1 + ', currency=' + toString(this.i1p_1) + ', englishName=' + this.j1p_1 + ', arabicName=' + this.k1p_1 + ', phoneRegex=' + this.l1p_1 + ')';
  };
  protoOf(Serbia).hashCode = function () {
    var result = this.f1p_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1p_1) | 0;
    result = imul(result, 31) + hashCode(this.i1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1p_1) | 0;
    return result;
  };
  protoOf(Serbia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Serbia))
      return false;
    var tmp0_other_with_cast = other instanceof Serbia ? other : THROW_CCE();
    if (!this.f1p_1.equals(tmp0_other_with_cast.f1p_1))
      return false;
    if (!(this.g1p_1 === tmp0_other_with_cast.g1p_1))
      return false;
    if (!(this.h1p_1 === tmp0_other_with_cast.h1p_1))
      return false;
    if (!equals(this.i1p_1, tmp0_other_with_cast.i1p_1))
      return false;
    if (!(this.j1p_1 === tmp0_other_with_cast.j1p_1))
      return false;
    if (!(this.k1p_1 === tmp0_other_with_cast.k1p_1))
      return false;
    if (!(this.l1p_1 === tmp0_other_with_cast.l1p_1))
      return false;
    return true;
  };
  function Companion_198() {
  }
  var Companion_instance_198;
  function Companion_getInstance_198() {
    return Companion_instance_198;
  }
  function Seychelles(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SYC' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Seychelles' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u064A\u0634\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.m1p_1 = phoneNumPrefix;
    this.n1p_1 = isoCode2;
    this.o1p_1 = isoCode3;
    this.p1p_1 = currency;
    this.q1p_1 = englishName;
    this.r1p_1 = arabicName;
    this.s1p_1 = phoneRegex;
  }
  protoOf(Seychelles).wd = function () {
    return this.m1p_1;
  };
  protoOf(Seychelles).rd = function () {
    return this.n1p_1;
  };
  protoOf(Seychelles).sd = function () {
    return this.o1p_1;
  };
  protoOf(Seychelles).td = function () {
    return this.p1p_1;
  };
  protoOf(Seychelles).ud = function () {
    return this.q1p_1;
  };
  protoOf(Seychelles).vd = function () {
    return this.r1p_1;
  };
  protoOf(Seychelles).xd = function () {
    return this.s1p_1;
  };
  protoOf(Seychelles).toString = function () {
    return 'Seychelles(phoneNumPrefix=' + this.m1p_1.toString() + ', isoCode2=' + this.n1p_1 + ', isoCode3=' + this.o1p_1 + ', currency=' + toString(this.p1p_1) + ', englishName=' + this.q1p_1 + ', arabicName=' + this.r1p_1 + ', phoneRegex=' + this.s1p_1 + ')';
  };
  protoOf(Seychelles).hashCode = function () {
    var result = this.m1p_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.n1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1p_1) | 0;
    result = imul(result, 31) + hashCode(this.p1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1p_1) | 0;
    return result;
  };
  protoOf(Seychelles).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Seychelles))
      return false;
    var tmp0_other_with_cast = other instanceof Seychelles ? other : THROW_CCE();
    if (!this.m1p_1.equals(tmp0_other_with_cast.m1p_1))
      return false;
    if (!(this.n1p_1 === tmp0_other_with_cast.n1p_1))
      return false;
    if (!(this.o1p_1 === tmp0_other_with_cast.o1p_1))
      return false;
    if (!equals(this.p1p_1, tmp0_other_with_cast.p1p_1))
      return false;
    if (!(this.q1p_1 === tmp0_other_with_cast.q1p_1))
      return false;
    if (!(this.r1p_1 === tmp0_other_with_cast.r1p_1))
      return false;
    if (!(this.s1p_1 === tmp0_other_with_cast.s1p_1))
      return false;
    return true;
  };
  function Companion_199() {
  }
  var Companion_instance_199;
  function Companion_getInstance_199() {
    return Companion_instance_199;
  }
  function SierraLeone(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SLE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Sierra Leone' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u064A\u0631\u0627\u0644\u064A\u0648\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.t1p_1 = phoneNumPrefix;
    this.u1p_1 = isoCode2;
    this.v1p_1 = isoCode3;
    this.w1p_1 = currency;
    this.x1p_1 = englishName;
    this.y1p_1 = arabicName;
    this.z1p_1 = phoneRegex;
  }
  protoOf(SierraLeone).wd = function () {
    return this.t1p_1;
  };
  protoOf(SierraLeone).rd = function () {
    return this.u1p_1;
  };
  protoOf(SierraLeone).sd = function () {
    return this.v1p_1;
  };
  protoOf(SierraLeone).td = function () {
    return this.w1p_1;
  };
  protoOf(SierraLeone).ud = function () {
    return this.x1p_1;
  };
  protoOf(SierraLeone).vd = function () {
    return this.y1p_1;
  };
  protoOf(SierraLeone).xd = function () {
    return this.z1p_1;
  };
  protoOf(SierraLeone).toString = function () {
    return 'SierraLeone(phoneNumPrefix=' + this.t1p_1.toString() + ', isoCode2=' + this.u1p_1 + ', isoCode3=' + this.v1p_1 + ', currency=' + toString(this.w1p_1) + ', englishName=' + this.x1p_1 + ', arabicName=' + this.y1p_1 + ', phoneRegex=' + this.z1p_1 + ')';
  };
  protoOf(SierraLeone).hashCode = function () {
    var result = this.t1p_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1p_1) | 0;
    result = imul(result, 31) + hashCode(this.w1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1p_1) | 0;
    return result;
  };
  protoOf(SierraLeone).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SierraLeone))
      return false;
    var tmp0_other_with_cast = other instanceof SierraLeone ? other : THROW_CCE();
    if (!this.t1p_1.equals(tmp0_other_with_cast.t1p_1))
      return false;
    if (!(this.u1p_1 === tmp0_other_with_cast.u1p_1))
      return false;
    if (!(this.v1p_1 === tmp0_other_with_cast.v1p_1))
      return false;
    if (!equals(this.w1p_1, tmp0_other_with_cast.w1p_1))
      return false;
    if (!(this.x1p_1 === tmp0_other_with_cast.x1p_1))
      return false;
    if (!(this.y1p_1 === tmp0_other_with_cast.y1p_1))
      return false;
    if (!(this.z1p_1 === tmp0_other_with_cast.z1p_1))
      return false;
    return true;
  };
  function Companion_200() {
  }
  var Companion_instance_200;
  function Companion_getInstance_200() {
    return Companion_instance_200;
  }
  function Singapore(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SGP' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Singapore' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.a1q_1 = phoneNumPrefix;
    this.b1q_1 = isoCode2;
    this.c1q_1 = isoCode3;
    this.d1q_1 = currency;
    this.e1q_1 = englishName;
    this.f1q_1 = arabicName;
    this.g1q_1 = phoneRegex;
  }
  protoOf(Singapore).wd = function () {
    return this.a1q_1;
  };
  protoOf(Singapore).rd = function () {
    return this.b1q_1;
  };
  protoOf(Singapore).sd = function () {
    return this.c1q_1;
  };
  protoOf(Singapore).td = function () {
    return this.d1q_1;
  };
  protoOf(Singapore).ud = function () {
    return this.e1q_1;
  };
  protoOf(Singapore).vd = function () {
    return this.f1q_1;
  };
  protoOf(Singapore).xd = function () {
    return this.g1q_1;
  };
  protoOf(Singapore).toString = function () {
    return 'Singapore(phoneNumPrefix=' + this.a1q_1.toString() + ', isoCode2=' + this.b1q_1 + ', isoCode3=' + this.c1q_1 + ', currency=' + toString(this.d1q_1) + ', englishName=' + this.e1q_1 + ', arabicName=' + this.f1q_1 + ', phoneRegex=' + this.g1q_1 + ')';
  };
  protoOf(Singapore).hashCode = function () {
    var result = this.a1q_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1q_1) | 0;
    result = imul(result, 31) + hashCode(this.d1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1q_1) | 0;
    return result;
  };
  protoOf(Singapore).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Singapore))
      return false;
    var tmp0_other_with_cast = other instanceof Singapore ? other : THROW_CCE();
    if (!this.a1q_1.equals(tmp0_other_with_cast.a1q_1))
      return false;
    if (!(this.b1q_1 === tmp0_other_with_cast.b1q_1))
      return false;
    if (!(this.c1q_1 === tmp0_other_with_cast.c1q_1))
      return false;
    if (!equals(this.d1q_1, tmp0_other_with_cast.d1q_1))
      return false;
    if (!(this.e1q_1 === tmp0_other_with_cast.e1q_1))
      return false;
    if (!(this.f1q_1 === tmp0_other_with_cast.f1q_1))
      return false;
    if (!(this.g1q_1 === tmp0_other_with_cast.g1q_1))
      return false;
    return true;
  };
  function Companion_201() {
  }
  var Companion_instance_201;
  function Companion_getInstance_201() {
    return Companion_instance_201;
  }
  function SintMaartenDutchpart(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SX' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SXM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Sint Maarten (Dutch part)' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u064A\u0646\u062A \u0645\u0627\u0631\u062A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.h1q_1 = phoneNumPrefix;
    this.i1q_1 = isoCode2;
    this.j1q_1 = isoCode3;
    this.k1q_1 = currency;
    this.l1q_1 = englishName;
    this.m1q_1 = arabicName;
    this.n1q_1 = phoneRegex;
  }
  protoOf(SintMaartenDutchpart).wd = function () {
    return this.h1q_1;
  };
  protoOf(SintMaartenDutchpart).rd = function () {
    return this.i1q_1;
  };
  protoOf(SintMaartenDutchpart).sd = function () {
    return this.j1q_1;
  };
  protoOf(SintMaartenDutchpart).td = function () {
    return this.k1q_1;
  };
  protoOf(SintMaartenDutchpart).ud = function () {
    return this.l1q_1;
  };
  protoOf(SintMaartenDutchpart).vd = function () {
    return this.m1q_1;
  };
  protoOf(SintMaartenDutchpart).xd = function () {
    return this.n1q_1;
  };
  protoOf(SintMaartenDutchpart).toString = function () {
    return 'SintMaartenDutchpart(phoneNumPrefix=' + this.h1q_1.toString() + ', isoCode2=' + this.i1q_1 + ', isoCode3=' + this.j1q_1 + ', currency=' + toString(this.k1q_1) + ', englishName=' + this.l1q_1 + ', arabicName=' + this.m1q_1 + ', phoneRegex=' + this.n1q_1 + ')';
  };
  protoOf(SintMaartenDutchpart).hashCode = function () {
    var result = this.h1q_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1q_1) | 0;
    result = imul(result, 31) + hashCode(this.k1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1q_1) | 0;
    return result;
  };
  protoOf(SintMaartenDutchpart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SintMaartenDutchpart))
      return false;
    var tmp0_other_with_cast = other instanceof SintMaartenDutchpart ? other : THROW_CCE();
    if (!this.h1q_1.equals(tmp0_other_with_cast.h1q_1))
      return false;
    if (!(this.i1q_1 === tmp0_other_with_cast.i1q_1))
      return false;
    if (!(this.j1q_1 === tmp0_other_with_cast.j1q_1))
      return false;
    if (!equals(this.k1q_1, tmp0_other_with_cast.k1q_1))
      return false;
    if (!(this.l1q_1 === tmp0_other_with_cast.l1q_1))
      return false;
    if (!(this.m1q_1 === tmp0_other_with_cast.m1q_1))
      return false;
    if (!(this.n1q_1 === tmp0_other_with_cast.n1q_1))
      return false;
    return true;
  };
  function Companion_202() {
  }
  var Companion_instance_202;
  function Companion_getInstance_202() {
    return Companion_instance_202;
  }
  function Slovakia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SVK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Slovakia' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0644\u0648\u0641\u0627\u0643\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.o1q_1 = phoneNumPrefix;
    this.p1q_1 = isoCode2;
    this.q1q_1 = isoCode3;
    this.r1q_1 = currency;
    this.s1q_1 = englishName;
    this.t1q_1 = arabicName;
    this.u1q_1 = phoneRegex;
  }
  protoOf(Slovakia).wd = function () {
    return this.o1q_1;
  };
  protoOf(Slovakia).rd = function () {
    return this.p1q_1;
  };
  protoOf(Slovakia).sd = function () {
    return this.q1q_1;
  };
  protoOf(Slovakia).td = function () {
    return this.r1q_1;
  };
  protoOf(Slovakia).ud = function () {
    return this.s1q_1;
  };
  protoOf(Slovakia).vd = function () {
    return this.t1q_1;
  };
  protoOf(Slovakia).xd = function () {
    return this.u1q_1;
  };
  protoOf(Slovakia).toString = function () {
    return 'Slovakia(phoneNumPrefix=' + this.o1q_1.toString() + ', isoCode2=' + this.p1q_1 + ', isoCode3=' + this.q1q_1 + ', currency=' + toString(this.r1q_1) + ', englishName=' + this.s1q_1 + ', arabicName=' + this.t1q_1 + ', phoneRegex=' + this.u1q_1 + ')';
  };
  protoOf(Slovakia).hashCode = function () {
    var result = this.o1q_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1q_1) | 0;
    result = imul(result, 31) + hashCode(this.r1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1q_1) | 0;
    return result;
  };
  protoOf(Slovakia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Slovakia))
      return false;
    var tmp0_other_with_cast = other instanceof Slovakia ? other : THROW_CCE();
    if (!this.o1q_1.equals(tmp0_other_with_cast.o1q_1))
      return false;
    if (!(this.p1q_1 === tmp0_other_with_cast.p1q_1))
      return false;
    if (!(this.q1q_1 === tmp0_other_with_cast.q1q_1))
      return false;
    if (!equals(this.r1q_1, tmp0_other_with_cast.r1q_1))
      return false;
    if (!(this.s1q_1 === tmp0_other_with_cast.s1q_1))
      return false;
    if (!(this.t1q_1 === tmp0_other_with_cast.t1q_1))
      return false;
    if (!(this.u1q_1 === tmp0_other_with_cast.u1q_1))
      return false;
    return true;
  };
  function Companion_203() {
  }
  var Companion_instance_203;
  function Companion_getInstance_203() {
    return Companion_instance_203;
  }
  function Slovenia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SVN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Slovenia' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0644\u0648\u0641\u064A\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.v1q_1 = phoneNumPrefix;
    this.w1q_1 = isoCode2;
    this.x1q_1 = isoCode3;
    this.y1q_1 = currency;
    this.z1q_1 = englishName;
    this.a1r_1 = arabicName;
    this.b1r_1 = phoneRegex;
  }
  protoOf(Slovenia).wd = function () {
    return this.v1q_1;
  };
  protoOf(Slovenia).rd = function () {
    return this.w1q_1;
  };
  protoOf(Slovenia).sd = function () {
    return this.x1q_1;
  };
  protoOf(Slovenia).td = function () {
    return this.y1q_1;
  };
  protoOf(Slovenia).ud = function () {
    return this.z1q_1;
  };
  protoOf(Slovenia).vd = function () {
    return this.a1r_1;
  };
  protoOf(Slovenia).xd = function () {
    return this.b1r_1;
  };
  protoOf(Slovenia).toString = function () {
    return 'Slovenia(phoneNumPrefix=' + this.v1q_1.toString() + ', isoCode2=' + this.w1q_1 + ', isoCode3=' + this.x1q_1 + ', currency=' + toString(this.y1q_1) + ', englishName=' + this.z1q_1 + ', arabicName=' + this.a1r_1 + ', phoneRegex=' + this.b1r_1 + ')';
  };
  protoOf(Slovenia).hashCode = function () {
    var result = this.v1q_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1q_1) | 0;
    result = imul(result, 31) + hashCode(this.y1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1r_1) | 0;
    return result;
  };
  protoOf(Slovenia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Slovenia))
      return false;
    var tmp0_other_with_cast = other instanceof Slovenia ? other : THROW_CCE();
    if (!this.v1q_1.equals(tmp0_other_with_cast.v1q_1))
      return false;
    if (!(this.w1q_1 === tmp0_other_with_cast.w1q_1))
      return false;
    if (!(this.x1q_1 === tmp0_other_with_cast.x1q_1))
      return false;
    if (!equals(this.y1q_1, tmp0_other_with_cast.y1q_1))
      return false;
    if (!(this.z1q_1 === tmp0_other_with_cast.z1q_1))
      return false;
    if (!(this.a1r_1 === tmp0_other_with_cast.a1r_1))
      return false;
    if (!(this.b1r_1 === tmp0_other_with_cast.b1r_1))
      return false;
    return true;
  };
  function Companion_204() {
  }
  var Companion_instance_204;
  function Companion_getInstance_204() {
    return Companion_instance_204;
  }
  function SolomonIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SB' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SLB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Solomon Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0633\u0644\u064A\u0645\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.c1r_1 = phoneNumPrefix;
    this.d1r_1 = isoCode2;
    this.e1r_1 = isoCode3;
    this.f1r_1 = currency;
    this.g1r_1 = englishName;
    this.h1r_1 = arabicName;
    this.i1r_1 = phoneRegex;
  }
  protoOf(SolomonIslands).wd = function () {
    return this.c1r_1;
  };
  protoOf(SolomonIslands).rd = function () {
    return this.d1r_1;
  };
  protoOf(SolomonIslands).sd = function () {
    return this.e1r_1;
  };
  protoOf(SolomonIslands).td = function () {
    return this.f1r_1;
  };
  protoOf(SolomonIslands).ud = function () {
    return this.g1r_1;
  };
  protoOf(SolomonIslands).vd = function () {
    return this.h1r_1;
  };
  protoOf(SolomonIslands).xd = function () {
    return this.i1r_1;
  };
  protoOf(SolomonIslands).toString = function () {
    return 'SolomonIslands(phoneNumPrefix=' + this.c1r_1.toString() + ', isoCode2=' + this.d1r_1 + ', isoCode3=' + this.e1r_1 + ', currency=' + toString(this.f1r_1) + ', englishName=' + this.g1r_1 + ', arabicName=' + this.h1r_1 + ', phoneRegex=' + this.i1r_1 + ')';
  };
  protoOf(SolomonIslands).hashCode = function () {
    var result = this.c1r_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.d1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1r_1) | 0;
    result = imul(result, 31) + hashCode(this.f1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1r_1) | 0;
    return result;
  };
  protoOf(SolomonIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SolomonIslands))
      return false;
    var tmp0_other_with_cast = other instanceof SolomonIslands ? other : THROW_CCE();
    if (!this.c1r_1.equals(tmp0_other_with_cast.c1r_1))
      return false;
    if (!(this.d1r_1 === tmp0_other_with_cast.d1r_1))
      return false;
    if (!(this.e1r_1 === tmp0_other_with_cast.e1r_1))
      return false;
    if (!equals(this.f1r_1, tmp0_other_with_cast.f1r_1))
      return false;
    if (!(this.g1r_1 === tmp0_other_with_cast.g1r_1))
      return false;
    if (!(this.h1r_1 === tmp0_other_with_cast.h1r_1))
      return false;
    if (!(this.i1r_1 === tmp0_other_with_cast.i1r_1))
      return false;
    return true;
  };
  function Companion_205() {
  }
  var Companion_instance_205;
  function Companion_getInstance_205() {
    return Companion_instance_205;
  }
  function Somalia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SOM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Somalia' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0635\u0648\u0645\u0627\u0644' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.j1r_1 = phoneNumPrefix;
    this.k1r_1 = isoCode2;
    this.l1r_1 = isoCode3;
    this.m1r_1 = currency;
    this.n1r_1 = englishName;
    this.o1r_1 = arabicName;
    this.p1r_1 = phoneRegex;
  }
  protoOf(Somalia).wd = function () {
    return this.j1r_1;
  };
  protoOf(Somalia).rd = function () {
    return this.k1r_1;
  };
  protoOf(Somalia).sd = function () {
    return this.l1r_1;
  };
  protoOf(Somalia).td = function () {
    return this.m1r_1;
  };
  protoOf(Somalia).ud = function () {
    return this.n1r_1;
  };
  protoOf(Somalia).vd = function () {
    return this.o1r_1;
  };
  protoOf(Somalia).xd = function () {
    return this.p1r_1;
  };
  protoOf(Somalia).toString = function () {
    return 'Somalia(phoneNumPrefix=' + this.j1r_1.toString() + ', isoCode2=' + this.k1r_1 + ', isoCode3=' + this.l1r_1 + ', currency=' + toString(this.m1r_1) + ', englishName=' + this.n1r_1 + ', arabicName=' + this.o1r_1 + ', phoneRegex=' + this.p1r_1 + ')';
  };
  protoOf(Somalia).hashCode = function () {
    var result = this.j1r_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.k1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1r_1) | 0;
    result = imul(result, 31) + hashCode(this.m1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1r_1) | 0;
    return result;
  };
  protoOf(Somalia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Somalia))
      return false;
    var tmp0_other_with_cast = other instanceof Somalia ? other : THROW_CCE();
    if (!this.j1r_1.equals(tmp0_other_with_cast.j1r_1))
      return false;
    if (!(this.k1r_1 === tmp0_other_with_cast.k1r_1))
      return false;
    if (!(this.l1r_1 === tmp0_other_with_cast.l1r_1))
      return false;
    if (!equals(this.m1r_1, tmp0_other_with_cast.m1r_1))
      return false;
    if (!(this.n1r_1 === tmp0_other_with_cast.n1r_1))
      return false;
    if (!(this.o1r_1 === tmp0_other_with_cast.o1r_1))
      return false;
    if (!(this.p1r_1 === tmp0_other_with_cast.p1r_1))
      return false;
    return true;
  };
  function Companion_206() {
  }
  var Companion_instance_206;
  function Companion_getInstance_206() {
    return Companion_instance_206;
  }
  function SouthAfrica(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ZA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ZAF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'South Africa' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.q1r_1 = phoneNumPrefix;
    this.r1r_1 = isoCode2;
    this.s1r_1 = isoCode3;
    this.t1r_1 = currency;
    this.u1r_1 = englishName;
    this.v1r_1 = arabicName;
    this.w1r_1 = phoneRegex;
  }
  protoOf(SouthAfrica).wd = function () {
    return this.q1r_1;
  };
  protoOf(SouthAfrica).rd = function () {
    return this.r1r_1;
  };
  protoOf(SouthAfrica).sd = function () {
    return this.s1r_1;
  };
  protoOf(SouthAfrica).td = function () {
    return this.t1r_1;
  };
  protoOf(SouthAfrica).ud = function () {
    return this.u1r_1;
  };
  protoOf(SouthAfrica).vd = function () {
    return this.v1r_1;
  };
  protoOf(SouthAfrica).xd = function () {
    return this.w1r_1;
  };
  protoOf(SouthAfrica).toString = function () {
    return 'SouthAfrica(phoneNumPrefix=' + this.q1r_1.toString() + ', isoCode2=' + this.r1r_1 + ', isoCode3=' + this.s1r_1 + ', currency=' + toString(this.t1r_1) + ', englishName=' + this.u1r_1 + ', arabicName=' + this.v1r_1 + ', phoneRegex=' + this.w1r_1 + ')';
  };
  protoOf(SouthAfrica).hashCode = function () {
    var result = this.q1r_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1r_1) | 0;
    result = imul(result, 31) + hashCode(this.t1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1r_1) | 0;
    return result;
  };
  protoOf(SouthAfrica).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SouthAfrica))
      return false;
    var tmp0_other_with_cast = other instanceof SouthAfrica ? other : THROW_CCE();
    if (!this.q1r_1.equals(tmp0_other_with_cast.q1r_1))
      return false;
    if (!(this.r1r_1 === tmp0_other_with_cast.r1r_1))
      return false;
    if (!(this.s1r_1 === tmp0_other_with_cast.s1r_1))
      return false;
    if (!equals(this.t1r_1, tmp0_other_with_cast.t1r_1))
      return false;
    if (!(this.u1r_1 === tmp0_other_with_cast.u1r_1))
      return false;
    if (!(this.v1r_1 === tmp0_other_with_cast.v1r_1))
      return false;
    if (!(this.w1r_1 === tmp0_other_with_cast.w1r_1))
      return false;
    return true;
  };
  function Companion_207() {
  }
  var Companion_instance_207;
  function Companion_getInstance_207() {
    return Companion_instance_207;
  }
  function SouthGeorgiaandtheSouthSandwichIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SGS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'South Georgia and the South Sandwich Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0648\u0631\u062C\u064A\u0627 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629 \u0648\u062C\u0632\u0631 \u0633\u0627\u0646\u062F\u0648\u064A\u062A\u0634 \u0627\u0644\u062C\u0646\u0648\u0628\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.x1r_1 = phoneNumPrefix;
    this.y1r_1 = isoCode2;
    this.z1r_1 = isoCode3;
    this.a1s_1 = currency;
    this.b1s_1 = englishName;
    this.c1s_1 = arabicName;
    this.d1s_1 = phoneRegex;
  }
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).wd = function () {
    return this.x1r_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).rd = function () {
    return this.y1r_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).sd = function () {
    return this.z1r_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).td = function () {
    return this.a1s_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).ud = function () {
    return this.b1s_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).vd = function () {
    return this.c1s_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).xd = function () {
    return this.d1s_1;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).toString = function () {
    return 'SouthGeorgiaandtheSouthSandwichIslands(phoneNumPrefix=' + this.x1r_1.toString() + ', isoCode2=' + this.y1r_1 + ', isoCode3=' + this.z1r_1 + ', currency=' + toString(this.a1s_1) + ', englishName=' + this.b1s_1 + ', arabicName=' + this.c1s_1 + ', phoneRegex=' + this.d1s_1 + ')';
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).hashCode = function () {
    var result = this.x1r_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.y1r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1r_1) | 0;
    result = imul(result, 31) + hashCode(this.a1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1s_1) | 0;
    return result;
  };
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SouthGeorgiaandtheSouthSandwichIslands))
      return false;
    var tmp0_other_with_cast = other instanceof SouthGeorgiaandtheSouthSandwichIslands ? other : THROW_CCE();
    if (!this.x1r_1.equals(tmp0_other_with_cast.x1r_1))
      return false;
    if (!(this.y1r_1 === tmp0_other_with_cast.y1r_1))
      return false;
    if (!(this.z1r_1 === tmp0_other_with_cast.z1r_1))
      return false;
    if (!equals(this.a1s_1, tmp0_other_with_cast.a1s_1))
      return false;
    if (!(this.b1s_1 === tmp0_other_with_cast.b1s_1))
      return false;
    if (!(this.c1s_1 === tmp0_other_with_cast.c1s_1))
      return false;
    if (!(this.d1s_1 === tmp0_other_with_cast.d1s_1))
      return false;
    return true;
  };
  function Companion_208() {
  }
  var Companion_instance_208;
  function Companion_getInstance_208() {
    return Companion_instance_208;
  }
  function SouthSudan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SS' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SSD' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'South Sudan' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.e1s_1 = phoneNumPrefix;
    this.f1s_1 = isoCode2;
    this.g1s_1 = isoCode3;
    this.h1s_1 = currency;
    this.i1s_1 = englishName;
    this.j1s_1 = arabicName;
    this.k1s_1 = phoneRegex;
  }
  protoOf(SouthSudan).wd = function () {
    return this.e1s_1;
  };
  protoOf(SouthSudan).rd = function () {
    return this.f1s_1;
  };
  protoOf(SouthSudan).sd = function () {
    return this.g1s_1;
  };
  protoOf(SouthSudan).td = function () {
    return this.h1s_1;
  };
  protoOf(SouthSudan).ud = function () {
    return this.i1s_1;
  };
  protoOf(SouthSudan).vd = function () {
    return this.j1s_1;
  };
  protoOf(SouthSudan).xd = function () {
    return this.k1s_1;
  };
  protoOf(SouthSudan).toString = function () {
    return 'SouthSudan(phoneNumPrefix=' + this.e1s_1.toString() + ', isoCode2=' + this.f1s_1 + ', isoCode3=' + this.g1s_1 + ', currency=' + toString(this.h1s_1) + ', englishName=' + this.i1s_1 + ', arabicName=' + this.j1s_1 + ', phoneRegex=' + this.k1s_1 + ')';
  };
  protoOf(SouthSudan).hashCode = function () {
    var result = this.e1s_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.f1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1s_1) | 0;
    result = imul(result, 31) + hashCode(this.h1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1s_1) | 0;
    return result;
  };
  protoOf(SouthSudan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SouthSudan))
      return false;
    var tmp0_other_with_cast = other instanceof SouthSudan ? other : THROW_CCE();
    if (!this.e1s_1.equals(tmp0_other_with_cast.e1s_1))
      return false;
    if (!(this.f1s_1 === tmp0_other_with_cast.f1s_1))
      return false;
    if (!(this.g1s_1 === tmp0_other_with_cast.g1s_1))
      return false;
    if (!equals(this.h1s_1, tmp0_other_with_cast.h1s_1))
      return false;
    if (!(this.i1s_1 === tmp0_other_with_cast.i1s_1))
      return false;
    if (!(this.j1s_1 === tmp0_other_with_cast.j1s_1))
      return false;
    if (!(this.k1s_1 === tmp0_other_with_cast.k1s_1))
      return false;
    return true;
  };
  function Companion_209() {
  }
  var Companion_instance_209;
  function Companion_getInstance_209() {
    return Companion_instance_209;
  }
  function Spain(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ES' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ESP' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Spain' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0633\u0628\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.l1s_1 = phoneNumPrefix;
    this.m1s_1 = isoCode2;
    this.n1s_1 = isoCode3;
    this.o1s_1 = currency;
    this.p1s_1 = englishName;
    this.q1s_1 = arabicName;
    this.r1s_1 = phoneRegex;
  }
  protoOf(Spain).wd = function () {
    return this.l1s_1;
  };
  protoOf(Spain).rd = function () {
    return this.m1s_1;
  };
  protoOf(Spain).sd = function () {
    return this.n1s_1;
  };
  protoOf(Spain).td = function () {
    return this.o1s_1;
  };
  protoOf(Spain).ud = function () {
    return this.p1s_1;
  };
  protoOf(Spain).vd = function () {
    return this.q1s_1;
  };
  protoOf(Spain).xd = function () {
    return this.r1s_1;
  };
  protoOf(Spain).toString = function () {
    return 'Spain(phoneNumPrefix=' + this.l1s_1.toString() + ', isoCode2=' + this.m1s_1 + ', isoCode3=' + this.n1s_1 + ', currency=' + toString(this.o1s_1) + ', englishName=' + this.p1s_1 + ', arabicName=' + this.q1s_1 + ', phoneRegex=' + this.r1s_1 + ')';
  };
  protoOf(Spain).hashCode = function () {
    var result = this.l1s_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1s_1) | 0;
    result = imul(result, 31) + hashCode(this.o1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1s_1) | 0;
    return result;
  };
  protoOf(Spain).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Spain))
      return false;
    var tmp0_other_with_cast = other instanceof Spain ? other : THROW_CCE();
    if (!this.l1s_1.equals(tmp0_other_with_cast.l1s_1))
      return false;
    if (!(this.m1s_1 === tmp0_other_with_cast.m1s_1))
      return false;
    if (!(this.n1s_1 === tmp0_other_with_cast.n1s_1))
      return false;
    if (!equals(this.o1s_1, tmp0_other_with_cast.o1s_1))
      return false;
    if (!(this.p1s_1 === tmp0_other_with_cast.p1s_1))
      return false;
    if (!(this.q1s_1 === tmp0_other_with_cast.q1s_1))
      return false;
    if (!(this.r1s_1 === tmp0_other_with_cast.r1s_1))
      return false;
    return true;
  };
  function Companion_210() {
  }
  var Companion_instance_210;
  function Companion_getInstance_210() {
    return Companion_instance_210;
  }
  function SriLanka(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'LK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'LKA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Sri Lanka' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0631\u064A\u0644\u0627\u0646\u0643\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.s1s_1 = phoneNumPrefix;
    this.t1s_1 = isoCode2;
    this.u1s_1 = isoCode3;
    this.v1s_1 = currency;
    this.w1s_1 = englishName;
    this.x1s_1 = arabicName;
    this.y1s_1 = phoneRegex;
  }
  protoOf(SriLanka).wd = function () {
    return this.s1s_1;
  };
  protoOf(SriLanka).rd = function () {
    return this.t1s_1;
  };
  protoOf(SriLanka).sd = function () {
    return this.u1s_1;
  };
  protoOf(SriLanka).td = function () {
    return this.v1s_1;
  };
  protoOf(SriLanka).ud = function () {
    return this.w1s_1;
  };
  protoOf(SriLanka).vd = function () {
    return this.x1s_1;
  };
  protoOf(SriLanka).xd = function () {
    return this.y1s_1;
  };
  protoOf(SriLanka).toString = function () {
    return 'SriLanka(phoneNumPrefix=' + this.s1s_1.toString() + ', isoCode2=' + this.t1s_1 + ', isoCode3=' + this.u1s_1 + ', currency=' + toString(this.v1s_1) + ', englishName=' + this.w1s_1 + ', arabicName=' + this.x1s_1 + ', phoneRegex=' + this.y1s_1 + ')';
  };
  protoOf(SriLanka).hashCode = function () {
    var result = this.s1s_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1s_1) | 0;
    result = imul(result, 31) + hashCode(this.v1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1s_1) | 0;
    return result;
  };
  protoOf(SriLanka).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SriLanka))
      return false;
    var tmp0_other_with_cast = other instanceof SriLanka ? other : THROW_CCE();
    if (!this.s1s_1.equals(tmp0_other_with_cast.s1s_1))
      return false;
    if (!(this.t1s_1 === tmp0_other_with_cast.t1s_1))
      return false;
    if (!(this.u1s_1 === tmp0_other_with_cast.u1s_1))
      return false;
    if (!equals(this.v1s_1, tmp0_other_with_cast.v1s_1))
      return false;
    if (!(this.w1s_1 === tmp0_other_with_cast.w1s_1))
      return false;
    if (!(this.x1s_1 === tmp0_other_with_cast.x1s_1))
      return false;
    if (!(this.y1s_1 === tmp0_other_with_cast.y1s_1))
      return false;
    return true;
  };
  function Companion_211() {
  }
  var Companion_instance_211;
  function Companion_getInstance_211() {
    return Companion_instance_211;
  }
  function Sudan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SD' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SDN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Sudan' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0633\u0648\u062F\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.z1s_1 = phoneNumPrefix;
    this.a1t_1 = isoCode2;
    this.b1t_1 = isoCode3;
    this.c1t_1 = currency;
    this.d1t_1 = englishName;
    this.e1t_1 = arabicName;
    this.f1t_1 = phoneRegex;
  }
  protoOf(Sudan).wd = function () {
    return this.z1s_1;
  };
  protoOf(Sudan).rd = function () {
    return this.a1t_1;
  };
  protoOf(Sudan).sd = function () {
    return this.b1t_1;
  };
  protoOf(Sudan).td = function () {
    return this.c1t_1;
  };
  protoOf(Sudan).ud = function () {
    return this.d1t_1;
  };
  protoOf(Sudan).vd = function () {
    return this.e1t_1;
  };
  protoOf(Sudan).xd = function () {
    return this.f1t_1;
  };
  protoOf(Sudan).toString = function () {
    return 'Sudan(phoneNumPrefix=' + this.z1s_1.toString() + ', isoCode2=' + this.a1t_1 + ', isoCode3=' + this.b1t_1 + ', currency=' + toString(this.c1t_1) + ', englishName=' + this.d1t_1 + ', arabicName=' + this.e1t_1 + ', phoneRegex=' + this.f1t_1 + ')';
  };
  protoOf(Sudan).hashCode = function () {
    var result = this.z1s_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1t_1) | 0;
    result = imul(result, 31) + hashCode(this.c1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1t_1) | 0;
    return result;
  };
  protoOf(Sudan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Sudan))
      return false;
    var tmp0_other_with_cast = other instanceof Sudan ? other : THROW_CCE();
    if (!this.z1s_1.equals(tmp0_other_with_cast.z1s_1))
      return false;
    if (!(this.a1t_1 === tmp0_other_with_cast.a1t_1))
      return false;
    if (!(this.b1t_1 === tmp0_other_with_cast.b1t_1))
      return false;
    if (!equals(this.c1t_1, tmp0_other_with_cast.c1t_1))
      return false;
    if (!(this.d1t_1 === tmp0_other_with_cast.d1t_1))
      return false;
    if (!(this.e1t_1 === tmp0_other_with_cast.e1t_1))
      return false;
    if (!(this.f1t_1 === tmp0_other_with_cast.f1t_1))
      return false;
    return true;
  };
  function Companion_212() {
  }
  var Companion_instance_212;
  function Companion_getInstance_212() {
    return Companion_instance_212;
  }
  function Suriname(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SUR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Suriname' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0648\u0631\u064A\u0646\u0627\u0645' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.g1t_1 = phoneNumPrefix;
    this.h1t_1 = isoCode2;
    this.i1t_1 = isoCode3;
    this.j1t_1 = currency;
    this.k1t_1 = englishName;
    this.l1t_1 = arabicName;
    this.m1t_1 = phoneRegex;
  }
  protoOf(Suriname).wd = function () {
    return this.g1t_1;
  };
  protoOf(Suriname).rd = function () {
    return this.h1t_1;
  };
  protoOf(Suriname).sd = function () {
    return this.i1t_1;
  };
  protoOf(Suriname).td = function () {
    return this.j1t_1;
  };
  protoOf(Suriname).ud = function () {
    return this.k1t_1;
  };
  protoOf(Suriname).vd = function () {
    return this.l1t_1;
  };
  protoOf(Suriname).xd = function () {
    return this.m1t_1;
  };
  protoOf(Suriname).toString = function () {
    return 'Suriname(phoneNumPrefix=' + this.g1t_1.toString() + ', isoCode2=' + this.h1t_1 + ', isoCode3=' + this.i1t_1 + ', currency=' + toString(this.j1t_1) + ', englishName=' + this.k1t_1 + ', arabicName=' + this.l1t_1 + ', phoneRegex=' + this.m1t_1 + ')';
  };
  protoOf(Suriname).hashCode = function () {
    var result = this.g1t_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1t_1) | 0;
    result = imul(result, 31) + hashCode(this.j1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1t_1) | 0;
    return result;
  };
  protoOf(Suriname).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Suriname))
      return false;
    var tmp0_other_with_cast = other instanceof Suriname ? other : THROW_CCE();
    if (!this.g1t_1.equals(tmp0_other_with_cast.g1t_1))
      return false;
    if (!(this.h1t_1 === tmp0_other_with_cast.h1t_1))
      return false;
    if (!(this.i1t_1 === tmp0_other_with_cast.i1t_1))
      return false;
    if (!equals(this.j1t_1, tmp0_other_with_cast.j1t_1))
      return false;
    if (!(this.k1t_1 === tmp0_other_with_cast.k1t_1))
      return false;
    if (!(this.l1t_1 === tmp0_other_with_cast.l1t_1))
      return false;
    if (!(this.m1t_1 === tmp0_other_with_cast.m1t_1))
      return false;
    return true;
  };
  function Companion_213() {
  }
  var Companion_instance_213;
  function Companion_getInstance_213() {
    return Companion_instance_213;
  }
  function SvalbardandJanMayen(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SJ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SJM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Svalbard and Jan Mayen' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0641\u0627\u0644\u0628\u0627\u0631\u062F \u0648\u064A\u0627\u0646 \u0645\u0627\u064A\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.n1t_1 = phoneNumPrefix;
    this.o1t_1 = isoCode2;
    this.p1t_1 = isoCode3;
    this.q1t_1 = currency;
    this.r1t_1 = englishName;
    this.s1t_1 = arabicName;
    this.t1t_1 = phoneRegex;
  }
  protoOf(SvalbardandJanMayen).wd = function () {
    return this.n1t_1;
  };
  protoOf(SvalbardandJanMayen).rd = function () {
    return this.o1t_1;
  };
  protoOf(SvalbardandJanMayen).sd = function () {
    return this.p1t_1;
  };
  protoOf(SvalbardandJanMayen).td = function () {
    return this.q1t_1;
  };
  protoOf(SvalbardandJanMayen).ud = function () {
    return this.r1t_1;
  };
  protoOf(SvalbardandJanMayen).vd = function () {
    return this.s1t_1;
  };
  protoOf(SvalbardandJanMayen).xd = function () {
    return this.t1t_1;
  };
  protoOf(SvalbardandJanMayen).toString = function () {
    return 'SvalbardandJanMayen(phoneNumPrefix=' + this.n1t_1.toString() + ', isoCode2=' + this.o1t_1 + ', isoCode3=' + this.p1t_1 + ', currency=' + toString(this.q1t_1) + ', englishName=' + this.r1t_1 + ', arabicName=' + this.s1t_1 + ', phoneRegex=' + this.t1t_1 + ')';
  };
  protoOf(SvalbardandJanMayen).hashCode = function () {
    var result = this.n1t_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1t_1) | 0;
    result = imul(result, 31) + hashCode(this.q1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1t_1) | 0;
    return result;
  };
  protoOf(SvalbardandJanMayen).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SvalbardandJanMayen))
      return false;
    var tmp0_other_with_cast = other instanceof SvalbardandJanMayen ? other : THROW_CCE();
    if (!this.n1t_1.equals(tmp0_other_with_cast.n1t_1))
      return false;
    if (!(this.o1t_1 === tmp0_other_with_cast.o1t_1))
      return false;
    if (!(this.p1t_1 === tmp0_other_with_cast.p1t_1))
      return false;
    if (!equals(this.q1t_1, tmp0_other_with_cast.q1t_1))
      return false;
    if (!(this.r1t_1 === tmp0_other_with_cast.r1t_1))
      return false;
    if (!(this.s1t_1 === tmp0_other_with_cast.s1t_1))
      return false;
    if (!(this.t1t_1 === tmp0_other_with_cast.t1t_1))
      return false;
    return true;
  };
  function Companion_214() {
  }
  var Companion_instance_214;
  function Companion_getInstance_214() {
    return Companion_instance_214;
  }
  function Eswatini(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SWZ' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Eswatini' : englishName;
    arabicName = arabicName === VOID ? '\u0625\u0633\u0648\u0627\u062A\u064A\u0646\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.u1t_1 = phoneNumPrefix;
    this.v1t_1 = isoCode2;
    this.w1t_1 = isoCode3;
    this.x1t_1 = currency;
    this.y1t_1 = englishName;
    this.z1t_1 = arabicName;
    this.a1u_1 = phoneRegex;
  }
  protoOf(Eswatini).wd = function () {
    return this.u1t_1;
  };
  protoOf(Eswatini).rd = function () {
    return this.v1t_1;
  };
  protoOf(Eswatini).sd = function () {
    return this.w1t_1;
  };
  protoOf(Eswatini).td = function () {
    return this.x1t_1;
  };
  protoOf(Eswatini).ud = function () {
    return this.y1t_1;
  };
  protoOf(Eswatini).vd = function () {
    return this.z1t_1;
  };
  protoOf(Eswatini).xd = function () {
    return this.a1u_1;
  };
  protoOf(Eswatini).toString = function () {
    return 'Eswatini(phoneNumPrefix=' + this.u1t_1.toString() + ', isoCode2=' + this.v1t_1 + ', isoCode3=' + this.w1t_1 + ', currency=' + toString(this.x1t_1) + ', englishName=' + this.y1t_1 + ', arabicName=' + this.z1t_1 + ', phoneRegex=' + this.a1u_1 + ')';
  };
  protoOf(Eswatini).hashCode = function () {
    var result = this.u1t_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.v1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1t_1) | 0;
    result = imul(result, 31) + hashCode(this.x1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1u_1) | 0;
    return result;
  };
  protoOf(Eswatini).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Eswatini))
      return false;
    var tmp0_other_with_cast = other instanceof Eswatini ? other : THROW_CCE();
    if (!this.u1t_1.equals(tmp0_other_with_cast.u1t_1))
      return false;
    if (!(this.v1t_1 === tmp0_other_with_cast.v1t_1))
      return false;
    if (!(this.w1t_1 === tmp0_other_with_cast.w1t_1))
      return false;
    if (!equals(this.x1t_1, tmp0_other_with_cast.x1t_1))
      return false;
    if (!(this.y1t_1 === tmp0_other_with_cast.y1t_1))
      return false;
    if (!(this.z1t_1 === tmp0_other_with_cast.z1t_1))
      return false;
    if (!(this.a1u_1 === tmp0_other_with_cast.a1u_1))
      return false;
    return true;
  };
  function Companion_215() {
  }
  var Companion_instance_215;
  function Companion_getInstance_215() {
    return Companion_instance_215;
  }
  function Sweden(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SWE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Sweden' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0633\u0648\u064A\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.b1u_1 = phoneNumPrefix;
    this.c1u_1 = isoCode2;
    this.d1u_1 = isoCode3;
    this.e1u_1 = currency;
    this.f1u_1 = englishName;
    this.g1u_1 = arabicName;
    this.h1u_1 = phoneRegex;
  }
  protoOf(Sweden).wd = function () {
    return this.b1u_1;
  };
  protoOf(Sweden).rd = function () {
    return this.c1u_1;
  };
  protoOf(Sweden).sd = function () {
    return this.d1u_1;
  };
  protoOf(Sweden).td = function () {
    return this.e1u_1;
  };
  protoOf(Sweden).ud = function () {
    return this.f1u_1;
  };
  protoOf(Sweden).vd = function () {
    return this.g1u_1;
  };
  protoOf(Sweden).xd = function () {
    return this.h1u_1;
  };
  protoOf(Sweden).toString = function () {
    return 'Sweden(phoneNumPrefix=' + this.b1u_1.toString() + ', isoCode2=' + this.c1u_1 + ', isoCode3=' + this.d1u_1 + ', currency=' + toString(this.e1u_1) + ', englishName=' + this.f1u_1 + ', arabicName=' + this.g1u_1 + ', phoneRegex=' + this.h1u_1 + ')';
  };
  protoOf(Sweden).hashCode = function () {
    var result = this.b1u_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1u_1) | 0;
    result = imul(result, 31) + hashCode(this.e1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1u_1) | 0;
    return result;
  };
  protoOf(Sweden).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Sweden))
      return false;
    var tmp0_other_with_cast = other instanceof Sweden ? other : THROW_CCE();
    if (!this.b1u_1.equals(tmp0_other_with_cast.b1u_1))
      return false;
    if (!(this.c1u_1 === tmp0_other_with_cast.c1u_1))
      return false;
    if (!(this.d1u_1 === tmp0_other_with_cast.d1u_1))
      return false;
    if (!equals(this.e1u_1, tmp0_other_with_cast.e1u_1))
      return false;
    if (!(this.f1u_1 === tmp0_other_with_cast.f1u_1))
      return false;
    if (!(this.g1u_1 === tmp0_other_with_cast.g1u_1))
      return false;
    if (!(this.h1u_1 === tmp0_other_with_cast.h1u_1))
      return false;
    return true;
  };
  function Companion_216() {
  }
  var Companion_instance_216;
  function Companion_getInstance_216() {
    return Companion_instance_216;
  }
  function Switzerland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'CH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'CHE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Switzerland' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0648\u064A\u0633\u0631\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.i1u_1 = phoneNumPrefix;
    this.j1u_1 = isoCode2;
    this.k1u_1 = isoCode3;
    this.l1u_1 = currency;
    this.m1u_1 = englishName;
    this.n1u_1 = arabicName;
    this.o1u_1 = phoneRegex;
  }
  protoOf(Switzerland).wd = function () {
    return this.i1u_1;
  };
  protoOf(Switzerland).rd = function () {
    return this.j1u_1;
  };
  protoOf(Switzerland).sd = function () {
    return this.k1u_1;
  };
  protoOf(Switzerland).td = function () {
    return this.l1u_1;
  };
  protoOf(Switzerland).ud = function () {
    return this.m1u_1;
  };
  protoOf(Switzerland).vd = function () {
    return this.n1u_1;
  };
  protoOf(Switzerland).xd = function () {
    return this.o1u_1;
  };
  protoOf(Switzerland).toString = function () {
    return 'Switzerland(phoneNumPrefix=' + this.i1u_1.toString() + ', isoCode2=' + this.j1u_1 + ', isoCode3=' + this.k1u_1 + ', currency=' + toString(this.l1u_1) + ', englishName=' + this.m1u_1 + ', arabicName=' + this.n1u_1 + ', phoneRegex=' + this.o1u_1 + ')';
  };
  protoOf(Switzerland).hashCode = function () {
    var result = this.i1u_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1u_1) | 0;
    result = imul(result, 31) + hashCode(this.l1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1u_1) | 0;
    return result;
  };
  protoOf(Switzerland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Switzerland))
      return false;
    var tmp0_other_with_cast = other instanceof Switzerland ? other : THROW_CCE();
    if (!this.i1u_1.equals(tmp0_other_with_cast.i1u_1))
      return false;
    if (!(this.j1u_1 === tmp0_other_with_cast.j1u_1))
      return false;
    if (!(this.k1u_1 === tmp0_other_with_cast.k1u_1))
      return false;
    if (!equals(this.l1u_1, tmp0_other_with_cast.l1u_1))
      return false;
    if (!(this.m1u_1 === tmp0_other_with_cast.m1u_1))
      return false;
    if (!(this.n1u_1 === tmp0_other_with_cast.n1u_1))
      return false;
    if (!(this.o1u_1 === tmp0_other_with_cast.o1u_1))
      return false;
    return true;
  };
  function Companion_217() {
  }
  var Companion_instance_217;
  function Companion_getInstance_217() {
    return Companion_instance_217;
  }
  function SyrianArabRepublic(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'SY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'SYR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Syrian Arab Republic' : englishName;
    arabicName = arabicName === VOID ? '\u0633\u0648\u0631\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.p1u_1 = phoneNumPrefix;
    this.q1u_1 = isoCode2;
    this.r1u_1 = isoCode3;
    this.s1u_1 = currency;
    this.t1u_1 = englishName;
    this.u1u_1 = arabicName;
    this.v1u_1 = phoneRegex;
  }
  protoOf(SyrianArabRepublic).wd = function () {
    return this.p1u_1;
  };
  protoOf(SyrianArabRepublic).rd = function () {
    return this.q1u_1;
  };
  protoOf(SyrianArabRepublic).sd = function () {
    return this.r1u_1;
  };
  protoOf(SyrianArabRepublic).td = function () {
    return this.s1u_1;
  };
  protoOf(SyrianArabRepublic).ud = function () {
    return this.t1u_1;
  };
  protoOf(SyrianArabRepublic).vd = function () {
    return this.u1u_1;
  };
  protoOf(SyrianArabRepublic).xd = function () {
    return this.v1u_1;
  };
  protoOf(SyrianArabRepublic).toString = function () {
    return 'SyrianArabRepublic(phoneNumPrefix=' + this.p1u_1.toString() + ', isoCode2=' + this.q1u_1 + ', isoCode3=' + this.r1u_1 + ', currency=' + toString(this.s1u_1) + ', englishName=' + this.t1u_1 + ', arabicName=' + this.u1u_1 + ', phoneRegex=' + this.v1u_1 + ')';
  };
  protoOf(SyrianArabRepublic).hashCode = function () {
    var result = this.p1u_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1u_1) | 0;
    result = imul(result, 31) + hashCode(this.s1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1u_1) | 0;
    return result;
  };
  protoOf(SyrianArabRepublic).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SyrianArabRepublic))
      return false;
    var tmp0_other_with_cast = other instanceof SyrianArabRepublic ? other : THROW_CCE();
    if (!this.p1u_1.equals(tmp0_other_with_cast.p1u_1))
      return false;
    if (!(this.q1u_1 === tmp0_other_with_cast.q1u_1))
      return false;
    if (!(this.r1u_1 === tmp0_other_with_cast.r1u_1))
      return false;
    if (!equals(this.s1u_1, tmp0_other_with_cast.s1u_1))
      return false;
    if (!(this.t1u_1 === tmp0_other_with_cast.t1u_1))
      return false;
    if (!(this.u1u_1 === tmp0_other_with_cast.u1u_1))
      return false;
    if (!(this.v1u_1 === tmp0_other_with_cast.v1u_1))
      return false;
    return true;
  };
  function Companion_218() {
  }
  var Companion_instance_218;
  function Companion_getInstance_218() {
    return Companion_instance_218;
  }
  function TaiwanProvinceofChina(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TWN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Taiwan, Province of China' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0627\u064A\u0648\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.w1u_1 = phoneNumPrefix;
    this.x1u_1 = isoCode2;
    this.y1u_1 = isoCode3;
    this.z1u_1 = currency;
    this.a1v_1 = englishName;
    this.b1v_1 = arabicName;
    this.c1v_1 = phoneRegex;
  }
  protoOf(TaiwanProvinceofChina).wd = function () {
    return this.w1u_1;
  };
  protoOf(TaiwanProvinceofChina).rd = function () {
    return this.x1u_1;
  };
  protoOf(TaiwanProvinceofChina).sd = function () {
    return this.y1u_1;
  };
  protoOf(TaiwanProvinceofChina).td = function () {
    return this.z1u_1;
  };
  protoOf(TaiwanProvinceofChina).ud = function () {
    return this.a1v_1;
  };
  protoOf(TaiwanProvinceofChina).vd = function () {
    return this.b1v_1;
  };
  protoOf(TaiwanProvinceofChina).xd = function () {
    return this.c1v_1;
  };
  protoOf(TaiwanProvinceofChina).toString = function () {
    return 'TaiwanProvinceofChina(phoneNumPrefix=' + this.w1u_1.toString() + ', isoCode2=' + this.x1u_1 + ', isoCode3=' + this.y1u_1 + ', currency=' + toString(this.z1u_1) + ', englishName=' + this.a1v_1 + ', arabicName=' + this.b1v_1 + ', phoneRegex=' + this.c1v_1 + ')';
  };
  protoOf(TaiwanProvinceofChina).hashCode = function () {
    var result = this.w1u_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.x1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1u_1) | 0;
    result = imul(result, 31) + hashCode(this.z1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1v_1) | 0;
    return result;
  };
  protoOf(TaiwanProvinceofChina).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TaiwanProvinceofChina))
      return false;
    var tmp0_other_with_cast = other instanceof TaiwanProvinceofChina ? other : THROW_CCE();
    if (!this.w1u_1.equals(tmp0_other_with_cast.w1u_1))
      return false;
    if (!(this.x1u_1 === tmp0_other_with_cast.x1u_1))
      return false;
    if (!(this.y1u_1 === tmp0_other_with_cast.y1u_1))
      return false;
    if (!equals(this.z1u_1, tmp0_other_with_cast.z1u_1))
      return false;
    if (!(this.a1v_1 === tmp0_other_with_cast.a1v_1))
      return false;
    if (!(this.b1v_1 === tmp0_other_with_cast.b1v_1))
      return false;
    if (!(this.c1v_1 === tmp0_other_with_cast.c1v_1))
      return false;
    return true;
  };
  function Companion_219() {
  }
  var Companion_instance_219;
  function Companion_getInstance_219() {
    return Companion_instance_219;
  }
  function Tajikistan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TJ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TJK' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Tajikistan' : englishName;
    arabicName = arabicName === VOID ? '\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.d1v_1 = phoneNumPrefix;
    this.e1v_1 = isoCode2;
    this.f1v_1 = isoCode3;
    this.g1v_1 = currency;
    this.h1v_1 = englishName;
    this.i1v_1 = arabicName;
    this.j1v_1 = phoneRegex;
  }
  protoOf(Tajikistan).wd = function () {
    return this.d1v_1;
  };
  protoOf(Tajikistan).rd = function () {
    return this.e1v_1;
  };
  protoOf(Tajikistan).sd = function () {
    return this.f1v_1;
  };
  protoOf(Tajikistan).td = function () {
    return this.g1v_1;
  };
  protoOf(Tajikistan).ud = function () {
    return this.h1v_1;
  };
  protoOf(Tajikistan).vd = function () {
    return this.i1v_1;
  };
  protoOf(Tajikistan).xd = function () {
    return this.j1v_1;
  };
  protoOf(Tajikistan).toString = function () {
    return 'Tajikistan(phoneNumPrefix=' + this.d1v_1.toString() + ', isoCode2=' + this.e1v_1 + ', isoCode3=' + this.f1v_1 + ', currency=' + toString(this.g1v_1) + ', englishName=' + this.h1v_1 + ', arabicName=' + this.i1v_1 + ', phoneRegex=' + this.j1v_1 + ')';
  };
  protoOf(Tajikistan).hashCode = function () {
    var result = this.d1v_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1v_1) | 0;
    result = imul(result, 31) + hashCode(this.g1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1v_1) | 0;
    return result;
  };
  protoOf(Tajikistan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Tajikistan))
      return false;
    var tmp0_other_with_cast = other instanceof Tajikistan ? other : THROW_CCE();
    if (!this.d1v_1.equals(tmp0_other_with_cast.d1v_1))
      return false;
    if (!(this.e1v_1 === tmp0_other_with_cast.e1v_1))
      return false;
    if (!(this.f1v_1 === tmp0_other_with_cast.f1v_1))
      return false;
    if (!equals(this.g1v_1, tmp0_other_with_cast.g1v_1))
      return false;
    if (!(this.h1v_1 === tmp0_other_with_cast.h1v_1))
      return false;
    if (!(this.i1v_1 === tmp0_other_with_cast.i1v_1))
      return false;
    if (!(this.j1v_1 === tmp0_other_with_cast.j1v_1))
      return false;
    return true;
  };
  function Companion_220() {
  }
  var Companion_instance_220;
  function Companion_getInstance_220() {
    return Companion_instance_220;
  }
  function TanzaniaUnitedRepublicof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TZA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Tanzania, United Republic of' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0646\u0632\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.k1v_1 = phoneNumPrefix;
    this.l1v_1 = isoCode2;
    this.m1v_1 = isoCode3;
    this.n1v_1 = currency;
    this.o1v_1 = englishName;
    this.p1v_1 = arabicName;
    this.q1v_1 = phoneRegex;
  }
  protoOf(TanzaniaUnitedRepublicof).wd = function () {
    return this.k1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).rd = function () {
    return this.l1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).sd = function () {
    return this.m1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).td = function () {
    return this.n1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).ud = function () {
    return this.o1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).vd = function () {
    return this.p1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).xd = function () {
    return this.q1v_1;
  };
  protoOf(TanzaniaUnitedRepublicof).toString = function () {
    return 'TanzaniaUnitedRepublicof(phoneNumPrefix=' + this.k1v_1.toString() + ', isoCode2=' + this.l1v_1 + ', isoCode3=' + this.m1v_1 + ', currency=' + toString(this.n1v_1) + ', englishName=' + this.o1v_1 + ', arabicName=' + this.p1v_1 + ', phoneRegex=' + this.q1v_1 + ')';
  };
  protoOf(TanzaniaUnitedRepublicof).hashCode = function () {
    var result = this.k1v_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.l1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1v_1) | 0;
    result = imul(result, 31) + hashCode(this.n1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1v_1) | 0;
    return result;
  };
  protoOf(TanzaniaUnitedRepublicof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TanzaniaUnitedRepublicof))
      return false;
    var tmp0_other_with_cast = other instanceof TanzaniaUnitedRepublicof ? other : THROW_CCE();
    if (!this.k1v_1.equals(tmp0_other_with_cast.k1v_1))
      return false;
    if (!(this.l1v_1 === tmp0_other_with_cast.l1v_1))
      return false;
    if (!(this.m1v_1 === tmp0_other_with_cast.m1v_1))
      return false;
    if (!equals(this.n1v_1, tmp0_other_with_cast.n1v_1))
      return false;
    if (!(this.o1v_1 === tmp0_other_with_cast.o1v_1))
      return false;
    if (!(this.p1v_1 === tmp0_other_with_cast.p1v_1))
      return false;
    if (!(this.q1v_1 === tmp0_other_with_cast.q1v_1))
      return false;
    return true;
  };
  function Companion_221() {
  }
  var Companion_instance_221;
  function Companion_getInstance_221() {
    return Companion_instance_221;
  }
  function Thailand(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TH' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'THA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Thailand' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0627\u064A\u0644\u0627\u0646\u062F' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.r1v_1 = phoneNumPrefix;
    this.s1v_1 = isoCode2;
    this.t1v_1 = isoCode3;
    this.u1v_1 = currency;
    this.v1v_1 = englishName;
    this.w1v_1 = arabicName;
    this.x1v_1 = phoneRegex;
  }
  protoOf(Thailand).wd = function () {
    return this.r1v_1;
  };
  protoOf(Thailand).rd = function () {
    return this.s1v_1;
  };
  protoOf(Thailand).sd = function () {
    return this.t1v_1;
  };
  protoOf(Thailand).td = function () {
    return this.u1v_1;
  };
  protoOf(Thailand).ud = function () {
    return this.v1v_1;
  };
  protoOf(Thailand).vd = function () {
    return this.w1v_1;
  };
  protoOf(Thailand).xd = function () {
    return this.x1v_1;
  };
  protoOf(Thailand).toString = function () {
    return 'Thailand(phoneNumPrefix=' + this.r1v_1.toString() + ', isoCode2=' + this.s1v_1 + ', isoCode3=' + this.t1v_1 + ', currency=' + toString(this.u1v_1) + ', englishName=' + this.v1v_1 + ', arabicName=' + this.w1v_1 + ', phoneRegex=' + this.x1v_1 + ')';
  };
  protoOf(Thailand).hashCode = function () {
    var result = this.r1v_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.s1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1v_1) | 0;
    result = imul(result, 31) + hashCode(this.u1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1v_1) | 0;
    return result;
  };
  protoOf(Thailand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Thailand))
      return false;
    var tmp0_other_with_cast = other instanceof Thailand ? other : THROW_CCE();
    if (!this.r1v_1.equals(tmp0_other_with_cast.r1v_1))
      return false;
    if (!(this.s1v_1 === tmp0_other_with_cast.s1v_1))
      return false;
    if (!(this.t1v_1 === tmp0_other_with_cast.t1v_1))
      return false;
    if (!equals(this.u1v_1, tmp0_other_with_cast.u1v_1))
      return false;
    if (!(this.v1v_1 === tmp0_other_with_cast.v1v_1))
      return false;
    if (!(this.w1v_1 === tmp0_other_with_cast.w1v_1))
      return false;
    if (!(this.x1v_1 === tmp0_other_with_cast.x1v_1))
      return false;
    return true;
  };
  function Companion_222() {
  }
  var Companion_instance_222;
  function Companion_getInstance_222() {
    return Companion_instance_222;
  }
  function TimorLeste(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TL' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TLS' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Timor-Leste' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u064A\u0645\u0648\u0631 \u0627\u0644\u0634\u0631\u0642\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.y1v_1 = phoneNumPrefix;
    this.z1v_1 = isoCode2;
    this.a1w_1 = isoCode3;
    this.b1w_1 = currency;
    this.c1w_1 = englishName;
    this.d1w_1 = arabicName;
    this.e1w_1 = phoneRegex;
  }
  protoOf(TimorLeste).wd = function () {
    return this.y1v_1;
  };
  protoOf(TimorLeste).rd = function () {
    return this.z1v_1;
  };
  protoOf(TimorLeste).sd = function () {
    return this.a1w_1;
  };
  protoOf(TimorLeste).td = function () {
    return this.b1w_1;
  };
  protoOf(TimorLeste).ud = function () {
    return this.c1w_1;
  };
  protoOf(TimorLeste).vd = function () {
    return this.d1w_1;
  };
  protoOf(TimorLeste).xd = function () {
    return this.e1w_1;
  };
  protoOf(TimorLeste).toString = function () {
    return 'TimorLeste(phoneNumPrefix=' + this.y1v_1.toString() + ', isoCode2=' + this.z1v_1 + ', isoCode3=' + this.a1w_1 + ', currency=' + toString(this.b1w_1) + ', englishName=' + this.c1w_1 + ', arabicName=' + this.d1w_1 + ', phoneRegex=' + this.e1w_1 + ')';
  };
  protoOf(TimorLeste).hashCode = function () {
    var result = this.y1v_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.z1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1w_1) | 0;
    result = imul(result, 31) + hashCode(this.b1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1w_1) | 0;
    return result;
  };
  protoOf(TimorLeste).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimorLeste))
      return false;
    var tmp0_other_with_cast = other instanceof TimorLeste ? other : THROW_CCE();
    if (!this.y1v_1.equals(tmp0_other_with_cast.y1v_1))
      return false;
    if (!(this.z1v_1 === tmp0_other_with_cast.z1v_1))
      return false;
    if (!(this.a1w_1 === tmp0_other_with_cast.a1w_1))
      return false;
    if (!equals(this.b1w_1, tmp0_other_with_cast.b1w_1))
      return false;
    if (!(this.c1w_1 === tmp0_other_with_cast.c1w_1))
      return false;
    if (!(this.d1w_1 === tmp0_other_with_cast.d1w_1))
      return false;
    if (!(this.e1w_1 === tmp0_other_with_cast.e1w_1))
      return false;
    return true;
  };
  function Companion_223() {
  }
  var Companion_instance_223;
  function Companion_getInstance_223() {
    return Companion_instance_223;
  }
  function Togo(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TGO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Togo' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0648\u063A\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.f1w_1 = phoneNumPrefix;
    this.g1w_1 = isoCode2;
    this.h1w_1 = isoCode3;
    this.i1w_1 = currency;
    this.j1w_1 = englishName;
    this.k1w_1 = arabicName;
    this.l1w_1 = phoneRegex;
  }
  protoOf(Togo).wd = function () {
    return this.f1w_1;
  };
  protoOf(Togo).rd = function () {
    return this.g1w_1;
  };
  protoOf(Togo).sd = function () {
    return this.h1w_1;
  };
  protoOf(Togo).td = function () {
    return this.i1w_1;
  };
  protoOf(Togo).ud = function () {
    return this.j1w_1;
  };
  protoOf(Togo).vd = function () {
    return this.k1w_1;
  };
  protoOf(Togo).xd = function () {
    return this.l1w_1;
  };
  protoOf(Togo).toString = function () {
    return 'Togo(phoneNumPrefix=' + this.f1w_1.toString() + ', isoCode2=' + this.g1w_1 + ', isoCode3=' + this.h1w_1 + ', currency=' + toString(this.i1w_1) + ', englishName=' + this.j1w_1 + ', arabicName=' + this.k1w_1 + ', phoneRegex=' + this.l1w_1 + ')';
  };
  protoOf(Togo).hashCode = function () {
    var result = this.f1w_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1w_1) | 0;
    result = imul(result, 31) + hashCode(this.i1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1w_1) | 0;
    return result;
  };
  protoOf(Togo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Togo))
      return false;
    var tmp0_other_with_cast = other instanceof Togo ? other : THROW_CCE();
    if (!this.f1w_1.equals(tmp0_other_with_cast.f1w_1))
      return false;
    if (!(this.g1w_1 === tmp0_other_with_cast.g1w_1))
      return false;
    if (!(this.h1w_1 === tmp0_other_with_cast.h1w_1))
      return false;
    if (!equals(this.i1w_1, tmp0_other_with_cast.i1w_1))
      return false;
    if (!(this.j1w_1 === tmp0_other_with_cast.j1w_1))
      return false;
    if (!(this.k1w_1 === tmp0_other_with_cast.k1w_1))
      return false;
    if (!(this.l1w_1 === tmp0_other_with_cast.l1w_1))
      return false;
    return true;
  };
  function Companion_224() {
  }
  var Companion_instance_224;
  function Companion_getInstance_224() {
    return Companion_instance_224;
  }
  function Tokelau(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TK' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TKL' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Tokelau' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0648\u0643\u064A\u0644\u0627\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.m1w_1 = phoneNumPrefix;
    this.n1w_1 = isoCode2;
    this.o1w_1 = isoCode3;
    this.p1w_1 = currency;
    this.q1w_1 = englishName;
    this.r1w_1 = arabicName;
    this.s1w_1 = phoneRegex;
  }
  protoOf(Tokelau).wd = function () {
    return this.m1w_1;
  };
  protoOf(Tokelau).rd = function () {
    return this.n1w_1;
  };
  protoOf(Tokelau).sd = function () {
    return this.o1w_1;
  };
  protoOf(Tokelau).td = function () {
    return this.p1w_1;
  };
  protoOf(Tokelau).ud = function () {
    return this.q1w_1;
  };
  protoOf(Tokelau).vd = function () {
    return this.r1w_1;
  };
  protoOf(Tokelau).xd = function () {
    return this.s1w_1;
  };
  protoOf(Tokelau).toString = function () {
    return 'Tokelau(phoneNumPrefix=' + this.m1w_1.toString() + ', isoCode2=' + this.n1w_1 + ', isoCode3=' + this.o1w_1 + ', currency=' + toString(this.p1w_1) + ', englishName=' + this.q1w_1 + ', arabicName=' + this.r1w_1 + ', phoneRegex=' + this.s1w_1 + ')';
  };
  protoOf(Tokelau).hashCode = function () {
    var result = this.m1w_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.n1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1w_1) | 0;
    result = imul(result, 31) + hashCode(this.p1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1w_1) | 0;
    return result;
  };
  protoOf(Tokelau).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Tokelau))
      return false;
    var tmp0_other_with_cast = other instanceof Tokelau ? other : THROW_CCE();
    if (!this.m1w_1.equals(tmp0_other_with_cast.m1w_1))
      return false;
    if (!(this.n1w_1 === tmp0_other_with_cast.n1w_1))
      return false;
    if (!(this.o1w_1 === tmp0_other_with_cast.o1w_1))
      return false;
    if (!equals(this.p1w_1, tmp0_other_with_cast.p1w_1))
      return false;
    if (!(this.q1w_1 === tmp0_other_with_cast.q1w_1))
      return false;
    if (!(this.r1w_1 === tmp0_other_with_cast.r1w_1))
      return false;
    if (!(this.s1w_1 === tmp0_other_with_cast.s1w_1))
      return false;
    return true;
  };
  function Companion_225() {
  }
  var Companion_instance_225;
  function Companion_getInstance_225() {
    return Companion_instance_225;
  }
  function Tonga(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TO' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TON' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Tonga' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0648\u0646\u063A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.t1w_1 = phoneNumPrefix;
    this.u1w_1 = isoCode2;
    this.v1w_1 = isoCode3;
    this.w1w_1 = currency;
    this.x1w_1 = englishName;
    this.y1w_1 = arabicName;
    this.z1w_1 = phoneRegex;
  }
  protoOf(Tonga).wd = function () {
    return this.t1w_1;
  };
  protoOf(Tonga).rd = function () {
    return this.u1w_1;
  };
  protoOf(Tonga).sd = function () {
    return this.v1w_1;
  };
  protoOf(Tonga).td = function () {
    return this.w1w_1;
  };
  protoOf(Tonga).ud = function () {
    return this.x1w_1;
  };
  protoOf(Tonga).vd = function () {
    return this.y1w_1;
  };
  protoOf(Tonga).xd = function () {
    return this.z1w_1;
  };
  protoOf(Tonga).toString = function () {
    return 'Tonga(phoneNumPrefix=' + this.t1w_1.toString() + ', isoCode2=' + this.u1w_1 + ', isoCode3=' + this.v1w_1 + ', currency=' + toString(this.w1w_1) + ', englishName=' + this.x1w_1 + ', arabicName=' + this.y1w_1 + ', phoneRegex=' + this.z1w_1 + ')';
  };
  protoOf(Tonga).hashCode = function () {
    var result = this.t1w_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1w_1) | 0;
    result = imul(result, 31) + hashCode(this.w1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1w_1) | 0;
    return result;
  };
  protoOf(Tonga).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Tonga))
      return false;
    var tmp0_other_with_cast = other instanceof Tonga ? other : THROW_CCE();
    if (!this.t1w_1.equals(tmp0_other_with_cast.t1w_1))
      return false;
    if (!(this.u1w_1 === tmp0_other_with_cast.u1w_1))
      return false;
    if (!(this.v1w_1 === tmp0_other_with_cast.v1w_1))
      return false;
    if (!equals(this.w1w_1, tmp0_other_with_cast.w1w_1))
      return false;
    if (!(this.x1w_1 === tmp0_other_with_cast.x1w_1))
      return false;
    if (!(this.y1w_1 === tmp0_other_with_cast.y1w_1))
      return false;
    if (!(this.z1w_1 === tmp0_other_with_cast.z1w_1))
      return false;
    return true;
  };
  function Companion_226() {
  }
  var Companion_instance_226;
  function Companion_getInstance_226() {
    return Companion_instance_226;
  }
  function TrinidadandTobago(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TT' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TTO' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Trinidad and Tobago' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0631\u064A\u0646\u064A\u062F\u0627\u062F \u0648\u062A\u0648\u0628\u0627\u063A\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.a1x_1 = phoneNumPrefix;
    this.b1x_1 = isoCode2;
    this.c1x_1 = isoCode3;
    this.d1x_1 = currency;
    this.e1x_1 = englishName;
    this.f1x_1 = arabicName;
    this.g1x_1 = phoneRegex;
  }
  protoOf(TrinidadandTobago).wd = function () {
    return this.a1x_1;
  };
  protoOf(TrinidadandTobago).rd = function () {
    return this.b1x_1;
  };
  protoOf(TrinidadandTobago).sd = function () {
    return this.c1x_1;
  };
  protoOf(TrinidadandTobago).td = function () {
    return this.d1x_1;
  };
  protoOf(TrinidadandTobago).ud = function () {
    return this.e1x_1;
  };
  protoOf(TrinidadandTobago).vd = function () {
    return this.f1x_1;
  };
  protoOf(TrinidadandTobago).xd = function () {
    return this.g1x_1;
  };
  protoOf(TrinidadandTobago).toString = function () {
    return 'TrinidadandTobago(phoneNumPrefix=' + this.a1x_1.toString() + ', isoCode2=' + this.b1x_1 + ', isoCode3=' + this.c1x_1 + ', currency=' + toString(this.d1x_1) + ', englishName=' + this.e1x_1 + ', arabicName=' + this.f1x_1 + ', phoneRegex=' + this.g1x_1 + ')';
  };
  protoOf(TrinidadandTobago).hashCode = function () {
    var result = this.a1x_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1x_1) | 0;
    result = imul(result, 31) + hashCode(this.d1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1x_1) | 0;
    return result;
  };
  protoOf(TrinidadandTobago).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TrinidadandTobago))
      return false;
    var tmp0_other_with_cast = other instanceof TrinidadandTobago ? other : THROW_CCE();
    if (!this.a1x_1.equals(tmp0_other_with_cast.a1x_1))
      return false;
    if (!(this.b1x_1 === tmp0_other_with_cast.b1x_1))
      return false;
    if (!(this.c1x_1 === tmp0_other_with_cast.c1x_1))
      return false;
    if (!equals(this.d1x_1, tmp0_other_with_cast.d1x_1))
      return false;
    if (!(this.e1x_1 === tmp0_other_with_cast.e1x_1))
      return false;
    if (!(this.f1x_1 === tmp0_other_with_cast.f1x_1))
      return false;
    if (!(this.g1x_1 === tmp0_other_with_cast.g1x_1))
      return false;
    return true;
  };
  function Companion_227() {
  }
  var Companion_instance_227;
  function Companion_getInstance_227() {
    return Companion_instance_227;
  }
  function Tunisia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(216, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TUN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Tunisia' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0648\u0646\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(8) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '20123456' : phoneNumberHint;
    this.za_1 = phoneNumPrefix;
    this.ab_1 = isoCode2;
    this.bb_1 = isoCode3;
    this.cb_1 = currency;
    this.db_1 = englishName;
    this.eb_1 = arabicName;
    this.fb_1 = phoneRegex;
    this.gb_1 = phoneNumberHint;
  }
  protoOf(Tunisia).wd = function () {
    return this.za_1;
  };
  protoOf(Tunisia).rd = function () {
    return this.ab_1;
  };
  protoOf(Tunisia).sd = function () {
    return this.bb_1;
  };
  protoOf(Tunisia).td = function () {
    return this.cb_1;
  };
  protoOf(Tunisia).ud = function () {
    return this.db_1;
  };
  protoOf(Tunisia).vd = function () {
    return this.eb_1;
  };
  protoOf(Tunisia).xd = function () {
    return this.fb_1;
  };
  protoOf(Tunisia).yd = function () {
    return this.gb_1;
  };
  protoOf(Tunisia).toString = function () {
    return 'Tunisia(phoneNumPrefix=' + this.za_1.toString() + ', isoCode2=' + this.ab_1 + ', isoCode3=' + this.bb_1 + ', currency=' + toString(this.cb_1) + ', englishName=' + this.db_1 + ', arabicName=' + this.eb_1 + ', phoneRegex=' + this.fb_1 + ', phoneNumberHint=' + this.gb_1 + ')';
  };
  protoOf(Tunisia).hashCode = function () {
    var result = this.za_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ab_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bb_1) | 0;
    result = imul(result, 31) + hashCode(this.cb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.db_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.eb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.gb_1) | 0;
    return result;
  };
  protoOf(Tunisia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Tunisia))
      return false;
    var tmp0_other_with_cast = other instanceof Tunisia ? other : THROW_CCE();
    if (!this.za_1.equals(tmp0_other_with_cast.za_1))
      return false;
    if (!(this.ab_1 === tmp0_other_with_cast.ab_1))
      return false;
    if (!(this.bb_1 === tmp0_other_with_cast.bb_1))
      return false;
    if (!equals(this.cb_1, tmp0_other_with_cast.cb_1))
      return false;
    if (!(this.db_1 === tmp0_other_with_cast.db_1))
      return false;
    if (!(this.eb_1 === tmp0_other_with_cast.eb_1))
      return false;
    if (!(this.fb_1 === tmp0_other_with_cast.fb_1))
      return false;
    if (!(this.gb_1 === tmp0_other_with_cast.gb_1))
      return false;
    return true;
  };
  function Companion_228() {
  }
  var Companion_instance_228;
  function Companion_getInstance_228() {
    return Companion_instance_228;
  }
  function Turkey(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(90, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TR' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TUR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Turkey' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0631\u0643\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '5012345678' : phoneNumberHint;
    this.ra_1 = phoneNumPrefix;
    this.sa_1 = isoCode2;
    this.ta_1 = isoCode3;
    this.ua_1 = currency;
    this.va_1 = englishName;
    this.wa_1 = arabicName;
    this.xa_1 = phoneRegex;
    this.ya_1 = phoneNumberHint;
  }
  protoOf(Turkey).wd = function () {
    return this.ra_1;
  };
  protoOf(Turkey).rd = function () {
    return this.sa_1;
  };
  protoOf(Turkey).sd = function () {
    return this.ta_1;
  };
  protoOf(Turkey).td = function () {
    return this.ua_1;
  };
  protoOf(Turkey).ud = function () {
    return this.va_1;
  };
  protoOf(Turkey).vd = function () {
    return this.wa_1;
  };
  protoOf(Turkey).xd = function () {
    return this.xa_1;
  };
  protoOf(Turkey).yd = function () {
    return this.ya_1;
  };
  protoOf(Turkey).toString = function () {
    return 'Turkey(phoneNumPrefix=' + this.ra_1.toString() + ', isoCode2=' + this.sa_1 + ', isoCode3=' + this.ta_1 + ', currency=' + toString(this.ua_1) + ', englishName=' + this.va_1 + ', arabicName=' + this.wa_1 + ', phoneRegex=' + this.xa_1 + ', phoneNumberHint=' + this.ya_1 + ')';
  };
  protoOf(Turkey).hashCode = function () {
    var result = this.ra_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.sa_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ta_1) | 0;
    result = imul(result, 31) + hashCode(this.ua_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.va_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.wa_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xa_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ya_1) | 0;
    return result;
  };
  protoOf(Turkey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Turkey))
      return false;
    var tmp0_other_with_cast = other instanceof Turkey ? other : THROW_CCE();
    if (!this.ra_1.equals(tmp0_other_with_cast.ra_1))
      return false;
    if (!(this.sa_1 === tmp0_other_with_cast.sa_1))
      return false;
    if (!(this.ta_1 === tmp0_other_with_cast.ta_1))
      return false;
    if (!equals(this.ua_1, tmp0_other_with_cast.ua_1))
      return false;
    if (!(this.va_1 === tmp0_other_with_cast.va_1))
      return false;
    if (!(this.wa_1 === tmp0_other_with_cast.wa_1))
      return false;
    if (!(this.xa_1 === tmp0_other_with_cast.xa_1))
      return false;
    if (!(this.ya_1 === tmp0_other_with_cast.ya_1))
      return false;
    return true;
  };
  function Companion_229() {
  }
  var Companion_instance_229;
  function Companion_getInstance_229() {
    return Companion_instance_229;
  }
  function Turkmenistan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TKM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Turkmenistan' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.h1x_1 = phoneNumPrefix;
    this.i1x_1 = isoCode2;
    this.j1x_1 = isoCode3;
    this.k1x_1 = currency;
    this.l1x_1 = englishName;
    this.m1x_1 = arabicName;
    this.n1x_1 = phoneRegex;
  }
  protoOf(Turkmenistan).wd = function () {
    return this.h1x_1;
  };
  protoOf(Turkmenistan).rd = function () {
    return this.i1x_1;
  };
  protoOf(Turkmenistan).sd = function () {
    return this.j1x_1;
  };
  protoOf(Turkmenistan).td = function () {
    return this.k1x_1;
  };
  protoOf(Turkmenistan).ud = function () {
    return this.l1x_1;
  };
  protoOf(Turkmenistan).vd = function () {
    return this.m1x_1;
  };
  protoOf(Turkmenistan).xd = function () {
    return this.n1x_1;
  };
  protoOf(Turkmenistan).toString = function () {
    return 'Turkmenistan(phoneNumPrefix=' + this.h1x_1.toString() + ', isoCode2=' + this.i1x_1 + ', isoCode3=' + this.j1x_1 + ', currency=' + toString(this.k1x_1) + ', englishName=' + this.l1x_1 + ', arabicName=' + this.m1x_1 + ', phoneRegex=' + this.n1x_1 + ')';
  };
  protoOf(Turkmenistan).hashCode = function () {
    var result = this.h1x_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1x_1) | 0;
    result = imul(result, 31) + hashCode(this.k1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1x_1) | 0;
    return result;
  };
  protoOf(Turkmenistan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Turkmenistan))
      return false;
    var tmp0_other_with_cast = other instanceof Turkmenistan ? other : THROW_CCE();
    if (!this.h1x_1.equals(tmp0_other_with_cast.h1x_1))
      return false;
    if (!(this.i1x_1 === tmp0_other_with_cast.i1x_1))
      return false;
    if (!(this.j1x_1 === tmp0_other_with_cast.j1x_1))
      return false;
    if (!equals(this.k1x_1, tmp0_other_with_cast.k1x_1))
      return false;
    if (!(this.l1x_1 === tmp0_other_with_cast.l1x_1))
      return false;
    if (!(this.m1x_1 === tmp0_other_with_cast.m1x_1))
      return false;
    if (!(this.n1x_1 === tmp0_other_with_cast.n1x_1))
      return false;
    return true;
  };
  function Companion_230() {
  }
  var Companion_instance_230;
  function Companion_getInstance_230() {
    return Companion_instance_230;
  }
  function TurksandCaicosIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TC' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TCA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Turks and Caicos Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u062A\u0648\u0631\u0643\u0633 \u0648\u0643\u0627\u064A\u0643\u0648\u0633' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.o1x_1 = phoneNumPrefix;
    this.p1x_1 = isoCode2;
    this.q1x_1 = isoCode3;
    this.r1x_1 = currency;
    this.s1x_1 = englishName;
    this.t1x_1 = arabicName;
    this.u1x_1 = phoneRegex;
  }
  protoOf(TurksandCaicosIslands).wd = function () {
    return this.o1x_1;
  };
  protoOf(TurksandCaicosIslands).rd = function () {
    return this.p1x_1;
  };
  protoOf(TurksandCaicosIslands).sd = function () {
    return this.q1x_1;
  };
  protoOf(TurksandCaicosIslands).td = function () {
    return this.r1x_1;
  };
  protoOf(TurksandCaicosIslands).ud = function () {
    return this.s1x_1;
  };
  protoOf(TurksandCaicosIslands).vd = function () {
    return this.t1x_1;
  };
  protoOf(TurksandCaicosIslands).xd = function () {
    return this.u1x_1;
  };
  protoOf(TurksandCaicosIslands).toString = function () {
    return 'TurksandCaicosIslands(phoneNumPrefix=' + this.o1x_1.toString() + ', isoCode2=' + this.p1x_1 + ', isoCode3=' + this.q1x_1 + ', currency=' + toString(this.r1x_1) + ', englishName=' + this.s1x_1 + ', arabicName=' + this.t1x_1 + ', phoneRegex=' + this.u1x_1 + ')';
  };
  protoOf(TurksandCaicosIslands).hashCode = function () {
    var result = this.o1x_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1x_1) | 0;
    result = imul(result, 31) + hashCode(this.r1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1x_1) | 0;
    return result;
  };
  protoOf(TurksandCaicosIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TurksandCaicosIslands))
      return false;
    var tmp0_other_with_cast = other instanceof TurksandCaicosIslands ? other : THROW_CCE();
    if (!this.o1x_1.equals(tmp0_other_with_cast.o1x_1))
      return false;
    if (!(this.p1x_1 === tmp0_other_with_cast.p1x_1))
      return false;
    if (!(this.q1x_1 === tmp0_other_with_cast.q1x_1))
      return false;
    if (!equals(this.r1x_1, tmp0_other_with_cast.r1x_1))
      return false;
    if (!(this.s1x_1 === tmp0_other_with_cast.s1x_1))
      return false;
    if (!(this.t1x_1 === tmp0_other_with_cast.t1x_1))
      return false;
    if (!(this.u1x_1 === tmp0_other_with_cast.u1x_1))
      return false;
    return true;
  };
  function Companion_231() {
  }
  var Companion_instance_231;
  function Companion_getInstance_231() {
    return Companion_instance_231;
  }
  function Tuvalu(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'TV' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'TUV' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Tuvalu' : englishName;
    arabicName = arabicName === VOID ? '\u062A\u0648\u0641\u0627\u0644\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.v1x_1 = phoneNumPrefix;
    this.w1x_1 = isoCode2;
    this.x1x_1 = isoCode3;
    this.y1x_1 = currency;
    this.z1x_1 = englishName;
    this.a1y_1 = arabicName;
    this.b1y_1 = phoneRegex;
  }
  protoOf(Tuvalu).wd = function () {
    return this.v1x_1;
  };
  protoOf(Tuvalu).rd = function () {
    return this.w1x_1;
  };
  protoOf(Tuvalu).sd = function () {
    return this.x1x_1;
  };
  protoOf(Tuvalu).td = function () {
    return this.y1x_1;
  };
  protoOf(Tuvalu).ud = function () {
    return this.z1x_1;
  };
  protoOf(Tuvalu).vd = function () {
    return this.a1y_1;
  };
  protoOf(Tuvalu).xd = function () {
    return this.b1y_1;
  };
  protoOf(Tuvalu).toString = function () {
    return 'Tuvalu(phoneNumPrefix=' + this.v1x_1.toString() + ', isoCode2=' + this.w1x_1 + ', isoCode3=' + this.x1x_1 + ', currency=' + toString(this.y1x_1) + ', englishName=' + this.z1x_1 + ', arabicName=' + this.a1y_1 + ', phoneRegex=' + this.b1y_1 + ')';
  };
  protoOf(Tuvalu).hashCode = function () {
    var result = this.v1x_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1x_1) | 0;
    result = imul(result, 31) + hashCode(this.y1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1y_1) | 0;
    return result;
  };
  protoOf(Tuvalu).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Tuvalu))
      return false;
    var tmp0_other_with_cast = other instanceof Tuvalu ? other : THROW_CCE();
    if (!this.v1x_1.equals(tmp0_other_with_cast.v1x_1))
      return false;
    if (!(this.w1x_1 === tmp0_other_with_cast.w1x_1))
      return false;
    if (!(this.x1x_1 === tmp0_other_with_cast.x1x_1))
      return false;
    if (!equals(this.y1x_1, tmp0_other_with_cast.y1x_1))
      return false;
    if (!(this.z1x_1 === tmp0_other_with_cast.z1x_1))
      return false;
    if (!(this.a1y_1 === tmp0_other_with_cast.a1y_1))
      return false;
    if (!(this.b1y_1 === tmp0_other_with_cast.b1y_1))
      return false;
    return true;
  };
  function Companion_232() {
  }
  var Companion_instance_232;
  function Companion_getInstance_232() {
    return Companion_instance_232;
  }
  function Uganda(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'UG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'UGA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Uganda' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0648\u063A\u0646\u062F\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.c1y_1 = phoneNumPrefix;
    this.d1y_1 = isoCode2;
    this.e1y_1 = isoCode3;
    this.f1y_1 = currency;
    this.g1y_1 = englishName;
    this.h1y_1 = arabicName;
    this.i1y_1 = phoneRegex;
  }
  protoOf(Uganda).wd = function () {
    return this.c1y_1;
  };
  protoOf(Uganda).rd = function () {
    return this.d1y_1;
  };
  protoOf(Uganda).sd = function () {
    return this.e1y_1;
  };
  protoOf(Uganda).td = function () {
    return this.f1y_1;
  };
  protoOf(Uganda).ud = function () {
    return this.g1y_1;
  };
  protoOf(Uganda).vd = function () {
    return this.h1y_1;
  };
  protoOf(Uganda).xd = function () {
    return this.i1y_1;
  };
  protoOf(Uganda).toString = function () {
    return 'Uganda(phoneNumPrefix=' + this.c1y_1.toString() + ', isoCode2=' + this.d1y_1 + ', isoCode3=' + this.e1y_1 + ', currency=' + toString(this.f1y_1) + ', englishName=' + this.g1y_1 + ', arabicName=' + this.h1y_1 + ', phoneRegex=' + this.i1y_1 + ')';
  };
  protoOf(Uganda).hashCode = function () {
    var result = this.c1y_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.d1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1y_1) | 0;
    result = imul(result, 31) + hashCode(this.f1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1y_1) | 0;
    return result;
  };
  protoOf(Uganda).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Uganda))
      return false;
    var tmp0_other_with_cast = other instanceof Uganda ? other : THROW_CCE();
    if (!this.c1y_1.equals(tmp0_other_with_cast.c1y_1))
      return false;
    if (!(this.d1y_1 === tmp0_other_with_cast.d1y_1))
      return false;
    if (!(this.e1y_1 === tmp0_other_with_cast.e1y_1))
      return false;
    if (!equals(this.f1y_1, tmp0_other_with_cast.f1y_1))
      return false;
    if (!(this.g1y_1 === tmp0_other_with_cast.g1y_1))
      return false;
    if (!(this.h1y_1 === tmp0_other_with_cast.h1y_1))
      return false;
    if (!(this.i1y_1 === tmp0_other_with_cast.i1y_1))
      return false;
    return true;
  };
  function Companion_233() {
  }
  var Companion_instance_233;
  function Companion_getInstance_233() {
    return Companion_instance_233;
  }
  function Ukraine(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'UA' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'UKR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Ukraine' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.j1y_1 = phoneNumPrefix;
    this.k1y_1 = isoCode2;
    this.l1y_1 = isoCode3;
    this.m1y_1 = currency;
    this.n1y_1 = englishName;
    this.o1y_1 = arabicName;
    this.p1y_1 = phoneRegex;
  }
  protoOf(Ukraine).wd = function () {
    return this.j1y_1;
  };
  protoOf(Ukraine).rd = function () {
    return this.k1y_1;
  };
  protoOf(Ukraine).sd = function () {
    return this.l1y_1;
  };
  protoOf(Ukraine).td = function () {
    return this.m1y_1;
  };
  protoOf(Ukraine).ud = function () {
    return this.n1y_1;
  };
  protoOf(Ukraine).vd = function () {
    return this.o1y_1;
  };
  protoOf(Ukraine).xd = function () {
    return this.p1y_1;
  };
  protoOf(Ukraine).toString = function () {
    return 'Ukraine(phoneNumPrefix=' + this.j1y_1.toString() + ', isoCode2=' + this.k1y_1 + ', isoCode3=' + this.l1y_1 + ', currency=' + toString(this.m1y_1) + ', englishName=' + this.n1y_1 + ', arabicName=' + this.o1y_1 + ', phoneRegex=' + this.p1y_1 + ')';
  };
  protoOf(Ukraine).hashCode = function () {
    var result = this.j1y_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.k1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1y_1) | 0;
    result = imul(result, 31) + hashCode(this.m1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1y_1) | 0;
    return result;
  };
  protoOf(Ukraine).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ukraine))
      return false;
    var tmp0_other_with_cast = other instanceof Ukraine ? other : THROW_CCE();
    if (!this.j1y_1.equals(tmp0_other_with_cast.j1y_1))
      return false;
    if (!(this.k1y_1 === tmp0_other_with_cast.k1y_1))
      return false;
    if (!(this.l1y_1 === tmp0_other_with_cast.l1y_1))
      return false;
    if (!equals(this.m1y_1, tmp0_other_with_cast.m1y_1))
      return false;
    if (!(this.n1y_1 === tmp0_other_with_cast.n1y_1))
      return false;
    if (!(this.o1y_1 === tmp0_other_with_cast.o1y_1))
      return false;
    if (!(this.p1y_1 === tmp0_other_with_cast.p1y_1))
      return false;
    return true;
  };
  function Companion_234() {
  }
  var Companion_instance_234;
  function Companion_getInstance_234() {
    return Companion_instance_234;
  }
  function UnitedKingdomofGreatBritainandNorthernIreland(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(44, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'GB' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'GBR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'United Kingdom of Great Britain and Northern Ireland' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '7400123456' : phoneNumberHint;
    this.ja_1 = phoneNumPrefix;
    this.ka_1 = isoCode2;
    this.la_1 = isoCode3;
    this.ma_1 = currency;
    this.na_1 = englishName;
    this.oa_1 = arabicName;
    this.pa_1 = phoneRegex;
    this.qa_1 = phoneNumberHint;
  }
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).wd = function () {
    return this.ja_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).rd = function () {
    return this.ka_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).sd = function () {
    return this.la_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).td = function () {
    return this.ma_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).ud = function () {
    return this.na_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).vd = function () {
    return this.oa_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).xd = function () {
    return this.pa_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).yd = function () {
    return this.qa_1;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).toString = function () {
    return 'UnitedKingdomofGreatBritainandNorthernIreland(phoneNumPrefix=' + this.ja_1.toString() + ', isoCode2=' + this.ka_1 + ', isoCode3=' + this.la_1 + ', currency=' + toString(this.ma_1) + ', englishName=' + this.na_1 + ', arabicName=' + this.oa_1 + ', phoneRegex=' + this.pa_1 + ', phoneNumberHint=' + this.qa_1 + ')';
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).hashCode = function () {
    var result = this.ja_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ka_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.la_1) | 0;
    result = imul(result, 31) + hashCode(this.ma_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.na_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.oa_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pa_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qa_1) | 0;
    return result;
  };
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UnitedKingdomofGreatBritainandNorthernIreland))
      return false;
    var tmp0_other_with_cast = other instanceof UnitedKingdomofGreatBritainandNorthernIreland ? other : THROW_CCE();
    if (!this.ja_1.equals(tmp0_other_with_cast.ja_1))
      return false;
    if (!(this.ka_1 === tmp0_other_with_cast.ka_1))
      return false;
    if (!(this.la_1 === tmp0_other_with_cast.la_1))
      return false;
    if (!equals(this.ma_1, tmp0_other_with_cast.ma_1))
      return false;
    if (!(this.na_1 === tmp0_other_with_cast.na_1))
      return false;
    if (!(this.oa_1 === tmp0_other_with_cast.oa_1))
      return false;
    if (!(this.pa_1 === tmp0_other_with_cast.pa_1))
      return false;
    if (!(this.qa_1 === tmp0_other_with_cast.qa_1))
      return false;
    return true;
  };
  function Companion_235() {
  }
  var Companion_instance_235;
  function Companion_getInstance_235() {
    return Companion_instance_235;
  }
  function UnitedStatesofAmerica(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex, phoneNumberHint) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(1, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'US' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'USA' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'United States of America' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getSimplePhoneRegex(10) : phoneRegex;
    phoneNumberHint = phoneNumberHint === VOID ? '2015550123' : phoneNumberHint;
    this.p7_1 = phoneNumPrefix;
    this.q7_1 = isoCode2;
    this.r7_1 = isoCode3;
    this.s7_1 = currency;
    this.t7_1 = englishName;
    this.u7_1 = arabicName;
    this.v7_1 = phoneRegex;
    this.w7_1 = phoneNumberHint;
  }
  protoOf(UnitedStatesofAmerica).wd = function () {
    return this.p7_1;
  };
  protoOf(UnitedStatesofAmerica).rd = function () {
    return this.q7_1;
  };
  protoOf(UnitedStatesofAmerica).sd = function () {
    return this.r7_1;
  };
  protoOf(UnitedStatesofAmerica).td = function () {
    return this.s7_1;
  };
  protoOf(UnitedStatesofAmerica).ud = function () {
    return this.t7_1;
  };
  protoOf(UnitedStatesofAmerica).vd = function () {
    return this.u7_1;
  };
  protoOf(UnitedStatesofAmerica).xd = function () {
    return this.v7_1;
  };
  protoOf(UnitedStatesofAmerica).yd = function () {
    return this.w7_1;
  };
  protoOf(UnitedStatesofAmerica).toString = function () {
    return 'UnitedStatesofAmerica(phoneNumPrefix=' + this.p7_1.toString() + ', isoCode2=' + this.q7_1 + ', isoCode3=' + this.r7_1 + ', currency=' + toString(this.s7_1) + ', englishName=' + this.t7_1 + ', arabicName=' + this.u7_1 + ', phoneRegex=' + this.v7_1 + ', phoneNumberHint=' + this.w7_1 + ')';
  };
  protoOf(UnitedStatesofAmerica).hashCode = function () {
    var result = this.p7_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r7_1) | 0;
    result = imul(result, 31) + hashCode(this.s7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w7_1) | 0;
    return result;
  };
  protoOf(UnitedStatesofAmerica).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UnitedStatesofAmerica))
      return false;
    var tmp0_other_with_cast = other instanceof UnitedStatesofAmerica ? other : THROW_CCE();
    if (!this.p7_1.equals(tmp0_other_with_cast.p7_1))
      return false;
    if (!(this.q7_1 === tmp0_other_with_cast.q7_1))
      return false;
    if (!(this.r7_1 === tmp0_other_with_cast.r7_1))
      return false;
    if (!equals(this.s7_1, tmp0_other_with_cast.s7_1))
      return false;
    if (!(this.t7_1 === tmp0_other_with_cast.t7_1))
      return false;
    if (!(this.u7_1 === tmp0_other_with_cast.u7_1))
      return false;
    if (!(this.v7_1 === tmp0_other_with_cast.v7_1))
      return false;
    if (!(this.w7_1 === tmp0_other_with_cast.w7_1))
      return false;
    return true;
  };
  function Companion_236() {
  }
  var Companion_instance_236;
  function Companion_getInstance_236() {
    return Companion_instance_236;
  }
  function UnitedStatesMinorOutlyingIslands(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'UM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'UMI' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'United States Minor Outlying Islands' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629 \u0627\u0644\u0635\u063A\u064A\u0631\u0629 \u0627\u0644\u0646\u0627\u0626\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.q1y_1 = phoneNumPrefix;
    this.r1y_1 = isoCode2;
    this.s1y_1 = isoCode3;
    this.t1y_1 = currency;
    this.u1y_1 = englishName;
    this.v1y_1 = arabicName;
    this.w1y_1 = phoneRegex;
  }
  protoOf(UnitedStatesMinorOutlyingIslands).wd = function () {
    return this.q1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).rd = function () {
    return this.r1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).sd = function () {
    return this.s1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).td = function () {
    return this.t1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).ud = function () {
    return this.u1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).vd = function () {
    return this.v1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).xd = function () {
    return this.w1y_1;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).toString = function () {
    return 'UnitedStatesMinorOutlyingIslands(phoneNumPrefix=' + this.q1y_1.toString() + ', isoCode2=' + this.r1y_1 + ', isoCode3=' + this.s1y_1 + ', currency=' + toString(this.t1y_1) + ', englishName=' + this.u1y_1 + ', arabicName=' + this.v1y_1 + ', phoneRegex=' + this.w1y_1 + ')';
  };
  protoOf(UnitedStatesMinorOutlyingIslands).hashCode = function () {
    var result = this.q1y_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1y_1) | 0;
    result = imul(result, 31) + hashCode(this.t1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1y_1) | 0;
    return result;
  };
  protoOf(UnitedStatesMinorOutlyingIslands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UnitedStatesMinorOutlyingIslands))
      return false;
    var tmp0_other_with_cast = other instanceof UnitedStatesMinorOutlyingIslands ? other : THROW_CCE();
    if (!this.q1y_1.equals(tmp0_other_with_cast.q1y_1))
      return false;
    if (!(this.r1y_1 === tmp0_other_with_cast.r1y_1))
      return false;
    if (!(this.s1y_1 === tmp0_other_with_cast.s1y_1))
      return false;
    if (!equals(this.t1y_1, tmp0_other_with_cast.t1y_1))
      return false;
    if (!(this.u1y_1 === tmp0_other_with_cast.u1y_1))
      return false;
    if (!(this.v1y_1 === tmp0_other_with_cast.v1y_1))
      return false;
    if (!(this.w1y_1 === tmp0_other_with_cast.w1y_1))
      return false;
    return true;
  };
  function Companion_237() {
  }
  var Companion_instance_237;
  function Companion_getInstance_237() {
    return Companion_instance_237;
  }
  function Uruguay(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'UY' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'URY' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Uruguay' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u0623\u0648\u0631\u0648\u063A\u0648\u0627\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.x1y_1 = phoneNumPrefix;
    this.y1y_1 = isoCode2;
    this.z1y_1 = isoCode3;
    this.a1z_1 = currency;
    this.b1z_1 = englishName;
    this.c1z_1 = arabicName;
    this.d1z_1 = phoneRegex;
  }
  protoOf(Uruguay).wd = function () {
    return this.x1y_1;
  };
  protoOf(Uruguay).rd = function () {
    return this.y1y_1;
  };
  protoOf(Uruguay).sd = function () {
    return this.z1y_1;
  };
  protoOf(Uruguay).td = function () {
    return this.a1z_1;
  };
  protoOf(Uruguay).ud = function () {
    return this.b1z_1;
  };
  protoOf(Uruguay).vd = function () {
    return this.c1z_1;
  };
  protoOf(Uruguay).xd = function () {
    return this.d1z_1;
  };
  protoOf(Uruguay).toString = function () {
    return 'Uruguay(phoneNumPrefix=' + this.x1y_1.toString() + ', isoCode2=' + this.y1y_1 + ', isoCode3=' + this.z1y_1 + ', currency=' + toString(this.a1z_1) + ', englishName=' + this.b1z_1 + ', arabicName=' + this.c1z_1 + ', phoneRegex=' + this.d1z_1 + ')';
  };
  protoOf(Uruguay).hashCode = function () {
    var result = this.x1y_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.y1y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1y_1) | 0;
    result = imul(result, 31) + hashCode(this.a1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1z_1) | 0;
    return result;
  };
  protoOf(Uruguay).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Uruguay))
      return false;
    var tmp0_other_with_cast = other instanceof Uruguay ? other : THROW_CCE();
    if (!this.x1y_1.equals(tmp0_other_with_cast.x1y_1))
      return false;
    if (!(this.y1y_1 === tmp0_other_with_cast.y1y_1))
      return false;
    if (!(this.z1y_1 === tmp0_other_with_cast.z1y_1))
      return false;
    if (!equals(this.a1z_1, tmp0_other_with_cast.a1z_1))
      return false;
    if (!(this.b1z_1 === tmp0_other_with_cast.b1z_1))
      return false;
    if (!(this.c1z_1 === tmp0_other_with_cast.c1z_1))
      return false;
    if (!(this.d1z_1 === tmp0_other_with_cast.d1z_1))
      return false;
    return true;
  };
  function Companion_238() {
  }
  var Companion_instance_238;
  function Companion_getInstance_238() {
    return Companion_instance_238;
  }
  function Uzbekistan(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'UZ' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'UZB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Uzbekistan' : englishName;
    arabicName = arabicName === VOID ? '\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.e1z_1 = phoneNumPrefix;
    this.f1z_1 = isoCode2;
    this.g1z_1 = isoCode3;
    this.h1z_1 = currency;
    this.i1z_1 = englishName;
    this.j1z_1 = arabicName;
    this.k1z_1 = phoneRegex;
  }
  protoOf(Uzbekistan).wd = function () {
    return this.e1z_1;
  };
  protoOf(Uzbekistan).rd = function () {
    return this.f1z_1;
  };
  protoOf(Uzbekistan).sd = function () {
    return this.g1z_1;
  };
  protoOf(Uzbekistan).td = function () {
    return this.h1z_1;
  };
  protoOf(Uzbekistan).ud = function () {
    return this.i1z_1;
  };
  protoOf(Uzbekistan).vd = function () {
    return this.j1z_1;
  };
  protoOf(Uzbekistan).xd = function () {
    return this.k1z_1;
  };
  protoOf(Uzbekistan).toString = function () {
    return 'Uzbekistan(phoneNumPrefix=' + this.e1z_1.toString() + ', isoCode2=' + this.f1z_1 + ', isoCode3=' + this.g1z_1 + ', currency=' + toString(this.h1z_1) + ', englishName=' + this.i1z_1 + ', arabicName=' + this.j1z_1 + ', phoneRegex=' + this.k1z_1 + ')';
  };
  protoOf(Uzbekistan).hashCode = function () {
    var result = this.e1z_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.f1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1z_1) | 0;
    result = imul(result, 31) + hashCode(this.h1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1z_1) | 0;
    return result;
  };
  protoOf(Uzbekistan).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Uzbekistan))
      return false;
    var tmp0_other_with_cast = other instanceof Uzbekistan ? other : THROW_CCE();
    if (!this.e1z_1.equals(tmp0_other_with_cast.e1z_1))
      return false;
    if (!(this.f1z_1 === tmp0_other_with_cast.f1z_1))
      return false;
    if (!(this.g1z_1 === tmp0_other_with_cast.g1z_1))
      return false;
    if (!equals(this.h1z_1, tmp0_other_with_cast.h1z_1))
      return false;
    if (!(this.i1z_1 === tmp0_other_with_cast.i1z_1))
      return false;
    if (!(this.j1z_1 === tmp0_other_with_cast.j1z_1))
      return false;
    if (!(this.k1z_1 === tmp0_other_with_cast.k1z_1))
      return false;
    return true;
  };
  function Companion_239() {
  }
  var Companion_instance_239;
  function Companion_getInstance_239() {
    return Companion_instance_239;
  }
  function Vanuatu(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VU' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VUT' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Vanuatu' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u0627\u0646\u0648\u0627\u062A\u0648' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.l1z_1 = phoneNumPrefix;
    this.m1z_1 = isoCode2;
    this.n1z_1 = isoCode3;
    this.o1z_1 = currency;
    this.p1z_1 = englishName;
    this.q1z_1 = arabicName;
    this.r1z_1 = phoneRegex;
  }
  protoOf(Vanuatu).wd = function () {
    return this.l1z_1;
  };
  protoOf(Vanuatu).rd = function () {
    return this.m1z_1;
  };
  protoOf(Vanuatu).sd = function () {
    return this.n1z_1;
  };
  protoOf(Vanuatu).td = function () {
    return this.o1z_1;
  };
  protoOf(Vanuatu).ud = function () {
    return this.p1z_1;
  };
  protoOf(Vanuatu).vd = function () {
    return this.q1z_1;
  };
  protoOf(Vanuatu).xd = function () {
    return this.r1z_1;
  };
  protoOf(Vanuatu).toString = function () {
    return 'Vanuatu(phoneNumPrefix=' + this.l1z_1.toString() + ', isoCode2=' + this.m1z_1 + ', isoCode3=' + this.n1z_1 + ', currency=' + toString(this.o1z_1) + ', englishName=' + this.p1z_1 + ', arabicName=' + this.q1z_1 + ', phoneRegex=' + this.r1z_1 + ')';
  };
  protoOf(Vanuatu).hashCode = function () {
    var result = this.l1z_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.m1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1z_1) | 0;
    result = imul(result, 31) + hashCode(this.o1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1z_1) | 0;
    return result;
  };
  protoOf(Vanuatu).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vanuatu))
      return false;
    var tmp0_other_with_cast = other instanceof Vanuatu ? other : THROW_CCE();
    if (!this.l1z_1.equals(tmp0_other_with_cast.l1z_1))
      return false;
    if (!(this.m1z_1 === tmp0_other_with_cast.m1z_1))
      return false;
    if (!(this.n1z_1 === tmp0_other_with_cast.n1z_1))
      return false;
    if (!equals(this.o1z_1, tmp0_other_with_cast.o1z_1))
      return false;
    if (!(this.p1z_1 === tmp0_other_with_cast.p1z_1))
      return false;
    if (!(this.q1z_1 === tmp0_other_with_cast.q1z_1))
      return false;
    if (!(this.r1z_1 === tmp0_other_with_cast.r1z_1))
      return false;
    return true;
  };
  function Companion_240() {
  }
  var Companion_instance_240;
  function Companion_getInstance_240() {
    return Companion_instance_240;
  }
  function VenezuelaBolivarianRepublicof(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VEN' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Venezuela (Bolivarian Republic of)' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u0646\u0632\u0648\u064A\u0644\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.s1z_1 = phoneNumPrefix;
    this.t1z_1 = isoCode2;
    this.u1z_1 = isoCode3;
    this.v1z_1 = currency;
    this.w1z_1 = englishName;
    this.x1z_1 = arabicName;
    this.y1z_1 = phoneRegex;
  }
  protoOf(VenezuelaBolivarianRepublicof).wd = function () {
    return this.s1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).rd = function () {
    return this.t1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).sd = function () {
    return this.u1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).td = function () {
    return this.v1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).ud = function () {
    return this.w1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).vd = function () {
    return this.x1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).xd = function () {
    return this.y1z_1;
  };
  protoOf(VenezuelaBolivarianRepublicof).toString = function () {
    return 'VenezuelaBolivarianRepublicof(phoneNumPrefix=' + this.s1z_1.toString() + ', isoCode2=' + this.t1z_1 + ', isoCode3=' + this.u1z_1 + ', currency=' + toString(this.v1z_1) + ', englishName=' + this.w1z_1 + ', arabicName=' + this.x1z_1 + ', phoneRegex=' + this.y1z_1 + ')';
  };
  protoOf(VenezuelaBolivarianRepublicof).hashCode = function () {
    var result = this.s1z_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1z_1) | 0;
    result = imul(result, 31) + hashCode(this.v1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x1z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1z_1) | 0;
    return result;
  };
  protoOf(VenezuelaBolivarianRepublicof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VenezuelaBolivarianRepublicof))
      return false;
    var tmp0_other_with_cast = other instanceof VenezuelaBolivarianRepublicof ? other : THROW_CCE();
    if (!this.s1z_1.equals(tmp0_other_with_cast.s1z_1))
      return false;
    if (!(this.t1z_1 === tmp0_other_with_cast.t1z_1))
      return false;
    if (!(this.u1z_1 === tmp0_other_with_cast.u1z_1))
      return false;
    if (!equals(this.v1z_1, tmp0_other_with_cast.v1z_1))
      return false;
    if (!(this.w1z_1 === tmp0_other_with_cast.w1z_1))
      return false;
    if (!(this.x1z_1 === tmp0_other_with_cast.x1z_1))
      return false;
    if (!(this.y1z_1 === tmp0_other_with_cast.y1z_1))
      return false;
    return true;
  };
  function Companion_241() {
  }
  var Companion_instance_241;
  function Companion_getInstance_241() {
    return Companion_instance_241;
  }
  function VietNam(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VN' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VNM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Viet Nam' : englishName;
    arabicName = arabicName === VOID ? '\u0641\u064A\u062A\u0646\u0627\u0645' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.z1z_1 = phoneNumPrefix;
    this.a20_1 = isoCode2;
    this.b20_1 = isoCode3;
    this.c20_1 = currency;
    this.d20_1 = englishName;
    this.e20_1 = arabicName;
    this.f20_1 = phoneRegex;
  }
  protoOf(VietNam).wd = function () {
    return this.z1z_1;
  };
  protoOf(VietNam).rd = function () {
    return this.a20_1;
  };
  protoOf(VietNam).sd = function () {
    return this.b20_1;
  };
  protoOf(VietNam).td = function () {
    return this.c20_1;
  };
  protoOf(VietNam).ud = function () {
    return this.d20_1;
  };
  protoOf(VietNam).vd = function () {
    return this.e20_1;
  };
  protoOf(VietNam).xd = function () {
    return this.f20_1;
  };
  protoOf(VietNam).toString = function () {
    return 'VietNam(phoneNumPrefix=' + this.z1z_1.toString() + ', isoCode2=' + this.a20_1 + ', isoCode3=' + this.b20_1 + ', currency=' + toString(this.c20_1) + ', englishName=' + this.d20_1 + ', arabicName=' + this.e20_1 + ', phoneRegex=' + this.f20_1 + ')';
  };
  protoOf(VietNam).hashCode = function () {
    var result = this.z1z_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b20_1) | 0;
    result = imul(result, 31) + hashCode(this.c20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f20_1) | 0;
    return result;
  };
  protoOf(VietNam).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VietNam))
      return false;
    var tmp0_other_with_cast = other instanceof VietNam ? other : THROW_CCE();
    if (!this.z1z_1.equals(tmp0_other_with_cast.z1z_1))
      return false;
    if (!(this.a20_1 === tmp0_other_with_cast.a20_1))
      return false;
    if (!(this.b20_1 === tmp0_other_with_cast.b20_1))
      return false;
    if (!equals(this.c20_1, tmp0_other_with_cast.c20_1))
      return false;
    if (!(this.d20_1 === tmp0_other_with_cast.d20_1))
      return false;
    if (!(this.e20_1 === tmp0_other_with_cast.e20_1))
      return false;
    if (!(this.f20_1 === tmp0_other_with_cast.f20_1))
      return false;
    return true;
  };
  function Companion_242() {
  }
  var Companion_instance_242;
  function Companion_getInstance_242() {
    return Companion_instance_242;
  }
  function VirginIslandsBritish(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VG' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VGB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Virgin Islands (British)' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0627\u0644\u0639\u0630\u0631\u0627\u0621 \u0627\u0644\u0628\u0631\u064A\u0637\u0627\u0646\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.g20_1 = phoneNumPrefix;
    this.h20_1 = isoCode2;
    this.i20_1 = isoCode3;
    this.j20_1 = currency;
    this.k20_1 = englishName;
    this.l20_1 = arabicName;
    this.m20_1 = phoneRegex;
  }
  protoOf(VirginIslandsBritish).wd = function () {
    return this.g20_1;
  };
  protoOf(VirginIslandsBritish).rd = function () {
    return this.h20_1;
  };
  protoOf(VirginIslandsBritish).sd = function () {
    return this.i20_1;
  };
  protoOf(VirginIslandsBritish).td = function () {
    return this.j20_1;
  };
  protoOf(VirginIslandsBritish).ud = function () {
    return this.k20_1;
  };
  protoOf(VirginIslandsBritish).vd = function () {
    return this.l20_1;
  };
  protoOf(VirginIslandsBritish).xd = function () {
    return this.m20_1;
  };
  protoOf(VirginIslandsBritish).toString = function () {
    return 'VirginIslandsBritish(phoneNumPrefix=' + this.g20_1.toString() + ', isoCode2=' + this.h20_1 + ', isoCode3=' + this.i20_1 + ', currency=' + toString(this.j20_1) + ', englishName=' + this.k20_1 + ', arabicName=' + this.l20_1 + ', phoneRegex=' + this.m20_1 + ')';
  };
  protoOf(VirginIslandsBritish).hashCode = function () {
    var result = this.g20_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i20_1) | 0;
    result = imul(result, 31) + hashCode(this.j20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m20_1) | 0;
    return result;
  };
  protoOf(VirginIslandsBritish).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VirginIslandsBritish))
      return false;
    var tmp0_other_with_cast = other instanceof VirginIslandsBritish ? other : THROW_CCE();
    if (!this.g20_1.equals(tmp0_other_with_cast.g20_1))
      return false;
    if (!(this.h20_1 === tmp0_other_with_cast.h20_1))
      return false;
    if (!(this.i20_1 === tmp0_other_with_cast.i20_1))
      return false;
    if (!equals(this.j20_1, tmp0_other_with_cast.j20_1))
      return false;
    if (!(this.k20_1 === tmp0_other_with_cast.k20_1))
      return false;
    if (!(this.l20_1 === tmp0_other_with_cast.l20_1))
      return false;
    if (!(this.m20_1 === tmp0_other_with_cast.m20_1))
      return false;
    return true;
  };
  function Companion_243() {
  }
  var Companion_instance_243;
  function Companion_getInstance_243() {
    return Companion_instance_243;
  }
  function VirginIslandsUS(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'VI' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'VIR' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Virgin Islands (U.S.)' : englishName;
    arabicName = arabicName === VOID ? '\u062C\u0632\u0631 \u0627\u0644\u0639\u0630\u0631\u0627\u0621 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A\u0629' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.n20_1 = phoneNumPrefix;
    this.o20_1 = isoCode2;
    this.p20_1 = isoCode3;
    this.q20_1 = currency;
    this.r20_1 = englishName;
    this.s20_1 = arabicName;
    this.t20_1 = phoneRegex;
  }
  protoOf(VirginIslandsUS).wd = function () {
    return this.n20_1;
  };
  protoOf(VirginIslandsUS).rd = function () {
    return this.o20_1;
  };
  protoOf(VirginIslandsUS).sd = function () {
    return this.p20_1;
  };
  protoOf(VirginIslandsUS).td = function () {
    return this.q20_1;
  };
  protoOf(VirginIslandsUS).ud = function () {
    return this.r20_1;
  };
  protoOf(VirginIslandsUS).vd = function () {
    return this.s20_1;
  };
  protoOf(VirginIslandsUS).xd = function () {
    return this.t20_1;
  };
  protoOf(VirginIslandsUS).toString = function () {
    return 'VirginIslandsUS(phoneNumPrefix=' + this.n20_1.toString() + ', isoCode2=' + this.o20_1 + ', isoCode3=' + this.p20_1 + ', currency=' + toString(this.q20_1) + ', englishName=' + this.r20_1 + ', arabicName=' + this.s20_1 + ', phoneRegex=' + this.t20_1 + ')';
  };
  protoOf(VirginIslandsUS).hashCode = function () {
    var result = this.n20_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p20_1) | 0;
    result = imul(result, 31) + hashCode(this.q20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t20_1) | 0;
    return result;
  };
  protoOf(VirginIslandsUS).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VirginIslandsUS))
      return false;
    var tmp0_other_with_cast = other instanceof VirginIslandsUS ? other : THROW_CCE();
    if (!this.n20_1.equals(tmp0_other_with_cast.n20_1))
      return false;
    if (!(this.o20_1 === tmp0_other_with_cast.o20_1))
      return false;
    if (!(this.p20_1 === tmp0_other_with_cast.p20_1))
      return false;
    if (!equals(this.q20_1, tmp0_other_with_cast.q20_1))
      return false;
    if (!(this.r20_1 === tmp0_other_with_cast.r20_1))
      return false;
    if (!(this.s20_1 === tmp0_other_with_cast.s20_1))
      return false;
    if (!(this.t20_1 === tmp0_other_with_cast.t20_1))
      return false;
    return true;
  };
  function Companion_244() {
  }
  var Companion_instance_244;
  function Companion_getInstance_244() {
    return Companion_instance_244;
  }
  function WallisandFutuna(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'WF' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'WLF' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Wallis and Futuna' : englishName;
    arabicName = arabicName === VOID ? '\u0648\u0627\u0644\u064A\u0633 \u0648\u0641\u0648\u062A\u0648\u0646\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.u20_1 = phoneNumPrefix;
    this.v20_1 = isoCode2;
    this.w20_1 = isoCode3;
    this.x20_1 = currency;
    this.y20_1 = englishName;
    this.z20_1 = arabicName;
    this.a21_1 = phoneRegex;
  }
  protoOf(WallisandFutuna).wd = function () {
    return this.u20_1;
  };
  protoOf(WallisandFutuna).rd = function () {
    return this.v20_1;
  };
  protoOf(WallisandFutuna).sd = function () {
    return this.w20_1;
  };
  protoOf(WallisandFutuna).td = function () {
    return this.x20_1;
  };
  protoOf(WallisandFutuna).ud = function () {
    return this.y20_1;
  };
  protoOf(WallisandFutuna).vd = function () {
    return this.z20_1;
  };
  protoOf(WallisandFutuna).xd = function () {
    return this.a21_1;
  };
  protoOf(WallisandFutuna).toString = function () {
    return 'WallisandFutuna(phoneNumPrefix=' + this.u20_1.toString() + ', isoCode2=' + this.v20_1 + ', isoCode3=' + this.w20_1 + ', currency=' + toString(this.x20_1) + ', englishName=' + this.y20_1 + ', arabicName=' + this.z20_1 + ', phoneRegex=' + this.a21_1 + ')';
  };
  protoOf(WallisandFutuna).hashCode = function () {
    var result = this.u20_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.v20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w20_1) | 0;
    result = imul(result, 31) + hashCode(this.x20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z20_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a21_1) | 0;
    return result;
  };
  protoOf(WallisandFutuna).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WallisandFutuna))
      return false;
    var tmp0_other_with_cast = other instanceof WallisandFutuna ? other : THROW_CCE();
    if (!this.u20_1.equals(tmp0_other_with_cast.u20_1))
      return false;
    if (!(this.v20_1 === tmp0_other_with_cast.v20_1))
      return false;
    if (!(this.w20_1 === tmp0_other_with_cast.w20_1))
      return false;
    if (!equals(this.x20_1, tmp0_other_with_cast.x20_1))
      return false;
    if (!(this.y20_1 === tmp0_other_with_cast.y20_1))
      return false;
    if (!(this.z20_1 === tmp0_other_with_cast.z20_1))
      return false;
    if (!(this.a21_1 === tmp0_other_with_cast.a21_1))
      return false;
    return true;
  };
  function Companion_245() {
  }
  var Companion_instance_245;
  function Companion_getInstance_245() {
    return Companion_instance_245;
  }
  function Yemen(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'YE' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'YEM' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Yemen' : englishName;
    arabicName = arabicName === VOID ? '\u0627\u0644\u064A\u0645\u0646' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.b21_1 = phoneNumPrefix;
    this.c21_1 = isoCode2;
    this.d21_1 = isoCode3;
    this.e21_1 = currency;
    this.f21_1 = englishName;
    this.g21_1 = arabicName;
    this.h21_1 = phoneRegex;
  }
  protoOf(Yemen).wd = function () {
    return this.b21_1;
  };
  protoOf(Yemen).rd = function () {
    return this.c21_1;
  };
  protoOf(Yemen).sd = function () {
    return this.d21_1;
  };
  protoOf(Yemen).td = function () {
    return this.e21_1;
  };
  protoOf(Yemen).ud = function () {
    return this.f21_1;
  };
  protoOf(Yemen).vd = function () {
    return this.g21_1;
  };
  protoOf(Yemen).xd = function () {
    return this.h21_1;
  };
  protoOf(Yemen).toString = function () {
    return 'Yemen(phoneNumPrefix=' + this.b21_1.toString() + ', isoCode2=' + this.c21_1 + ', isoCode3=' + this.d21_1 + ', currency=' + toString(this.e21_1) + ', englishName=' + this.f21_1 + ', arabicName=' + this.g21_1 + ', phoneRegex=' + this.h21_1 + ')';
  };
  protoOf(Yemen).hashCode = function () {
    var result = this.b21_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d21_1) | 0;
    result = imul(result, 31) + hashCode(this.e21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h21_1) | 0;
    return result;
  };
  protoOf(Yemen).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Yemen))
      return false;
    var tmp0_other_with_cast = other instanceof Yemen ? other : THROW_CCE();
    if (!this.b21_1.equals(tmp0_other_with_cast.b21_1))
      return false;
    if (!(this.c21_1 === tmp0_other_with_cast.c21_1))
      return false;
    if (!(this.d21_1 === tmp0_other_with_cast.d21_1))
      return false;
    if (!equals(this.e21_1, tmp0_other_with_cast.e21_1))
      return false;
    if (!(this.f21_1 === tmp0_other_with_cast.f21_1))
      return false;
    if (!(this.g21_1 === tmp0_other_with_cast.g21_1))
      return false;
    if (!(this.h21_1 === tmp0_other_with_cast.h21_1))
      return false;
    return true;
  };
  function Companion_246() {
  }
  var Companion_instance_246;
  function Companion_getInstance_246() {
    return Companion_instance_246;
  }
  function Zambia(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ZM' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ZMB' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Zambia' : englishName;
    arabicName = arabicName === VOID ? '\u0632\u0627\u0645\u0628\u064A\u0627' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.i21_1 = phoneNumPrefix;
    this.j21_1 = isoCode2;
    this.k21_1 = isoCode3;
    this.l21_1 = currency;
    this.m21_1 = englishName;
    this.n21_1 = arabicName;
    this.o21_1 = phoneRegex;
  }
  protoOf(Zambia).wd = function () {
    return this.i21_1;
  };
  protoOf(Zambia).rd = function () {
    return this.j21_1;
  };
  protoOf(Zambia).sd = function () {
    return this.k21_1;
  };
  protoOf(Zambia).td = function () {
    return this.l21_1;
  };
  protoOf(Zambia).ud = function () {
    return this.m21_1;
  };
  protoOf(Zambia).vd = function () {
    return this.n21_1;
  };
  protoOf(Zambia).xd = function () {
    return this.o21_1;
  };
  protoOf(Zambia).toString = function () {
    return 'Zambia(phoneNumPrefix=' + this.i21_1.toString() + ', isoCode2=' + this.j21_1 + ', isoCode3=' + this.k21_1 + ', currency=' + toString(this.l21_1) + ', englishName=' + this.m21_1 + ', arabicName=' + this.n21_1 + ', phoneRegex=' + this.o21_1 + ')';
  };
  protoOf(Zambia).hashCode = function () {
    var result = this.i21_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k21_1) | 0;
    result = imul(result, 31) + hashCode(this.l21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o21_1) | 0;
    return result;
  };
  protoOf(Zambia).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Zambia))
      return false;
    var tmp0_other_with_cast = other instanceof Zambia ? other : THROW_CCE();
    if (!this.i21_1.equals(tmp0_other_with_cast.i21_1))
      return false;
    if (!(this.j21_1 === tmp0_other_with_cast.j21_1))
      return false;
    if (!(this.k21_1 === tmp0_other_with_cast.k21_1))
      return false;
    if (!equals(this.l21_1, tmp0_other_with_cast.l21_1))
      return false;
    if (!(this.m21_1 === tmp0_other_with_cast.m21_1))
      return false;
    if (!(this.n21_1 === tmp0_other_with_cast.n21_1))
      return false;
    if (!(this.o21_1 === tmp0_other_with_cast.o21_1))
      return false;
    return true;
  };
  function Companion_247() {
  }
  var Companion_instance_247;
  function Companion_getInstance_247() {
    return Companion_instance_247;
  }
  function Zimbabwe(phoneNumPrefix, isoCode2, isoCode3, currency, englishName, arabicName, phoneRegex) {
    phoneNumPrefix = phoneNumPrefix === VOID ? new Long(0, 0) : phoneNumPrefix;
    isoCode2 = isoCode2 === VOID ? 'ZW' : isoCode2;
    isoCode3 = isoCode3 === VOID ? 'ZWE' : isoCode3;
    currency = currency === VOID ? USD_getInstance() : currency;
    englishName = englishName === VOID ? 'Zimbabwe' : englishName;
    arabicName = arabicName === VOID ? '\u0632\u064A\u0645\u0628\u0627\u0628\u0648\u064A' : arabicName;
    phoneRegex = phoneRegex === VOID ? getPhoneRegex(0) : phoneRegex;
    this.p21_1 = phoneNumPrefix;
    this.q21_1 = isoCode2;
    this.r21_1 = isoCode3;
    this.s21_1 = currency;
    this.t21_1 = englishName;
    this.u21_1 = arabicName;
    this.v21_1 = phoneRegex;
  }
  protoOf(Zimbabwe).wd = function () {
    return this.p21_1;
  };
  protoOf(Zimbabwe).rd = function () {
    return this.q21_1;
  };
  protoOf(Zimbabwe).sd = function () {
    return this.r21_1;
  };
  protoOf(Zimbabwe).td = function () {
    return this.s21_1;
  };
  protoOf(Zimbabwe).ud = function () {
    return this.t21_1;
  };
  protoOf(Zimbabwe).vd = function () {
    return this.u21_1;
  };
  protoOf(Zimbabwe).xd = function () {
    return this.v21_1;
  };
  protoOf(Zimbabwe).toString = function () {
    return 'Zimbabwe(phoneNumPrefix=' + this.p21_1.toString() + ', isoCode2=' + this.q21_1 + ', isoCode3=' + this.r21_1 + ', currency=' + toString(this.s21_1) + ', englishName=' + this.t21_1 + ', arabicName=' + this.u21_1 + ', phoneRegex=' + this.v21_1 + ')';
  };
  protoOf(Zimbabwe).hashCode = function () {
    var result = this.p21_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r21_1) | 0;
    result = imul(result, 31) + hashCode(this.s21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v21_1) | 0;
    return result;
  };
  protoOf(Zimbabwe).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Zimbabwe))
      return false;
    var tmp0_other_with_cast = other instanceof Zimbabwe ? other : THROW_CCE();
    if (!this.p21_1.equals(tmp0_other_with_cast.p21_1))
      return false;
    if (!(this.q21_1 === tmp0_other_with_cast.q21_1))
      return false;
    if (!(this.r21_1 === tmp0_other_with_cast.r21_1))
      return false;
    if (!equals(this.s21_1, tmp0_other_with_cast.s21_1))
      return false;
    if (!(this.t21_1 === tmp0_other_with_cast.t21_1))
      return false;
    if (!(this.u21_1 === tmp0_other_with_cast.u21_1))
      return false;
    if (!(this.v21_1 === tmp0_other_with_cast.v21_1))
      return false;
    return true;
  };
  function getPhoneRegex(countryPhonePrefix) {
    return '^(00' + countryPhonePrefix + '|' + countryPhonePrefix + '|\\+' + countryPhonePrefix + ')$';
  }
  function getSimplePhoneRegex(length) {
    return '^[0-9]{' + length + '}$';
  }
  function Currency(iso4217Code, englishName, arabicName, arabicShortName) {
    this.iso4217Code = iso4217Code;
    this.englishName = englishName;
    this.arabicName = arabicName;
    this.arabicShortName = arabicShortName;
  }
  protoOf(Currency).w21 = function () {
    return this.iso4217Code;
  };
  protoOf(Currency).ud = function () {
    return this.englishName;
  };
  protoOf(Currency).vd = function () {
    return this.arabicName;
  };
  protoOf(Currency).x21 = function () {
    return this.arabicShortName;
  };
  function EGP() {
    EGP_instance = this;
    Currency.call(this, 'EGP', 'EGP', '\u062C\u0646\u064A\u0647 \u0645\u0635\u0631\u064A', '\u062C.\u0645');
  }
  var EGP_instance;
  function EGP_getInstance() {
    if (EGP_instance == null)
      new EGP();
    return EGP_instance;
  }
  function AED() {
    AED_instance = this;
    Currency.call(this, 'AED', 'AED', '\u062F\u0631\u0647\u0645 \u0627\u0645\u0627\u0631\u0627\u062A\u064A', '\u062F.\u0625');
  }
  var AED_instance;
  function AED_getInstance() {
    if (AED_instance == null)
      new AED();
    return AED_instance;
  }
  function SAR() {
    SAR_instance = this;
    Currency.call(this, 'SAR', 'SAR', '\u0631\u064A\u0627\u0644 \u0633\u0639\u0648\u062F\u064A', '\u0631.\u0633');
  }
  var SAR_instance;
  function SAR_getInstance() {
    if (SAR_instance == null)
      new SAR();
    return SAR_instance;
  }
  function IQD() {
    IQD_instance = this;
    Currency.call(this, 'IQD', 'IQD', '\u062F\u064A\u0646\u0627\u0631 \u0639\u0631\u0627\u0642\u064A', '\u062F.\u0639');
  }
  var IQD_instance;
  function IQD_getInstance() {
    if (IQD_instance == null)
      new IQD();
    return IQD_instance;
  }
  function USD() {
    USD_instance = this;
    Currency.call(this, 'USD', 'USD', 'USD', 'USD');
  }
  var USD_instance;
  function USD_getInstance() {
    if (USD_instance == null)
      new USD();
    return USD_instance;
  }
  function CTM() {
    CTM_instance = this;
    Currency.call(this, 'CTM', 'CTM', 'CTM', 'CTM');
  }
  var CTM_instance;
  function CTM_getInstance() {
    if (CTM_instance == null)
      new CTM();
    return CTM_instance;
  }
  function KWD() {
    KWD_instance = this;
    Currency.call(this, 'KWD', 'KWD', '\u062F\u064A\u0646\u0627\u0631 \u0643\u0648\u064A\u062A\u064A', '\u062F.\u0643');
  }
  var KWD_instance;
  function KWD_getInstance() {
    if (KWD_instance == null)
      new KWD();
    return KWD_instance;
  }
  function OMR() {
    OMR_instance = this;
    Currency.call(this, 'OMR', 'OMR', '\u0631\u064A\u0627\u0644 \u0639\u0645\u0627\u0646\u064A', '\u0631.\u0639');
  }
  var OMR_instance;
  function OMR_getInstance() {
    if (OMR_instance == null)
      new OMR();
    return OMR_instance;
  }
  function Locale() {
  }
  function English() {
    English_instance = this;
    Locale.call(this);
  }
  var English_instance;
  function English_getInstance() {
    if (English_instance == null)
      new English();
    return English_instance;
  }
  function Arabic() {
    Arabic_instance = this;
    Locale.call(this);
  }
  var Arabic_instance;
  function Arabic_getInstance() {
    if (Arabic_instance == null)
      new Arabic();
    return Arabic_instance;
  }
  function getCountryProvider() {
    return new CountryProvider();
  }
  function getCountryFromIsoCode2(isoCode2) {
    return CountryResolver_instance.retrieveMultitenancyEnabledCountriesFromIsoCode2(isoCode2);
  }
  function getCountryFromIsoCode3(isoCode3) {
    return CountryResolver_instance.retrieveMultitenancyEnabledCountriesFromIsoCode3(isoCode3);
  }
  function getCurrencyFromIso4217Code(currencyIso4217Code) {
    return CurrencyResolver_instance.retrieveCurrencyFromIso4217Code(currencyIso4217Code);
  }
  function getSupportedPhoneCountriesUseCase(ignoreUncoveredCountries) {
    ignoreUncoveredCountries = ignoreUncoveredCountries === VOID ? false : ignoreUncoveredCountries;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = (new GetSupportedPhoneCountriesUseCase()).qd(ignoreUncoveredCountries);
    return copyToArray(this_0);
  }
  function getSupportedNationalities(locale) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = (new GetSupportedNationalities()).nd(locale);
    return copyToArray(this_0);
  }
  function getCountryFromPhoneNumPrefix(phoneNumPrefix) {
    return CountryResolver_instance.retrieveCountryFromPhonePrefix(phoneNumPrefix);
  }
  function isPhoneNumberValid_0(phoneNumber) {
    return CountryResolver_instance.isPhoneNumberValid(phoneNumber);
  }
  //region block: post-declaration
  protoOf(Egypt).zd = get_flagUrl;
  protoOf(Egypt).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Egypt), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Egypt), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Egypt), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Egypt), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Egypt), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Egypt), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Egypt), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Egypt), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Egypt), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(UAE).zd = get_flagUrl;
  protoOf(UAE).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(UAE), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(UAE), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(UAE), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(UAE), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(UAE), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(UAE), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(UAE), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(UAE), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(UAE), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(KSA).zd = get_flagUrl;
  protoOf(KSA).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(KSA), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(KSA), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(KSA), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(KSA), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(KSA), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(KSA), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(KSA), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(KSA), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(KSA), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(TMT).zd = get_flagUrl;
  protoOf(TMT).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(TMT), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(TMT), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(TMT), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(TMT), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(TMT), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(TMT), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(TMT), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(TMT), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(TMT), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Afghanistan).yd = get_phoneNumberHint;
  protoOf(Afghanistan).zd = get_flagUrl;
  protoOf(Afghanistan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Afghanistan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Afghanistan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Afghanistan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Afghanistan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Afghanistan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Afghanistan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Afghanistan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Afghanistan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Afghanistan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(AlandIslands).yd = get_phoneNumberHint;
  protoOf(AlandIslands).zd = get_flagUrl;
  protoOf(AlandIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(AlandIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(AlandIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(AlandIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(AlandIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(AlandIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(AlandIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(AlandIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(AlandIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(AlandIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Albania).yd = get_phoneNumberHint;
  protoOf(Albania).zd = get_flagUrl;
  protoOf(Albania).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Albania), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Albania), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Albania), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Albania), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Albania), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Albania), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Albania), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Albania), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Albania), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Algeria).zd = get_flagUrl;
  protoOf(Algeria).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Algeria), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Algeria), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Algeria), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Algeria), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Algeria), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Algeria), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Algeria), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Algeria), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Algeria), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(AmericanSamoa).yd = get_phoneNumberHint;
  protoOf(AmericanSamoa).zd = get_flagUrl;
  protoOf(AmericanSamoa).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(AmericanSamoa), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(AmericanSamoa), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(AmericanSamoa), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(AmericanSamoa), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(AmericanSamoa), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(AmericanSamoa), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(AmericanSamoa), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(AmericanSamoa), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(AmericanSamoa), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Andorra).yd = get_phoneNumberHint;
  protoOf(Andorra).zd = get_flagUrl;
  protoOf(Andorra).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Andorra), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Andorra), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Andorra), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Andorra), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Andorra), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Andorra), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Andorra), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Andorra), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Andorra), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Angola).yd = get_phoneNumberHint;
  protoOf(Angola).zd = get_flagUrl;
  protoOf(Angola).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Angola), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Angola), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Angola), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Angola), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Angola), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Angola), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Angola), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Angola), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Angola), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Anguilla).yd = get_phoneNumberHint;
  protoOf(Anguilla).zd = get_flagUrl;
  protoOf(Anguilla).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Anguilla), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Anguilla), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Anguilla), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Anguilla), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Anguilla), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Anguilla), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Anguilla), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Anguilla), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Anguilla), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Antarctica).yd = get_phoneNumberHint;
  protoOf(Antarctica).zd = get_flagUrl;
  protoOf(Antarctica).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Antarctica), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Antarctica), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Antarctica), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Antarctica), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Antarctica), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Antarctica), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Antarctica), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Antarctica), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Antarctica), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(AntiguaandBarbuda).yd = get_phoneNumberHint;
  protoOf(AntiguaandBarbuda).zd = get_flagUrl;
  protoOf(AntiguaandBarbuda).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(AntiguaandBarbuda), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(AntiguaandBarbuda), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Argentina).yd = get_phoneNumberHint;
  protoOf(Argentina).zd = get_flagUrl;
  protoOf(Argentina).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Argentina), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Argentina), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Argentina), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Argentina), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Argentina), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Argentina), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Argentina), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Argentina), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Argentina), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Armenia).yd = get_phoneNumberHint;
  protoOf(Armenia).zd = get_flagUrl;
  protoOf(Armenia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Armenia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Armenia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Armenia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Armenia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Armenia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Armenia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Armenia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Armenia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Armenia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Aruba).yd = get_phoneNumberHint;
  protoOf(Aruba).zd = get_flagUrl;
  protoOf(Aruba).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Aruba), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Aruba), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Aruba), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Aruba), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Aruba), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Aruba), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Aruba), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Aruba), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Aruba), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Australia).yd = get_phoneNumberHint;
  protoOf(Australia).zd = get_flagUrl;
  protoOf(Australia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Australia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Australia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Australia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Australia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Australia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Australia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Australia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Australia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Australia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Austria).yd = get_phoneNumberHint;
  protoOf(Austria).zd = get_flagUrl;
  protoOf(Austria).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Austria), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Austria), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Austria), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Austria), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Austria), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Austria), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Austria), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Austria), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Austria), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Azerbaijan).yd = get_phoneNumberHint;
  protoOf(Azerbaijan).zd = get_flagUrl;
  protoOf(Azerbaijan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Azerbaijan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Azerbaijan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Azerbaijan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Azerbaijan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Azerbaijan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Azerbaijan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Azerbaijan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Azerbaijan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Azerbaijan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Bahamas).yd = get_phoneNumberHint;
  protoOf(Bahamas).zd = get_flagUrl;
  protoOf(Bahamas).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Bahamas), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Bahamas), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Bahamas), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Bahamas), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Bahamas), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Bahamas), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Bahamas), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Bahamas), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Bahamas), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Bahrain).zd = get_flagUrl;
  protoOf(Bahrain).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Bahrain), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Bahrain), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Bahrain), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Bahrain), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Bahrain), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Bahrain), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Bahrain), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Bahrain), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Bahrain), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Bangladesh).zd = get_flagUrl;
  protoOf(Bangladesh).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Bangladesh), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Bangladesh), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Bangladesh), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Bangladesh), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Bangladesh), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Bangladesh), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Bangladesh), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Bangladesh), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Bangladesh), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Barbados).yd = get_phoneNumberHint;
  protoOf(Barbados).zd = get_flagUrl;
  protoOf(Barbados).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Barbados), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Barbados), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Barbados), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Barbados), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Barbados), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Barbados), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Barbados), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Barbados), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Barbados), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Belarus).yd = get_phoneNumberHint;
  protoOf(Belarus).zd = get_flagUrl;
  protoOf(Belarus).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Belarus), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Belarus), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Belarus), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Belarus), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Belarus), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Belarus), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Belarus), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Belarus), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Belarus), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Belgium).yd = get_phoneNumberHint;
  protoOf(Belgium).zd = get_flagUrl;
  protoOf(Belgium).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Belgium), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Belgium), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Belgium), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Belgium), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Belgium), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Belgium), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Belgium), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Belgium), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Belgium), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Belize).yd = get_phoneNumberHint;
  protoOf(Belize).zd = get_flagUrl;
  protoOf(Belize).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Belize), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Belize), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Belize), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Belize), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Belize), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Belize), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Belize), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Belize), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Belize), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Benin).yd = get_phoneNumberHint;
  protoOf(Benin).zd = get_flagUrl;
  protoOf(Benin).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Benin), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Benin), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Benin), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Benin), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Benin), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Benin), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Benin), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Benin), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Benin), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Bermuda).yd = get_phoneNumberHint;
  protoOf(Bermuda).zd = get_flagUrl;
  protoOf(Bermuda).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Bermuda), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Bermuda), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Bermuda), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Bermuda), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Bermuda), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Bermuda), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Bermuda), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Bermuda), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Bermuda), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Bhutan).yd = get_phoneNumberHint;
  protoOf(Bhutan).zd = get_flagUrl;
  protoOf(Bhutan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Bhutan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Bhutan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Bhutan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Bhutan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Bhutan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Bhutan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Bhutan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Bhutan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Bhutan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BoliviaPlurinationalStateof).yd = get_phoneNumberHint;
  protoOf(BoliviaPlurinationalStateof).zd = get_flagUrl;
  protoOf(BoliviaPlurinationalStateof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BoliviaPlurinationalStateof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BoliviaPlurinationalStateof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BonaireSintEustatiusandSaba).yd = get_phoneNumberHint;
  protoOf(BonaireSintEustatiusandSaba).zd = get_flagUrl;
  protoOf(BonaireSintEustatiusandSaba).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BonaireSintEustatiusandSaba), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BosniaandHerzegovina).yd = get_phoneNumberHint;
  protoOf(BosniaandHerzegovina).zd = get_flagUrl;
  protoOf(BosniaandHerzegovina).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BosniaandHerzegovina), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BosniaandHerzegovina), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Botswana).yd = get_phoneNumberHint;
  protoOf(Botswana).zd = get_flagUrl;
  protoOf(Botswana).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Botswana), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Botswana), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Botswana), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Botswana), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Botswana), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Botswana), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Botswana), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Botswana), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Botswana), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BouvetIsland).yd = get_phoneNumberHint;
  protoOf(BouvetIsland).zd = get_flagUrl;
  protoOf(BouvetIsland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BouvetIsland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BouvetIsland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BouvetIsland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BouvetIsland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BouvetIsland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BouvetIsland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BouvetIsland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BouvetIsland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BouvetIsland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Brazil).yd = get_phoneNumberHint;
  protoOf(Brazil).zd = get_flagUrl;
  protoOf(Brazil).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Brazil), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Brazil), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Brazil), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Brazil), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Brazil), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Brazil), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Brazil), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Brazil), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Brazil), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BritishIndianOceanTerritory).yd = get_phoneNumberHint;
  protoOf(BritishIndianOceanTerritory).zd = get_flagUrl;
  protoOf(BritishIndianOceanTerritory).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BritishIndianOceanTerritory), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BritishIndianOceanTerritory), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BruneiDarussalam).yd = get_phoneNumberHint;
  protoOf(BruneiDarussalam).zd = get_flagUrl;
  protoOf(BruneiDarussalam).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BruneiDarussalam), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BruneiDarussalam), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BruneiDarussalam), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BruneiDarussalam), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BruneiDarussalam), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BruneiDarussalam), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BruneiDarussalam), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BruneiDarussalam), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BruneiDarussalam), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Bulgaria).yd = get_phoneNumberHint;
  protoOf(Bulgaria).zd = get_flagUrl;
  protoOf(Bulgaria).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Bulgaria), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Bulgaria), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Bulgaria), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Bulgaria), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Bulgaria), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Bulgaria), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Bulgaria), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Bulgaria), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Bulgaria), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(BurkinaFaso).yd = get_phoneNumberHint;
  protoOf(BurkinaFaso).zd = get_flagUrl;
  protoOf(BurkinaFaso).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(BurkinaFaso), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(BurkinaFaso), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(BurkinaFaso), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(BurkinaFaso), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(BurkinaFaso), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(BurkinaFaso), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(BurkinaFaso), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(BurkinaFaso), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(BurkinaFaso), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Burundi).yd = get_phoneNumberHint;
  protoOf(Burundi).zd = get_flagUrl;
  protoOf(Burundi).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Burundi), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Burundi), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Burundi), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Burundi), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Burundi), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Burundi), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Burundi), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Burundi), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Burundi), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Cambodia).yd = get_phoneNumberHint;
  protoOf(Cambodia).zd = get_flagUrl;
  protoOf(Cambodia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Cambodia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Cambodia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Cambodia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Cambodia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Cambodia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Cambodia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Cambodia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Cambodia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Cambodia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Cameroon).yd = get_phoneNumberHint;
  protoOf(Cameroon).zd = get_flagUrl;
  protoOf(Cameroon).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Cameroon), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Cameroon), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Cameroon), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Cameroon), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Cameroon), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Cameroon), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Cameroon), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Cameroon), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Cameroon), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Canada).yd = get_phoneNumberHint;
  protoOf(Canada).zd = get_flagUrl;
  protoOf(Canada).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Canada), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Canada), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Canada), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Canada), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Canada), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Canada), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Canada), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Canada), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Canada), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CaboVerde).yd = get_phoneNumberHint;
  protoOf(CaboVerde).zd = get_flagUrl;
  protoOf(CaboVerde).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CaboVerde), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CaboVerde), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CaboVerde), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CaboVerde), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CaboVerde), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CaboVerde), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CaboVerde), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CaboVerde), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CaboVerde), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CaymanIslands).yd = get_phoneNumberHint;
  protoOf(CaymanIslands).zd = get_flagUrl;
  protoOf(CaymanIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CaymanIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CaymanIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CaymanIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CaymanIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CaymanIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CaymanIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CaymanIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CaymanIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CaymanIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CentralAfricanRepublic).yd = get_phoneNumberHint;
  protoOf(CentralAfricanRepublic).zd = get_flagUrl;
  protoOf(CentralAfricanRepublic).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CentralAfricanRepublic), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CentralAfricanRepublic), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Chad).yd = get_phoneNumberHint;
  protoOf(Chad).zd = get_flagUrl;
  protoOf(Chad).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Chad), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Chad), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Chad), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Chad), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Chad), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Chad), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Chad), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Chad), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Chad), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Chile).yd = get_phoneNumberHint;
  protoOf(Chile).zd = get_flagUrl;
  protoOf(Chile).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Chile), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Chile), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Chile), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Chile), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Chile), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Chile), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Chile), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Chile), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Chile), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(China).zd = get_flagUrl;
  protoOf(China).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(China), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(China), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(China), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(China), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(China), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(China), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(China), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(China), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(China), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(ChristmasIsland).yd = get_phoneNumberHint;
  protoOf(ChristmasIsland).zd = get_flagUrl;
  protoOf(ChristmasIsland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(ChristmasIsland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(ChristmasIsland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(ChristmasIsland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(ChristmasIsland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(ChristmasIsland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(ChristmasIsland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(ChristmasIsland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(ChristmasIsland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(ChristmasIsland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CocosKeelingIslands).yd = get_phoneNumberHint;
  protoOf(CocosKeelingIslands).zd = get_flagUrl;
  protoOf(CocosKeelingIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CocosKeelingIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CocosKeelingIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CocosKeelingIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CocosKeelingIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CocosKeelingIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CocosKeelingIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CocosKeelingIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CocosKeelingIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CocosKeelingIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Colombia).yd = get_phoneNumberHint;
  protoOf(Colombia).zd = get_flagUrl;
  protoOf(Colombia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Colombia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Colombia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Colombia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Colombia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Colombia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Colombia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Colombia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Colombia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Colombia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Comoros).yd = get_phoneNumberHint;
  protoOf(Comoros).zd = get_flagUrl;
  protoOf(Comoros).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Comoros), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Comoros), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Comoros), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Comoros), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Comoros), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Comoros), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Comoros), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Comoros), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Comoros), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Congo).yd = get_phoneNumberHint;
  protoOf(Congo).zd = get_flagUrl;
  protoOf(Congo).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Congo), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Congo), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Congo), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Congo), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Congo), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Congo), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Congo), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Congo), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Congo), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CongoDemocraticRepublicofthe).yd = get_phoneNumberHint;
  protoOf(CongoDemocraticRepublicofthe).zd = get_flagUrl;
  protoOf(CongoDemocraticRepublicofthe).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CongoDemocraticRepublicofthe), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CookIslands).yd = get_phoneNumberHint;
  protoOf(CookIslands).zd = get_flagUrl;
  protoOf(CookIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CookIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CookIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CookIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CookIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CookIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CookIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CookIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CookIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CookIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CostaRica).yd = get_phoneNumberHint;
  protoOf(CostaRica).zd = get_flagUrl;
  protoOf(CostaRica).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CostaRica), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CostaRica), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CostaRica), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CostaRica), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CostaRica), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CostaRica), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CostaRica), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CostaRica), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CostaRica), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(CotedIvoire).yd = get_phoneNumberHint;
  protoOf(CotedIvoire).zd = get_flagUrl;
  protoOf(CotedIvoire).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(CotedIvoire), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(CotedIvoire), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(CotedIvoire), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(CotedIvoire), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(CotedIvoire), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(CotedIvoire), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(CotedIvoire), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(CotedIvoire), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(CotedIvoire), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Croatia).yd = get_phoneNumberHint;
  protoOf(Croatia).zd = get_flagUrl;
  protoOf(Croatia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Croatia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Croatia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Croatia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Croatia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Croatia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Croatia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Croatia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Croatia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Croatia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Cuba).yd = get_phoneNumberHint;
  protoOf(Cuba).zd = get_flagUrl;
  protoOf(Cuba).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Cuba), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Cuba), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Cuba), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Cuba), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Cuba), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Cuba), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Cuba), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Cuba), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Cuba), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Curacao).yd = get_phoneNumberHint;
  protoOf(Curacao).zd = get_flagUrl;
  protoOf(Curacao).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Curacao), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Curacao), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Curacao), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Curacao), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Curacao), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Curacao), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Curacao), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Curacao), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Curacao), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Cyprus).yd = get_phoneNumberHint;
  protoOf(Cyprus).zd = get_flagUrl;
  protoOf(Cyprus).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Cyprus), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Cyprus), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Cyprus), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Cyprus), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Cyprus), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Cyprus), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Cyprus), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Cyprus), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Cyprus), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Czechia).yd = get_phoneNumberHint;
  protoOf(Czechia).zd = get_flagUrl;
  protoOf(Czechia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Czechia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Czechia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Czechia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Czechia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Czechia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Czechia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Czechia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Czechia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Czechia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Denmark).yd = get_phoneNumberHint;
  protoOf(Denmark).zd = get_flagUrl;
  protoOf(Denmark).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Denmark), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Denmark), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Denmark), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Denmark), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Denmark), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Denmark), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Denmark), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Denmark), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Denmark), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Djibouti).yd = get_phoneNumberHint;
  protoOf(Djibouti).zd = get_flagUrl;
  protoOf(Djibouti).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Djibouti), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Djibouti), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Djibouti), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Djibouti), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Djibouti), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Djibouti), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Djibouti), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Djibouti), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Djibouti), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Dominica).yd = get_phoneNumberHint;
  protoOf(Dominica).zd = get_flagUrl;
  protoOf(Dominica).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Dominica), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Dominica), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Dominica), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Dominica), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Dominica), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Dominica), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Dominica), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Dominica), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Dominica), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(DominicanRepublic).yd = get_phoneNumberHint;
  protoOf(DominicanRepublic).zd = get_flagUrl;
  protoOf(DominicanRepublic).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(DominicanRepublic), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(DominicanRepublic), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(DominicanRepublic), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(DominicanRepublic), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(DominicanRepublic), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(DominicanRepublic), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(DominicanRepublic), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(DominicanRepublic), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(DominicanRepublic), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Ecuador).yd = get_phoneNumberHint;
  protoOf(Ecuador).zd = get_flagUrl;
  protoOf(Ecuador).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Ecuador), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Ecuador), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Ecuador), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Ecuador), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Ecuador), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Ecuador), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Ecuador), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Ecuador), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Ecuador), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(ElSalvador).yd = get_phoneNumberHint;
  protoOf(ElSalvador).zd = get_flagUrl;
  protoOf(ElSalvador).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(ElSalvador), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(ElSalvador), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(ElSalvador), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(ElSalvador), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(ElSalvador), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(ElSalvador), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(ElSalvador), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(ElSalvador), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(ElSalvador), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(EquatorialGuinea).yd = get_phoneNumberHint;
  protoOf(EquatorialGuinea).zd = get_flagUrl;
  protoOf(EquatorialGuinea).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(EquatorialGuinea), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(EquatorialGuinea), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(EquatorialGuinea), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(EquatorialGuinea), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(EquatorialGuinea), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(EquatorialGuinea), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(EquatorialGuinea), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(EquatorialGuinea), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(EquatorialGuinea), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Eritrea).yd = get_phoneNumberHint;
  protoOf(Eritrea).zd = get_flagUrl;
  protoOf(Eritrea).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Eritrea), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Eritrea), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Eritrea), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Eritrea), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Eritrea), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Eritrea), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Eritrea), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Eritrea), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Eritrea), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Estonia).yd = get_phoneNumberHint;
  protoOf(Estonia).zd = get_flagUrl;
  protoOf(Estonia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Estonia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Estonia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Estonia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Estonia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Estonia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Estonia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Estonia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Estonia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Estonia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Ethiopia).yd = get_phoneNumberHint;
  protoOf(Ethiopia).zd = get_flagUrl;
  protoOf(Ethiopia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Ethiopia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Ethiopia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Ethiopia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Ethiopia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Ethiopia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Ethiopia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Ethiopia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Ethiopia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Ethiopia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(FalklandIslandsMalvinas).yd = get_phoneNumberHint;
  protoOf(FalklandIslandsMalvinas).zd = get_flagUrl;
  protoOf(FalklandIslandsMalvinas).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(FalklandIslandsMalvinas), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(FalklandIslandsMalvinas), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(FaroeIslands).yd = get_phoneNumberHint;
  protoOf(FaroeIslands).zd = get_flagUrl;
  protoOf(FaroeIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(FaroeIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(FaroeIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(FaroeIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(FaroeIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(FaroeIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(FaroeIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(FaroeIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(FaroeIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(FaroeIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Fiji).yd = get_phoneNumberHint;
  protoOf(Fiji).zd = get_flagUrl;
  protoOf(Fiji).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Fiji), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Fiji), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Fiji), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Fiji), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Fiji), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Fiji), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Fiji), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Fiji), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Fiji), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Finland).yd = get_phoneNumberHint;
  protoOf(Finland).zd = get_flagUrl;
  protoOf(Finland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Finland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Finland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Finland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Finland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Finland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Finland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Finland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Finland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Finland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(France).zd = get_flagUrl;
  protoOf(France).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(France), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(France), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(France), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(France), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(France), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(France), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(France), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(France), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(France), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(FrenchGuiana).yd = get_phoneNumberHint;
  protoOf(FrenchGuiana).zd = get_flagUrl;
  protoOf(FrenchGuiana).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(FrenchGuiana), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(FrenchGuiana), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(FrenchGuiana), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(FrenchGuiana), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(FrenchGuiana), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(FrenchGuiana), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(FrenchGuiana), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(FrenchGuiana), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(FrenchGuiana), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(FrenchPolynesia).yd = get_phoneNumberHint;
  protoOf(FrenchPolynesia).zd = get_flagUrl;
  protoOf(FrenchPolynesia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(FrenchPolynesia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(FrenchPolynesia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(FrenchPolynesia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(FrenchPolynesia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(FrenchPolynesia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(FrenchPolynesia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(FrenchPolynesia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(FrenchPolynesia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(FrenchPolynesia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(FrenchSouthernTerritories).yd = get_phoneNumberHint;
  protoOf(FrenchSouthernTerritories).zd = get_flagUrl;
  protoOf(FrenchSouthernTerritories).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(FrenchSouthernTerritories), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(FrenchSouthernTerritories), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Gabon).yd = get_phoneNumberHint;
  protoOf(Gabon).zd = get_flagUrl;
  protoOf(Gabon).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Gabon), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Gabon), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Gabon), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Gabon), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Gabon), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Gabon), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Gabon), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Gabon), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Gabon), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Gambia).yd = get_phoneNumberHint;
  protoOf(Gambia).zd = get_flagUrl;
  protoOf(Gambia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Gambia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Gambia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Gambia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Gambia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Gambia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Gambia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Gambia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Gambia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Gambia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Georgia).yd = get_phoneNumberHint;
  protoOf(Georgia).zd = get_flagUrl;
  protoOf(Georgia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Georgia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Georgia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Georgia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Georgia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Georgia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Georgia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Georgia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Georgia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Georgia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Germany).zd = get_flagUrl;
  protoOf(Germany).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Germany), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Germany), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Germany), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Germany), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Germany), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Germany), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Germany), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Germany), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Germany), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Ghana).yd = get_phoneNumberHint;
  protoOf(Ghana).zd = get_flagUrl;
  protoOf(Ghana).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Ghana), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Ghana), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Ghana), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Ghana), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Ghana), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Ghana), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Ghana), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Ghana), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Ghana), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Gibraltar).yd = get_phoneNumberHint;
  protoOf(Gibraltar).zd = get_flagUrl;
  protoOf(Gibraltar).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Gibraltar), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Gibraltar), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Gibraltar), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Gibraltar), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Gibraltar), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Gibraltar), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Gibraltar), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Gibraltar), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Gibraltar), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Greece).yd = get_phoneNumberHint;
  protoOf(Greece).zd = get_flagUrl;
  protoOf(Greece).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Greece), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Greece), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Greece), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Greece), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Greece), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Greece), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Greece), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Greece), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Greece), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Greenland).yd = get_phoneNumberHint;
  protoOf(Greenland).zd = get_flagUrl;
  protoOf(Greenland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Greenland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Greenland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Greenland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Greenland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Greenland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Greenland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Greenland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Greenland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Greenland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Grenada).yd = get_phoneNumberHint;
  protoOf(Grenada).zd = get_flagUrl;
  protoOf(Grenada).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Grenada), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Grenada), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Grenada), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Grenada), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Grenada), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Grenada), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Grenada), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Grenada), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Grenada), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Guadeloupe).yd = get_phoneNumberHint;
  protoOf(Guadeloupe).zd = get_flagUrl;
  protoOf(Guadeloupe).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Guadeloupe), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Guadeloupe), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Guadeloupe), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Guadeloupe), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Guadeloupe), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Guadeloupe), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Guadeloupe), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Guadeloupe), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Guadeloupe), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Guam).yd = get_phoneNumberHint;
  protoOf(Guam).zd = get_flagUrl;
  protoOf(Guam).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Guam), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Guam), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Guam), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Guam), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Guam), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Guam), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Guam), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Guam), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Guam), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Guatemala).yd = get_phoneNumberHint;
  protoOf(Guatemala).zd = get_flagUrl;
  protoOf(Guatemala).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Guatemala), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Guatemala), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Guatemala), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Guatemala), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Guatemala), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Guatemala), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Guatemala), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Guatemala), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Guatemala), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Guernsey).yd = get_phoneNumberHint;
  protoOf(Guernsey).zd = get_flagUrl;
  protoOf(Guernsey).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Guernsey), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Guernsey), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Guernsey), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Guernsey), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Guernsey), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Guernsey), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Guernsey), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Guernsey), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Guernsey), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Guinea).yd = get_phoneNumberHint;
  protoOf(Guinea).zd = get_flagUrl;
  protoOf(Guinea).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Guinea), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Guinea), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Guinea), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Guinea), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Guinea), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Guinea), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Guinea), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Guinea), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Guinea), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(GuineaBissau).yd = get_phoneNumberHint;
  protoOf(GuineaBissau).zd = get_flagUrl;
  protoOf(GuineaBissau).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(GuineaBissau), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(GuineaBissau), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(GuineaBissau), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(GuineaBissau), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(GuineaBissau), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(GuineaBissau), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(GuineaBissau), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(GuineaBissau), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(GuineaBissau), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Guyana).yd = get_phoneNumberHint;
  protoOf(Guyana).zd = get_flagUrl;
  protoOf(Guyana).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Guyana), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Guyana), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Guyana), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Guyana), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Guyana), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Guyana), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Guyana), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Guyana), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Guyana), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Haiti).yd = get_phoneNumberHint;
  protoOf(Haiti).zd = get_flagUrl;
  protoOf(Haiti).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Haiti), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Haiti), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Haiti), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Haiti), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Haiti), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Haiti), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Haiti), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Haiti), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Haiti), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(HeardIslandandMcDonaldIslands).yd = get_phoneNumberHint;
  protoOf(HeardIslandandMcDonaldIslands).zd = get_flagUrl;
  protoOf(HeardIslandandMcDonaldIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(HeardIslandandMcDonaldIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(HolySee).yd = get_phoneNumberHint;
  protoOf(HolySee).zd = get_flagUrl;
  protoOf(HolySee).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(HolySee), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(HolySee), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(HolySee), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(HolySee), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(HolySee), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(HolySee), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(HolySee), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(HolySee), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(HolySee), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Honduras).yd = get_phoneNumberHint;
  protoOf(Honduras).zd = get_flagUrl;
  protoOf(Honduras).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Honduras), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Honduras), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Honduras), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Honduras), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Honduras), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Honduras), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Honduras), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Honduras), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Honduras), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(HongKong).yd = get_phoneNumberHint;
  protoOf(HongKong).zd = get_flagUrl;
  protoOf(HongKong).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(HongKong), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(HongKong), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(HongKong), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(HongKong), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(HongKong), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(HongKong), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(HongKong), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(HongKong), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(HongKong), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Hungary).yd = get_phoneNumberHint;
  protoOf(Hungary).zd = get_flagUrl;
  protoOf(Hungary).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Hungary), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Hungary), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Hungary), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Hungary), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Hungary), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Hungary), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Hungary), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Hungary), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Hungary), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Iceland).yd = get_phoneNumberHint;
  protoOf(Iceland).zd = get_flagUrl;
  protoOf(Iceland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Iceland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Iceland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Iceland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Iceland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Iceland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Iceland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Iceland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Iceland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Iceland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(India).zd = get_flagUrl;
  protoOf(India).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(India), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(India), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(India), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(India), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(India), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(India), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(India), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(India), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(India), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Indonesia).yd = get_phoneNumberHint;
  protoOf(Indonesia).zd = get_flagUrl;
  protoOf(Indonesia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Indonesia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Indonesia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Indonesia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Indonesia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Indonesia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Indonesia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Indonesia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Indonesia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Indonesia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(IranIslamicRepublicof).yd = get_phoneNumberHint;
  protoOf(IranIslamicRepublicof).zd = get_flagUrl;
  protoOf(IranIslamicRepublicof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(IranIslamicRepublicof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(IranIslamicRepublicof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Iraq).zd = get_flagUrl;
  protoOf(Iraq).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Iraq), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Iraq), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Iraq), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Iraq), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Iraq), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Iraq), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Iraq), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Iraq), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Iraq), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Ireland).yd = get_phoneNumberHint;
  protoOf(Ireland).zd = get_flagUrl;
  protoOf(Ireland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Ireland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Ireland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Ireland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Ireland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Ireland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Ireland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Ireland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Ireland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Ireland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(IsleofMan).yd = get_phoneNumberHint;
  protoOf(IsleofMan).zd = get_flagUrl;
  protoOf(IsleofMan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(IsleofMan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(IsleofMan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(IsleofMan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(IsleofMan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(IsleofMan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(IsleofMan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(IsleofMan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(IsleofMan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(IsleofMan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Israel).yd = get_phoneNumberHint;
  protoOf(Israel).zd = get_flagUrl;
  protoOf(Israel).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Israel), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Israel), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Israel), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Israel), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Israel), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Israel), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Israel), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Israel), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Israel), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Italy).yd = get_phoneNumberHint;
  protoOf(Italy).zd = get_flagUrl;
  protoOf(Italy).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Italy), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Italy), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Italy), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Italy), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Italy), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Italy), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Italy), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Italy), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Italy), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Jamaica).yd = get_phoneNumberHint;
  protoOf(Jamaica).zd = get_flagUrl;
  protoOf(Jamaica).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Jamaica), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Jamaica), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Jamaica), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Jamaica), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Jamaica), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Jamaica), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Jamaica), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Jamaica), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Jamaica), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Japan).yd = get_phoneNumberHint;
  protoOf(Japan).zd = get_flagUrl;
  protoOf(Japan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Japan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Japan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Japan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Japan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Japan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Japan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Japan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Japan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Japan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Jersey).yd = get_phoneNumberHint;
  protoOf(Jersey).zd = get_flagUrl;
  protoOf(Jersey).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Jersey), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Jersey), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Jersey), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Jersey), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Jersey), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Jersey), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Jersey), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Jersey), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Jersey), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Jordan).zd = get_flagUrl;
  protoOf(Jordan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Jordan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Jordan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Jordan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Jordan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Jordan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Jordan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Jordan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Jordan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Jordan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Kazakhstan).yd = get_phoneNumberHint;
  protoOf(Kazakhstan).zd = get_flagUrl;
  protoOf(Kazakhstan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Kazakhstan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Kazakhstan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Kazakhstan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Kazakhstan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Kazakhstan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Kazakhstan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Kazakhstan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Kazakhstan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Kazakhstan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Kenya).zd = get_flagUrl;
  protoOf(Kenya).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Kenya), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Kenya), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Kenya), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Kenya), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Kenya), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Kenya), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Kenya), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Kenya), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Kenya), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Kiribati).yd = get_phoneNumberHint;
  protoOf(Kiribati).zd = get_flagUrl;
  protoOf(Kiribati).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Kiribati), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Kiribati), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Kiribati), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Kiribati), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Kiribati), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Kiribati), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Kiribati), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Kiribati), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Kiribati), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(KoreaDemocraticPeoplesRepublicof).yd = get_phoneNumberHint;
  protoOf(KoreaDemocraticPeoplesRepublicof).zd = get_flagUrl;
  protoOf(KoreaDemocraticPeoplesRepublicof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(KoreaDemocraticPeoplesRepublicof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(KoreaRepublicof).yd = get_phoneNumberHint;
  protoOf(KoreaRepublicof).zd = get_flagUrl;
  protoOf(KoreaRepublicof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(KoreaRepublicof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(KoreaRepublicof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(KoreaRepublicof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(KoreaRepublicof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(KoreaRepublicof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(KoreaRepublicof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(KoreaRepublicof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(KoreaRepublicof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(KoreaRepublicof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Kuwait).zd = get_flagUrl;
  protoOf(Kuwait).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Kuwait), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Kuwait), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Kuwait), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Kuwait), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Kuwait), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Kuwait), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Kuwait), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Kuwait), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Kuwait), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Kyrgyzstan).yd = get_phoneNumberHint;
  protoOf(Kyrgyzstan).zd = get_flagUrl;
  protoOf(Kyrgyzstan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Kyrgyzstan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Kyrgyzstan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Kyrgyzstan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Kyrgyzstan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Kyrgyzstan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Kyrgyzstan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Kyrgyzstan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Kyrgyzstan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Kyrgyzstan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(LaoPeoplesDemocraticRepublic).yd = get_phoneNumberHint;
  protoOf(LaoPeoplesDemocraticRepublic).zd = get_flagUrl;
  protoOf(LaoPeoplesDemocraticRepublic).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(LaoPeoplesDemocraticRepublic), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Latvia).yd = get_phoneNumberHint;
  protoOf(Latvia).zd = get_flagUrl;
  protoOf(Latvia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Latvia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Latvia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Latvia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Latvia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Latvia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Latvia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Latvia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Latvia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Latvia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Lebanon).zd = get_flagUrl;
  protoOf(Lebanon).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Lebanon), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Lebanon), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Lebanon), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Lebanon), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Lebanon), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Lebanon), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Lebanon), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Lebanon), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Lebanon), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Lesotho).yd = get_phoneNumberHint;
  protoOf(Lesotho).zd = get_flagUrl;
  protoOf(Lesotho).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Lesotho), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Lesotho), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Lesotho), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Lesotho), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Lesotho), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Lesotho), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Lesotho), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Lesotho), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Lesotho), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Liberia).yd = get_phoneNumberHint;
  protoOf(Liberia).zd = get_flagUrl;
  protoOf(Liberia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Liberia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Liberia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Liberia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Liberia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Liberia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Liberia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Liberia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Liberia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Liberia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Libya).zd = get_flagUrl;
  protoOf(Libya).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Libya), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Libya), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Libya), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Libya), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Libya), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Libya), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Libya), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Libya), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Libya), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Liechtenstein).yd = get_phoneNumberHint;
  protoOf(Liechtenstein).zd = get_flagUrl;
  protoOf(Liechtenstein).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Liechtenstein), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Liechtenstein), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Liechtenstein), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Liechtenstein), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Liechtenstein), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Liechtenstein), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Liechtenstein), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Liechtenstein), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Liechtenstein), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Lithuania).yd = get_phoneNumberHint;
  protoOf(Lithuania).zd = get_flagUrl;
  protoOf(Lithuania).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Lithuania), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Lithuania), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Lithuania), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Lithuania), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Lithuania), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Lithuania), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Lithuania), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Lithuania), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Lithuania), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Luxembourg).yd = get_phoneNumberHint;
  protoOf(Luxembourg).zd = get_flagUrl;
  protoOf(Luxembourg).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Luxembourg), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Luxembourg), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Luxembourg), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Luxembourg), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Luxembourg), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Luxembourg), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Luxembourg), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Luxembourg), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Luxembourg), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Macao).yd = get_phoneNumberHint;
  protoOf(Macao).zd = get_flagUrl;
  protoOf(Macao).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Macao), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Macao), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Macao), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Macao), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Macao), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Macao), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Macao), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Macao), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Macao), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(NorthMacedonia).yd = get_phoneNumberHint;
  protoOf(NorthMacedonia).zd = get_flagUrl;
  protoOf(NorthMacedonia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(NorthMacedonia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(NorthMacedonia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(NorthMacedonia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(NorthMacedonia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(NorthMacedonia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(NorthMacedonia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(NorthMacedonia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(NorthMacedonia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(NorthMacedonia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Madagascar).yd = get_phoneNumberHint;
  protoOf(Madagascar).zd = get_flagUrl;
  protoOf(Madagascar).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Madagascar), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Madagascar), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Madagascar), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Madagascar), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Madagascar), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Madagascar), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Madagascar), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Madagascar), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Madagascar), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Malawi).yd = get_phoneNumberHint;
  protoOf(Malawi).zd = get_flagUrl;
  protoOf(Malawi).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Malawi), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Malawi), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Malawi), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Malawi), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Malawi), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Malawi), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Malawi), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Malawi), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Malawi), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Malaysia).yd = get_phoneNumberHint;
  protoOf(Malaysia).zd = get_flagUrl;
  protoOf(Malaysia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Malaysia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Malaysia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Malaysia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Malaysia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Malaysia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Malaysia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Malaysia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Malaysia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Malaysia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Maldives).yd = get_phoneNumberHint;
  protoOf(Maldives).zd = get_flagUrl;
  protoOf(Maldives).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Maldives), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Maldives), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Maldives), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Maldives), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Maldives), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Maldives), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Maldives), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Maldives), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Maldives), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mali).yd = get_phoneNumberHint;
  protoOf(Mali).zd = get_flagUrl;
  protoOf(Mali).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mali), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mali), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mali), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mali), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mali), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mali), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mali), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mali), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mali), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Malta).yd = get_phoneNumberHint;
  protoOf(Malta).zd = get_flagUrl;
  protoOf(Malta).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Malta), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Malta), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Malta), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Malta), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Malta), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Malta), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Malta), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Malta), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Malta), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(MarshallIslands).yd = get_phoneNumberHint;
  protoOf(MarshallIslands).zd = get_flagUrl;
  protoOf(MarshallIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(MarshallIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(MarshallIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(MarshallIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(MarshallIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(MarshallIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(MarshallIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(MarshallIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(MarshallIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(MarshallIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Martinique).yd = get_phoneNumberHint;
  protoOf(Martinique).zd = get_flagUrl;
  protoOf(Martinique).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Martinique), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Martinique), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Martinique), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Martinique), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Martinique), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Martinique), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Martinique), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Martinique), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Martinique), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mauritania).yd = get_phoneNumberHint;
  protoOf(Mauritania).zd = get_flagUrl;
  protoOf(Mauritania).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mauritania), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mauritania), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mauritania), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mauritania), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mauritania), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mauritania), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mauritania), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mauritania), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mauritania), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mauritius).yd = get_phoneNumberHint;
  protoOf(Mauritius).zd = get_flagUrl;
  protoOf(Mauritius).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mauritius), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mauritius), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mauritius), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mauritius), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mauritius), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mauritius), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mauritius), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mauritius), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mauritius), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mayotte).yd = get_phoneNumberHint;
  protoOf(Mayotte).zd = get_flagUrl;
  protoOf(Mayotte).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mayotte), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mayotte), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mayotte), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mayotte), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mayotte), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mayotte), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mayotte), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mayotte), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mayotte), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mexico).yd = get_phoneNumberHint;
  protoOf(Mexico).zd = get_flagUrl;
  protoOf(Mexico).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mexico), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mexico), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mexico), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mexico), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mexico), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mexico), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mexico), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mexico), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mexico), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(MicronesiaFederatedStatesof).yd = get_phoneNumberHint;
  protoOf(MicronesiaFederatedStatesof).zd = get_flagUrl;
  protoOf(MicronesiaFederatedStatesof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(MicronesiaFederatedStatesof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(MicronesiaFederatedStatesof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Morocco).zd = get_flagUrl;
  protoOf(Morocco).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Morocco), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Morocco), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Morocco), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Morocco), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Morocco), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Morocco), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Morocco), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Morocco), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Morocco), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(MoldovaRepublicof).yd = get_phoneNumberHint;
  protoOf(MoldovaRepublicof).zd = get_flagUrl;
  protoOf(MoldovaRepublicof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(MoldovaRepublicof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(MoldovaRepublicof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(MoldovaRepublicof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(MoldovaRepublicof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(MoldovaRepublicof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(MoldovaRepublicof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(MoldovaRepublicof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(MoldovaRepublicof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(MoldovaRepublicof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Monaco).yd = get_phoneNumberHint;
  protoOf(Monaco).zd = get_flagUrl;
  protoOf(Monaco).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Monaco), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Monaco), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Monaco), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Monaco), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Monaco), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Monaco), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Monaco), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Monaco), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Monaco), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mongolia).yd = get_phoneNumberHint;
  protoOf(Mongolia).zd = get_flagUrl;
  protoOf(Mongolia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mongolia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mongolia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mongolia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mongolia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mongolia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mongolia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mongolia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mongolia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mongolia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Montenegro).yd = get_phoneNumberHint;
  protoOf(Montenegro).zd = get_flagUrl;
  protoOf(Montenegro).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Montenegro), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Montenegro), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Montenegro), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Montenegro), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Montenegro), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Montenegro), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Montenegro), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Montenegro), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Montenegro), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Montserrat).yd = get_phoneNumberHint;
  protoOf(Montserrat).zd = get_flagUrl;
  protoOf(Montserrat).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Montserrat), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Montserrat), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Montserrat), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Montserrat), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Montserrat), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Montserrat), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Montserrat), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Montserrat), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Montserrat), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Mozambique).yd = get_phoneNumberHint;
  protoOf(Mozambique).zd = get_flagUrl;
  protoOf(Mozambique).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Mozambique), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Mozambique), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Mozambique), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Mozambique), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Mozambique), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Mozambique), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Mozambique), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Mozambique), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Mozambique), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Myanmar).yd = get_phoneNumberHint;
  protoOf(Myanmar).zd = get_flagUrl;
  protoOf(Myanmar).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Myanmar), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Myanmar), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Myanmar), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Myanmar), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Myanmar), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Myanmar), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Myanmar), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Myanmar), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Myanmar), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Namibia).yd = get_phoneNumberHint;
  protoOf(Namibia).zd = get_flagUrl;
  protoOf(Namibia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Namibia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Namibia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Namibia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Namibia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Namibia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Namibia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Namibia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Namibia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Namibia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Nauru).yd = get_phoneNumberHint;
  protoOf(Nauru).zd = get_flagUrl;
  protoOf(Nauru).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Nauru), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Nauru), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Nauru), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Nauru), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Nauru), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Nauru), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Nauru), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Nauru), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Nauru), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Nepal).zd = get_flagUrl;
  protoOf(Nepal).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Nepal), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Nepal), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Nepal), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Nepal), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Nepal), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Nepal), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Nepal), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Nepal), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Nepal), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Netherlands).yd = get_phoneNumberHint;
  protoOf(Netherlands).zd = get_flagUrl;
  protoOf(Netherlands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Netherlands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Netherlands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Netherlands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Netherlands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Netherlands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Netherlands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Netherlands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Netherlands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Netherlands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(NewCaledonia).yd = get_phoneNumberHint;
  protoOf(NewCaledonia).zd = get_flagUrl;
  protoOf(NewCaledonia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(NewCaledonia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(NewCaledonia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(NewCaledonia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(NewCaledonia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(NewCaledonia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(NewCaledonia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(NewCaledonia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(NewCaledonia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(NewCaledonia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(NewZealand).yd = get_phoneNumberHint;
  protoOf(NewZealand).zd = get_flagUrl;
  protoOf(NewZealand).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(NewZealand), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(NewZealand), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(NewZealand), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(NewZealand), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(NewZealand), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(NewZealand), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(NewZealand), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(NewZealand), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(NewZealand), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Nicaragua).yd = get_phoneNumberHint;
  protoOf(Nicaragua).zd = get_flagUrl;
  protoOf(Nicaragua).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Nicaragua), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Nicaragua), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Nicaragua), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Nicaragua), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Nicaragua), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Nicaragua), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Nicaragua), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Nicaragua), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Nicaragua), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Niger).yd = get_phoneNumberHint;
  protoOf(Niger).zd = get_flagUrl;
  protoOf(Niger).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Niger), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Niger), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Niger), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Niger), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Niger), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Niger), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Niger), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Niger), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Niger), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Nigeria).zd = get_flagUrl;
  protoOf(Nigeria).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Nigeria), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Nigeria), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Nigeria), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Nigeria), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Nigeria), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Nigeria), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Nigeria), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Nigeria), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Nigeria), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Niue).yd = get_phoneNumberHint;
  protoOf(Niue).zd = get_flagUrl;
  protoOf(Niue).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Niue), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Niue), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Niue), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Niue), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Niue), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Niue), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Niue), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Niue), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Niue), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(NorfolkIsland).yd = get_phoneNumberHint;
  protoOf(NorfolkIsland).zd = get_flagUrl;
  protoOf(NorfolkIsland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(NorfolkIsland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(NorfolkIsland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(NorfolkIsland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(NorfolkIsland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(NorfolkIsland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(NorfolkIsland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(NorfolkIsland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(NorfolkIsland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(NorfolkIsland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(NorthernMarianaIslands).yd = get_phoneNumberHint;
  protoOf(NorthernMarianaIslands).zd = get_flagUrl;
  protoOf(NorthernMarianaIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(NorthernMarianaIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(NorthernMarianaIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Norway).yd = get_phoneNumberHint;
  protoOf(Norway).zd = get_flagUrl;
  protoOf(Norway).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Norway), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Norway), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Norway), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Norway), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Norway), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Norway), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Norway), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Norway), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Norway), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Oman).zd = get_flagUrl;
  protoOf(Oman).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Oman), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Oman), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Oman), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Oman), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Oman), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Oman), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Oman), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Oman), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Oman), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Pakistan).zd = get_flagUrl;
  protoOf(Pakistan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Pakistan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Pakistan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Pakistan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Pakistan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Pakistan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Pakistan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Pakistan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Pakistan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Pakistan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Palau).yd = get_phoneNumberHint;
  protoOf(Palau).zd = get_flagUrl;
  protoOf(Palau).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Palau), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Palau), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Palau), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Palau), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Palau), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Palau), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Palau), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Palau), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Palau), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(PalestineStateof).yd = get_phoneNumberHint;
  protoOf(PalestineStateof).zd = get_flagUrl;
  protoOf(PalestineStateof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(PalestineStateof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(PalestineStateof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(PalestineStateof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(PalestineStateof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(PalestineStateof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(PalestineStateof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(PalestineStateof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(PalestineStateof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(PalestineStateof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Panama).yd = get_phoneNumberHint;
  protoOf(Panama).zd = get_flagUrl;
  protoOf(Panama).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Panama), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Panama), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Panama), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Panama), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Panama), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Panama), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Panama), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Panama), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Panama), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(PapuaNewGuinea).yd = get_phoneNumberHint;
  protoOf(PapuaNewGuinea).zd = get_flagUrl;
  protoOf(PapuaNewGuinea).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(PapuaNewGuinea), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(PapuaNewGuinea), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(PapuaNewGuinea), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(PapuaNewGuinea), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(PapuaNewGuinea), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(PapuaNewGuinea), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(PapuaNewGuinea), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(PapuaNewGuinea), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(PapuaNewGuinea), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Paraguay).yd = get_phoneNumberHint;
  protoOf(Paraguay).zd = get_flagUrl;
  protoOf(Paraguay).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Paraguay), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Paraguay), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Paraguay), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Paraguay), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Paraguay), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Paraguay), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Paraguay), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Paraguay), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Paraguay), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Peru).yd = get_phoneNumberHint;
  protoOf(Peru).zd = get_flagUrl;
  protoOf(Peru).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Peru), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Peru), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Peru), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Peru), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Peru), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Peru), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Peru), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Peru), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Peru), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Philippines).zd = get_flagUrl;
  protoOf(Philippines).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Philippines), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Philippines), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Philippines), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Philippines), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Philippines), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Philippines), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Philippines), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Philippines), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Philippines), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Pitcairn).yd = get_phoneNumberHint;
  protoOf(Pitcairn).zd = get_flagUrl;
  protoOf(Pitcairn).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Pitcairn), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Pitcairn), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Pitcairn), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Pitcairn), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Pitcairn), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Pitcairn), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Pitcairn), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Pitcairn), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Pitcairn), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Poland).yd = get_phoneNumberHint;
  protoOf(Poland).zd = get_flagUrl;
  protoOf(Poland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Poland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Poland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Poland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Poland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Poland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Poland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Poland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Poland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Poland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Portugal).yd = get_phoneNumberHint;
  protoOf(Portugal).zd = get_flagUrl;
  protoOf(Portugal).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Portugal), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Portugal), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Portugal), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Portugal), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Portugal), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Portugal), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Portugal), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Portugal), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Portugal), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(PuertoRico).yd = get_phoneNumberHint;
  protoOf(PuertoRico).zd = get_flagUrl;
  protoOf(PuertoRico).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(PuertoRico), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(PuertoRico), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(PuertoRico), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(PuertoRico), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(PuertoRico), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(PuertoRico), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(PuertoRico), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(PuertoRico), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(PuertoRico), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Qatar).zd = get_flagUrl;
  protoOf(Qatar).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Qatar), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Qatar), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Qatar), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Qatar), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Qatar), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Qatar), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Qatar), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Qatar), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Qatar), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Reunion).yd = get_phoneNumberHint;
  protoOf(Reunion).zd = get_flagUrl;
  protoOf(Reunion).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Reunion), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Reunion), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Reunion), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Reunion), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Reunion), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Reunion), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Reunion), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Reunion), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Reunion), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Romania).yd = get_phoneNumberHint;
  protoOf(Romania).zd = get_flagUrl;
  protoOf(Romania).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Romania), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Romania), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Romania), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Romania), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Romania), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Romania), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Romania), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Romania), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Romania), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(RussianFederation).yd = get_phoneNumberHint;
  protoOf(RussianFederation).zd = get_flagUrl;
  protoOf(RussianFederation).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(RussianFederation), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(RussianFederation), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(RussianFederation), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(RussianFederation), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(RussianFederation), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(RussianFederation), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(RussianFederation), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(RussianFederation), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(RussianFederation), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Rwanda).yd = get_phoneNumberHint;
  protoOf(Rwanda).zd = get_flagUrl;
  protoOf(Rwanda).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Rwanda), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Rwanda), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Rwanda), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Rwanda), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Rwanda), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Rwanda), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Rwanda), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Rwanda), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Rwanda), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintBarthelemy).yd = get_phoneNumberHint;
  protoOf(SaintBarthelemy).zd = get_flagUrl;
  protoOf(SaintBarthelemy).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintBarthelemy), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintBarthelemy), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintBarthelemy), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintBarthelemy), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintBarthelemy), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintBarthelemy), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintBarthelemy), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintBarthelemy), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintBarthelemy), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintHelenaAscensionandTristandaCunha).yd = get_phoneNumberHint;
  protoOf(SaintHelenaAscensionandTristandaCunha).zd = get_flagUrl;
  protoOf(SaintHelenaAscensionandTristandaCunha).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintHelenaAscensionandTristandaCunha), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintKittsandNevis).yd = get_phoneNumberHint;
  protoOf(SaintKittsandNevis).zd = get_flagUrl;
  protoOf(SaintKittsandNevis).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintKittsandNevis), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintKittsandNevis), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintKittsandNevis), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintKittsandNevis), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintKittsandNevis), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintKittsandNevis), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintKittsandNevis), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintKittsandNevis), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintKittsandNevis), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintLucia).yd = get_phoneNumberHint;
  protoOf(SaintLucia).zd = get_flagUrl;
  protoOf(SaintLucia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintLucia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintLucia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintLucia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintLucia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintLucia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintLucia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintLucia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintLucia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintLucia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintMartinFrenchpart).yd = get_phoneNumberHint;
  protoOf(SaintMartinFrenchpart).zd = get_flagUrl;
  protoOf(SaintMartinFrenchpart).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintMartinFrenchpart), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintMartinFrenchpart), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintPierreandMiquelon).yd = get_phoneNumberHint;
  protoOf(SaintPierreandMiquelon).zd = get_flagUrl;
  protoOf(SaintPierreandMiquelon).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintPierreandMiquelon), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintPierreandMiquelon), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaintVincentandtheGrenadines).yd = get_phoneNumberHint;
  protoOf(SaintVincentandtheGrenadines).zd = get_flagUrl;
  protoOf(SaintVincentandtheGrenadines).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaintVincentandtheGrenadines), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaintVincentandtheGrenadines), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Samoa).yd = get_phoneNumberHint;
  protoOf(Samoa).zd = get_flagUrl;
  protoOf(Samoa).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Samoa), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Samoa), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Samoa), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Samoa), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Samoa), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Samoa), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Samoa), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Samoa), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Samoa), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SanMarino).yd = get_phoneNumberHint;
  protoOf(SanMarino).zd = get_flagUrl;
  protoOf(SanMarino).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SanMarino), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SanMarino), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SanMarino), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SanMarino), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SanMarino), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SanMarino), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SanMarino), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SanMarino), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SanMarino), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SaoTomeandPrincipe).yd = get_phoneNumberHint;
  protoOf(SaoTomeandPrincipe).zd = get_flagUrl;
  protoOf(SaoTomeandPrincipe).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SaoTomeandPrincipe), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SaoTomeandPrincipe), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Senegal).yd = get_phoneNumberHint;
  protoOf(Senegal).zd = get_flagUrl;
  protoOf(Senegal).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Senegal), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Senegal), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Senegal), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Senegal), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Senegal), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Senegal), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Senegal), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Senegal), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Senegal), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Serbia).yd = get_phoneNumberHint;
  protoOf(Serbia).zd = get_flagUrl;
  protoOf(Serbia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Serbia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Serbia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Serbia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Serbia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Serbia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Serbia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Serbia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Serbia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Serbia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Seychelles).yd = get_phoneNumberHint;
  protoOf(Seychelles).zd = get_flagUrl;
  protoOf(Seychelles).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Seychelles), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Seychelles), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Seychelles), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Seychelles), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Seychelles), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Seychelles), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Seychelles), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Seychelles), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Seychelles), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SierraLeone).yd = get_phoneNumberHint;
  protoOf(SierraLeone).zd = get_flagUrl;
  protoOf(SierraLeone).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SierraLeone), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SierraLeone), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SierraLeone), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SierraLeone), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SierraLeone), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SierraLeone), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SierraLeone), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SierraLeone), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SierraLeone), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Singapore).yd = get_phoneNumberHint;
  protoOf(Singapore).zd = get_flagUrl;
  protoOf(Singapore).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Singapore), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Singapore), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Singapore), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Singapore), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Singapore), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Singapore), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Singapore), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Singapore), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Singapore), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SintMaartenDutchpart).yd = get_phoneNumberHint;
  protoOf(SintMaartenDutchpart).zd = get_flagUrl;
  protoOf(SintMaartenDutchpart).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SintMaartenDutchpart), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SintMaartenDutchpart), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Slovakia).yd = get_phoneNumberHint;
  protoOf(Slovakia).zd = get_flagUrl;
  protoOf(Slovakia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Slovakia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Slovakia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Slovakia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Slovakia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Slovakia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Slovakia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Slovakia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Slovakia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Slovakia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Slovenia).yd = get_phoneNumberHint;
  protoOf(Slovenia).zd = get_flagUrl;
  protoOf(Slovenia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Slovenia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Slovenia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Slovenia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Slovenia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Slovenia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Slovenia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Slovenia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Slovenia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Slovenia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SolomonIslands).yd = get_phoneNumberHint;
  protoOf(SolomonIslands).zd = get_flagUrl;
  protoOf(SolomonIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SolomonIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SolomonIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SolomonIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SolomonIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SolomonIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SolomonIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SolomonIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SolomonIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SolomonIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Somalia).yd = get_phoneNumberHint;
  protoOf(Somalia).zd = get_flagUrl;
  protoOf(Somalia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Somalia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Somalia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Somalia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Somalia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Somalia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Somalia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Somalia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Somalia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Somalia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SouthAfrica).yd = get_phoneNumberHint;
  protoOf(SouthAfrica).zd = get_flagUrl;
  protoOf(SouthAfrica).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SouthAfrica), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SouthAfrica), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SouthAfrica), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SouthAfrica), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SouthAfrica), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SouthAfrica), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SouthAfrica), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SouthAfrica), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SouthAfrica), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).yd = get_phoneNumberHint;
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).zd = get_flagUrl;
  protoOf(SouthGeorgiaandtheSouthSandwichIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SouthGeorgiaandtheSouthSandwichIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SouthSudan).yd = get_phoneNumberHint;
  protoOf(SouthSudan).zd = get_flagUrl;
  protoOf(SouthSudan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SouthSudan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SouthSudan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SouthSudan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SouthSudan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SouthSudan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SouthSudan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SouthSudan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SouthSudan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SouthSudan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Spain).yd = get_phoneNumberHint;
  protoOf(Spain).zd = get_flagUrl;
  protoOf(Spain).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Spain), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Spain), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Spain), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Spain), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Spain), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Spain), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Spain), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Spain), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Spain), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SriLanka).yd = get_phoneNumberHint;
  protoOf(SriLanka).zd = get_flagUrl;
  protoOf(SriLanka).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SriLanka), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SriLanka), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SriLanka), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SriLanka), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SriLanka), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SriLanka), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SriLanka), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SriLanka), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SriLanka), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Sudan).yd = get_phoneNumberHint;
  protoOf(Sudan).zd = get_flagUrl;
  protoOf(Sudan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Sudan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Sudan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Sudan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Sudan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Sudan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Sudan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Sudan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Sudan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Sudan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Suriname).yd = get_phoneNumberHint;
  protoOf(Suriname).zd = get_flagUrl;
  protoOf(Suriname).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Suriname), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Suriname), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Suriname), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Suriname), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Suriname), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Suriname), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Suriname), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Suriname), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Suriname), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SvalbardandJanMayen).yd = get_phoneNumberHint;
  protoOf(SvalbardandJanMayen).zd = get_flagUrl;
  protoOf(SvalbardandJanMayen).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SvalbardandJanMayen), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SvalbardandJanMayen), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Eswatini).yd = get_phoneNumberHint;
  protoOf(Eswatini).zd = get_flagUrl;
  protoOf(Eswatini).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Eswatini), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Eswatini), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Eswatini), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Eswatini), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Eswatini), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Eswatini), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Eswatini), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Eswatini), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Eswatini), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Sweden).yd = get_phoneNumberHint;
  protoOf(Sweden).zd = get_flagUrl;
  protoOf(Sweden).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Sweden), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Sweden), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Sweden), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Sweden), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Sweden), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Sweden), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Sweden), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Sweden), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Sweden), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Switzerland).yd = get_phoneNumberHint;
  protoOf(Switzerland).zd = get_flagUrl;
  protoOf(Switzerland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Switzerland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Switzerland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Switzerland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Switzerland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Switzerland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Switzerland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Switzerland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Switzerland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Switzerland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(SyrianArabRepublic).yd = get_phoneNumberHint;
  protoOf(SyrianArabRepublic).zd = get_flagUrl;
  protoOf(SyrianArabRepublic).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(SyrianArabRepublic), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(SyrianArabRepublic), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(SyrianArabRepublic), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(SyrianArabRepublic), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(SyrianArabRepublic), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(SyrianArabRepublic), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(SyrianArabRepublic), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(SyrianArabRepublic), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(SyrianArabRepublic), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(TaiwanProvinceofChina).yd = get_phoneNumberHint;
  protoOf(TaiwanProvinceofChina).zd = get_flagUrl;
  protoOf(TaiwanProvinceofChina).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(TaiwanProvinceofChina), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(TaiwanProvinceofChina), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Tajikistan).yd = get_phoneNumberHint;
  protoOf(Tajikistan).zd = get_flagUrl;
  protoOf(Tajikistan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Tajikistan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Tajikistan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Tajikistan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Tajikistan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Tajikistan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Tajikistan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Tajikistan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Tajikistan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Tajikistan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(TanzaniaUnitedRepublicof).yd = get_phoneNumberHint;
  protoOf(TanzaniaUnitedRepublicof).zd = get_flagUrl;
  protoOf(TanzaniaUnitedRepublicof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(TanzaniaUnitedRepublicof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Thailand).yd = get_phoneNumberHint;
  protoOf(Thailand).zd = get_flagUrl;
  protoOf(Thailand).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Thailand), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Thailand), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Thailand), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Thailand), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Thailand), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Thailand), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Thailand), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Thailand), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Thailand), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(TimorLeste).yd = get_phoneNumberHint;
  protoOf(TimorLeste).zd = get_flagUrl;
  protoOf(TimorLeste).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(TimorLeste), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(TimorLeste), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(TimorLeste), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(TimorLeste), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(TimorLeste), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(TimorLeste), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(TimorLeste), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(TimorLeste), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(TimorLeste), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Togo).yd = get_phoneNumberHint;
  protoOf(Togo).zd = get_flagUrl;
  protoOf(Togo).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Togo), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Togo), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Togo), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Togo), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Togo), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Togo), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Togo), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Togo), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Togo), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Tokelau).yd = get_phoneNumberHint;
  protoOf(Tokelau).zd = get_flagUrl;
  protoOf(Tokelau).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Tokelau), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Tokelau), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Tokelau), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Tokelau), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Tokelau), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Tokelau), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Tokelau), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Tokelau), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Tokelau), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Tonga).yd = get_phoneNumberHint;
  protoOf(Tonga).zd = get_flagUrl;
  protoOf(Tonga).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Tonga), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Tonga), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Tonga), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Tonga), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Tonga), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Tonga), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Tonga), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Tonga), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Tonga), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(TrinidadandTobago).yd = get_phoneNumberHint;
  protoOf(TrinidadandTobago).zd = get_flagUrl;
  protoOf(TrinidadandTobago).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(TrinidadandTobago), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(TrinidadandTobago), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(TrinidadandTobago), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(TrinidadandTobago), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(TrinidadandTobago), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(TrinidadandTobago), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(TrinidadandTobago), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(TrinidadandTobago), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(TrinidadandTobago), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Tunisia).zd = get_flagUrl;
  protoOf(Tunisia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Tunisia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Tunisia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Tunisia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Tunisia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Tunisia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Tunisia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Tunisia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Tunisia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Tunisia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Turkey).zd = get_flagUrl;
  protoOf(Turkey).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Turkey), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Turkey), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Turkey), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Turkey), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Turkey), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Turkey), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Turkey), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Turkey), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Turkey), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Turkmenistan).yd = get_phoneNumberHint;
  protoOf(Turkmenistan).zd = get_flagUrl;
  protoOf(Turkmenistan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Turkmenistan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Turkmenistan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Turkmenistan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Turkmenistan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Turkmenistan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Turkmenistan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Turkmenistan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Turkmenistan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Turkmenistan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(TurksandCaicosIslands).yd = get_phoneNumberHint;
  protoOf(TurksandCaicosIslands).zd = get_flagUrl;
  protoOf(TurksandCaicosIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(TurksandCaicosIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(TurksandCaicosIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Tuvalu).yd = get_phoneNumberHint;
  protoOf(Tuvalu).zd = get_flagUrl;
  protoOf(Tuvalu).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Tuvalu), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Tuvalu), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Tuvalu), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Tuvalu), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Tuvalu), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Tuvalu), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Tuvalu), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Tuvalu), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Tuvalu), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Uganda).yd = get_phoneNumberHint;
  protoOf(Uganda).zd = get_flagUrl;
  protoOf(Uganda).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Uganda), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Uganda), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Uganda), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Uganda), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Uganda), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Uganda), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Uganda), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Uganda), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Uganda), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Ukraine).yd = get_phoneNumberHint;
  protoOf(Ukraine).zd = get_flagUrl;
  protoOf(Ukraine).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Ukraine), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Ukraine), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Ukraine), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Ukraine), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Ukraine), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Ukraine), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Ukraine), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Ukraine), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Ukraine), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).zd = get_flagUrl;
  protoOf(UnitedKingdomofGreatBritainandNorthernIreland).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(UnitedKingdomofGreatBritainandNorthernIreland), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(UnitedStatesofAmerica).zd = get_flagUrl;
  protoOf(UnitedStatesofAmerica).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(UnitedStatesofAmerica), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(UnitedStatesofAmerica), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(UnitedStatesMinorOutlyingIslands).yd = get_phoneNumberHint;
  protoOf(UnitedStatesMinorOutlyingIslands).zd = get_flagUrl;
  protoOf(UnitedStatesMinorOutlyingIslands).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(UnitedStatesMinorOutlyingIslands), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Uruguay).yd = get_phoneNumberHint;
  protoOf(Uruguay).zd = get_flagUrl;
  protoOf(Uruguay).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Uruguay), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Uruguay), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Uruguay), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Uruguay), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Uruguay), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Uruguay), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Uruguay), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Uruguay), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Uruguay), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Uzbekistan).yd = get_phoneNumberHint;
  protoOf(Uzbekistan).zd = get_flagUrl;
  protoOf(Uzbekistan).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Uzbekistan), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Uzbekistan), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Uzbekistan), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Uzbekistan), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Uzbekistan), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Uzbekistan), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Uzbekistan), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Uzbekistan), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Uzbekistan), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Vanuatu).yd = get_phoneNumberHint;
  protoOf(Vanuatu).zd = get_flagUrl;
  protoOf(Vanuatu).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Vanuatu), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Vanuatu), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Vanuatu), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Vanuatu), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Vanuatu), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Vanuatu), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Vanuatu), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Vanuatu), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Vanuatu), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(VenezuelaBolivarianRepublicof).yd = get_phoneNumberHint;
  protoOf(VenezuelaBolivarianRepublicof).zd = get_flagUrl;
  protoOf(VenezuelaBolivarianRepublicof).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(VenezuelaBolivarianRepublicof), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(VietNam).yd = get_phoneNumberHint;
  protoOf(VietNam).zd = get_flagUrl;
  protoOf(VietNam).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(VietNam), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(VietNam), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(VietNam), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(VietNam), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(VietNam), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(VietNam), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(VietNam), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(VietNam), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(VietNam), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(VirginIslandsBritish).yd = get_phoneNumberHint;
  protoOf(VirginIslandsBritish).zd = get_flagUrl;
  protoOf(VirginIslandsBritish).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(VirginIslandsBritish), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(VirginIslandsBritish), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(VirginIslandsBritish), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(VirginIslandsBritish), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(VirginIslandsBritish), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(VirginIslandsBritish), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(VirginIslandsBritish), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(VirginIslandsBritish), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(VirginIslandsBritish), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(VirginIslandsUS).yd = get_phoneNumberHint;
  protoOf(VirginIslandsUS).zd = get_flagUrl;
  protoOf(VirginIslandsUS).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(VirginIslandsUS), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(VirginIslandsUS), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(VirginIslandsUS), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(VirginIslandsUS), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(VirginIslandsUS), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(VirginIslandsUS), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(VirginIslandsUS), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(VirginIslandsUS), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(VirginIslandsUS), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(WallisandFutuna).yd = get_phoneNumberHint;
  protoOf(WallisandFutuna).zd = get_flagUrl;
  protoOf(WallisandFutuna).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(WallisandFutuna), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(WallisandFutuna), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(WallisandFutuna), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(WallisandFutuna), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(WallisandFutuna), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(WallisandFutuna), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(WallisandFutuna), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(WallisandFutuna), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(WallisandFutuna), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Yemen).yd = get_phoneNumberHint;
  protoOf(Yemen).zd = get_flagUrl;
  protoOf(Yemen).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Yemen), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Yemen), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Yemen), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Yemen), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Yemen), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Yemen), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Yemen), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Yemen), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Yemen), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Zambia).yd = get_phoneNumberHint;
  protoOf(Zambia).zd = get_flagUrl;
  protoOf(Zambia).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Zambia), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Zambia), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Zambia), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Zambia), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Zambia), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Zambia), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Zambia), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Zambia), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Zambia), 'flagUrl', function () {
    return this.zd();
  });
  protoOf(Zimbabwe).yd = get_phoneNumberHint;
  protoOf(Zimbabwe).zd = get_flagUrl;
  protoOf(Zimbabwe).isPhoneNumberValid = isPhoneNumberValid;
  defineProp(protoOf(Zimbabwe), 'phoneNumPrefix', function () {
    return this.wd();
  });
  defineProp(protoOf(Zimbabwe), 'isoCode2', function () {
    return this.rd();
  });
  defineProp(protoOf(Zimbabwe), 'isoCode3', function () {
    return this.sd();
  });
  defineProp(protoOf(Zimbabwe), 'currency', function () {
    return this.td();
  });
  defineProp(protoOf(Zimbabwe), 'englishName', function () {
    return this.ud();
  });
  defineProp(protoOf(Zimbabwe), 'arabicName', function () {
    return this.vd();
  });
  defineProp(protoOf(Zimbabwe), 'phoneRegex', function () {
    return this.xd();
  });
  defineProp(protoOf(Zimbabwe), 'phoneNumberHint', function () {
    return this.yd();
  });
  defineProp(protoOf(Zimbabwe), 'flagUrl', function () {
    return this.zd();
  });
  //endregion
  //region block: init
  CountryResolver_instance = new CountryResolver();
  CurrencyResolver_instance = new CurrencyResolver();
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  Companion_instance_10 = new Companion_10();
  Companion_instance_11 = new Companion_11();
  Companion_instance_12 = new Companion_12();
  Companion_instance_13 = new Companion_13();
  Companion_instance_14 = new Companion_14();
  Companion_instance_15 = new Companion_15();
  Companion_instance_16 = new Companion_16();
  Companion_instance_17 = new Companion_17();
  Companion_instance_18 = new Companion_18();
  Companion_instance_19 = new Companion_19();
  Companion_instance_20 = new Companion_20();
  Companion_instance_21 = new Companion_21();
  Companion_instance_22 = new Companion_22();
  Companion_instance_23 = new Companion_23();
  Companion_instance_24 = new Companion_24();
  Companion_instance_25 = new Companion_25();
  Companion_instance_26 = new Companion_26();
  Companion_instance_27 = new Companion_27();
  Companion_instance_28 = new Companion_28();
  Companion_instance_29 = new Companion_29();
  Companion_instance_30 = new Companion_30();
  Companion_instance_31 = new Companion_31();
  Companion_instance_32 = new Companion_32();
  Companion_instance_33 = new Companion_33();
  Companion_instance_34 = new Companion_34();
  Companion_instance_35 = new Companion_35();
  Companion_instance_36 = new Companion_36();
  Companion_instance_37 = new Companion_37();
  Companion_instance_38 = new Companion_38();
  Companion_instance_39 = new Companion_39();
  Companion_instance_40 = new Companion_40();
  Companion_instance_41 = new Companion_41();
  Companion_instance_42 = new Companion_42();
  Companion_instance_43 = new Companion_43();
  Companion_instance_44 = new Companion_44();
  Companion_instance_45 = new Companion_45();
  Companion_instance_46 = new Companion_46();
  Companion_instance_47 = new Companion_47();
  Companion_instance_48 = new Companion_48();
  Companion_instance_49 = new Companion_49();
  Companion_instance_50 = new Companion_50();
  Companion_instance_51 = new Companion_51();
  Companion_instance_52 = new Companion_52();
  Companion_instance_53 = new Companion_53();
  Companion_instance_54 = new Companion_54();
  Companion_instance_55 = new Companion_55();
  Companion_instance_56 = new Companion_56();
  Companion_instance_57 = new Companion_57();
  Companion_instance_58 = new Companion_58();
  Companion_instance_59 = new Companion_59();
  Companion_instance_60 = new Companion_60();
  Companion_instance_61 = new Companion_61();
  Companion_instance_62 = new Companion_62();
  Companion_instance_63 = new Companion_63();
  Companion_instance_64 = new Companion_64();
  Companion_instance_65 = new Companion_65();
  Companion_instance_66 = new Companion_66();
  Companion_instance_67 = new Companion_67();
  Companion_instance_68 = new Companion_68();
  Companion_instance_69 = new Companion_69();
  Companion_instance_70 = new Companion_70();
  Companion_instance_71 = new Companion_71();
  Companion_instance_72 = new Companion_72();
  Companion_instance_73 = new Companion_73();
  Companion_instance_74 = new Companion_74();
  Companion_instance_75 = new Companion_75();
  Companion_instance_76 = new Companion_76();
  Companion_instance_77 = new Companion_77();
  Companion_instance_78 = new Companion_78();
  Companion_instance_79 = new Companion_79();
  Companion_instance_80 = new Companion_80();
  Companion_instance_81 = new Companion_81();
  Companion_instance_82 = new Companion_82();
  Companion_instance_83 = new Companion_83();
  Companion_instance_84 = new Companion_84();
  Companion_instance_85 = new Companion_85();
  Companion_instance_86 = new Companion_86();
  Companion_instance_87 = new Companion_87();
  Companion_instance_88 = new Companion_88();
  Companion_instance_89 = new Companion_89();
  Companion_instance_90 = new Companion_90();
  Companion_instance_91 = new Companion_91();
  Companion_instance_92 = new Companion_92();
  Companion_instance_93 = new Companion_93();
  Companion_instance_94 = new Companion_94();
  Companion_instance_95 = new Companion_95();
  Companion_instance_96 = new Companion_96();
  Companion_instance_97 = new Companion_97();
  Companion_instance_98 = new Companion_98();
  Companion_instance_99 = new Companion_99();
  Companion_instance_100 = new Companion_100();
  Companion_instance_101 = new Companion_101();
  Companion_instance_102 = new Companion_102();
  Companion_instance_103 = new Companion_103();
  Companion_instance_104 = new Companion_104();
  Companion_instance_105 = new Companion_105();
  Companion_instance_106 = new Companion_106();
  Companion_instance_107 = new Companion_107();
  Companion_instance_108 = new Companion_108();
  Companion_instance_109 = new Companion_109();
  Companion_instance_110 = new Companion_110();
  Companion_instance_111 = new Companion_111();
  Companion_instance_112 = new Companion_112();
  Companion_instance_113 = new Companion_113();
  Companion_instance_114 = new Companion_114();
  Companion_instance_115 = new Companion_115();
  Companion_instance_116 = new Companion_116();
  Companion_instance_117 = new Companion_117();
  Companion_instance_118 = new Companion_118();
  Companion_instance_119 = new Companion_119();
  Companion_instance_120 = new Companion_120();
  Companion_instance_121 = new Companion_121();
  Companion_instance_122 = new Companion_122();
  Companion_instance_123 = new Companion_123();
  Companion_instance_124 = new Companion_124();
  Companion_instance_125 = new Companion_125();
  Companion_instance_126 = new Companion_126();
  Companion_instance_127 = new Companion_127();
  Companion_instance_128 = new Companion_128();
  Companion_instance_129 = new Companion_129();
  Companion_instance_130 = new Companion_130();
  Companion_instance_131 = new Companion_131();
  Companion_instance_132 = new Companion_132();
  Companion_instance_133 = new Companion_133();
  Companion_instance_134 = new Companion_134();
  Companion_instance_135 = new Companion_135();
  Companion_instance_136 = new Companion_136();
  Companion_instance_137 = new Companion_137();
  Companion_instance_138 = new Companion_138();
  Companion_instance_139 = new Companion_139();
  Companion_instance_140 = new Companion_140();
  Companion_instance_141 = new Companion_141();
  Companion_instance_142 = new Companion_142();
  Companion_instance_143 = new Companion_143();
  Companion_instance_144 = new Companion_144();
  Companion_instance_145 = new Companion_145();
  Companion_instance_146 = new Companion_146();
  Companion_instance_147 = new Companion_147();
  Companion_instance_148 = new Companion_148();
  Companion_instance_149 = new Companion_149();
  Companion_instance_150 = new Companion_150();
  Companion_instance_151 = new Companion_151();
  Companion_instance_152 = new Companion_152();
  Companion_instance_153 = new Companion_153();
  Companion_instance_154 = new Companion_154();
  Companion_instance_155 = new Companion_155();
  Companion_instance_156 = new Companion_156();
  Companion_instance_157 = new Companion_157();
  Companion_instance_158 = new Companion_158();
  Companion_instance_159 = new Companion_159();
  Companion_instance_160 = new Companion_160();
  Companion_instance_161 = new Companion_161();
  Companion_instance_162 = new Companion_162();
  Companion_instance_163 = new Companion_163();
  Companion_instance_164 = new Companion_164();
  Companion_instance_165 = new Companion_165();
  Companion_instance_166 = new Companion_166();
  Companion_instance_167 = new Companion_167();
  Companion_instance_168 = new Companion_168();
  Companion_instance_169 = new Companion_169();
  Companion_instance_170 = new Companion_170();
  Companion_instance_171 = new Companion_171();
  Companion_instance_172 = new Companion_172();
  Companion_instance_173 = new Companion_173();
  Companion_instance_174 = new Companion_174();
  Companion_instance_175 = new Companion_175();
  Companion_instance_176 = new Companion_176();
  Companion_instance_177 = new Companion_177();
  Companion_instance_178 = new Companion_178();
  Companion_instance_179 = new Companion_179();
  Companion_instance_180 = new Companion_180();
  Companion_instance_181 = new Companion_181();
  Companion_instance_182 = new Companion_182();
  Companion_instance_183 = new Companion_183();
  Companion_instance_184 = new Companion_184();
  Companion_instance_185 = new Companion_185();
  Companion_instance_186 = new Companion_186();
  Companion_instance_187 = new Companion_187();
  Companion_instance_188 = new Companion_188();
  Companion_instance_189 = new Companion_189();
  Companion_instance_190 = new Companion_190();
  Companion_instance_191 = new Companion_191();
  Companion_instance_192 = new Companion_192();
  Companion_instance_193 = new Companion_193();
  Companion_instance_194 = new Companion_194();
  Companion_instance_195 = new Companion_195();
  Companion_instance_196 = new Companion_196();
  Companion_instance_197 = new Companion_197();
  Companion_instance_198 = new Companion_198();
  Companion_instance_199 = new Companion_199();
  Companion_instance_200 = new Companion_200();
  Companion_instance_201 = new Companion_201();
  Companion_instance_202 = new Companion_202();
  Companion_instance_203 = new Companion_203();
  Companion_instance_204 = new Companion_204();
  Companion_instance_205 = new Companion_205();
  Companion_instance_206 = new Companion_206();
  Companion_instance_207 = new Companion_207();
  Companion_instance_208 = new Companion_208();
  Companion_instance_209 = new Companion_209();
  Companion_instance_210 = new Companion_210();
  Companion_instance_211 = new Companion_211();
  Companion_instance_212 = new Companion_212();
  Companion_instance_213 = new Companion_213();
  Companion_instance_214 = new Companion_214();
  Companion_instance_215 = new Companion_215();
  Companion_instance_216 = new Companion_216();
  Companion_instance_217 = new Companion_217();
  Companion_instance_218 = new Companion_218();
  Companion_instance_219 = new Companion_219();
  Companion_instance_220 = new Companion_220();
  Companion_instance_221 = new Companion_221();
  Companion_instance_222 = new Companion_222();
  Companion_instance_223 = new Companion_223();
  Companion_instance_224 = new Companion_224();
  Companion_instance_225 = new Companion_225();
  Companion_instance_226 = new Companion_226();
  Companion_instance_227 = new Companion_227();
  Companion_instance_228 = new Companion_228();
  Companion_instance_229 = new Companion_229();
  Companion_instance_230 = new Companion_230();
  Companion_instance_231 = new Companion_231();
  Companion_instance_232 = new Companion_232();
  Companion_instance_233 = new Companion_233();
  Companion_instance_234 = new Companion_234();
  Companion_instance_235 = new Companion_235();
  Companion_instance_236 = new Companion_236();
  Companion_instance_237 = new Companion_237();
  Companion_instance_238 = new Companion_238();
  Companion_instance_239 = new Companion_239();
  Companion_instance_240 = new Companion_240();
  Companion_instance_241 = new Companion_241();
  Companion_instance_242 = new Companion_242();
  Companion_instance_243 = new Companion_243();
  Companion_instance_244 = new Companion_244();
  Companion_instance_245 = new Companion_245();
  Companion_instance_246 = new Companion_246();
  Companion_instance_247 = new Companion_247();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$country = $com$taager.country || ($com$taager.country = {});
    $com$taager$country.CountryProvider = CountryProvider;
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$country = $com$taager.country || ($com$taager.country = {});
    defineProp($com$taager$country, 'CountryResolver', CountryResolver_getInstance);
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$country = $com$taager.country || ($com$taager.country = {});
    defineProp($com$taager$country, 'CurrencyResolver', CurrencyResolver_getInstance);
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$country = $com$taager.country || ($com$taager.country = {});
    var $com$taager$country$model = $com$taager$country.model || ($com$taager$country.model = {});
    $com$taager$country$model.Egypt = Egypt;
    defineProp($com$taager$country$model.Egypt, 'Companion', Companion_getInstance);
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$country = $com$taager.country || ($com$taager.country = {});
    var $com$taager$country$model = $com$taager$country.model || ($com$taager$country.model = {});
    $com$taager$country$model.Currency = Currency;
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$locale = $com$taager.locale || ($com$taager.locale = {});
    $com$taager$locale.Locale = Locale;
    defineProp($com$taager$locale, 'English', English_getInstance);
    defineProp($com$taager$locale, 'Arabic', Arabic_getInstance);
    _.getCountryProvider = getCountryProvider;
    _.getCountryFromIsoCode2 = getCountryFromIsoCode2;
    _.getCountryFromIsoCode3 = getCountryFromIsoCode3;
    _.getCurrencyFromIso4217Code = getCurrencyFromIso4217Code;
    _.getSupportedPhoneCountriesUseCase = getSupportedPhoneCountriesUseCase;
    _.getSupportedNationalities = getSupportedNationalities;
    _.getCountryFromPhoneNumPrefix = getCountryFromPhoneNumPrefix;
    _.isPhoneNumberValid = isPhoneNumberValid_0;
  }
  $jsExportAll$(_);
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib.js')));

//# sourceMappingURL=shared-experience-library-countryresolver.js.map
